import {
  ON_START_GET_SMS_SETTINGS,ON_GET_SMS_SETTINGS,ON_ERROR_GET_SMS_SETTINGS,
  ON_START_UPDATE_SMS_SETTINGS,ON_UPDATE_SMS_SETTINGS,ON_ERROR_UPDATE_SMS_SETTINGS,
  ON_START_GET_DASHBOARD_VALUEOF,ON_GET_DASHBOARD_VALUEOF,ON_ERROR_GET_DASHBOARD_VALUEOF,
  ON_START_UPDATE_DASHBOARD_VALUEOF,ON_UPDATE_DASHBOARD_VALUEOF,ON_ERROR_UPDATE_DASHBOARD_VALUEOF,
  ON_START_GET_KONTO_TAGS,ON_GET_KONTO_TAGS,ON_ERROR_GET_KONTO_TAGS,
  ON_START_FETCH_MINAORT,ON_FETCH_MINAORT,ON_ERROR_MINAORT,
  ON_START_GET_KUND_KONTAKTER,ON_GET_KUND_KONTAKTER,ON_ERROR_GET_KUND_KONTAKTER,
  ON_START_ADD_ARTIKEL_TBAVDRAG, ON_ADD_ARTIKEL_TBAVDRAG, ON_ERROR_ADD_ARTIKEL_TBAVDRAG,
  ON_START_GET_ARTIKEL_TBAVDRAG,ON_GET_ARTIKEL_TBAVDRAG,ON_ERROR_GET_ARTIKEL_TBAVDRAG,
  ON_START_DELETE_ORGNR_FAMILY_TREE, ON_DELETE_ORGNR_FAMILY_TREE,
  ON_START_ADD_ORGNR_FAMILY_TREE, ON_ADD_ORGNR_FAMILY_TREE, ON_ERROR_ADD_ORGNR_FAMILY_TREE,
  ON_START_ORGNR_FAMILY_TREE,ON_ORGNR_FAMILY_TREE,ON_ERROR__ORGNR_FAMILY_TREE,
  ON_START_FLODE_LIKES,ON_FLODE_LIKES,ON_ERROR_FLODE_LIKES,
  ON_START_SEARCH_KOMMENTAR,ON_SEARCH_KOMMENTAR,ON_ERROR_SEARCH_KOMMENTAR,
  ON_START_GET_UNDERKONTO_KUNDER,ON_GET_UNDERKONTO_KUNDER,ON_ERROR_GET_UNDERKONTO_KUNDER,
  ON_START_GET_IMPORT_SAMPLE,ON_GET_IMPORT_SAMPLE,ON_ERROR_GET_IMPORT_SAMPLE,
  ON_START_CHECH_KUNDNR,ON_CHECH_KUNDNR,ON_ERROR_CHECH_KUNDNR,
  ON_START_FETCH_RAPPORTV2,ON_FETCH_RAPPORTV2,ON_ERROR_FETCH_RAPPORTV2,ON_SET_TO_NULL_IMPORTSAMPLE,
  ON_START_DELETE_AFID_RAPPORTV2, ON_DELETE_AFID_RAPPORTV2, ON_ERROR_DELETE_AFID_RAPPORTV2,
  ON_START_UPDATE_RAPPORTV2, ON_UPDATE_RAPPORTV2, ON_ERROR_UPDATE_RAPPORTV2,
  ON_START_GET_SPARAD_RAPPORTV2,ON_GET_SPARAD_RAPPORTV2,ON_ERROR_GET_SPARAD_RAPPORTV2,
  ON_START_GET_LOGG_RAPPORTV2,ON_GET_LOGG_RAPPORTV2,ON_ERROR_GET_LOGG_RAPPORTV2,
  ON_START_GET_KONTO_STORAGE,ON_GET_KONTO_STORAGE,ON_ERROR_GET_KONTO_STORAGE,
  ON_START_GET_CATE_ARENDE_AFID,ON_GE_CATE_ARENDE_AFID,ON_ERROR_CATE_ARENDE_AFID,
  ON_START_SAVE_NEW_CATE_ARENDE, ON_SAVE_SAVE_NEW_CATE_ARENDE, ON_ERROR_SAVE_NEW_CATE_ARENDE,
  ON_DELETE_SAVE_NEW_CATE_ARENDE,ON_DELETE_ARENDE_CATE_FREEINPUT,
  ON_START_GET_FREEINPUT_ARENDE_AFID,ON_GET_FREEINPUT_ARENDE_AFID,ON_ERROR_FREEINPUT_ARENDE_AFID,
  ON_START_SAVE_NEW_ARENDE_CATE_FREEINPUT, ON_SAVE_NEW_NEW_ARENDE_CATE_FREEINPUT, ON_ERROR_SAVE_NEW_ARENDE_CATE_FREEINPUT,
  ON_START_GET_FI_AFID_ARENDE,ON_GET_FI_AFID_ARENDE,ON_ERROR_FI_AFID_ARENDE,
  START_FETCH_CONTACT1_BY_ID,  ON_FETCH_CONTACT1_BY_ID_REST,
  START_FETCH_CONTACT2_BY_ID,  ON_FETCH_CONTACT2_BY_ID_REST,
  START_FETCH_CONTACT3_BY_ID,  ON_FETCH_CONTACT3_BY_ID_REST,
  ON_START_GET_VALITIVE,ON_GET_VALITIVE,ON_ERROR_GET_VALITIVE,
  ON_START_GET_UPDATED_AVTAL_KALKYL,ON_GET_UPDATED_AVTAL_KALKYL,ON_ERROR_GET_UPDATED_AVTAL_KALKYL,  
  ON_START_CREATE_RINGLIST_FROM_KUNDLIST, ON_CREATE_RINGLIST_FROM_KUNDLIST, ON_ERROR_CREATE_RINGLIST_FROM_KUNDLIST,
  ON_START_GET_IMPORTERAD_RINGLISTOR,ON_GET_IMPORTERAD_RINGLISTOR,ON_ERROR_GET_IMPORTERAD_RINGLISTOR,
  ON_START_FETCH_KOPIERA_USER,
  ON_START_AKTIVE_TYP_AV_AFFAR,ON_AKTIVE_TYP_AV_AFFAR,ON_ERROR_AKTIVE_TYP_AV_AFFAR,
  ON_START_GET_DOWN_FILE_NO_SAVE,ON_GET_DOWN_FILE_NO_SAVE,ON_ERROR_GET_DOWN_FILE_NO_SAVE,
  ON_START_GET_ADS,ON_GET_ADS,ON_ERROR_GET_ADS,
  ON_START_GET_FBADS,ON_GET_FBADS,ON_ERROR_GET_FBADS,
  ON_START_GET_FAKTURA_INTERVALL_AFID,  ON_GET_FAKTURA_INTERVALL_AFID,  ON_ERROR_GET_FAKTURA_INTERVALL_AFID,
  ON_START_SAVE_NEW_TYP_AV_AFFAR,ON_SAVE_NEW_TYP_AV_AFFAR,ON_ERROR_SAVE_NEW_TYP_AV_AFFAR,
  ON_START_GET_TYP_AV_AFFAR,  ON_GET_TYP_AV_AFFAR,  ON_ERROR_GET_TYP_AV_AFFAR,
  ON_START_DELETE_TYP_AV_AFFAR,   ON_DELETE_TYP_AV_AFFAR,   ON_ERROR_DELETE_TYP_AV_AFFAR,
  ON_START_GET_PRISLISTA_BY_ORGNR,ON_GET_PRISLISTA_BY_ORGNR,ON_ERROR_GET_PRISLISTA_BY_ORGNR,
  ON_START_CHECK_FORTNOX_KUNDNAME1,ON_GET_CHECK_FORTNOX_KUNDNAME1,ON_ERROR_GET_CHECK_FORTNOX_KUNDNAME1,
  ON_START_CHECK_FORTNOX_KUNDNAME,ON_GET_CHECK_FORTNOX_KUNDNAME,ON_ERROR_GET_CHECK_FORTNOX_KUNDNAME,
  ON_START_UPDATE_AVTALFORMULA,  ON_UPDATE_AVTALFORMULA,  ON_ERROR_UPDATE_AVTALFORMULA,
  ON_START_GET_AVTALFORMULA, ON_GET_AVTALFORMULA, ON_ERROR_AVTALFORMULA,
  ON_START_UPDATE_EVENT_STATUS, ON_UPDATE_EVENT_STATUS, ON_ERROR_UPDATE_EVENT_STATUS,
  ON_START_DELETE_EVENT_STATUS, ON_DELETE_EVENT_STATUS, ON_ERROR_DELETE_EVENT_STATUS,
  ON_START_GET_EVENT_STATUS,  ON_GET_EVENT_STATUS, 
  ON_START_UPDATE_AKTIVITETE_TYPE, ON_UPDATE_AKTIVITETE_TYPE, ON_ERROR_UPDATE_AKTIVITETE_TYPE,
  ON_START_DELETE_AKTIVITETE_TYPE, ON_DELETE_AKTIVITETE_TYPE, ON_ERROR_DELETE_AKTIVITETE_TYPE,
  ON_START_NEW_AKTIVITETE_TYPE, ON_NEW_AKTIVITETE_TYPE, ON_ERROR_AKTIVITETE_TYPE,
  ON_START_GET_AKTIVITETE_TYPE, ON_GET_AKTIVITETE_TYPE, ON_ERROR_GET_AKTIVITETE_TYPE,
  ON_START_NEW_EVENT_STATUS, ON_NEW_EVENT_STATUS, ON_ERROR_EVENT_STATUS,
  ON_START_GET_EVENT_SETTING_AF,ON_GET_EVENT_SETTING_AF,ON_ERROR_GET_EVENT_SETTING_AF,
  ON_START_UPDATE_EVENT_SETTING_AF, ON_UPDATE_EVENT_SETTING_AF, ON_ERROR_UPDATE_EVENT_SETTING_AF,
  ON_START_UPDATE_AVTALS_FORTNOX_SETTING,ON_UPDATE_AVTALS_FORTNOX_SETTING,ON_ERROR_UPDATE_AVTALS_FORTNOX_SETTING,
  ON_START_GET_AVTALS_FORTNOX_SETTINGS,ON_GET_AVTALS_FORTNOX_SETTINGSG,ON_ERROR_GET_AVTALS_FORTNOX_SETTINGS,
  ON_START_DELETE_AVTAL_AVSLUTNING,ON_DELETE_DELETE_AVTAL_AVSLUTNING,ON_ERROR_DELETE_AVTAL_AVSLUTNING,
  ON_START_SAVE_NEW_AVTAL_AVSLUTNING,ON_SAVE_NEW_AVTAL_AVSLUTNING,ON_ERROR_SAVE_NEW_AVTAL_AVSLUTNING,
  ON_START_GET_AVTALS_AVSLUTNING,ON_GET_AVTALS_AVSLUTNING,ON_ERROR_GET_AVTALS_AVSLUTNING,
  ON_START_GET_KUND_MESSAGE,ON_GET_KUND_MESSAGE,ON_ERROR_GET_KUND_MESSAGE,
  ON_START_MESSAGE_KUND,ON_MESSAGE_KUND,ON_ERROR_MESSAGE_KUND,
  ON_START_GET_NOTIST,ON_GET_NOTIST,ON_ERROR_GET_NOTIST,ON_CLOSE_KONTO_TOASTR,
  ON_CLOSE_KUND_TOASTR,ON_CLOSE_RAPPORT_TOASTR,
  ON_START_GET_NOTYFILE_USERS, ON_GET_NOTYFILE_USERS, ON_ERROR_GET_NOTYFILE_USERS,
  ON_START_GET_DOWN_FILE,ON_GET_DOWN_FILE,ON_ERROR_GET_DOWN_FILE,
  ON_START_GET_HOGIA_OFFICES,ON_GET_HOGIA_OFFICES,ON_ERROR_GET_HOGIA_OFFICES,
  ON_START_FORTNOX_TERMOFPAY_GET, ON_FORTNOX_TERMOFPAY_GET, ON_ERROR_FORTNOX_TERMOFPAY_GET,
  ON_START_FORTNOX_WAYOFDELIVERY_GET, ON_FORTNOX_WAYOFDELIVERY_GET, ON_ERROR_FORTNOX_WAYOFDELIVERY_GET,
  ON_START_FORTNOX_PRISLISTOR_GET,ON_FORTNOX_PRISLISTOR_GET,ON_ERROR_FORTNOX_PRISLISTOR_GET,
  ON_START_FORTNOX_TERMSOFDELIVERY_GET, ON_FORTNOX_TERMSOFDELIVERY_GET, ON_ERROR_FORTNOX_TERMSOFDELIVERY_GET,
  ON_START_DELETE_HANDELSE_LOGG, ON_DELETE_HANDELSE_LOGG, ON_ERROR_DELETE_HANDELSE_LOGG,
  ON_START_EDIT_HANDELSE_LOGG,ON_EDIT_HANDELSE_LOGG,ON_ERROR_START_EDIT_HANDELSE_LOGG,
  ON_START_GET_DONT_HA_PL_CHILD,ON_GET_DONT_HA_PL_CHILD,ON_ERROR_GET_DONT_HA_PL_CHILD,
  ON_START_FORTNOX_TEMPLATE_GET,   ON_FORTNOX_TEMPLATE_GET,   ON_ERROR_FORTNOX_TEMPLATE_GET,
  ON_START_FORTNOX_TERMOFPAYMENTS_GET,   ON_FORTNOX_TERMOFPAYMENTS_GET,   ON_ERROR_FORTNOX_TERMOFPAYMENTS_GET,
  ON_START_FORTNOX_ATTACHMENTS_GET,   ON_FORTNOX_ATTACHMENTS_GET,   ON_ERROR_FORTNOX_ATTACHMENTS_GET,
  ON_START_DELETE_ARANDE_EMAIL,ON_DELETE_ARANDE_EMAIL,ON_ERROR_DELETE_ARANDE_EMAIL,
  ON_START_NEW_ARANDE_EMAIL, ON_NEW_ARANDE_EMAIL, ON_ERROR_NEW_ARANDE_EMAIL,
  ON_START_DELETE_CASE_TYPE, ON_DELETE_CASE_TYPE, ON_ERROR_DELETE_CASE_TYPE,
  ON_START_DELETE_CASE_CATE_TYPE, ON_DELETE_CASE_CATE_TYPE, ON_ERROR_DELETE_CASE_CATE_TYPE,
  ON_START_NEW_CASE_CATE_TYPE, ON_NEW_CASE_CATE_TYPE, ON_ERROR_NEW_CASE_CATE_TYPE,
  ON_START_GET_ARANDETYP_KUND,ON_FETCH_ARANDETYP_KUND,ON_ERROR_ARANDETYP_KUND,
  ON_START_FETCH_UTOKNING,ON_FETCH_UTOKNING,ON_ERROR_FETCH_UTOKNING,
  ON_START_FETCH_UTOKNING_DYNAMIC_FIELDS,ON_FETCH_UTOKNING_DYNAMIC_FIELDS,ON_ERROR_FETCH_UTOKNING_DYNAMIC_FIELDS,
  ON_START_KUND_KUNDDATA_GET, ON_KUND_KUNDDATA_GET, ON_ERROR_KUND_KUNDDATA_GET,
  ON_START_FETCH_UTOKNING_RAPPORT,ON_FETCH_UTOKNING_RAPPORT,ON_ERROR_FETCH_UTOKNING_RAPPORT,
  ON_START_NEW_CASE_TYPE,   ON_NEW_CASE_TYPE,   ON_ERROR_NEW_CASE_TYPE,
  ON_START_BESTALLA_FORTNOX, ON_BESTALLA_FORTNOX, ON_ERROR_BESTALLA_FORTNOX,
  ON_START_GET_AF_FORTNOX,ON_GET_AF_FORTNOX,ON_ERROR_GET_AF_FORTNOX,
  ON_START_GET_AF_LFORTNOX,ON_GET_AF_LFORTNOX,ON_ERROR_GET_AF_LFORTNOX,
  ON_START_GET_AF_DFORTNOX,ON_GET_AF_DFORTNOX,ON_ERROR_GET_AF_DFORTNOX,
  ON_START_GET_AF_FORTNOX_KUNDER,ON_GET_AF_FORTNOX_KUNDER,ON_ERROR_GET_AF_FORTNOX_KUNDER,
  ON_START_FORTNOX_NEWKUND, ON_FORTNOX_NEWKUND, ON_ERROR_FORTNOX_NEWKUND,
  ON_START_FORTNOX_EDITKUND, ON_FORTNOX_EDITKUND, ON_ERROR_FORTNOX_EDITKUND,
  ON_START_FORTNOX_CONNECT_KUND,ON_FORTNOX_CONNECT_KUND,ON_ERROR_FORTNOX_CONNECT_KUND,
  ON_START_FORTNOX_DELKUND, ON_FORTNOX_DELKUND, ON_ERROR_FORTNOX_DELKUND,
  ON_START_GET_AF_FORTNOX_KUND,ON_GET_AF_FORTNOX_KUND,ON_ERROR_GET_AF_FORTNOX_KUND,
  ON_START_GET_AF_FORTNOX_ARTIKLAR,ON_GET_AF_FORTNOX_ARTIKLAR,ON_ERROR_GET_AF_FORTNOX_ARTIKLAR,
  ON_START_GET_AF_FORTNOX_ORDER,ON_GET_AF_FORTNOX_ORDER,ON_ERROR_GET_AF_FORTNOX_ORDER,
  ON_START_GET_AF_FORTNOX_OFFERT,ON_GET_AF_FORTNOX_OFFERT,ON_ERROR_GET_AF_FORTNOX_OFFERT,
  ON_START_OFFICE_ALL_USERS, ON_OFFICE_ALL_USERS, ON_ERROR_OFFICE_ALL_USERS,
  ON_START_OFFICE_UPDATE_USER, ON_OFFICE_UPDATE_USER, ON_ERROR_OFFICE_UPDATE_USER,
  ON_START_FORTNOX_KUND_FAKTUROR, ON_FORTNOX_KUND_FAKTUROR, ON_ERROR_FORTNOX_KUND_FAKTUROR,ON_RESET_FORTNOX_KUND_FAKTUROR,
  ON_START_FORTNOX_FAKTUROR_CONNECT,ON_FORTNOX_FAKTUROR_CONNECT,ON_ERROR_FORTNOX_FAKTUROR_CONNECT,
  ON_START_FORTNOX_FAKTUROR_DOWNLOAD,ON_FORTNOX_FAKTURO_DOWNLOAD,ON_ERROR_FORTNOX_FAKTUROR_DOWNLOAD,
  ON_START_FORTNOX_FAKTUROR_CANCEL, ON_FORTNOX_FAKTUROR_CANCEL, ON_ERROR_FORTNOX_FAKTUROR_CANCEL,
  ON_START_OFFICE_GET, ON_OFFICE_GET, ON_ERROR_OFFICE_GET,ON_SET_ZERO_FORTNOX_UPPGIFTER,
  ON_START_UPDATEN_ARANDE_EMAIL, ON_UPDATEN_ARANDE_EMAIL, ON_ERROR_UPDATEN_ARANDE_EMAIL,
  ON_START_FORTNOX_FAKTURA_GET, ON_FORTNOX_FAKTURA_GET, ON_ERROR_FORTNOX_FAKTURA_GET,
  ON_START_FORTNOX_FAKTUROR_SEND, ON_FORTNOX_FAKTUROR_SEND, ON_ERROR_FORTNOX_FAKTUROR_SEND,
  ON_START_FORTNOX_FAKTUROR_EDIT,ON_FORTNOX_FAKTUROR_EDIT,ON_ERROR_FORTNOX_FAKTUROR_EDIT,
  ON_START_FORTNOX_FAKTUROR_NEW,ON_FORTNOX_FAKTUROR_NEW,ON_ERROR_FORTNOX_FAKTUROR_NEW,
  ON_START_KUND_KALKYL_OPTIONS,ON_KUND_KALKYL_OPTIONS,ON_ERROR_KUND_KALKYL_OPTIONS,
  ON_START_FETCH_EXCELMALL,ON_FETCH_EXCELMALL,ON_ERROR_EXCELMAL,
  ON_START_FETCH_EXCEL_KUNDDATA_AVTAL,ON_FETCH_EXCEL_KUNDDATA_AVTAL,ON_ERROR_EXCEL_KUNDDATA_AVTAL,
  ON_START_DIALER_ADD_BORTFALL, ON_DIALER_ADD_BORTFALL, ON_ERROR_DIALER_ADD_BORTFALL,
  ON_START_BLACK_LIST, ON_BLACK_LIST, ON_ERROR_BLACK_LIST,ON_DIALER_DELETE_BORTFALL,ON_DIALER_DELETE_BLACKLIST_TAGG,
  ON_START_DASHBORD_USERLIST, ON_DASHBORD_USERLIST, ON_ERROR_DASHBORD_USERLIST,
  ON_START_GET_AF_LHOGIA,ON_GET_AF_LHOGIA,ON_ERROR_GET_AF_LHOGIA,ON_GET_AF_LHOGIA_STORE,ON_GET_AF_LHOGIA_DELETE_STORE,
  ON_START_BESTALLA_HOGIA, ON_BESTALLA_HOGIA, ON_ERROR_BESTALLA_HOGIA,
  ON_START_FLYTTA_INAKTIV_USER, ON_FETCH_FLYTTA_INAKTIV_USER, ON_ERROR_FLYTTA_INAKTIV_USER,
  ON_FETCH_KOPIERA_USER,
  ON_START_UPDATE_KUND_DOCUMENT, ON_UPDATE_KUND_DOCUMENT, ON_ERROR_UPDATE_KUND_DOCUMENT,
  ON_START_GET_MINA_DOCUMENT_LIST,ON_GET_MINA_DOCUMENT_LIST,ON_ERROR_GET_MINA_DOCUMENT_LIST,
  ON_START_GET_MINA_DOCUMENT_KUND_LIST,ON_GET_MINA_DOCUMENT_KUND_LIST,ON_ERROR_GET_MINA_DOCUMENT_KUND_LIST,
  ON_START_NEW_ORDER_STATUS, ON_NEW_ORDER_STATUS, ON_ERROR_ORDER_STATUS,
  ON_START_DELETE_ORDER_STATUS, ON_DELETE_ORDER_STATUS, ON_ERROR_DELETE_ORDER_STATUS,
  ON_START_UPDATE_ORDER_STATUS, ON_UPDATE_ORDER_STATUS, ON_ERROR_UPDATE_ORDER_STATUS,
  ON_START_GET_ORDER_STATUS,ON_GET_ORDER_STATUS,
  FETCH_START_SAVE_NEW_CHILD,ON_SAVE_NEW_CHILD,ON_ERROR_SAVE_NEW_CHILD,
  ON_START_GET_CHILD,  ON_GET_CHILD,  ON_ERROR_GET_CHILD,
  ON_START_DELETE_AFID_CHILD, ON_DELETE_AFID_CHILD,  ON_ERROR_DELETE_AFID_CHILD, 
  FETCH_START_SAVE_BLTYPE_CHILD,ON_SAVE_BLTYPE_CHILD,ON_ERROR_SAVE_BLTYPE_CHILD,ON_SAVE_CCTYPE_CHILD,
  FETCH_START_SAVE_FNTYPE_CHILD,ON_SAVE_FNTYPE_CHILD,ON_ERROR_SAVE_FNTYPE_CHILD,
  FETCH_START_SAVE_CLTYPE_CHILD,ON_SAVE_CLTYPE_CHILD,ON_ERROR_SAVE_CLTYPE_CHILD,
  FETCH_START_SAVE_CATYPE_CHILD,ON_SAVE_CATYPE_CHILD,ON_ERROR_SAVE_CATYPE_CHILD,
  ON_START_CHILD_KONTO_GET, ON_CHILD_KONTO_GET, ON_ERROR_CHILD_KONTO_GET,
  ON_START_CHILD_KONTO_KONTOR_GET, ON_CHILD_KONTO_KONTOR_GET, ON_ERROR_CHILD_KONTO_KONTOR_GET,
  ON_START_CHILD_KONTO_USERS_GET, ON_CHILD_KONTO_USERS_GET, ON_ERROR_CHILD_KONTO_USERS_GET,
  ON_START_CHILD_KONTO_OFFICES_GET, ON_CHILD_KONTO_OFFICES_GET, ON_ERROR_CHILD_KONTO_OFFICES_GET,
 ON_START_CHILD_KONTO_TEAMS_GET, ON_CHILD_KONTO_TEAMS_GET, ON_ERROR_CHILD_KONTO_TEAMS_GET,
 ON_START_CHILD_KONTO_TEAM_SGET_ALL,ON_CHILD_KONTO_TEAMS_GET_ALL,ON_ERROR_CHILD_KONTO_TEAMS_GET_ALL,
  ON_START_CHILD_KONTO_USERS_ALL_GET, ON_CHILD_KONTO_USERS_ALL_GET, ON_ERROR_CHILD_KONTO_ALL_USERS_GET,
  ON_START_GET_ORDER_USER_HV, ON_GET_ORDER_USER_HV, ON_ERROR_ORDER_USER_HV,
  ON_START_DIALER_ADD_BLACKLIST_TAGG, ON_DIALER_ADD_BLACKLIST_TAGG, ON_ERROR_DIALER_ADD_BLACKLIST_TAGG,
  ON_START_CHILD_KONTO_AVTALTYPER_GET, ON_CHILD_KONTO_AVTALTYPER_GET, ON_ERROR_CHILD_KONTO_AVTALTYPER_GET,
  SET_DASHBORD_SALJ_FILTER,
  ON_START_NEW_PROJEKT_STATUS, ON_NEW_PROJEKT_STATUS, ON_ERROR_PROJEKT_STATUS,
  ON_START_DELETE_PROJEKT_STATUS, ON_DELETE_PROJEKT_STATUS, ON_ERROR_DELETE_PROJEKT_STATUS,
  ON_START_UPDATE_PROJEKT_STATUS, ON_UPDATE_PROJEKT_STATUS, ON_ERROR_UPDATE_PROJEKT_STATUS,
  ON_START_NEW_PROJEKT_FAS, ON_NEW_PROJEKT_FAS, ON_ERROR_PROJEKT_FAS,
  ON_START_DELETE_PROJEKT_FAS, ON_DELETE_PROJEKT_FAS, ON_ERROR_DELETE_PROJEKT_FAS,
  ON_START_UPDATE_PROJEKT_FAS, ON_UPDATE_PROJEKT_FAS, ON_ERROR_UPDATE_PROJEKT_FAS,
  ON_START_GET_PROJEKT_STATUS,ON_GET_PROJEKT_STATUS,
  ON_CLOSE_CHECK_FILE,ON_START_CHECK_FILE,ON_CHECK_FILE,ON_ERROR_CHECK_FILE,
  ON_START_NEW_ARENDE_STATUS, ON_NEW_ARENDE_STATUS, ON_ERROR_ARENDE_STATUS,
  ON_START_DELETE_ARENDE_STATUS, ON_DELETE_ARENDE_STATUS, ON_ERROR_DELETE_ARENDE_STATUS,
  ON_START_UPDATE_ARENDE_STATUS, ON_UPDATE_ARENDE_STATUS, ON_ERROR_UPDATE_ARENDE_STATUS,
  ON_START_GET_ARENDE_STATUS, ON_GET_ARENDE_STATUS,

  ON_START_CHECK_FORTNOX,ON_GET_CHECK_FORTNOX,ON_ERROR_GET_CHECK_FORTNOX,
  ON_START_EDIT_KUND_ITESCO_INFO, ON_EDIT_KUND_ITESCO_INFO, ON_ERROR_EDIT_KUND_ITESCO_INFO,ON_GET_KUNDER_PAGE_BASIC,ON_GET_KUNDER_SEARCH_BASIC,
  ON_GET_KONTAKT_PAGE_BASIC,ON_GET_KUND_TABINDEX,ON_GET_KUNDER_PAGE_ROWS_BASIC,ON_GET_KUND_SORTOBJ,
  ON_OPEN_FILTER_DASHBOARD_BARN,ON_ClOSE_FILTER_DASHBOARD_BARN,SET_DASHBORD_BARN_FILTER,SET_DASHBORD_PROSPEKT_FILTER,SET_DASHBORD_PULS_FILTER,
  SET_DASHBORD_KONTOR_FILTER,ON_OPEN_FILTER_DASHBOARD_KONTOR,ON_ClOSE_FILTER_DASHBOARD_KONTOR,
    FETCH_ACCOUNT_ERROR,ON_SET_KUND_SEARCH,ON_ClOSE_FILTER_DASHBOARD_PROSPEKT,ON_ClOSE_FILTER_DASHBOARD_PULS,ON_OPEN_FILTER_DASHBOARD_PROSPEKT,ON_OPEN_FILTER_DASHBOARD_PULS,
    ON_START_BESTALLA_CREDITSAFE, ON_BESTALLA_CREDITSAFE, ON_ERROR_BESTALLA_CREDITSAFE,
    ON_START_BESTALLA_SVEACREDIT, ON_BESTALLA_SVEACREDIT, ON_ERROR_BESTALLA_SVEACREDIT,
    ON_START_GET_CREDITSAFE,ON_GET_CREDITSAFE,ON_ERROR_GET_CREDITSAFE,
    ON_START_GET_SVEACREDIT,ON_GET_SVEACREDIT,ON_ERROR_GET_SVEACREDIT,
    ON_START_SEND_SVEACREDIT, ON_SEND_SVEACREDIT, ON_ERROR_SEND_SVEACREDIT,
    ON_START_SEND_CREDITSAFE, ON_SEND_CREDITSAFE, ON_ERROR_SEND_CREDITSAFE,
    ON_START_SEND_CREDITSAFE_CR, ON_ERROR_SEND_CREDITSAFE_CR,ON_RESET_CREDITSAFE,
    ON_START_CREDITSAFE_ALLOW_USER, ON_CREDITSAFE_ALLOW_USER, ON_ERROR_CREDITSAFE_ALLOW_USER,
    ON_START_SVEACREDIT_ALLOW_USER, ON_SVEACREDIT_ALLOW_USER, ON_ERROR_SVEACREDIT_ALLOW_USER,
    ON_START_GET_ALL_SVEACREDIT_ALLOW_USER,ON_GET_ALL_SVEACREDIT_ALLOW_USER,ON_ERROR_GET_ALL_SVEACREDIT_ALLOW_USER,
    ON_START_GET_ALL_CREDITSAFE_ALLOW_USER,ON_GET_ALL_CREDITSAFE_ALLOW_USER,ON_ERROR_GET_ALL_CREDITSAFE_ALLOW_USER,
    ON_START_CREDITSAFE_AKTIVE_ALLOW_USER, ON_CREDITSAFE_AKTIVE_ALLOW_USER, ON_ERROR_CREDITSAFE_AKTIVE_ALLOW_USER,
    ON_START_SVEACREDIT_AKTIVE_ALLOW_USER, ON_SVEACREDIT_AKTIVE_ALLOW_USER, ON_ERROR_SVEACREDIT_AKTIVE_ALLOW_USER,
    ON_START_GET_ALL_CREDITSAFE_CREDIT_RES,ON_GET_ALL_CREDITSAFE_CREDIT_RES,ON_ERROR_GET_ALL_CREDITSAFE_CREDIT_RES,
    ON_START_GET_LAST_CREDIT, ON_GET_LAST_CREDIT, ON_ERROR_GET_LAST_CREDIT,
    ON_START_GET_LAST_SVEACREDIT, ON_GET_LAST_SVEACREDIT, ON_ERROR_GET_LAST_SVEACREDIT,
    ON_START_GET_RPS_CREDIT, ON_GET_RPS_CREDIT, ON_ERROR_GET_RPS_CREDIT,
    ON_START_GET_ORDER_SETTING_AF, ON_GET_ORDER_SETTING_AF, ON_ERROR_GET_ORDER_SETTING_AF,
    ON_START_GET_ORDER_AFFAR_FROM_AF,ON_GET_ORDER_AFFAR_FROM_AF,ON_ERROR_GET_ORDER_AFFAR_FROM_AF,
    ON_START_NEW_ORDER_AFFAR_FROM_AF, ON_NEW_ORDER_AFFAR_FROM_AF, ON_ERROR_ORDER_AFFAR_FROM_AF,
    ON_START_UPDATE_ORDER_AFFAR_FROM_AF, ON_UPDATE_ORDER_AFFAR_FROM_AF,
    ON_START_GET_LOBBY_SETTING_AF,   ON_GET_LOBBY_SETTING_AF,   ON_ERROR_GET_LOBBY_SETTING_AF,
    ON_START_UPDATE_ORDER_SETTING_AF, ON_UPDATE_ORDER_SETTING_AF, ON_ERROR_UPDATE_ORDER_SETTING_AF,
    ON_START_UPDATE_LOBBY_SETTING_AF, ON_UPDATE_LOBBY_SETTING_AF, ON_ERROR_UPDATE_LOBBY_SETTING_AF,
    ON_START_FORTNOX_PROJEKT_GET,   ON_FORTNOX_PROJEKT_GET,   ON_ERROR_FORTNOX_PROJEKT_GET,
    ON_START_GET_ESIGNERING_FREE_SETTING_AF, ON_GET_ESIGNERING_FREE_SETTING_AF, ON_ERROR_GET_ESIGNERING_FREE_SETTING_AF,
    ON_START_NEW_ESIGNERING_FREE_SETTING_AF, ON_NEW_ESIGNERING_FREE_SETTING_AF, ON_ERROR_NEW_ESIGNERING_FREE_SETTING_AF,
    ON_START_DELETE_ESIGNERING_FREE_SETTING_AF,ON_DELETE_ESIGNERING_FREE_SETTING_AF,ON_ERROR_DELETE_ESIGNERING_FREE_SETTING_AF,
    ON_START_UPDATE_ESIGNERING_FREE_SETTING_AF, ON_UPDATE_ESIGNERING_FREE_SETTING_AF, ON_ERROR_UPDATE_ESIGNERING_FREE_SETTING_AF,
    ON_START_GET_ORGNR_FORDON, ON_GET_ORGNR_FORDON, ON_ERROR_GET_ORGNR_FORDON,
    ON_START_NEW_USER_VAXLE, ON_NEW_USER_VAXLE, ON_ERROR_NEW_USER_VAXLE,ON_START_GET_USER_VAXLE,
    ON_START_SET_KUNDLIST_TAG,ON_SET_KUNDLIST_TAG,ON_ERROR_SET_KUNDLIST_TAG,
    ON_START_SAVE_NEW_TYPE_ARTIKEL, ON_SAVE_SAVE_NEW_TYPE_ARTIKEL, ON_ERROR_SAVE_NEW_TYPE_ARTIKEL,
    ON_START_GET_TYPE_ARTIKEL_AFID,ON_GET_TYPE_ARTIKEL_AFID,ON_ERROR_TYPE_ARTIKEL_AFID,
		ON_START_GET_FREEINPUT_ARTIKEL_AFID_LIST, ON_GET_FREEINPUT_ARTIKEL_AFID_LIST, ON_ERROR_FREEINPUT_ARTIKEL_AFID_LIST,
		ON_START_GET_FREEINPUT_ARTIKEL_AFID_LIST_FILTER_OPTIONS, ON_GET_FREEINPUT_ARTIKEL_AFID_LIST_FILTER_OPTIONS, ON_ERROR_FREEINPUT_ARTIKEL_AFID_LIST_FILTER_OPTIONS,
    ON_DELETE_SAVE_NEW_TYPE_ARTIKEL,
    ON_START_GET_KUNDDATA_HEADER, ON_GET_KUNDDATA_HEADER, ON_ERROR_GET_KUNDDATA_HEADER,
    ON_START_GET_KUNDDATA_BYTYPE, ON_GET_KUNDDATA_BYTYPE, ON_ERROR_GET_KUNDDATA_BYTYPE,
    ON_START_DELETE_ROW_KUNDDATA_BYTYPE,ON_DELETE_ROW_KUNDDATA_BYTYPE,ON_ERROR_DELETE_ROW_KUNDDATA_BYTYPE,
    ON_SAVE_ROW_KUNDDATA_BYTYPE,ON_START_SAVE_ROW_KUNDDATA_BYTYPE,ON_SAVE_All_ROW_KUNDDATA_BYTYPE,
    ON_START_SAVE_ROW_KUNDDATA_DIALER_BYTYPE, ON_SAVE_All_ROW_KUNDDATA_DIALER_BYTYPE, ON_ERROR_GET_KUNDDATA_ALL_DIALER_BYTYPE,
    ON_START_DELETE_ROW_ALL_KUNDDATA_BYTYPE,ON_DELETE_ROW_ALL_KUNDDATA_BYTYPE,
    ON_START_DELETE_ALL_ROW_KUNDDATA_BYTYPE,ON_DELETE_ALL_ROW_KUNDDATA_BYTYPE,ON_ERROR_DELETE_ALL_ROW_KUNDDATA_BYTYPE,
    ON_START_GET_KUNDDATA_ALL_HEADER, ON_GET_KUNDDATA_ALL_HEADER, ON_ERROR_GET_KUNDDATA_ALL_HEADER,
    ON_START_GET_KUNDDATA_ALL_BYTYPE,ON_GET_KUNDDATA_ALL_BYTYPE,ON_ERROR_GET_KUNDDATA_ALL_BYTYPE,
    ON_START_GET_KUNDDATA_DIALER_ALL_BYTYPE,ON_GET_KUNDDATA_DIALER_ALL_BYTYPE,ON_ERROR_GET_KUNDDATA_DIALER_ALL_BYTYPE,
    ON_START_SAVE_NEW_TYPE_ARTIKEL_FREEINPUT, ON_SAVE_NEW_TYPE_ARTIKEL_FREEINPUT, ON_ERROR_SAVE_NEW_TYPE_ARTIKEL_FREEINPUT,
    ON_START_GET_FREEINPUT_ARTIKEL_AFID,ON_GET_FREEINPUT_ARTIKEL_AFID,ON_ERROR_FREEINPUT_ARTIKEL_AFID,ON_DELETE_TYPE_ARTIKEL_FREEINPUT,
    ON_START_GET_FREEINPUT_ARTIKEL_ALL_AFID,ON_GET_FREEINPUT_ARTIKEL_ALL_AFID,
    ON_START_FETCH_ORDER_IMPORT_FILE,ON_FETCH_ORDER_IMPORT_FILE,
    ON_START_GET_AFID_USERLIST,ON_GET_AFID_USERLIST,ON_ERROR_GET_AFID_USERLIST,
    ON_START_FETCH_KUND_HANDELSER_DIALERD,   ON_FETCH_KUND_HANDELSER_DIALERD,   ON_ERROR_FETCH_KUND_HANDELSER_DIALERD,
    FETCH_ALL_CONTACT_FLAGS,ON_FETCH_CONTACT_FLAGS_BY_ID,FETCH_ACCOUNT_FLAGS_ERROR,  
    ON_START_FETCH_SAVED_ANPASSAD,ON_FETCH_SAVED_ANPASSAD,ON_ERROR_FETCH_SAVED_ANPASSAD,ON_START_FETCH_UPDATE_ANPASSAD,
    ON_START_SAVE_NEW_PRISLISTA,ON_SAVE_NEW_PRISLISTA,ON_ERROR_SAVE_NEW_PRISLISTA,
    ON_START_GET_AFID_PRISLISTA,ON_GET_AFID_PRISLISTA,ON_ERROR_GET_AFID_PRISLISTA,
    ON_DELETE_DELETE_AFID_PRISLISTA,ON_UPDATE_AFID_PRISLISTA,ON_SAVE_PAGE_ANV,
    ON_START_CREATE_RINGLIST_FROM_KUNDDATA, ON_CREATE_RINGLIST_FROM_KUNDDATA, ON_ERROR_CREATE_RINGLIST_FROM_KUNDDATA,
    ON_START_CREATE_RINGLIST_FROM_AVTALSTID, ON_CREATE_RINGLIST_FROM_AVTALSTID, ON_ERROR_CREATE_RINGLIST_FROM_AVTALSTID,
    FETCH_START,
    FETCH_SUCCESS,
    INIT_URL,
    SHOW_MESSAGE,
    HIDE_MESSAGE,
    ON_ADD_CONTACT,
    START_FETCH_CONTACT_BY_ID,ON_FETCH_CONTACT_BY_ID_REST,FETCH_ACCOUNT_REST_ERROR,
    FETCH_ALL_CONTACT,
    FETCH_ALL_CONTACT_SUCCESS,
    ON_Update_STATUS_CONTACT,ON_Update_ANSVARIG_CONTACT,
    ON_DELETE_CONTACT,
    ON_FETCH_CONTACT_BY_ID,
    ON_SAVE_NEW_OFFICE,ON_SAVE_NEW_TEAM,
    ON_DELETE_OFFICE,ON_DELETE_TEAM,
    ON_EDIT_OFFICE,ON_EDIT_TEAM,
    ON_SAVE_NEW_USER,
    ON_EDIT_USER_BASIC,
    ON_START_EDIT_USER_BASIC,
    ON_SEARCH_KUND,
    ON_START_SEARCH_KUND,
    ON_ERROR_SEARCH_KUND,
    ON_FETCH_KUND_BASIC,ON_START_FETCH_KUND_BASIC,ON_ERROR_FETCH_KUND_BASIC,
    ON_START_FETCH_KUND_BASIC_NOMESSAGE,ON_FETCH_KUND_BASIC_NOMESSAGE,ON_START_FETCH_KUND_BASIC_REST,
    ON_AKTIVE_KUND, ON_START_AKTIVE_KUND,ON_ERROR_AKTIVE_KUND,ON_INAKTIVE_KUND,ON_START_INAKTIVE_KUND,
    ON_DELETE_KUND_ANSVARIG,
    ON_START_DELETE_KUND_ANSVARIG,
    ON_ERROR_DELETE_KUND_ANSVARIG,
    ON_NEW_KUND_ANSVARIG,
    ON_START_NEW_KUND_ANSVARIG,
    ON_ERROR_NEW_KUND_ANSVARIG,
    ON_DELETE_KUND_TAG,
    ON_START_DELETE_KUND_TAG,
    ON_ERROR_DELETE_KUND_TAG,
    ON_NEW_KUND_TAG,
    ON_START_NEW_KUND_TAG,
    ON_ERROR_NEW_KUND_TAG,
    ON_START_CREATE_HANDELSE,ON_CREATE_HANDELSE, ON_ERROR_CREATE_HANDELSE,
    ON_FETCH_KUND_HANDELSER,ON_ERROR_FETCH_KUND_HANDELSER,ON_START_FETCH_KUND_HANDELSER,
    ON_START_FETCH_CURRENT_HANDELSE,ON_FETCH_CURRENT_HANDELSE,ON_ERROR_FETCH_CURRENT_HANDELSE,
    ON_FETCH_CURRENT_HANDELSE_NEW_TEXT,ON_ERROR_FETCH_CURRENT_HANDELSE_NEW_TEXT,ON_START_FETCH_CURRENT_HANDELSE_NEW_TEXT,
    ON_DELETE_CURRENT_HANDELSE,ON_ERROR_DELETE_CURRENT_HANDELSE,ON_START_DELETE_CURRENT_HANDELSE,
    ON_START_NEW_KUND_KONTAKT,ON_NEW_KUND_KONTAKT,ON_ERROR_NEW_KUND_KONTAKT,
    ON_START_EDIT_KUND_KONTAKT,ON_EDIT_KUND_KONTAKT,ON_ERROR_EDIT_KUND_KONTAKT,
    ON_START_DELETE_KUND_KONTAKT,
    ON_DELETE_KUND_KONTAKT,
    ON_ERROR_DELETE_KUND_KONTAKT,
    ON_START_EDIT_KUND_INFO,
    ON_EDIT_KUND_INFO,
    ON_ERROR_EDIT_KUND_INFO,
    ON_START_NEW_LEVERANTOR,
    ON_ERROR_NEW_LEVERANTOR,
    ON_NEW_LEVERANTOR,
    ON_START_DELETE_LEVERANTOR,
    ON_ERROR_DELETE_LEVERANTOR,
    ON_DELETE_LEVERANTOR,
    ON_START_NEW_TYPE,
    ON_ERROR_NEW_TYPE,
    ON_NEW_TYPE,
    ON_START_DELETE_TYPE,
    ON_DELETE_TYPE,
    ON_ERROR_DELETE_TYPE,
    ON_START_UPDATE_TYPE,
    ON_UPDATE_TYPE,
    ON_ERROR_UPDATE_TYPE,
    ON_START_NEW_KALKYL,
    ON_NEW_KALKYL,
    ON_ERROR_NEW_KALKYL,
    ON_START_DELETE_KALKYL,
    ON_DELETE_KALKYL,
    ON_ERROR_DELETE_KALKYL,
    ON_START_UPDATE_KALKYL,
    ON_UPDATE_KALKYL,
    ON_ERROR_UPDATE_KALKYL,
    ON_START_NEW_SCHABLON,
    ON_NEW_SCHABLON,
    ON_ERROR_NEW_SCHABLON,
    ON_START_DELETE_SCHABLON,
    ON_DELETE_SCHABLON,
    ON_ERROR_DELETE_SCHABLON,
    ON_START_UPDATE_SCHABLON,
    ON_UPDATE_SCHABLON,
    ON_ERROR_UPDATE_SCHABLON,
    
 ON_START_GET_PROJEKT_FAS_LIST,
 ON_GET_PROJEKT_FAS_LIST,
 ON_ERROR_GET_PROJEKT_FAS_LIST,
    ON_START_GET_SCHABLON,
    ON_GET_SCHABLON,
    ON_ERROR_GET_SCHABLON,
    ON_START_NEW_SCHABLON_PRESET,
    ON_NEW_SCHABLON_PRESET,
    ON_ERROR_NEW_SCHABLON_PRESET,
    ON_START_DELETE_SCHABLON_PRESET,
    ON_DELETE_SCHABLON_PRESET,
    ON_ERROR_DELETE_SCHABLON_PRESET,
    ON_START_UPDATE_SCHABLON_PRESET,
    ON_UPDATE_SCHABLON_PRESET,
    ON_ERROR_UPDATE_SCHABLON_PRESET,

    
    ON_START_NEW_PROJEKT_FAS_VIEW,
    ON_NEW_PROJEKT_FAS_VIEW,
    ON_ERROR_NEW_PROJEKT_FAS_VIEW,
    ON_START_DELETE_PROJEKT_FAS_VIEW,
    ON_DELETE_PROJEKT_FAS_VIEW,
    ON_ERROR_DELETE_PROJEKT_FAS_VIEW,
    ON_START_UPDATE_PROJEKT_FAS_VIEW,
    ON_UPDATE_PROJEKT_FAS_VIEW,
    ON_ERROR_UPDATE_PROJEKT_FAS_VIEW,

    ON_START_RESET_SCHABLON,
    ON_RESET_SCHABLON,
    ON_ERROR_RESET_SCHABLON,
    ON_START_FETCH_KUND_KONTAKT,
    ON_FETCH_KUND_KONTAKT,
    ON_ERROR_FETCH_KUND_KONTAKT,
    ON_START_NEW_FAS,
    ON_NEW_FAS,
    ON_ERROR_NEW_FAS,
    ON_START_DELETE_FAS,
    ON_DELETE_FAS,
    ON_ERROR_DELETE_FAS,
    ON_UPDATE_FAS,
    ON_START_UPDATE_FAS,
    ON_ERROR_UPDATE_FAS,
    ON_GET_AVTPRO_BY_ORGNR,
    ON_START_GET_AVTPRO_BY_ORGNR,
    ON_ERROR_GET_AVTPRO_BY_ORGNR,
    ON_START_NEW_KUNDDATA,
    ON_NEW_KUNDDATA,
    ON_ERROR_NEW_KUNDDATA,
    ON_START_GET_KUNDDATA_BY_AVTAL,
    ON_GET_KUNDDATA_BY_AVTAL,
    ON_ERROR_GET_KUNDDATA_BY_AVTAL,
    ON_START_DELETE_KUNDDATA,
    ON_DELETE_KUNDDATA,
    ON_ERROR_DELETE_KUNDDATA,
    ON_START_UPDATE_KUNDDATA,
    ON_UPDATE_KUNDDATA,
    ON_ERROR_UPDATE_KUNDDATA,
    ON_START_KONTO_INFO_UPDATE,
    ON_KONTO_INFO_UPDATE,
    ON_ERROR_KONTO_INFO_UPDATE,
    ON_START_UPDATE_MODULE,
    ON_UPDATE_MODULE,ON_UPDATE_MODULE_DONT_UPDATE,
    ON_ERROR_UPDATE_MODULE,
    ON_START_NEW_ORDER_EMAIL,
    ON_NEW_ORDER_EMAIL,
    ON_ERROR_NEW_ORDER_EMAIL,
    ON_START_DELETE_ORDER_EMAIL,
    ON_DELETE_ORDER_EMAIL,
    ON_ERROR_DELETE_ORDER_EMAIL,
    ON_START_MINA_KUNDER, ON_MINA_KUNDER,ON_ERROR_MINA_KUNDER,
    ON_START_MINA_KUNDER_NOMESSAGE,ON_MINA_KUNDER_NOMESSAGE,
    ON_START_MINA_KUNDER_CLOSE_TO,
    ON_MINA_KUNDER_CLOSE_TO,
    ON_ERROR_MINA_KUNDER_CLOSE_TO,
    ON_START_MINA_KONTAKTPERSONER,ON_MINA_KONTAKTPERSONER,ON_ERROR_MINA_KONTAKTPERSONER,
    ON_START_MINA_KONTAKTPERSONER_NOMESSAGE,ON_MINA_KONTAKTPERSONER_NOMESSAGE,
    ON_START_GET_DOC_ORGNR,ON_GET_DOC_ORGNR,ON_GET_DOC_ORGNR_0, ON_ERROR_GET_DOC_ORGNR,
    ON_START_GET_DOC_ORGNR_PDF,ON_GET_DOC_ORGNR_PDF,ON_ERROR_GET_DOC_ORGNR_PDF,
    ON_START_IMPORT_FUNC,
    ON_IMPORT_FUNC,
    ON_ERROR_IMPORT_FUNC,
    ON_START_BESTALLA_ESIGN,
    ON_BESTALLA_ESIGN,
    ON_ERROR_BESTALLA_ESIGN,
    ON_START_INSERT_TILLGODO_KUND, ON_INSERT_TILLGODO_KUND, ON_ERROR_INSERT_TILLGODO_KUND,
    ON_START_GET_TILLGODO_KUND,ON_FETCH_TILLGODO_KUND,ON_ERROR_TILLGODO_KUND,
    ON_START_UPDATE_ORDER_FALT, ON_UPDATE_ORDER_FALT, ON_ERROR_UPDATE_ORDER_FALT,
    ON_START_DELETE_ORDER_FALT, ON_DELETE_ORDER_FALT, ON_ERROR_DELETE_ORDER_FALT,
    ON_START_UPDATE_PROSPEKT_FALT, ON_UPDATE_PROSPEKT_FALT, ON_ERROR_UPDATE_PROSPEKT_FALT,
    ON_START_DELETE_PROSPEKT_FALT, ON_DELETE_PROSPEKT_FALT, ON_ERROR_DELETE_PROSPEKT_FALT,
    ON_START_NEW_ORDER_FALT, ON_NEW_ORDER_FALT, ON_ERROR_ORDER_FALT,
    ON_START_NEW_PROSPEKT_FALT, ON_NEW_PROSPEKT_FALT, ON_ERROR_PROSPEKT_FALT,
    ON_START_GET_DASHBORAD_OBJEKT,ON_FETCH_DASHBORAD_OBJEKT,ON_ERROR_DASHBORAD_OBJEKT,
    ON_START_GET_DASHBORAD_LOOP_OBJEKT,ON_FETCH_DASHBORAD_LOOP_OBJEKT,ON_ERROR_DASHBORAD_LOOP_OBJEKT,
    ON_START_GENERATE_DASHBORAD_LINK, ON_GENERATE_DASHBORAD_LINK, ON_ERROR_GENERATE_DASHBORAD_LINK,
    ON_START_GET_AF_ESIGNERING,ON_GET_AF_ESIGNERING,ON_ERROR_GET_AF_ESIGNERING,
    ON_START_SAVE_ESIGN,ON_SAVE_ESIGN,ON_ERROR_SAVE_ESIGN,
    ON_START_GET_OLD_AF,ON_GET_OLD_AF,ON_ERROR_GET_OLD_AF,
    ON_START_GET_OLD_AF_USER,ON_GET_OLD_AF_USER,ON_ERROR_GET_OLD_AF_USER,
    ON_START_SYNC_USER,ON_SYNC_USER,ON_ERROR_SYNC_USER,
    ON_OPEN_FILTER_AVTAL,ON_OPEN_FILTER_PROSPEKT,ON_OPEN_FILTER_AKTIVITETER,ON_OPEN_FILTER_KUNDER,
    ON_OPEN_FILTER_ESIGNERING,ON_OPEN_FILTER_ORDER,ON_OPEN_FILTER_MOTE,
    ON_ClOSE_FILTER_AVTAL,ON_ClOSE_FILTER_PROSPEKT,ON_ClOSE_FILTER_AKTIVITETER,ON_ClOSE_FILTER_KUNDER,
    ON_ClOSE_FILTER_ORDER,ON_ClOSE_FILTER_MOTE,ON_ClOSE_FILTER_ESIGNERING,
    ON_START_FLAGA_HANDELSE,ON_FLAGA_HANDELSE,ON_ERROR_FLAGA_HANDELSE,
    ON_START_SEARCH_KUND_BASIC,ON_SEARCH_KUND_BASIC,ON_ERROR_SEARCH_KUND_BASIC,
    ON_START_GET_NEW_KUND_BASIC, ON_GET_NEW_KUND_BASIC, ON_ERROR_GET_NEW_KUND_BASIC,
 //   ON_START_GET_NEW_KUND_TOOLTIP_DETAILS, ON_GET_NEW_KUND_TOOLTIP_DETAILS, ON_ERROR_GET_NEW_KUND_TOOLTIP_DETAILS,
    ON_START_NEW_KUND,ON_NEW_KUND,ON_ERROR_NEW_KUND,
    ON_START_GET_NOTIS,ON_GET_NOTIS,ON_ERROR_GET_NOTIS,
    ON_START_NEW_UTOKNING, ON_NEW_UTOKNING, ON_ERROR_NEW_UTOKNING,
    ON_START_NEW_FALT, ON_NEW_FALT, ON_ERROR_NEW_FALT,
    ON_START_GET_UTOKNING,ON_GET_UTOKNING,ON_ERROR_GET_UTOKNING,
    ON_START_GET_UTOKNING_KUND_LIST_BY_TYPE,
    ON_GET_UTOKNING_KUND_LIST_BY_TYPE,
    ON_ERROR_GET_UTOKNING_KUND_LIST_BY_TYPE,
    ON_START_DELETE_FALT, ON_DELETE_FALT, ON_ERROR_DELETE_FALT,
    ON_START_SAVE_FALT, ON_SAVE_FALT, ON_ERROR_SAVE_FALT,
    ON_SAVE_KONTO_OBJECT,ON_ARCHIVE_KONTO_OBJECT,
    ON_START_DELETE_KALK_TEMP_ROW,
    ON_DELETE_KALK_TEMP_ROW,
    ON_ERROR_DELETE_KALK_TEMP_ROW,
    ON_START_ADD_KALK_TEMP_ROW,
    ON_ADD_KALK_TEMP_ROW,
    ON_ERROR_ADD_KALK_TEMP_ROW,
    ON_START_UPDATE_KALK_TEMP_ROW,
    ON_UPDATE_KALK_TEMP_ROW,
    ON_ERROR_UPDATE_KALK_TEMP_ROW,
    ON_START_KUND_NEW_UTOKNING, ON_KUND_NEW_UTOKNING, ON_ERROR_KUND_NEW_UTOKNING,
    ON_START_GET_UTOKNING_BY_ORGNR,ON_GET_UTOKNING_BY_ORGNR,ON_ERROR_UTOKNING_BY_ORGNR,
    ON_START_SAVE_UTOKNING_DESC_BY_ORGNR, ON_SAVE_UTOKNING_DESC_BY_ORGNR, ON_ERROR_SAVE_UTOKNING_DESC_BY_ORGNR,
    ON_START_GET_UTOKNING_DESC_BY_ORGNR, ON_GET_UTOKNING_DESC_BY_ORGNR, ON_ERROR_GET_UTOKNING_DESC_BY_ORGNR,
    ON_START_GET_UTOKNING_LIST_BY_ORGNR,ON_GET_UTOKNING_LIST_BY_ORGNR,ON_ERROR_UTOKNING_LIST_BY_ORGNR,
    ON_START_DELETE_UTOKNING_BY_ORGNR, ON_DELETE_UTOKNING_BY_ORGNR, ON_ERROR_DELETE_UTOKNING_BY_ORGNR,
    ON_START_KUND_UPDATE_UTOKNING, ON_KUND_UPDATE_UTOKNING, ON_ERROR_KUND_UPDATE_UTOKNING,
    ON_START_NEW_AFID_KEDJA, ON_NEW_AFID_KEDJA, ON_ERROR_NEW_AFID_KEDJA,
    ON_DELETE_AFID_KEDJA,ON_START_DELETE_AFID_KEDJA,ON_ERROR_DELETE_AFID_KEDJA,
    ON_UPDATE_AFID_KEDJA,ON_START_UPDATE_AFID_KEDJA,ON_ERROR_UPDATE_AFID_KEDJA,
    SET_KUNDER_FILTER,SET_PROSPEKT_FILTER,SET_AVTAL_FILTER,SET_EVENT_FILTER,
    ON_START_GET_AF_DIALER,ON_GET_AF_DIALER,ON_ERROR_GET_AF_DIALER,
    ON_START_GET_USER_DIALER,ON_GET_USER_DIALER,ON_ERROR_GET_USER_DIALER,
    ON_START_SAVE_USER_DIALER, ON_SAVE_USER_DIALER, ON_ERROR_SAVE_USER_DIALER,
    ON_START_SAVE_DIALER, ON_SAVE_DIALER, ON_ERROR_SAVE_DIALER,
    ON_START_DIALER_ADD_EJSVAR, ON_DIALER_ADD_EJSVAR, ON_ERROR_DIALER_ADD_EJSVAR,
    ON_START_DIALER_ADD_NEJTACK, ON_DIALER_ADD_NEJTACK, ON_ERROR_DIALER_ADD_NEJTACK,
    ON_START_ADD_DOCUMENT, ON_ADD_DOCUMENT, ON_ERROR_ADD_DOCUMENT,
    ON_START_SYNC_DOCUMENT_ONEDRIVE, ON_SYNC_DOCUMENT_ONEDRIVE, ON_ERROR_SYNC_DOCUMENT_ONEDRIVE,
    ON_DIALER_DELETE_NEJTACK,ON_DIALER_DELETE_EJSVAR,
    SET_ESIGNERING_FILTER,SET_DASHBORD_FILTER,SET_ORDER_FILTER,
    ON_ClOSE_FILTER_DASHBOARD_SALJ,ON_OPEN_FILTER_DASHBOARD_SALJ,
    ON_ClOSE_FILTER_DASHBOARD,ON_OPEN_FILTER_DASHBOARD,ON_OPEN_FILTER_ARENDE,ON_ClOSE_FILTER_ARENDE,ON_OPEN_FILTER_OFFERT,ON_OPEN_FILTER_PROJEKT,ON_ClOSE_FILTER_ARTIKLAR,
    ON_ClOSE_FILTER_OFFERT,
    ON_START_FETCH_ADMIN_STATISTIK,ON_FETCH_ADMIN_STATISTIK,ON_ERROR_ADMIN_STATISTIK,
    ON_START_FETCH_RAPPORT,ON_FETCH_RAPPORT,ON_ERROR_FETCH_RAPPORT,
    ON_FETCH_RAPPORT_MESSAGE,ON_ERROR_FETCH_RAPPORT_MESSAGE,
    ON_START_FETCH_MINATAG,ON_FETCH_MINATAG,ON_ERROR_MINATAG,
    ON_START_DELETE_KUND_DOCUMENT, ON_DELETE_KUND_DOCUMENT, ON_ERROR_DELETE_KUND_DOCUMENT,
    ON_START_GET_DASHBORAD_LINK,ON_FETCH_DASHBORAD_LINK,ON_ERROR_DASHBORAD_LINK,
    ON_START_GET_UTOKNING_BY_AFID,
    ON_START_UPDATE_KUND_UTOKNING_BY_AFID,
    ON_ERROR_UPDATE_KUND_UTOKNING_BY_AFID,
    ON_UPDATE_KUND_UTOKNING_BY_AFID,
    ON_GET_UTOKNING_BY_AFID,
    ON_CACHE_UTOKNING_BY_AFID,
    ON_LOAD_CACHE_UTOKNING_BY_AFID,
    SET_AKTIVITETER_FILTER,
    SET_ARENDE_FILTER,
    SET_OFFERT_FILTER,
    SET_PROJEKT_FILTER,
    SET_PROJEKTKORT_FILTER,
    ON_ERROR_UTOKNING_BY_AFID,
    ON_START_SEARCH_UTOKNING_BY_AFID,
    ON_ERROR_SEARCH_UTOKNING_BY_AFID,
    ON_SEARCH_UTOKNING_BY_AFID,
    ON_START_GET_UTOKNING_LOGG,
    ON_ERROR_GET_UTOKNING_LOGG,
    ON_GET_UTOKNING_LOGG,
    ON_START_BUFFER_UTOKNING_BY_AFID,
    ON_BUFFER_UTOKNING_BY_AFID,
    ON_ClOSE_FILTER_PROJEKT,
    ON_OPEN_FILTER_PROJEKTKORT,
    ON_ClOSE_FILTER_PROJEKTKORT,ON_ClOSE_FILTER_DASHBOARD_DIALER,
    ON_ClOSE_FILTER_DASHBOARD_BOKA,ON_OPEN_FILTER_DASHBOARD_BOKA,SET_DASHBORD_BOKA_FILTER,
    SET_DASHBORD_DIALER_FILTER,ON_OPEN_FILTER_DASHBOARD_DIALER,SET_DASHBORD_ANPASSAD_FILTER,
    SET_DASHBORD_ORDER_FILTER,ON_OPEN_FILTER_DASHBOARD_ORDER,ON_ClOSE_FILTER_DASHBOARD_ORDER,
    ON_RESET_CURRENT_OBJEKT_FALT, ON_OPEN_FILTER_ARTIKLAR,SET_ARTIKLAR_FILTER,
    SET_USERS_FILTER,SET_SMSS_FILTER,SET_CAMPAIGN_FILTER,
    ON_OPEN_FILTER_USERS,ON_ClOSE_FILTER_USERS,
    ON_OPEN_FILTER_SMSS,ON_ClOSE_FILTER_SMSS,
    ON_OPEN_FILTER_CAMPAIGN,ON_ClOSE_FILTER_CAMPAIGN,
    ON_START_CONNECT_WOOCOMMERCE, ON_CONNECT_WOOCOMMERCE, ON_ERROR_CONNECT_WOOCOMMERCE,
    ON_START_GET_WOOCOMMERCE, ON_GET_WOOCOMMERCE, ON_ERROR_GET_WOOCOMMERCE,
    ON_START_DISCONNECT_WOOCOMMERCE, ON_DISCONNECT_WOOCOMMERCE, ON_ERROR_DISCONNECT_WOOCOMMERCE,
    ON_START_SYNC_WOOCOMMERCE_CUSTOMERS, ON_SYNC_WOOCOMMERCE_CUSTOMERS,ON_ERROR_SYNC_WOOCOMMERCE_CUSTOMERS,
    ON_START_CREATE_WOOCOMMERCE_CUSTOMER, ON_CREATE_WOOCOMMERCE_CUSTOMER,ON_ERROR_CREATE_WOOCOMMERCE_CUSTOMER,
    ON_START_CONNECT_WOOCOMMERCE_CUSTOMER, ON_CONNECT_WOOCOMMERCE_CUSTOMER,ON_ERROR_CONNECT_WOOCOMMERCE_CUSTOMER,
    ON_START_DISCONNECT_WOOCOMMERCE_CUSTOMER, ON_DISCONNECT_WOOCOMMERCE_CUSTOMER,ON_ERROR_DISCONNECT_WOOCOMMERCE_CUSTOMER,
    ON_START_GET_WOOCOMMERCE_CUSTOMER, ON_GET_WOOCOMMERCE_CUSTOMER,ON_ERROR_GET_WOOCOMMERCE_CUSTOMER,
    ON_START_UPDATE_WOOCOMMERCE, ON_UPDATE_WOOCOMMERCE, ON_ERROR_UPDATE_WOOCOMMERCE,
    ON_START_CONNECT_WOOCOMMERCE_WP_REST,
    ON_CONNECT_WOOCOMMERCE_WP_REST,
    ON_ERROR_CONNECT_WOOCOMMERCE_WP_REST,
    ON_ERROR_DISCONNECT_WOOCOMMERCE_WP_REST,
    ON_START_DISCONNECT_WOOCOMMERCE_WP_REST,
    ON_DISCONNECT_WOOCOMMERCE_WP_REST,

    ON_START_CONNECT_BITLOG_REST,
    ON_CONNECT_BITLOG_REST,
    ON_ERROR_CONNECT_BITLOG_REST,
    ON_ERROR_DISCONNECT_BITLOG_REST,
    ON_START_DISCONNECT_BITLOG_REST,
    ON_DISCONNECT_BITLOG_REST,

    ON_START_ADD_WOOCOMMERCE_WEBHOOK,
    ON_ADD_WOOCOMMERCE_WEBHOOK,
    ON_ERROR_ADD_WOOCOMMERCE_WEBHOOK,
    ON_START_GET_WOOCOMMERCE_WEBHOOK,
    ON_GET_WOOCOMMERCE_WEBHOOK,
    ON_ERROR_GET_WOOCOMMERCE_WEBHOOK,
    ON_START_DELETE_WOOCOMMERCE_WEBHOOK,
    ON_DELETE_WOOCOMMERCE_WEBHOOK,
    ON_ERROR_DELETE_WOOCOMMERCE_WEBHOOK,
    ON_START_FETCH_WP_WOOCOMMERCE_WEBHOOK,
    ON_FETCH_WP_WOOCOMMERCE_WEBHOOK,
    ON_ERROR_FETCH_WP_WOOCOMMERCE_WEBHOOK,

    ON_GET_WHOLESALESUTIE_ROLES,
    ON_START_GET_WHOLESALESUTIE_ROLES,
    ON_ERROR_GET_WHOLESALESUTIE_ROLES,
    ON_CONNECT_WHOLESALESUTIE_ROLES_AFID_LIST,
    ON_START_CONNECT_WHOLESALESUTIE_ROLES_AFID_LIST,
    ON_ERROR_CONNECT_WHOLESALESUTIE_ROLES_AFID_LIST,
    ON_CREATE_WHOLESALESUTIE_ROLES_AFID_LIST,
    ON_START_CREATE_WHOLESALESUTIE_ROLES_AFID_LIST,
    ON_ERROR_CREATE_WHOLESALESUTIE_ROLES_AFID_LIST,

    ON_START_GET_PYRAMID, 
    ON_GET_PYRAMID, 
    ON_ERROR_GET_PYRAMID, 
    ON_START_CONNECT_PYRAMID, 
    ON_CONNECT_PYRAMID, 
    ON_ERROR_CONNECT_PYRAMID, 
    ON_START_DISCONNECT_PYRAMID, 
    ON_DISCONNECT_PYRAMID, 
    ON_ERROR_DISCONNECT_PYRAMID, 
    ON_START_UPDATE_PYRAMID, 
    ON_UPDATE_PYRAMID,
    ON_ERROR_UPDATE_PYRAMID, 

    ON_START_CREATE_PYRAMID_CUSTOMER,
    ON_CREATE_PYRAMID_CUSTOMER,
    ON_ERROR_CREATE_PYRAMID_CUSTOMER,
    ON_START_CONNECT_PYRAMID_CUSTOMER,
    ON_CONNECT_PYRAMID_CUSTOMER,
    ON_ERROR_CONNECT_PYRAMID_CUSTOMER,
    ON_START_DISCONNECT_PYRAMID_CUSTOMER,
    ON_DISCONNECT_PYRAMID_CUSTOMER,
    ON_ERROR_DISCONNECT_PYRAMID_CUSTOMER,
    ON_START_GET_PYRAMID_CUSTOMER,
    ON_GET_PYRAMID_CUSTOMER,
    ON_ERROR_GET_PYRAMID_CUSTOMER,

    ON_START_CREATE_PYRAMID_CONTACT,
    ON_CREATE_PYRAMID_CONTACT,
    ON_ERROR_CREATE_PYRAMID_CONTACT,
    ON_START_CONNECT_PYRAMID_CONTACT,
    ON_CONNECT_PYRAMID_CONTACT,
    ON_ERROR_CONNECT_PYRAMID_CONTACT,
    ON_START_DISCONNECT_PYRAMID_CONTACT,
    ON_DISCONNECT_PYRAMID_CONTACT,
    ON_ERROR_DISCONNECT_PYRAMID_CONTACT,
    ON_START_GET_PYRAMID_CONTACT,
    ON_GET_PYRAMID_CONTACT,
    ON_ERROR_GET_PYRAMID_CONTACT,

    ON_START_ADD_NEW_TAG_EVENT,
    ON_ADD_NEW_TAG_EVENT,
    ON_ERROR_ADD_NEW_TAG_EVENT,
    ON_START_ADD_NEW_TAG, ON_ADD_NEW_TAG, ON_ERROR_ADD_NEW_TAG,
    ON_START_REMOVE_TAG_FROM_SOURCE,
    ON_REMOVE_TAG_FROM_SOURCE,
    ON_ERROR_REMOVE_TAG_FROM_SOURCE,
    ON_START_REMOVE_TAG_FROM_ACCOUNT,
    ON_REMOVE_TAG_FROM_ACCOUNT,
    ON_ERROR_REMOVE_TAG_FROM_ACCOUNT,
    ON_START_UPDATE_TAG_FROM_ACCOUNT,
    ON_UPDATE_TAG_FROM_ACCOUNT,
    ON_ERROR_UPDATE_TAG_FROM_ACCOUNT,
    ON_START_STATISTIC_TOTALORDER,GET_STATISTIC_TOTALORDER,ERROR_STATISTIC_TOTALORDER,
    ON_START_STATISTIC_TOTALMOTEN,GET_STATISTIC_TOTALMOTE,ERROR_STATISTIC_TOTALMOTE,
    ON_START_STATISTIC_TOTALAKTIVITETER, GET_STATISTIC_TOTALAKTIVITETER, ERROR_STATISTIC_TOTALAKTIVITETER,
    ON_START_STATISTIC_TOTALOFFERT,GET_STATISTIC_TOTALOFFERT,ERROR_STATISTIC_TOTALOFFERT,
    ON_START_STATISTIC_LOPANDEINTAKT_TOTAL, GET_STATISTIC_LOPANDEINTAKT_TOTAL, ERROR_STATISTIC_LOPANDEINTAKT_TOTAL,
    ON_START_STATISTIC_ORDERTYP_TOTAL, GET_STATISTIC_ORDERTYP_TOTAL, ERROR_STATISTIC_ORDERTYP_TOTAL,
    ON_START_STATISTIC_SALES_TOTAL, GET_STATISTIC_SALES_TOTAL, ERROR_STATISTIC_SALES_TOTAL,
    ON_START_CREATE_API_TOKEN,
    ON_ERROR_CREATE_API_TOKEN,
    ON_CREATE_API_TOKEN,
    ON_START_REVOKE_API_TOKEN,
    ON_ERROR_REVOKE_API_TOKEN,
    ON_REVOKE_API_TOKEN,
    GET_AF_BUDGET_WORK_DAYS,
    

    ON_START_FETCH_VALID_REST_API_TOKEN,
    ON_ERROR_FETCH_VALID_REST_API_TOKEN,
    ON_FETCH_VALID_REST_API_TOKEN,

    ON_START_GET_AF_NOTIS,
    ON_GET_AF_NOTIS,
    ON_ERROR_GET_AF_NOTIS,
    ON_START_SET_AF_NOTIS_SEEN,
    ON_SET_AF_NOTIS_SEEN,
    ON_ERROR_SET_AF_NOTIS_SEEN,
    ON_START_ADD_AF_NOTIS,
    ON_ADD_AF_NOTIS,
    ON_ERROR_ADD_AF_NOTIS,

    ON_START_ADD_NEW_DISTRIKT,
    ON_ERROR_ADD_NEW_DISTRIKT,
    ON_ADD_NEW_DISTRIKT,

    ON_START_UPDATE_DISTRIKT,
    ON_ERROR_UPDATE_DISTRIKT,
    ON_UPDATE_DISTRIKT,

    ON_START_DELETE_DISTRIKT,
    ON_ERROR_DELETE_DISTRIKT,
    ON_DELETE_DISTRIKT,

    ON_START_GET_DISTRIKT,
    ON_ERROR_GET_DISTRIKT,
    ON_GET_DISTRIKT,
    ON_START_GET_MINA_DISTRIKT_POSTNR,
    ON_ERROR_GET_MINA_DISTRIKT_POSTNR,
    ON_GET_MINA_DISTRIKT_POSTNR,
    ON_GET_AKTIVAKUND_KONTAKTER,
    ON_START_GET_AKTIVAKUND_KONTAKTER,
    ON_ERROR_GET_AKTIVAKUND_KONTAKTER,

    ON_GET_ONEDRIVE_ROOT,
    ON_ERROR_GET_ONEDRIVE_ROOT,
    ON_START_GET_ONEDRIVE_ROOT,
    ON_GET_MY_DRIVES,
    ON_ERROR_GET_MY_DRIVES,
    ON_START_GET_MY_DRIVES,
    ON_ADD_ONEDRIVE_ROOT,
    ON_ERROR_ADD_ONEDRIVE_ROOT,
    ON_START_ADD_ONEDRIVE_ROOT,

    ON_START_FETCH_LYNES_SAMTAL_HISTORY,
    ON_FETCH_LYNES_SAMTAL_HISTORY,
    ON_ERROR_LYNES_SAMTAL_HISTORY,
    
    ON_START_CONNECT_ZENDESK,
    ON_CONNECT_ZENDESK,
    ON_ERROR_CONNECT_ZENDESK,
    ON_START_DISCONNECT_ZENDESK,
    ON_DISCONNECT_ZENDESK,
    ON_ERROR_DISCONNECT_ZENDESK,
    ON_GET_ZENDESK,
    ON_ERROR_GET_ZENDESK,
    ON_START_GET_ZENDESK,
    ON_SET_CURRENT_AVTAL_ANTAL_FRIA,

    ON_START_GET_THIS_DISTRIKT,
    ON_ERROR_GET_THIS_DISTRIKT,
    ON_GET_THIS_DISTRIKT,
    FETCH_START_SET_UNAUTHE,
    
    ON_ADD_AUTH_MAIL_DOMAIN,
    ON_ERROR_ADD_AUTH_MAIL_DOMAIN,
    ON_START_ADD_AUTH_MAIL_DOMAIN,
    ON_GET_AUTH_MAIL_DOMAIN,
    ON_ERROR_GET_AUTH_MAIL_DOMAIN,
    ON_START_GET_AUTH_MAIL_DOMAIN,
    ON_REMOVE_AUTH_MAIL_DOMAIN,
    ON_ERROR_REMOVE_AUTH_MAIL_DOMAIN,
    ON_START_REMOVE_AUTH_MAIL_DOMAIN,
    ON_VALIDATE_AUTH_MAIL_DOMAIN,
    ON_ERROR_VALIDATE_AUTH_MAIL_DOMAIN,
    ON_START_VALIDATE_AUTH_MAIL_DOMAIN,
    
    } from "../constants/ActionTypes";
  import axios from 'util/Api'
  import axiosOld from 'util/ApiOld'
  import { history } from "store";
  import {isUndefined,isEmpty} from 'lodash'
  import fileSaver from 'file-saver' 
  import {userSignOut,checkisExpired} from 'actions'
  import fileDownload from 'react-file-download';
  import {getMyUser,getMyUserProfilePic}  from './Auth'
  import { translate } from "../util/intlHelper";
  import {RefreshUserInterface,getProspektByUserid1,getAktivitetByUserID1, loadAktivaArtiklar} from 'actions'


  const setInitUrl = (url) => {
    return {
      type: INIT_URL,
      payload: url
    };
  };
   const showAuthMessage = (message) => {
    return {
        type: SHOW_MESSAGE,
        payload: message
    };
  };
 

  const getClientIp = async () => {
    let Ipadress='0.0.0.0'
   /* await fetch('https://geolocation-db.com/json/d802faa0-10bd-11ec-b2fe-47a0872c6708')
      .then(response => response.json())
      .then(data => {console.log(data)
        Ipadress= data.IPv4 || "0.0.0.0"
      });*/
       return Ipadress
  }

  export const setUserProfilePic = (Userid, Afid, OldImagePath, image) => {
    
    return (dispatch) => { 
      const jwt =  JSON.parse(localStorage.token);
      const formData = new FormData()
      // var pages = new Blob([offert.Pages], { type: 'application/json' });
      const ipAdress='0.0.0.0'

      // const files = [file, pages]

      formData.append('files[]', image)
      formData.append('Userid', Userid)
      formData.append('Afid', Afid)
      formData.append('OldImagePath', OldImagePath)

      axios.put('kontos/setUserProfilePic',
        formData,
        {
          body: {
            Userid,
            Afid,
            OldImagePath,ipAdress
          },
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization':   `Bearer ${jwt}`
          }
        }
      ).then(({data}) => {
        dispatch(getMyUser(Userid,Afid))
        dispatch(getMyUserProfilePic(Userid))
        console.log(data)
      }).catch(err => {
        console.log(err)
      })
    }

  }
  export const removeUserProfilePic = (Userid, Afid, ImagePath) => {
    return (dispatch) => { 
      const jwt =  JSON.parse(localStorage.token);
      const ipAdress='0.0.0.0'
      axios.put('kontos/removeUserProfilePic',{
          method: 'PUT',
          headers: {
              'content-type': 'application/json',
              'Authorization':   `Bearer ${jwt}`
          },
          body: {
            Userid,
            Afid,
            ImagePath,ipAdress
          }
      }).then(({data}) => {
        dispatch(getMyUser(Userid,Afid))
        dispatch(getMyUserProfilePic(Userid))
        
        console.log(data)
      }).catch(err => {
        console.log(err)
      })
    }
  }
 
  //getKonton
export const getKonton = () =>{
   // console.log(JWT)
   const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: FETCH_ALL_CONTACT});
      axios.get('kontos',{
        headers: { 'Authorization': `Bearer ${jwt}`}
      }      
      ).then(({data}) => {
        console.log(data)
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: FETCH_ALL_CONTACT_SUCCESS, payload: data.results});
        } else {
          dispatch({type: FETCH_ACCOUNT_ERROR, payload: data.error});
        }
      }).catch(function (error) {
        
        dispatch({type: FETCH_ACCOUNT_ERROR, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
  }

  export const exportUsers = () => {
    const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      // dispatch({type: ON_START_FETCH_UTOKNING_RAPPORT})
      axios.get('konto/rapport',  { params:{
     }, 
      responseType: 'arraybuffer' ,
      headers: { 'Authorization': `Bearer ${jwt}`} } ).then((resp) => {
       // console.log(resp)
       const dirtyFileName = resp.headers['content-disposition'];
       const regex = /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/;
       var  fileName = dirtyFileName.match(regex)[3];
       var blob = new Blob([resp.data], 
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
      );
      fileSaver.saveAs(blob, fileName);
      // dispatch({type: ON_FETCH_UTOKNING_RAPPORT})
      }).catch(function (error) {
      //  dispatch({type: ON_ERROR_FETCH_UTOKNING_RAPPORT})
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
      });
    }
  }
  //Jack 2023-11-01 Rapport "Förändringar (billing)" från superadmin
  export const exportKontosrapport = () => {
    const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      // dispatch({type: ON_START_FETCH_UTOKNING_RAPPORT})
      axios.get('konto/Konto/rapport',  { params:{
     }, 
      responseType: 'arraybuffer' ,
      headers: { 'Authorization': `Bearer ${jwt}`} } ).then((resp) => {
       // console.log(resp)
       const dirtyFileName = resp.headers['content-disposition'];
       const regex = /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/;
       var  fileName = dirtyFileName.match(regex)[3];
       var blob = new Blob([resp.data], 
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
      );
      fileSaver.saveAs(blob, fileName);
      // dispatch({type: ON_FETCH_UTOKNING_RAPPORT})
      }).catch(function (error) {
      //  dispatch({type: ON_ERROR_FETCH_UTOKNING_RAPPORT})
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
      });
    }
  }
  //
  export const createKonto = (konto) =>{
    let Nykonto = {
      id: '',
      name: konto.name,
      Orgnr: konto.Orgnr,
      Role: konto.Role,
      Token: konto.Token,
      IsKedja:konto.IsKedja,
      ansvarig:konto.ansvarig,
    };
    const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: FETCH_START});
      axios.put('konto/new', {
        method: 'PUT',
        headers: {
            'content-type': 'application/json',
            'Authorization':   `Bearer ${jwt}`
        },
        body: JSON.stringify(Nykonto)
    })
    .then(({data}) => {
      console.log("Create New account: ", data.message);
      if (data.success) {
        console.log(data);
        dispatch({type: FETCH_SUCCESS});
        dispatch({type: ON_ADD_CONTACT, payload: data.Konto});
      } else {
        dispatch({type: FETCH_ACCOUNT_ERROR, payload: data.error});
      }
    })
    .catch(function (error) {
      dispatch({type: FETCH_ACCOUNT_ERROR, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
    });
    }
  }
  //updateStateKonto
  export const updateStateKonto = (konto) =>{
    //console.log(konto)
    const jwt = JSON.parse(localStorage.token);;
    return (dispatch) => {
      dispatch({type: FETCH_START});
      axios.put('konto/updatestatus', {
        body: JSON.stringify(konto),
      }, {
        headers: {
            'content-type': 'application/json',
            'Authorization':   `Bearer ${jwt}`
        }
    }).then(({data}) => {
      console.log("Update status account: ", data.message);
      if (data.success) {
        console.log(data);
        dispatch({type: FETCH_SUCCESS});
        dispatch({type: ON_Update_STATUS_CONTACT, payload: data});
      } else {
        dispatch({type: FETCH_ACCOUNT_ERROR, payload: data.error});
      }
    })
    .catch(function (error) {
      dispatch({type: FETCH_ACCOUNT_ERROR, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
    });
    }
  }
  //updateAnsvarigKonto
  export const updateAnsvarigKonto = (konto) =>{
    //console.log(konto)
    const jwt = JSON.parse(localStorage.token);;
    return (dispatch) => {
      dispatch({type: FETCH_START});
      axios.put('konto/updateAnsvarig', {
        body: JSON.stringify(konto)}, {
        headers: {
            'content-type': 'application/json',
            'Authorization':   `Bearer ${jwt}`
        }
    }).then(({data}) => {
      console.log("Update account: ", data.message);
      if (data.success) {
        console.log(data);
        dispatch({type: FETCH_SUCCESS});
        dispatch({type: ON_Update_ANSVARIG_CONTACT, payload: data});
      } else {
        dispatch({type: FETCH_ACCOUNT_ERROR, payload: data.error});
      }
    })
    .catch(function (error) {
      dispatch({type: FETCH_ACCOUNT_ERROR, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
    });
    }
  }
  //DeleteKonto
  export const DeleteKonto = (konto) =>{
    console.log(konto)
    const jwt = JSON.parse(localStorage.token);;
    return (dispatch) => {
      dispatch({type: FETCH_START});
      axios.delete('konto/delete', {
        method: 'DELETE',
        data: {body:JSON.stringify(konto)},
        headers: {
            'content-type': 'application/json',
            'Authorization':   `Bearer ${jwt}`
        }       
    }).then(({data}) => {
      console.log("Update status account: ", data.message);
      if (data.success) {
        console.log(data);
        dispatch({type: FETCH_SUCCESS});
        dispatch({type: ON_DELETE_CONTACT, payload: data});
      } else {
        dispatch({type: FETCH_ACCOUNT_ERROR, payload: data.error});
      }
    })
    .catch(function (error) {
      dispatch({type: FETCH_ACCOUNT_ERROR, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
    });
    }
  }
  //ON_FETCH_CONTACT_BY_ID
  export const getKontonByidRest = (_kontoid,userid) =>{
    const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: START_FETCH_CONTACT_BY_ID});
      axios.get('kontos/getKontonByidRest',
      { params:{kontoid:_kontoid,userid:userid}, 
       headers: { 'Authorization': `Bearer ${jwt}`} }
      )
      .then(({data}) => {
        if (data.results) {
          dispatch({type: ON_FETCH_CONTACT_BY_ID_REST, payload: data.results});
        }else {
          dispatch({type: FETCH_ACCOUNT_REST_ERROR, payload: data.error});
        }       
      })
      .catch(function (error) {
        dispatch({type: FETCH_ACCOUNT_REST_ERROR, payload:  error.message});
      })
    }
  }
  
  export const getKontonByidRest1 = (_kontoid,userid) =>{
    const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: START_FETCH_CONTACT1_BY_ID});
      axios.get('kontos/getKontonByidRest1',
      { params:{kontoid:_kontoid,userid:userid}, 
       headers: { 'Authorization': `Bearer ${jwt}`} }
      )
      .then(({data}) => {
        if (data.results) {
          dispatch({type: ON_FETCH_CONTACT1_BY_ID_REST, payload: data.results});
        }else {
          dispatch({type: FETCH_ACCOUNT_REST_ERROR, payload: data.error});
        }       
      })
      .catch(function (error) {
        dispatch({type: FETCH_ACCOUNT_REST_ERROR, payload:  error.message});
      })
    }
  }
  export const getKontonByidRest2 = (_kontoid,userid) =>{
    const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: START_FETCH_CONTACT2_BY_ID});
      axios.get('kontos/getKontonByidRest2',
      { params:{kontoid:_kontoid,userid:userid}, 
       headers: { 'Authorization': `Bearer ${jwt}`} }
      )
      .then(({data}) => {
        if (data.results) {
          dispatch({type: ON_FETCH_CONTACT2_BY_ID_REST, payload: data.results});
        }else {
          dispatch({type: FETCH_ACCOUNT_REST_ERROR, payload: data.error});
        }       
      })
      .catch(function (error) {
        dispatch({type: FETCH_ACCOUNT_REST_ERROR, payload:  error.message});
      })
    }
  }
  export const getKontonByidRest3 = (_kontoid,userid) =>{
    const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: START_FETCH_CONTACT3_BY_ID});
      axios.get('kontos/getKontonByidRest3',
      { params:{kontoid:_kontoid,userid:userid}, 
       headers: { 'Authorization': `Bearer ${jwt}`} }
      )
      .then(({data}) => {
        if (data.results) {
          dispatch({type: ON_FETCH_CONTACT3_BY_ID_REST, payload: data.results});
        }else {
          dispatch({type: FETCH_ACCOUNT_REST_ERROR, payload: data.error});
        }       
      })
      .catch(function (error) {
        dispatch({type: FETCH_ACCOUNT_REST_ERROR, payload:  error.message});
      })
    }
  }
  export const getKontonByid = (_kontoid,userid) =>{
    const jwt =  JSON.parse(localStorage.token);
     return (dispatch) => {
       dispatch({type: FETCH_ALL_CONTACT});
       axios.get('kontos/getKontonByid',{ params:{kontoid:_kontoid,userid:userid}, 
       headers: { 'Authorization': `Bearer ${jwt}`} }      
       ).then(({data}) => {
        console.log("getKontonByid: ", data);
         if (data.results) {
          // dispatch({type: FETCH_ALL_CONTACT});
           dispatch({type: ON_FETCH_CONTACT_BY_ID, payload: data.results});
           let prospektFilter =isUndefined(localStorage.ProspektFilter)?[]:JSON.parse(localStorage.ProspektFilter)
           let AktiviterFilter =isUndefined(localStorage.AktiviterFilter)?[]:JSON.parse(localStorage.AktiviterFilter)
           dispatch(getKontonByidRest(_kontoid,userid))
           dispatch(getKontonByidRest1(_kontoid,userid))
           dispatch(getKontonByidRest2(_kontoid,userid))
           dispatch(getKontonByidRest3(_kontoid,userid))
           dispatch(getProspektByUserid1(_kontoid,userid,0,prospektFilter))
           dispatch(getAktivitetByUserID1(userid,_kontoid,AktiviterFilter))
         } else {
           dispatch({type: FETCH_ACCOUNT_ERROR, payload: data.error});
           dispatch(userSignOut()) 
         }         
         dispatch(RefreshUserInterface(userid,1))
       }).catch(function (error) {
         dispatch({type: FETCH_ACCOUNT_ERROR, payload: error.message});
            if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
          if(error.message === "Request failed with status code 401"){
          dispatch(userSignOut())  
          }
       if(error.message === "Network Error"){
          //reload and remove token 
          dispatch(userSignOut())
       } 
       });
     }
   }
   
//getKontonFlagsById
export const getKontonFlagsById = (_kontoid) =>{
  return (dispatch) => {
    dispatch({type: FETCH_ALL_CONTACT_FLAGS});
    axios.get('kontos/getKontonFlagsByid',{ params:{kontoid:_kontoid} 
    }
    ).then(({data}) => {
     console.log("getKontonFlagsById: ", data);
      if (data.results) {
       // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({type: ON_FETCH_CONTACT_FLAGS_BY_ID, payload: data.results});
      } else {
        dispatch({type: FETCH_ACCOUNT_FLAGS_ERROR, payload: data.error});
      }         
    }).catch(function (error) {
      dispatch({type: FETCH_ACCOUNT_FLAGS_ERROR, payload: error.message});
         if(!isUndefined(error.response)){
          if(error.message === "Network Error"){
            dispatch(userSignOut())
          } 
        }
        });
  }
}
export const getAktivaKunderKontakter = (Afid, userid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_GET_AKTIVAKUND_KONTAKTER});
    axios.get('kontos/getAktivaKunderKontakter',{ params:{Afid, userid} ,
      headers: {
        'content-type': 'application/json',
        'Authorization':   `Bearer ${jwt}`
    },
    }
    ).then(({data}) => {
     console.log("getAktivaKunderKontakter: ", data);
      if (data.results) {
       // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({type: ON_GET_AKTIVAKUND_KONTAKTER, payload: data.results.AktivaKundKontakter});
      } else {
        dispatch({type: ON_ERROR_GET_AKTIVAKUND_KONTAKTER, payload: data.error});
      }         
    }).catch(function (error) {
      dispatch({type: ON_ERROR_GET_AKTIVAKUND_KONTAKTER, payload: error.message});
         if(!isUndefined(error.response)){
          if(error.message === "Network Error"){
            dispatch(userSignOut())
          } 
        }
        });
  }
}
//onSaveNewOffice
export const onSaveNewOffice = (office,userid,Afid) => {
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: FETCH_START});
    const formData = new FormData()

    formData.append('office', JSON.stringify(office))
    formData.append('userid', userid)
    formData.append('Afid', Afid)
    formData.append('files[]', office.file)


    axios.put('kontos/new', 
    formData,
    {
      method: 'PUT',
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      },
      body: {
        office: JSON.stringify(office),
        userid:userid,
        Afid:Afid
      }
    }
  )
  .then(({data}) => {
    console.log("data:", data);
    dispatch({type: ON_SAVE_NEW_OFFICE, payload: data});
    //dispatch(RefreshUserInterface(userid))
  }).catch(function (error) {
    dispatch({type: FETCH_ACCOUNT_ERROR, payload: error.message});
       if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
  });


  }
}
//onDeleteOffice
export const onDeleteOffice = (office,userid,Afid) => {
  console.log("asd",office)
  const jwt =  JSON.parse(localStorage.token);
       return (dispatch) => {
      dispatch({type: FETCH_START});
      axios.delete('kontos/deleteOffice', {
        method: 'DELETE',
        data: {
          body:JSON.stringify(office),
          userid:userid,
          Afid:Afid
        },
        headers: {
            'content-type': 'application/json',
            'Authorization':   `Bearer ${jwt}`
        }       
    }).then(({data}) => {
      console.log("Delete Office: ", data.message);
      if (data.success) {
        console.log(data);
        dispatch({type: FETCH_SUCCESS});
        dispatch({type: ON_DELETE_OFFICE, payload: data});
        //dispatch(RefreshUserInterface(userid))
      } else {
        dispatch({type: FETCH_ACCOUNT_ERROR, payload: data.error});
      }
    })
    .catch(function (error) {
      dispatch({type: FETCH_ACCOUNT_ERROR, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
    });
    }
}
//onEditOffice
export const onEditOffice = (office,userid,Afid) => {
  const jwt =  JSON.parse(localStorage.token);
       return (dispatch) => {
      dispatch({type: FETCH_START});

      const formData = new FormData()
  
      formData.append('office', JSON.stringify(office))
      formData.append('userid', userid)
      formData.append('Afid', Afid)
      formData.append('files[]', office.file)

      axios.put('kontos/EditOffice', 
        formData,
        {
          method: 'PUT',
          body: {
            body:JSON.stringify(office),
            userid:userid,
            Afid:Afid
          },
          headers: {
              'content-type': 'application/json',
              'Authorization':   `Bearer ${jwt}`
          }     
        }
    ).then(({data}) => {
      console.log("Edit Office: ", data.message);
      if (data.success) {
        console.log(data);
        dispatch({type: FETCH_SUCCESS});
        dispatch({type: ON_EDIT_OFFICE, payload: data});
        //dispatch(RefreshUserInterface(userid))
      } else {
        dispatch({type: FETCH_ACCOUNT_ERROR, payload: data.error});
      }
    })
    .catch(function (error) {
      dispatch({type: FETCH_ACCOUNT_ERROR, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
    });
    }
}

//onSaveNewUser
export const onSaveNewUser = (user,userid,Afid,OfficeId) => {
  const Office = isUndefined(OfficeId)?user.OfficeId:OfficeId
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: FETCH_START});
    axios.put('kontos/newUser',{
      body: {
        user: JSON.stringify(user),
        userid:userid,
        Office:Office,
        Afid:Afid
      }
    }, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }}
  )
  .then(({data}) => {
    console.log("data:", data);
    if(data.success === true){
      dispatch({type: ON_SAVE_NEW_USER, payload: data});
      if(!isUndefined(data.CreatedU)){
        //redirect to
        history.push({
          pathname: '/app/profile/'+data.CreatedU,
          state: { userid: data.CreatedU },
          hash : "setting"
        })
      }
    }else{
      dispatch({type: FETCH_ACCOUNT_ERROR, payload: data.error});  
    }    
   // dispatch(getKontonByid(Afid, userid))
  }).catch(function (error) {
    dispatch({type: FETCH_ACCOUNT_ERROR, payload: error.message});
       if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
  });


  }
}
//onchangeUserBasic
export const onchangeUserBasic = (user,userid,Afid) => {
  const jwt =  JSON.parse(localStorage.token);
       return (dispatch) => {
      dispatch({type: FETCH_START});
      dispatch({type: ON_START_EDIT_USER_BASIC});
      axios.put('kontos/EditUserBasic', {
        body: {
          body:JSON.stringify(user),
          userid:userid,
          Afid:Afid
        }}, {
        headers: {
            'content-type': 'application/json',
            'Authorization':   `Bearer ${jwt}`
        }       
    }).then(({data}) => {
      console.log("Edit user: ", data.message);
      if (data.success) {
        console.log(data);
        dispatch({type: FETCH_SUCCESS});
        dispatch({type: ON_EDIT_USER_BASIC, payload: data});
      } else {
        dispatch({type: FETCH_ACCOUNT_ERROR, payload: data.error});
      }
    })
    .catch(function (error) {
      dispatch({type: FETCH_ACCOUNT_ERROR, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
    });
    }
}

//searchKund
export const searchKund = (searchText,Afid,userid,Btext=0) => {
  const jwt =  JSON.parse(localStorage.token);
     return (dispatch) => {
       dispatch({type: ON_START_SEARCH_KUND});
       axios.get('kontos/searchKund',
       { params:{
         searchText:searchText,
         Afid:Afid,
         userid:userid,
         Btext
        }, 
       headers: { 'Authorization': `Bearer ${jwt}`} }      
       ).then(({data}) => {
        console.log("searchKund: ", data);
         if (data.results) {
          // dispatch({type: FETCH_ALL_CONTACT});
           dispatch({type: ON_SEARCH_KUND, payload: data.results});
         } else {
           dispatch({type: ON_ERROR_SEARCH_KUND, payload: data});
         }
         dispatch(RefreshUserInterface(userid))
       }).catch(function (error) {
         dispatch({type: ON_ERROR_SEARCH_KUND, payload: error.message});
            if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
       });
     }
}
//searchKundBasic
export const searchKundBasic = (searchText,Afid,userid,Btext=2) => {
  const jwt =  JSON.parse(localStorage.token);
     return (dispatch) => {
       dispatch({type: ON_START_SEARCH_KUND_BASIC});
       axios.get('kontos/searchKund',
       { params:{
         searchText:searchText,
         Afid:Afid,
         userid:userid,
         Btext:Btext
        }, 
       headers: { 'Authorization': `Bearer ${jwt}`} }      
       ).then(({data}) => {
        console.log("searchKund: ", data);
         if (data.results) {
          // dispatch({type: FETCH_ALL_CONTACT});
           dispatch({type: ON_SEARCH_KUND_BASIC, payload: data.results});
         } else {
           dispatch({type: ON_ERROR_SEARCH_KUND_BASIC, payload: data.error});
         }
         dispatch(RefreshUserInterface(userid))
       }).catch(function (error) {
         dispatch({type: ON_ERROR_SEARCH_KUND_BASIC, payload: error.message});
            if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
       });
     }
}
//
//getKundByOrgnrRest
export const getKundByOrgnrRest = (Orgrn,Afid,userid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_FETCH_KUND_BASIC_REST});
    axios.get('kontos/getKundByOrgnrRest',{ params:{Orgnr:Orgrn,Afid:Afid,userid:userid}, 
    headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      if (data.results) {
        localStorage.setItem("CurrentOrgnr", Orgrn)
        dispatch({type: ON_FETCH_KUND_BASIC_NOMESSAGE, payload: data.results});
      }else {
        dispatch({type: ON_ERROR_FETCH_KUND_BASIC, payload: data.error});
      }
      dispatch(RefreshUserInterface(userid,1))
     }).catch(function (error) {
      dispatch({type: ON_ERROR_FETCH_KUND_BASIC, payload: error.message});
      if(!isUndefined(error.response)){
    if (error.response.status === 401) {
      dispatch({type: FETCH_START_SET_UNAUTHE});
     } 
   } 
     })
  }
}
 //getKundByOrgnr
 export const getKundByOrgnr = (Orgrn="",Afid,userid,Goto) =>{
  Orgrn = Orgrn.trim()
  const jwt =  JSON.parse(localStorage.token);
  Goto = isUndefined(Goto)?0:Goto
  console.log(Goto,"this.props.location")
   return (dispatch) => {
    if(parseInt(Goto) === 1){
      dispatch({type: ON_START_FETCH_KUND_BASIC});
    }
    else if(parseInt(Goto) === 2){
      history.replace({ state: { Orgnr: Orgrn} })
      dispatch({type: ON_START_FETCH_KUND_BASIC});
    }
    else{
      dispatch({type: ON_START_FETCH_KUND_BASIC_NOMESSAGE});
    }
     
     axios.get('kontos/getKundByOrgnr',{ params:{Orgnr:Orgrn,Afid:Afid,userid:userid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getKundByOrgnr: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
        localStorage.setItem("CurrentOrgnr", Orgrn)
        if(parseInt(Goto) === 1){
          console.log(1)
          dispatch({type: ON_FETCH_KUND_BASIC, payload: data.results});
        history.push({
          pathname: '/app/Kund',
          state: { Orgnr: Orgrn}
        })
        }
        else if(parseInt(Goto) === 2){
          dispatch({type: ON_FETCH_KUND_BASIC, payload: data.results});
        }
        else{
          dispatch({type: ON_FETCH_KUND_BASIC_NOMESSAGE, payload: data.results});
        }
       } else {
         dispatch({type: ON_ERROR_FETCH_KUND_BASIC, payload: data.error});
       }
       dispatch(getKundByOrgnrRest(Orgrn,Afid,userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FETCH_KUND_BASIC, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //getnewKundByOrgnr
 export const getnewKundByOrgnr =  (userid,Afid,Orgrn)  =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_NEW_KUND_BASIC});
     axios.get('kontos/getnewKundByOrgnr',{ params:{Orgnr:Orgrn,Afid:Afid,userid:userid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getnewKundByOrgnr: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_NEW_KUND_BASIC, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_NEW_KUND_BASIC, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid,1))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_NEW_KUND_BASIC, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //KontakterList
 export const getResetNullKontakterList =  ()  =>{
  return (dispatch) => {
    dispatch({type: ON_START_FETCH_KUND_KONTAKT});
  }
 }
 //
 /*
 export const getnewTooltipDetailsByOrgnr =  (userid,Afid,Orgrn)  =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_NEW_KUND_TOOLTIP_DETAILS});
     axios.get('kontos/getnewTooltipDetailsByOrgnr',{ params:{Orgnr:Orgrn,Afid:Afid,userid:userid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getnewTooltipDetailsByOrgnr: ", data);
       if (data.success) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_NEW_KUND_TOOLTIP_DETAILS, payload: { Tooltip: data.results }});
       } else {
         dispatch({type: ON_ERROR_GET_NEW_KUND_TOOLTIP_DETAILS, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_NEW_KUND_TOOLTIP_DETAILS, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 */

  //getKundhandelserByOrgnr
  export const getKundhandelserByOrgnr = (Orgrn,Afid,userid) =>{
    const jwt =  JSON.parse(localStorage.token);
     return (dispatch) => {
       dispatch({type: ON_START_FETCH_KUND_HANDELSER});
       axios.get('kontos/getKundhandelserByOrgnr',{ params:{Orgnr:Orgrn,Afid:Afid,userid:userid}, 
       headers: { 'Authorization': `Bearer ${jwt}`} }      
       ).then(({data}) => {
        console.log("getKundByOrgnr: ", data);
         if (data.results) {
          // dispatch({type: FETCH_ALL_CONTACT});
           dispatch({type: ON_FETCH_KUND_HANDELSER, payload: data.results});
         } else {
           dispatch({type: ON_ERROR_FETCH_KUND_HANDELSER, payload: data.error});
         }
         dispatch(getKundhandelserByOrgnrDailer(Orgrn,Afid,userid) )
         dispatch(RefreshUserInterface(userid))
       }).catch(function (error) {
         dispatch({type: ON_ERROR_FETCH_KUND_HANDELSER, payload: error.message});
            if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
       });
     }
   }
  //getKundhandelserByOrgnrDailer
  export const getKundhandelserByOrgnrDailer = (Orgrn,Afid,userid) =>{
    const jwt =  JSON.parse(localStorage.token);
     return (dispatch) => {
       dispatch({type: ON_START_FETCH_KUND_HANDELSER_DIALERD});
       axios.get('kontos/getKundhandelserByOrgnr/dialer',{ params:{Orgnr:Orgrn,Afid:Afid,userid:userid}, 
       headers: { 'Authorization': `Bearer ${jwt}`} }      
       ).then(({data}) => {
        console.log("getKundhandelserByOrgnrDailer: ", data);
         if (data.results) {
          console.log("getKundhandelserByOrgnrDailer: ", data);
          // dispatch({type: FETCH_ALL_CONTACT});
           dispatch({type: ON_FETCH_KUND_HANDELSER_DIALERD, payload: data.results});
         } else {
           dispatch({type: ON_ERROR_FETCH_KUND_HANDELSER_DIALERD, payload: data.error});
         }
       }).catch(function (error) {
         dispatch({type: ON_ERROR_FETCH_KUND_HANDELSER_DIALERD, payload: error.message});
            if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
       });
     }
   }
   
 //ActiveKundByOrgnr
 export const ActiveKundByOrgnr = (Orgrn,Afid,userid,DistriktId=null) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_AKTIVE_KUND});
     axios.get('kontos/ActiveKundByOrgnr',{ params:{Aktive:1,Orgnr:Orgrn,Afid:Afid,userid:userid,DistriktId}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("ActiveKundByOrgnr: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_AKTIVE_KUND, payload: data.results});
         dispatch(getKundByOrgnrRest(Orgrn,Afid,userid))
       } else {
         dispatch({type: ON_ERROR_AKTIVE_KUND, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_AKTIVE_KUND, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 } 
 //
 export const EjActiveKundByOrgnr = (Orgrn,Afid,userid,Kommentar) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch,getState) => {
    const {KundPagerows} = getState().accountsData;
     dispatch({type: ON_START_INAKTIVE_KUND});
     axios.get('kontos/ActiveKundByOrgnr',{ params:{Aktive:0,
      Orgnr:Orgrn,Afid:Afid,userid:userid,Kommentar:Kommentar}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("ActiveKundByOrgnr: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_INAKTIVE_KUND, payload: data.results});
         dispatch(getKundByOrgnrRest(Orgrn,Afid,userid))
       } else {
         dispatch({type: ON_ERROR_AKTIVE_KUND, payload: data.error});
       }
       ////dispatch(RefreshUserInterface(userid))
       let KunderFilter =isUndefined(localStorage.KunderFilter)?[]:JSON.parse(localStorage.KunderFilter)
       dispatch(getKunderByUserID(Afid,KunderFilter,userid,1,'',0,undefined,KundPagerows,1))
      }).catch(function (error) {
       dispatch({type: ON_ERROR_AKTIVE_KUND, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 } 
 //
 export const deleteAnsvarig = (Orgrn,Afid,userid,deluserid,userRole) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_KUND_ANSVARIG});
     axios.delete('kontos/Kund/Ansvarig', {
      method: 'DELETE',
      data: {
        Orgnr:Orgrn,
        Afid:Afid,
        userid:userid,deluserid
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("deleteAnsvarig: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_KUND_ANSVARIG, payload: 
          {
            ...data.results,
            userRole:userRole
          } });
       } else {
         dispatch({type: ON_ERROR_DELETE_KUND_ANSVARIG, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_KUND_ANSVARIG, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 } 
 //
 export const addNewAnsvarig = (Orgrn,Afid,user) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_NEW_KUND_ANSVARIG});
     axios.put('kontos/Kund/Ansvarig', {
      body: {
        Orgnr:Orgrn,
        Afid:Afid,
        user:user
      }
    }, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("NEwAnsvarig: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_NEW_KUND_ANSVARIG, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_NEW_KUND_ANSVARIG, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_NEW_KUND_ANSVARIG, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 } 
 //
 export const deleteTag = (Orgrn,Afid,Tagid,userid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_KUND_TAG});
     axios.delete('kontos/Kund/Tag', {
      method: 'DELETE',
      data: {
        Orgnr:Orgrn,
        Afid:Afid,
        Tagid:Tagid,
        userid:userid
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("deleteTAG: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_KUND_TAG, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DELETE_KUND_TAG, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_KUND_TAG, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 } 
 //
 export const addNewTag = (Orgrn,Afid,Tag,userid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_NEW_KUND_TAG});
     axios.put('kontos/Kund/Tag', {
      body: {
        Orgnr:Orgrn,
        Afid:Afid,
        Tag:Tag,
        userid:userid
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("NEwTAG: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_NEW_KUND_TAG, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_NEW_KUND_TAG, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_NEW_KUND_TAG, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 } 
export const onCloseWarning=()=>{
  return (dispatch) => {
    dispatch({type: ON_CLOSE_CHECK_FILE});
  }
}
//check if attachment is not contain maleware
export const checkMalewares = (file,callBackFunc)=>{
  const jwt =  JSON.parse(localStorage.token);
  let files = []
  files.push(file); 
  console.log(file,"FFFFFFFFFFFFF")
  var fromdata = new FormData();
  files.forEach(file => fromdata.append('files[]', file));
  return (dispatch) => {
    dispatch({type: ON_START_CHECK_FILE});
    axios.post('/file/check',
      fromdata,
     { headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization':   `Bearer ${jwt}`
      }
    }
    )
    .then(({data}) => {
      if (data.results) {
        dispatch({type: ON_CHECK_FILE,payload:data.results});
        if(!data.results.conT){
          if(callBackFunc) callBackFunc()
        }        
      }
      else{
        dispatch({type: ON_ERROR_CHECK_FILE,payload:data.error});
      }
    }).catch(function (error) {
      dispatch({type: ON_ERROR_CHECK_FILE, payload: error.message});
         if(!isUndefined(error.response)){
         if (error.response.status === 401) {
           dispatch({type: FETCH_START_SET_UNAUTHE});
          } 
        } 
    });
  }
}



 //CreateNewHandelse
 export const CreateNewHandelse = (Orgrn,Afid,userid,handelse) =>{
  const jwt =  JSON.parse(localStorage.token);
  let files = handelse.AttachFile; 
  var fromdata = new FormData();
  fromdata.append("Orgnr",Orgrn)
  fromdata.append("Afid",Afid)
  fromdata.append("userid",userid)
  fromdata.append("handelse",handelse.text)
  fromdata.append("Type","Anteckning")
  files.forEach(file => fromdata.append('files[]', file));
  return (dispatch) => {
    dispatch({type: ON_START_CREATE_HANDELSE});
    axios.post('kontos/handelse/new',
    fromdata,
     {
       body:{
        Orgnr:Orgrn,
        Afid:Afid,
        userid:userid,
        text:handelse.text,
        Type:"Anteckning"
       },
       headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization':   `Bearer ${jwt}`
        }
     }
     ).then(({data}) => {
    console.log("NEwhandelse: ", data);
     if (data.results) {
      // dispatch({type: FETCH_ALL_CONTACT});
       dispatch({type: ON_CREATE_HANDELSE, payload: data.results});
      } else {
       dispatch({type: ON_ERROR_CREATE_HANDELSE, payload: data.error});
     }
     //dispatch(RefreshUserInterface(userid))
   }).catch(function (error) {
     dispatch({type: ON_ERROR_CREATE_HANDELSE, payload: error.message});
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
   });
  } 
 }
 //getHandelseById
 export const getHandelseById = (handelseid,Afid,userid,handelsetype) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_FETCH_CURRENT_HANDELSE});
     axios.get('kontos/getHandelseById',{ params:{handelseid:handelseid,Afid:Afid,userid:userid,handelsetype:handelsetype}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getHandelseById: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_FETCH_CURRENT_HANDELSE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_FETCH_CURRENT_HANDELSE, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FETCH_CURRENT_HANDELSE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
  //addnTextHandelseById
 export const addnTextHandelseById= (Handelseid,Afid,userid,text,Orgnr)=>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_FETCH_CURRENT_HANDELSE_NEW_TEXT});
    axios.put('kontos/handelse/new', {
     body: {
       handelseid:Handelseid,
       Afid:Afid,
       text:text,
       userid:userid
     }}, {
     headers: {
         'content-type': 'application/json',
         'Authorization':   `Bearer ${jwt}`
     }       
 }).then(({data}) => {
     console.log("addnTextHandelseById: ", data);
      if (data.results) {
       // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({type: ON_FETCH_CURRENT_HANDELSE_NEW_TEXT, payload: data.results});
        dispatch(getKundhandelserByOrgnr(Orgnr,Afid,userid) )
      } else {
        dispatch({type: ON_ERROR_FETCH_CURRENT_HANDELSE_NEW_TEXT, payload: data.error});        
      }
      //dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
      dispatch({type: ON_ERROR_FETCH_CURRENT_HANDELSE_NEW_TEXT, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
    });
  }
 }
 
export const deletehandelseById= (Handelseid,Afid,userid,Orgnr)=>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_DELETE_CURRENT_HANDELSE});
    axios.delete('kontos/handelse', {
     method: 'DELETE',
     data: {
       handelseid:Handelseid,
       Afid:Afid,
       Orgnr:Orgnr,
       userid:userid
     },
     headers: {
         'content-type': 'application/json',
         'Authorization':   `Bearer ${jwt}`
     }       
 }).then(({data}) => {
     console.log("deletehandelseById: ", data);
      if (data.results) {
       // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({type: ON_DELETE_CURRENT_HANDELSE, payload: data.results});
      } else {
        dispatch({type: ON_ERROR_DELETE_CURRENT_HANDELSE, payload: data.error});
      }
      //dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
      dispatch({type: ON_ERROR_DELETE_CURRENT_HANDELSE, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
    });
  }
 }
export const deleteattachById= (Handelseid,Afid,userid,Orgnr)=>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_DELETE_CURRENT_HANDELSE});
    axios.delete('kontos/handelseAttach', {
     method: 'DELETE',
     data: {
       handelseid:Handelseid,
       Afid:Afid,
       Orgnr:Orgnr,
       userid:userid
     },
     headers: {
         'content-type': 'application/json',
         'Authorization':   `Bearer ${jwt}`
     }       
 }).then(({data}) => {
     console.log("deletehandelseById: ", data);
      if (data.results) {
       // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({type: ON_DELETE_CURRENT_HANDELSE, payload: data.results});
      } else {
        dispatch({type: ON_ERROR_DELETE_CURRENT_HANDELSE, payload: data.error});
      }
      //dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
      dispatch({type: ON_ERROR_DELETE_CURRENT_HANDELSE, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
    });
  }
 }
 //saveNewKontakt
 export const saveNewKontakt = (Orgrn,Afid,userid,Kontakt) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_NEW_KUND_KONTAKT});
     axios.put('kontos/Kund/Kontakt/new', {
      body: {
        Orgnr:Orgrn,
        Afid:Afid,
        Kontakt:Kontakt,
        userid:userid
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("saveNewKontakt: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_NEW_KUND_KONTAKT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_NEW_KUND_KONTAKT, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_NEW_KUND_KONTAKT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//updateKontakt
export const updateKontakt = (Orgrn,Afid,userid,Kontakt) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_EDIT_KUND_KONTAKT});
     axios.put('kontos/Kund/Kontakt/edit', {
      body: {
        Orgnr:Orgrn,
        Afid:Afid,
        Kontakt:Kontakt,
        userid:userid
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("updateKontakt: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_EDIT_KUND_KONTAKT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_EDIT_KUND_KONTAKT, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_EDIT_KUND_KONTAKT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//deleteKontakt
export const deleteKontakt = (Orgrn,Afid,userid,Kontakt) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_KUND_KONTAKT});
     axios.delete('kontos/Kund/Kontakt/delete', {
      method: 'DELETE',
      data: {
        Orgnr:Orgrn,
        Afid:Afid,
        Kontakt:Kontakt,
        userid:userid
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("deleteKontakt: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_KUND_KONTAKT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DELETE_KUND_KONTAKT, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_KUND_KONTAKT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //updateInfo
export const updateInfo = (Orgrn,Afid,userid,Kund) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_EDIT_KUND_INFO});
     axios.put('kontos/Kund/edit', {
      body: {
        Orgnr:Orgrn,
        Afid:Afid,
        Kund:Kund,
        userid:userid
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("updateInfo: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_EDIT_KUND_INFO, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_EDIT_KUND_INFO, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_EDIT_KUND_INFO, payload: error.message});
        console.log("Error****:", error); 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //updateInfoItesco
 export const updateInfoItesco = (Orgrn,Afid,userid,UpdateAddress) =>{
  UpdateAddress = isUndefined(UpdateAddress)?1:UpdateAddress
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_EDIT_KUND_ITESCO_INFO});
     axios.put('kontos/Kund/editItesco', {
      body: {
        Orgnr:Orgrn,
        Afid:Afid,
        UpdateAddress:UpdateAddress,
        userid:userid
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("updateInfo: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_EDIT_KUND_ITESCO_INFO, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_EDIT_KUND_ITESCO_INFO, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_EDIT_KUND_ITESCO_INFO, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 
 //changeOrgnrAfKund
 export const changeOrgnrAfKund = (Afid,userid,currentOrgnr,Orgnr) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_EDIT_KUND_INFO});
     axios.put('kontos/Kund/editOrgnr', {
      body: {
        currentOrgnr:currentOrgnr,
        Afid:Afid,
        Orgnr:Orgnr,
        userid:userid
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("changeOrgnrAfKund: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_EDIT_KUND_INFO, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_EDIT_KUND_INFO, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_EDIT_KUND_INFO, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //Avtal Order prospekt type
 //
 export const Addnewleverantor = ( userid, Afid,leverantor) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_NEW_LEVERANTOR});
     axios.put('kontos/Type/leverantor/new', {
      body: {
        userid:userid,
        Afid:Afid,
        leverantor:leverantor
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("Addnewleverantor: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_NEW_LEVERANTOR, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_NEW_LEVERANTOR, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_NEW_LEVERANTOR, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //deleteleverator
 export const deleteleverator = ( userid, Afid,leverantor) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_LEVERANTOR});
     axios.delete('kontos/Type/leverantor/delete', {
      method: 'DELETE',
      data: {
        userid:userid,
        Afid:Afid,
        leverantor:leverantor
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("Addnewleverantor: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_LEVERANTOR, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DELETE_LEVERANTOR, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_LEVERANTOR, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //AddnewType
//  export const AddnewType = ( userid, Afid,newtype) =>{
//   const jwt =  JSON.parse(localStorage.token);
//    return (dispatch) => {
//      dispatch({type: ON_START_NEW_TYPE});
//      axios.put('kontos/Type/new', {
//       method: 'PUT',
//       body: {
//         userid:userid,
//         Afid:Afid,
//         newtype:newtype
//       },
//       headers: {
//           'content-type': 'application/json',
//           'Authorization':   `Bearer ${jwt}`
//       }       
//   }).then(({data}) => {
//       console.log("AddnewType: ", data);
      
//        if (data.results) {
//         // dispatch({type: FETCH_ALL_CONTACT});
//          dispatch({type: ON_NEW_TYPE, payload: data.results});
//        } else {
//          dispatch({type: ON_ERROR_NEW_TYPE, payload: data.error});
//        }
//        //dispatch(RefreshUserInterface(userid))
//      }).catch(function (error) {
//        dispatch({type: ON_ERROR_NEW_TYPE, payload: error.message});
//           if(!isUndefined(error.response)){
//         if (error.response.status === 401) {
//           dispatch({type: FETCH_START_SET_UNAUTHE});
//          } 
//        } 
//        if(error.message === "Network Error"){
//           //reload and remove token 
//           //dispatch(userSignOut())
//        } 
//      });
//    }
//  }


export const AddnewType = (userid, Afid, newtypedata = {}) => {
  const jwt = JSON.parse(localStorage.token);

  const payload = {
    userid,
    Afid,
    ...newtypedata, 
  };

  return (dispatch) => {
    dispatch({ type: ON_START_NEW_TYPE });

    axios.put(
      'kontos/Type/new',
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${jwt}`
        }
      }
    )
    .then(({ data }) => {
      console.log("AddnewTypeClient: ", payload);
      if (data.results) {
        dispatch({ type: ON_NEW_TYPE, payload: data.results });
      } else {
        dispatch({ type: ON_ERROR_NEW_TYPE, payload: data.error || "Okänt fel" });
      }
    })
    .catch((error) => {
      console.error("AddnewType error:", error);
      dispatch({ type: ON_ERROR_NEW_TYPE, payload: error.message });
    });
  };
};


 //deletType
 export const deletType = ( userid, Afid,deletedtype) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_TYPE});
     axios.delete('kontos/Type/delete', {
      method: 'DELETE',
      data: {
        userid:userid,
        Afid:Afid,
        deletedtype:deletedtype
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("deletType: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_TYPE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DELETE_TYPE, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_LEVERANTOR, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
  //updateType

  export const updateType = (userid, Afid, newtypedata = {}) => {
  const jwt = JSON.parse(localStorage.token);

  const payload = {
    userid,
    Afid,
    ...newtypedata,
  };
  console.log("updateType payload: ", payload);

  return (dispatch) => {
    dispatch({ type: ON_START_UPDATE_TYPE });

    axios.put('kontos/Type/update', payload, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${jwt}`,
      },
    })
      .then(({ data }) => {
        console.log("updateTypeclient: ", data);
        if (data.results) {
          dispatch({ type: ON_UPDATE_TYPE, payload: data.results });
        } else {
          dispatch({ type: ON_ERROR_UPDATE_TYPE, payload: data.error || "Okänt fel" });
        }
      })
      .catch((error) => {
        console.error("updateType error:", error);
        dispatch({ type: ON_ERROR_UPDATE_TYPE, payload: error.message });

        if (error.response?.status === 401) {
          dispatch({ type: FETCH_START_SET_UNAUTHE });
        }
      });
  };
};

  // export const updateType = ( userid, Afid,newtype) =>{
  //   const jwt =  JSON.parse(localStorage.token);
  //    return (dispatch) => {
  //      dispatch({type: ON_START_UPDATE_TYPE});
  //      axios.put('kontos/Type/update', {
  //       method: 'PUT',
  //       body: {
  //         userid:userid,
  //         Afid:Afid,
  //         newtype:newtype
  //       },
  //       headers: {
  //           'content-type': 'application/json',
  //           'Authorization':   `Bearer ${jwt}`
  //       }       
  //   }).then(({data}) => {
  //       console.log("updateType: ", data);
  //        if (data.results) {
  //         // dispatch({type: FETCH_ALL_CONTACT});
  //          dispatch({type: ON_UPDATE_TYPE, payload: data.results});
  //        } else {
  //          dispatch({type: ON_ERROR_UPDATE_TYPE, payload: data.error});
  //        }
  //        //dispatch(RefreshUserInterface(userid))
  //      }).catch(function (error) {
  //        dispatch({type: ON_ERROR_UPDATE_TYPE, payload: error.message});
  //           if(!isUndefined(error.response)){
  //       if (error.response.status === 401) {
  //         dispatch({type: FETCH_START_SET_UNAUTHE});
  //        } 
  //      } 
  //      if(error.message === "Network Error"){
  //         //reload and remove token 
  //         //dispatch(userSignOut())
  //      } 
  //      });
  //    }
  //  }
  
  export const setThisTypDefaultOrderLev = ( userid, Afid,newtype,leve) =>{
    const jwt =  JSON.parse(localStorage.token);
     return (dispatch) => {
       dispatch({type: ON_START_UPDATE_TYPE});
       axios.put('kontos/Type/defaultLeve/set', {
        body: {
          userid:userid,
          Afid:Afid,
          newtype:newtype,
          leverantor:leve
        }}, {
        headers: {
            'content-type': 'application/json',
            'Authorization':   `Bearer ${jwt}`
        }       
    }).then(({data}) => {
        console.log("setThisTypDefaultOrderLev: ", data);
         if (data.results) {
          // dispatch({type: FETCH_ALL_CONTACT});
           dispatch({type: ON_UPDATE_TYPE, payload: data.results});
         } else {
           dispatch({type: ON_ERROR_UPDATE_TYPE, payload: data.error});
         }
         //dispatch(RefreshUserInterface(userid))
       }).catch(function (error) {
         dispatch({type: ON_ERROR_UPDATE_TYPE, payload: error.message});
            if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
       });
     }
   }
  //setThisTypDefault
  export const setThisTypDefault = ( userid, Afid,newtype) =>{
    const jwt =  JSON.parse(localStorage.token);
     return (dispatch) => {
       dispatch({type: ON_START_UPDATE_TYPE});
       axios.put('kontos/Type/default/set', {
        body: {
          userid:userid,
          Afid:Afid,
          newtype:newtype
        }}, {
        headers: {
            'content-type': 'application/json',
            'Authorization':   `Bearer ${jwt}`
        }       
    }).then(({data}) => {
        console.log("setThisTypDefault: ", data);
         if (data.results) {
          // dispatch({type: FETCH_ALL_CONTACT});
           dispatch({type: ON_UPDATE_TYPE, payload: data.results});
         } else {
           dispatch({type: ON_ERROR_UPDATE_TYPE, payload: data.error});
         }
         //dispatch(RefreshUserInterface(userid))
       }).catch(function (error) {
         dispatch({type: ON_ERROR_UPDATE_TYPE, payload: error.message});
            if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
       });
     }
   }
  //setThisRemoveTypDefault
  export const setThisRemoveTypDefault = ( userid, Afid,newtype) =>{
    const jwt =  JSON.parse(localStorage.token);
     return (dispatch) => {
       dispatch({type: ON_START_UPDATE_TYPE});
       axios.put('kontos/Type/default/remove', {
        body: {
          userid:userid,
          Afid:Afid,
          newtype:newtype
        }}, {
        headers: {
            'content-type': 'application/json',
            'Authorization':   `Bearer ${jwt}`
        }       
    }).then(({data}) => {
        console.log("setThisRemoveTypDefault: ", data);
         if (data.results) {
          // dispatch({type: FETCH_ALL_CONTACT});
           dispatch({type: ON_UPDATE_TYPE, payload: data.results});
         } else {
           dispatch({type: ON_ERROR_UPDATE_TYPE, payload: data.error});
         }
         //dispatch(RefreshUserInterface(userid))
       }).catch(function (error) {
         dispatch({type: ON_ERROR_UPDATE_TYPE, payload: error.message});
            if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
       });
     }
   }
  export const setThisTypDefaultAvtal = ( userid, Afid,newtype) =>{
    const jwt =  JSON.parse(localStorage.token);
     return (dispatch) => {
       dispatch({type: ON_START_UPDATE_TYPE});
       axios.put('kontos/Type/default/setA', {
        body: {
          userid:userid,
          Afid:Afid,
          newtype:newtype
        }},{
        headers: {
            'content-type': 'application/json',
            'Authorization':   `Bearer ${jwt}`
        }       
    }).then(({data}) => {
        console.log("setThisTypDefaultAvtal: ", data);
         if (data.results) {
          // dispatch({type: FETCH_ALL_CONTACT});
           dispatch({type: ON_UPDATE_TYPE, payload: data.results});
         } else {
           dispatch({type: ON_ERROR_UPDATE_TYPE, payload: data.error});
         }
         //dispatch(RefreshUserInterface(userid))
       }).catch(function (error) {
         dispatch({type: ON_ERROR_UPDATE_TYPE, payload: error.message});
            if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
       });
     }
   }
  //setThisRemoveTypDefault
  export const setThisRemoveTypDefaultAvtal = ( userid, Afid,newtype) =>{
    const jwt =  JSON.parse(localStorage.token);
     return (dispatch) => {
       dispatch({type: ON_START_UPDATE_TYPE});
       axios.put('kontos/Type/default/removeA', {
        body: {
          userid:userid,
          Afid:Afid,
          newtype:newtype
        }}, {
        headers: {
            'content-type': 'application/json',
            'Authorization':   `Bearer ${jwt}`
        }       
    }).then(({data}) => {
        console.log("setThisRemoveTypDefaultAvtal: ", data);
         if (data.results) {
          // dispatch({type: FETCH_ALL_CONTACT});
           dispatch({type: ON_UPDATE_TYPE, payload: data.results});
         } else {
           dispatch({type: ON_ERROR_UPDATE_TYPE, payload: data.error});
         }
         //dispatch(RefreshUserInterface(userid))
       }).catch(function (error) {
         dispatch({type: ON_ERROR_UPDATE_TYPE, payload: error.message});
            if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
       });
     }
   }
  //UpdateKalkyl
  export const UpdateKalkyl = ( userid, Afid,newtype) =>{
    const jwt =  JSON.parse(localStorage.token);
     return (dispatch) => {
       dispatch({type: ON_START_UPDATE_KALKYL});
       axios.put('kontos/Kalkyl/update', {
        body: {
          userid:userid,
          Afid:Afid,
          newtype:newtype
        }}, {
        headers: {
            'content-type': 'application/json',
            'Authorization':   `Bearer ${jwt}`
        }       
    }).then(({data}) => {
        console.log("UpdateKalkyl: ", data);
         if (data.results) {
           dispatch({type: ON_UPDATE_KALKYL, payload: data.results});
         } else {
           dispatch({type: ON_ERROR_UPDATE_KALKYL, payload: data.error});
         }
         //dispatch(RefreshUserInterface(userid))
       }).catch(function (error) {
         dispatch({type: ON_ERROR_UPDATE_KALKYL, payload: error.message});
            if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
       });
     }
   }
  
   
 //AddnewKalkyl
 export const AddnewKalkyl = ( userid, Afid,newtype) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_NEW_KALKYL});
     axios.put('kontos/Kalkyl/new', {
      body: {
        userid:userid,
        Afid:Afid,
        newtype:newtype
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("AddnewKalkyl: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_NEW_KALKYL, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_NEW_KALKYL, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_NEW_KALKYL, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//deletKalkyl
export const deletKalkyl = ( userid, Afid,deletedtype) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_KALKYL});
     axios.delete('kontos/Kalkyl/delete', {
      method: 'DELETE',
      data: {
        userid:userid,
        Afid:Afid,
        deletedtype:deletedtype
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("deletKalkyl: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_KALKYL, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DELETE_KALKYL, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_KALKYL, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
  //UpdateSchablon
  export const UpdateSchablon = ( userid, Afid,Schablon) =>{
    const jwt =  JSON.parse(localStorage.token);
     return (dispatch) => {
       dispatch({type: ON_START_UPDATE_SCHABLON});
       axios.put('kontos/Schablon/update', {
        body: {
          userid:userid,
          Afid:Afid,
          Schablon:Schablon
        },
             
    },{
      headers: {
        'content-type': 'application/json',
        'Authorization':   `Bearer ${jwt}`
    } 
    }).then(({data}) => {
        console.log("UpdateSchablon: ", data);
         if (data.results) {
           dispatch({type: ON_UPDATE_SCHABLON, payload: data.results});
         } else {
           dispatch({type: ON_ERROR_UPDATE_SCHABLON, payload: data.error});
         }
         //dispatch(RefreshUserInterface(userid))
       }).catch(function (error) {
         dispatch({type: ON_ERROR_UPDATE_SCHABLON, payload: error.message});
            if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
       });
     }
   }
  export const UpdateSchablonPreset = ( userid, Afid,SchablonPreset) =>{
    const jwt =  JSON.parse(localStorage.token);
     return (dispatch) => {
       dispatch({type: ON_START_UPDATE_SCHABLON_PRESET});
       axios.put('kontos/SchablonPreset/update', {
        method: 'PUT',
        body: {
          userid:userid,
          Afid:Afid,
          SchablonPreset:SchablonPreset
        },
             
    },{
      headers: {
        'content-type': 'application/json',
        'Authorization':   `Bearer ${jwt}`
    } 
    }).then(({data}) => {
        console.log("UpdateSchablonPreset: ", data);
         if (data.results) {
           dispatch({type: ON_UPDATE_SCHABLON_PRESET, payload: data.results});
         } else {
           dispatch({type: ON_ERROR_UPDATE_SCHABLON_PRESET, payload: data.error});
         }
         //dispatch(RefreshUserInterface(userid))
       }).catch(function (error) {
         dispatch({type: ON_ERROR_UPDATE_SCHABLON_PRESET, payload: error.message});
            if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
       });
     }
   }
  
   
 //AddnewSchablon
 export const AddnewSchablon = ( userid, Afid,Schablon) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_NEW_SCHABLON});
     axios.put('kontos/Schablon/new', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        Schablon:Schablon
      },
           
  },{
    headers: {
      'content-type': 'application/json',
      'Authorization':   `Bearer ${jwt}`
  }  
  }).then(({data}) => {
      console.log("AddnewSchablon: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_NEW_SCHABLON, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_NEW_SCHABLON, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_NEW_SCHABLON, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 
 //AddnewSchablonPreset
 export const AddnewSchablonPreset = ( userid, Afid,SchablonPreset) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_NEW_SCHABLON_PRESET});
     axios.put('kontos/SchablonPreset/new', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        SchablonPreset:SchablonPreset
      },
           
  },{
    headers: {
      'content-type': 'application/json',
      'Authorization':   `Bearer ${jwt}`
  }  
  }).then(({data}) => {
      console.log("AddnewSchablon: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_NEW_SCHABLON_PRESET, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_NEW_SCHABLON_PRESET, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_NEW_SCHABLON_PRESET, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 export const ResetSchablon = ( userid, Afid, PresetId) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_RESET_SCHABLON});
     axios.post('kontos/Schablon/reset', {
      method: 'POST',
      body: {
        userid:userid,
        Afid:Afid,
        PresetId:PresetId
      },
           
  },{
    headers: {
      'content-type': 'application/json',
      'Authorization':   `Bearer ${jwt}`
  }  
  }).then(({data}) => {
      console.log("ResetSchablon: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_RESET_SCHABLON, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_RESET_SCHABLON, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_RESET_SCHABLON, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//deletSchablon
export const deletSchablon = ( userid, Afid,deletedtype) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_SCHABLON});
     axios.delete('kontos/Schablon/delete', {
      method: 'DELETE',
      data: {
        userid:userid,
        Afid:Afid,
        deletedtype:deletedtype
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("deletSchablon: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_SCHABLON, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DELETE_SCHABLON, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_SCHABLON, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
export const GetSchablon = ( userid, Afid,PresetId) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_SCHABLON});
     axios.get('kontos/Schablon/get', {
      params: {
        userid:userid,
        Afid:Afid,
        PresetId:PresetId
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("GetSchablon: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_SCHABLON, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_SCHABLON, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_SCHABLON, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//deletSchablonPreset
export const deletSchablonPreset = ( userid, Afid,deletedtype) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_SCHABLON_PRESET});
     axios.delete('kontos/SchablonPreset/delete', {
      method: 'DELETE',
      data: {
        userid:userid,
        Afid:Afid,
        deletedtype:deletedtype
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("deletSchablon: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_SCHABLON_PRESET, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DELETE_SCHABLON_PRESET, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_SCHABLON_PRESET, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //getKundKontakter
 export const getKundKontakter = (userid,AFid,Orgnr)  =>{
   console.log(Orgnr)
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_FETCH_KUND_KONTAKT});
     axios.get('kontos/getKundKontakterByOrgnr',{ params:{Orgnr:Orgnr,Afid:AFid,userid:userid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getKundKontakter: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_FETCH_KUND_KONTAKT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_FETCH_KUND_KONTAKT, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid,1))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FETCH_KUND_KONTAKT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //AddnewFas
 export const AddnewFas = ( userid, Afid,newFas) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_NEW_FAS});
     axios.put('kontos/Fas/new', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        newFas:newFas
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("AddnewFas: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_NEW_FAS, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_NEW_FAS, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_NEW_FAS, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //DeleteFas
 export const DeleteFas = ( userid, Afid,Fas,replcedFas) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_FAS});
     axios.delete('kontos/Fas/delete', {
      method: 'DELETE',
      data: {
        userid:userid,
        Afid:Afid,
        Fas:Fas,
        replcedFas:replcedFas,
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("DeleteFas: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_FAS, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DELETE_FAS, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_FAS, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //UpdateFas
 export const UpdateFas = ( userid, Afid,Fas) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_UPDATE_FAS});
     axios.put('kontos/Fas/update', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        Fas:Fas
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("UpdateFas: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_UPDATE_FAS, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_UPDATE_FAS, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_FAS, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }

//getKundAvtalProspekt
export const getKundAvtalProspekt = (Orgrn,Afid,userid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
    dispatch({type: ON_START_GET_AVTPRO_BY_ORGNR});
    axios.get('kontos/Kund/getAvtalProspektByOrgnr',
    { params:{Orgnr:Orgrn,Afid:Afid,userid:userid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getKundAvtalProspekt: ", data);
       if (data.results) {
        dispatch({type: ON_GET_AVTPRO_BY_ORGNR, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_AVTPRO_BY_ORGNR, payload: data.error});
      }
      dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_AVTPRO_BY_ORGNR, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}

//getKundprislista
export const getKundprislista = (Orgrn,Afid,userid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
    dispatch({type: ON_START_GET_PRISLISTA_BY_ORGNR});
    axios.get('kontos/Kund/getfortnoxPrisList',
    { params:{Orgnr:Orgrn,Afid:Afid,userid:userid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getKundAvtalProspekt: ", data);
       if (data.results) {
        dispatch({type: ON_GET_PRISLISTA_BY_ORGNR, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_PRISLISTA_BY_ORGNR, payload: data.error});
      }
      dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_PRISLISTA_BY_ORGNR, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}
 //AddnewKundData
 export const AddnewKundData = ( userid, Afid,newType) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_NEW_KUNDDATA});
     axios.put('kontos/KundData/new', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        newType:newType
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("AddnewKundData: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_NEW_KUNDDATA, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_NEW_KUNDDATA, payload: data.error});
       }
    //   //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_NEW_KUNDDATA, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//getKundDataByAvtalTyp
export const getKundDataByAvtalTyp = ( userid, Afid,AvtalTyp,avtalId) =>{
  let AvtalId = isUndefined(avtalId)?0:avtalId
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
    dispatch({type: ON_START_GET_KUNDDATA_BY_AVTAL});
    axios.get('kontos/KundData/getByType',
    { params:{AvtalTyp:AvtalTyp,Afid:Afid,userid:userid,AvtalId}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getKundDataByAvtalTyp: ", data);
       if (data.results) {
        dispatch({type: ON_GET_KUNDDATA_BY_AVTAL, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_KUNDDATA_BY_AVTAL, payload: data.error});
      }
      dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_KUNDDATA_BY_AVTAL, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}
//DeleteKundData
 export const DeleteKundData = ( userid, Afid,AvtalTyp) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_KUNDDATA});
     axios.delete('kontos/KundData/delete', {
      method: 'DELETE',
      data: {
        userid:userid,
        Afid:Afid,
        AvtalTyp:AvtalTyp
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("DeleteKundData: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_KUNDDATA, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DELETE_KUNDDATA, payload: data.error});
       }
      // //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_KUNDDATA, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //UpdateKundData
 export const UpdateKundData = ( userid, Afid,AvtalTyp,callBackFunc) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_UPDATE_KUNDDATA});
     axios.put('kontos/KundData/update', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        AvtalTyp:AvtalTyp
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("UpdateKundData: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_UPDATE_KUNDDATA, payload: data.results});
         if(!isUndefined(callBackFunc)){
           callBackFunc(data.results.KundDatalist);
         }
       } else {
         dispatch({type: ON_ERROR_UPDATE_KUNDDATA, payload: data.error});
       }
   //    //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_KUNDDATA, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//onSaveKontoInfo
export const onSaveKontoInfo =  ( userid, Afid,infoState) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: ON_START_KONTO_INFO_UPDATE});
      axios.put('kontos/Info/update', {
       body: {
         Afid:Afid,
         userid:userid,
         infoState:infoState
       }},
       {headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
       console.log("onSaveKontoInfo: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_KONTO_INFO_UPDATE, payload: data.results});
        } else {
          dispatch({type: ON_ERROR_KONTO_INFO_UPDATE, payload: data.error});
        }
        //dispatch(RefreshUserInterface(userid))
      }).catch(function (error) {
        dispatch({type: ON_ERROR_KONTO_INFO_UPDATE, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
//UpdateThisModule
//
export const UpdateThisModule = (userid, Afid,Meta,Value,update = true) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_UPDATE_MODULE});
     axios.put('kontos/Module/update', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        Meta:Meta,
        Value:Value
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("UpdateThisModule: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
        if(update === true){
        dispatch({type: ON_UPDATE_MODULE, payload: data.results});
        }else{
          dispatch({type: ON_UPDATE_MODULE_DONT_UPDATE, payload: data.results});
        }
       } else {
         dispatch({type: ON_ERROR_UPDATE_MODULE, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_MODULE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
export const UpdateThisModuleWithFile = (userid, Afid,Meta,file, RemoveFile) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_UPDATE_MODULE});

     const formData = new FormData()

     formData.append('files[]', file)
     formData.append('userid', userid)
     formData.append('Afid', Afid)
     formData.append('Meta', Meta)
     formData.append('RemoveFile', RemoveFile)


     axios.put('kontos/Module/updateWithFile', 
     formData,
     {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        Meta:Meta,
        RemoveFile:RemoveFile,
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("UpdateThisModule: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_UPDATE_MODULE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_UPDATE_MODULE, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_MODULE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//onSaveNewOrderEmail
export const onSaveNewOrderEmail = ( userid, Afid,newState) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_NEW_ORDER_EMAIL});
     axios.put('kontos/OrderEmail/new', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        newState:newState
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("onSaveNewOrderEmail: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_NEW_ORDER_EMAIL, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_NEW_ORDER_EMAIL, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_NEW_ORDER_EMAIL, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //onDeleteOrderEmail
 export const onDeleteOrderEmail = ( userid, Afid,DelState) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_ORDER_EMAIL});
     axios.delete('kontos/OrderEmail/delete', {
      method: 'DELETE',
      data: {
        userid:userid,
        Afid:Afid,
        DelState:DelState
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("onDeleteOrderEmail: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_ORDER_EMAIL, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DELETE_ORDER_EMAIL, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_ORDER_EMAIL, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//getKunderByUserID
export const getKunderByUserID = (Afid,Filterstate,MainUser,Page,searchWord,type,sortBy,pageRows,NoMessage) => {
  Page = (isUndefined(Page)?1:Page)
  let Type = (isUndefined(type)?0:type)
  searchWord = (isUndefined(searchWord)?"":searchWord)
  NoMessage = (isUndefined(NoMessage)?0:NoMessage)
  pageRows = (isUndefined(pageRows)?15:pageRows)
  sortBy = (isUndefined(sortBy)?{label:"KundName",Method:"asc"}:sortBy)
  const jwt =  JSON.parse(localStorage.token);
     return (dispatch) => {
      if(parseInt(NoMessage) ===1){
        dispatch({type: ON_START_MINA_KUNDER_NOMESSAGE});
      }else{
        dispatch({type: ON_START_MINA_KUNDER});
      }
       
       axios.get('kontos/MinaKunder',
       { params:{
         Afid:Afid,
         MainUser:MainUser,
         Filterstate:Filterstate,
         Page:Page,
         Type:Type,
         sortBy:sortBy,
         pageRows:pageRows,
         searchWord:searchWord
        }, 
       headers: { 'Authorization': `Bearer ${jwt}`} }      
       ).then(({data}) => {
        console.log("searchKund: ", data);
         if (data.results) {
          // dispatch({type: FETCH_ALL_CONTACT});
          if(parseInt(NoMessage) ===1){
            dispatch({type: ON_MINA_KUNDER_NOMESSAGE, payload: data.results});
          }else{
            dispatch({type: ON_MINA_KUNDER, payload: data.results});
          }
           
         } else {
           dispatch({type: ON_ERROR_MINA_KUNDER, payload: data.error});
         }
         dispatch(RefreshUserInterface(MainUser))
       }).catch(function (error) {
         dispatch({type: ON_ERROR_MINA_KUNDER, payload: error.message});
            if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
       });
     }
}
export const getKunderCloseToByUserID = (Afid,MainUser,type, Position) => {
  let Type = (isUndefined(type)?0:type)
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_MINA_KUNDER_CLOSE_TO});
    axios.get('kontos/MinaKunderCloseTo',
    { params:{
      Afid:Afid,
      MainUser:MainUser,
      Type:Type,
      Position: Position
    }, 
    headers: { 'Authorization': `Bearer ${jwt}`} }      
    ).then(({data}) => {
    console.log("getKunderCloseToByUserID: ", data);
      if (data.results) {
      // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({type: ON_MINA_KUNDER_CLOSE_TO, payload: data.results});
      } else {
        dispatch({type: ON_ERROR_MINA_KUNDER_CLOSE_TO, payload: data.error});
      }
      dispatch(RefreshUserInterface(MainUser))
    }).catch(function (error) {
      dispatch({type: ON_ERROR_MINA_KUNDER_CLOSE_TO, payload: error.message});
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
    if(error.message === "Network Error"){
      //reload and remove token 
      //dispatch(userSignOut())
    } 
    });
  }
}
export const getMinaKunderKarta = (Afid,MainUser,type) => {
  let Type = (isUndefined(type)?0:type)
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_MINA_KUNDER_CLOSE_TO});
    axios.get('kontos/getMinaKunderKarta',
    { params:{
      Afid:Afid,
      MainUser:MainUser,
      Type:Type,
    }, 
    headers: { 'Authorization': `Bearer ${jwt}`} }      
    ).then(({data}) => {
    console.log("getMinaKunderKarta: ", data);
      if (data.results) {
      // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({type: ON_MINA_KUNDER_CLOSE_TO, payload: data.results});
      } else {
        dispatch({type: ON_ERROR_MINA_KUNDER_CLOSE_TO, payload: data.error});
      }
      dispatch(RefreshUserInterface(MainUser))
    }).catch(function (error) {
      dispatch({type: ON_ERROR_MINA_KUNDER_CLOSE_TO, payload: error.message});
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
    if(error.message === "Network Error"){
      //reload and remove token 
      //dispatch(userSignOut())
    } 
    });
  }
}

export const getKontakpersonerByUserID = (Afid,Filterstate,MainUser,Page,searchWord,type,PageRows,NoMessage) => {
  Page = (isUndefined(Page)?1:Page)
  let Type = (isUndefined(type)?0:type)
  searchWord = (isUndefined(searchWord)?"":searchWord)
  NoMessage = (isUndefined(NoMessage)?0:NoMessage)
  PageRows = (isUndefined(PageRows)?15:PageRows)
  const jwt =  JSON.parse(localStorage.token);
     return (dispatch) => {
      if(parseInt(NoMessage) === 1){
        dispatch({type: ON_START_MINA_KONTAKTPERSONER_NOMESSAGE});
      }else{
        dispatch({type: ON_START_MINA_KONTAKTPERSONER});
      }
       
       axios.get('kontos/MinaKontakpersoner',
       { params:{
         Afid:Afid,
         MainUser:MainUser,
         Filterstate:Filterstate,
         Page:Page,
         PageRows:PageRows,
         Type:Type,
         searchWord:searchWord
        }, 
       headers: { 'Authorization': `Bearer ${jwt}`} }      
       ).then(({data}) => {
        console.log("searchKund: ", data);
         if (data.results) {
          // dispatch({type: FETCH_ALL_CONTACT});
          if(parseInt(NoMessage) === 1){
            dispatch({type: ON_MINA_KONTAKTPERSONER_NOMESSAGE, payload: data.results});
          }else{
            dispatch({type: ON_MINA_KONTAKTPERSONER, payload: data.results});
          }
           
         } else {
           dispatch({type: ON_ERROR_MINA_KONTAKTPERSONER, payload: data.error});
         }
         dispatch(RefreshUserInterface(MainUser))
       }).catch(function (error) {
         dispatch({type: ON_ERROR_MINA_KONTAKTPERSONER, payload: error.message});
            if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
       });
     }
}
//getDocByOrgnr
export const getDocByOrgnr = (userid,Afid,Orgnr,Page,searchWord,type=0) =>{
  Page = (isUndefined(Page)?0:Page)
  searchWord = (isUndefined(searchWord)?"":searchWord)
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_GET_DOC_ORGNR});
    axios.get('kontos/Document/getByOrgnr',
    { params:{Orgnr:Orgnr,Afid:Afid,userid:userid,Page:Page,searchWord:searchWord,type:type}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getDocByOrgnr: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
        if(parseInt(type) === 1){
          dispatch({type: ON_GET_DOC_ORGNR_0, payload: data.results});
        }else{
          dispatch({type: ON_GET_DOC_ORGNR, payload: data.results});
        }         
       } else {
         dispatch({type: ON_ERROR_GET_DOC_ORGNR, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_DOC_ORGNR, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}

export const getDocByOrgnrPdf = (userid,Afid,Orgnr,Page,searchWord,type=0) =>{
  Page = (isUndefined(Page)?0:Page)
  searchWord = (isUndefined(searchWord)?"":searchWord)
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_GET_DOC_ORGNR_PDF});
    axios.get('kontos/Document/getByOrgnrPdf',
    { params:{Orgnr:Orgnr,Afid:Afid,userid:userid,Page:Page,searchWord:searchWord,type:type}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getDocByOrgnr: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_GET_DOC_ORGNR_PDF, payload: data.results});
        } else {
         dispatch({type: ON_ERROR_GET_DOC_ORGNR_PDF, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_DOC_ORGNR_PDF, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//importeraFunctionKonto
export const importeraFunctionKonto = (userid, Afid,NewState) =>{
  const jwt =  JSON.parse(localStorage.token);
  let files = NewState.ExcelFile.file; 
  var fromdata = new FormData();
  fromdata.append("Afid",Afid)
  fromdata.append("userid",userid)
  fromdata.append("function",NewState.function)
  fromdata.append("KundFunc",NewState.KundFunc)
  fromdata.append("PrislistorFunc",NewState.PrislistorFunc)
  fromdata.append("ObjId",NewState.ObjId)
  fromdata.append("ObjMetaKey",NewState.ObjMetaKey)
  fromdata.append("Mainprice",NewState.Mainprice)
  fromdata.append("Agare",NewState.ExcelFile.userid)
  fromdata.append("Tags",JSON.stringify(NewState.tags))
  files.forEach(file => fromdata.append('files[]', file));
  return (dispatch) => {
    dispatch({type: ON_START_IMPORT_FUNC,payload:NewState.function});
    axios.post('kontos/Import',
    fromdata,
     {
       body:{
        Afid:Afid,
        userid:userid,
        function:NewState.function,
        KundFunc:NewState.KundFunc,
        PrislistorFunc:NewState.PrislistorFunc,
        ObjId:NewState.ObjId,
        ObjMetaKey:NewState.ObjMetaKey,
				Mainprice:NewState.Mainprice,
        Agare:NewState.ExcelFile.userid,
        Tags:JSON.stringify(NewState.tags),
       },
       headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization':   `Bearer ${jwt}`
        }
     }
     ).then(({data}) => {
    console.log("importeraFunctionKonto: ", data);
     if (data.success) {
      // dispatch({type: FETCH_ALL_CONTACT});
       dispatch({type: ON_IMPORT_FUNC, payload: data});
     } else {
       dispatch({type: ON_ERROR_IMPORT_FUNC, payload: data.error});
     }
   }).catch(function (error) {
     dispatch({type: ON_ERROR_IMPORT_FUNC, payload: error.message});
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
   });
  } 
 }
//bestallaScriveKonto
export const bestallaScriveKonto = ( userid, Afid,Email) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_BESTALLA_ESIGN});
     axios.put('kontos/Signering/Bestalla', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        Email:Email
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("bestallaScriveKonto: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_BESTALLA_ESIGN, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_BESTALLA_ESIGN, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_BESTALLA_ESIGN, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//updateScriveKonto
export const updateScriveKonto = ( userid, Afid,Email) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_BESTALLA_ESIGN});
     axios.put('kontos/Signering/updateEmail', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        Email:Email
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      //console.log("updateScriveKonto: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_BESTALLA_ESIGN, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_BESTALLA_ESIGN, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_BESTALLA_ESIGN, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//getEsigneringAf
export const getEsigneringAf = (Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_GET_AF_ESIGNERING});
    axios.get('kontos/Signering/get',
    { params:{Afid:Afid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getEsigneringAf: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_AF_ESIGNERING, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_AF_ESIGNERING, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_AF_ESIGNERING, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//getDialerAf
export const getDialerAf = (Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_GET_AF_DIALER});
    axios.get('kontos/Dialer/get',
    { params:{Afid:Afid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getDialerAf: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_AF_DIALER, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_AF_DIALER, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_AF_DIALER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//getuserDialerSetting
export const getuserDialerSetting = (Afid,userid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_GET_USER_DIALER});
    axios.get('kontos/Dialer/user/get',
    { params:{Afid:Afid,userid:userid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getDialerAf: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_USER_DIALER, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_USER_DIALER, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_USER_DIALER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//saveEsigneringToken
export const saveEsigneringToken = ( userid, Afid,Token) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_SAVE_ESIGN});
     axios.put('kontos/Signering/save', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        Token:Token
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("saveEsigneringToken: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_SAVE_ESIGN, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_SAVE_ESIGN, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SAVE_ESIGN, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//getOldKontos
export const getOldKontos = () =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_GET_OLD_AF});
    axiosOld.get('kontos/OldAF/get',
    { params:{}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getOldKontos: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_OLD_AF, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_OLD_AF, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_OLD_AF, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
         // //dispatch(userSignOut())
       } 
     });
  }
}
//getOldUserKonto
export const getOldUserKonto = (OAfid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_GET_OLD_AF_USER});
    axiosOld.get('kontos/OldAF/getuser',
    { params:{Afid:OAfid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getOldUserKonto: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_OLD_AF_USER, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_OLD_AF_USER, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_OLD_AF_USER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
         // //dispatch(userSignOut())
       } 
     });
  }
}
//syncaOldWithNewUser
export const syncaOldWithNewUser = (userid,Afid,olduserid,oldAfid,funKtion) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_SYNC_USER});
    axiosOld.put('kontos/OldAF/Sync', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        olduserid:olduserid,
        oldAfid:oldAfid,
        funKtion:funKtion,
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      } 
    }).then(({data}) => {
      console.log("syncaOldWithNewUser: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_SYNC_USER, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_SYNC_USER, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SYNC_USER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
         // //dispatch(userSignOut())
       } 
     });
  }
}
//OpenFilterPopUp
export const OpenFilterPopUp = (userid, Afid, page)  =>{
  return (dispatch) => {
    switch(page){
      case "Avtal":dispatch({type: ON_OPEN_FILTER_AVTAL});break; 
      case "Prospekt":dispatch({type: ON_OPEN_FILTER_PROSPEKT});break; 
      case "Aktiviteter":dispatch({type: ON_OPEN_FILTER_AKTIVITETER});break; 
      case "Kunder":dispatch({type: ON_OPEN_FILTER_KUNDER});break; 
      case "Esignering":dispatch({type: ON_OPEN_FILTER_ESIGNERING});break; 
      case "Order":dispatch({type: ON_OPEN_FILTER_ORDER});break; 
      case "Möte":dispatch({type: ON_OPEN_FILTER_MOTE});break; 
      case "Dashboard":dispatch({type: ON_OPEN_FILTER_DASHBOARD});break; 
      case "DashboardAnpassad":dispatch({type: ON_OPEN_FILTER_DASHBOARD});break; 
      case "DashboardSalj":dispatch({type: ON_OPEN_FILTER_DASHBOARD_SALJ});break; 
      case "DashboardBokning":dispatch({type: ON_OPEN_FILTER_DASHBOARD_BOKA});break; 
      case "DashboardDialer":dispatch({type: ON_OPEN_FILTER_DASHBOARD_DIALER});break; 
      case "DashboardOrder":dispatch({type: ON_OPEN_FILTER_DASHBOARD_ORDER});break; 
      case "DashboardBarn":dispatch({type: ON_OPEN_FILTER_DASHBOARD_BARN});break; 
      case "Dashboardprospekt":dispatch({type: ON_OPEN_FILTER_DASHBOARD_PROSPEKT});break; 
      case "Dashboardpuls":dispatch({type: ON_OPEN_FILTER_DASHBOARD_PULS});break; 
      case "DashboardV2":dispatch({type: ON_OPEN_FILTER_DASHBOARD});break; 
      case "DashboardSaljV2":dispatch({type: ON_OPEN_FILTER_DASHBOARD_SALJ});break; 
      case "DashboardBokningV2":dispatch({type: ON_OPEN_FILTER_DASHBOARD_BOKA});break; 
      case "DashboardDialerV2":dispatch({type: ON_OPEN_FILTER_DASHBOARD_DIALER});break; 
      case "DashboardOrderV2":dispatch({type: ON_OPEN_FILTER_DASHBOARD_ORDER});break; 
      case "DashboardBarnV2":dispatch({type: ON_OPEN_FILTER_DASHBOARD_BARN});break; 
      case "DashboardprospektV2":dispatch({type: ON_OPEN_FILTER_DASHBOARD_PROSPEKT});break; 
      case "DashboardKontor":dispatch({type: ON_OPEN_FILTER_DASHBOARD_KONTOR});break; 
      case "Ärende":dispatch({type: ON_OPEN_FILTER_ARENDE});break; 
      case "Offert":dispatch({type: ON_OPEN_FILTER_OFFERT});break; 
      case "v2":dispatch({type: ON_OPEN_FILTER_OFFERT});break; 
      case "Projekt":dispatch({type: ON_OPEN_FILTER_PROJEKT});break; 
      case "ProjektKort":dispatch({type: ON_OPEN_FILTER_PROJEKTKORT});break; 
      case "Artiklar":dispatch({type: ON_OPEN_FILTER_ARTIKLAR});break; 
      case "Users":dispatch({type: ON_OPEN_FILTER_USERS});break; 
      case "SMScenter":dispatch({type: ON_OPEN_FILTER_SMSS});break; 
      case "Kampanj":dispatch({type: ON_OPEN_FILTER_CAMPAIGN});break; 
    }
  }
}


//closeFilterPopUp
export const closeFilterPopUp = ()  =>{
  return (dispatch) => {
    dispatch({type: ON_ClOSE_FILTER_AVTAL});
    dispatch({type: ON_ClOSE_FILTER_PROSPEKT});
    dispatch({type: ON_ClOSE_FILTER_AKTIVITETER});
    dispatch({type: ON_ClOSE_FILTER_KUNDER});
    dispatch({type: ON_ClOSE_FILTER_ORDER});
    dispatch({type: ON_ClOSE_FILTER_MOTE});
    dispatch({type: ON_ClOSE_FILTER_ESIGNERING});
    dispatch({type: ON_ClOSE_FILTER_DASHBOARD});
    dispatch({type: ON_ClOSE_FILTER_DASHBOARD_SALJ});
    dispatch({type: ON_ClOSE_FILTER_DASHBOARD_BOKA});
    dispatch({type: ON_ClOSE_FILTER_DASHBOARD_ORDER});
    dispatch({type: ON_ClOSE_FILTER_DASHBOARD_BARN});
    dispatch({type: ON_ClOSE_FILTER_DASHBOARD_DIALER});
    dispatch({type: ON_ClOSE_FILTER_DASHBOARD_PROSPEKT});
    dispatch({type: ON_ClOSE_FILTER_DASHBOARD_PULS});
    dispatch({type: ON_ClOSE_FILTER_DASHBOARD_KONTOR});
    dispatch({type: ON_ClOSE_FILTER_ARENDE});
    dispatch({type: ON_ClOSE_FILTER_ARTIKLAR});
    dispatch({type: ON_ClOSE_FILTER_OFFERT});
    dispatch({type: ON_ClOSE_FILTER_PROJEKT});
    dispatch({type: ON_ClOSE_FILTER_PROJEKTKORT});
    dispatch({type: ON_ClOSE_FILTER_USERS});
    dispatch({type: ON_ClOSE_FILTER_SMSS});
    dispatch({type: ON_ClOSE_FILTER_CAMPAIGN});
  }
}
//FlagThisHandelse
export const FlagThisHandelse = (Afid,userid,HandelseId,HandelseType,Flag,Orgnr) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_FLAGA_HANDELSE});
    axios.put('kontos/Handelse/Flag', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        HandelseId:HandelseId,
        HandelseType:HandelseType,
        Flag:Flag,
        Orgnr:Orgnr,
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      } 
    }).then(({data}) => {
      console.log("FlagThisHandelse: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_FLAGA_HANDELSE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_FLAGA_HANDELSE, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FLAGA_HANDELSE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//saveThisNewKund
export const saveThisNewKund = (userid,AFid,Kund) => {
  const jwt =  JSON.parse(localStorage.token);
       return (dispatch) => {
      dispatch({type: ON_START_NEW_KUND});
      axios.put('kontos/Kund/new', {
        method: 'PUT',
        body: {
          Kund:Kund,
          userid:userid,
          Afid:AFid
        }}, {
        headers: {
            'content-type': 'application/json',
            'Authorization':   `Bearer ${jwt}`
        }       
    }).then(({data}) => {
      console.log("saveThisNewKund: ", data.message);
      if (data.results) {
        dispatch({type: ON_NEW_KUND, payload: data.results});
        dispatch(getKontonByidRest1(AFid,userid))
        history.push({
          pathname: '/app/Kund',
          state: { Orgnr: data.results.Orgnr }
        });
      } else {
        dispatch({type: ON_ERROR_NEW_KUND, payload: data.error});
      }
      //dispatch(RefreshUserInterface(userid))
    })
    .catch(function (error) {
      dispatch({type: ON_ERROR_NEW_KUND, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
    });
    }
}
let errorCount = 0
//getNotisByUserid
export const getNotisByUserid = (userid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch(checkisExpired(jwt))
    dispatch({type: ON_START_GET_NOTIS});
    axios.get('kontos/Notis/getuser',
    { params:{userid:userid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
     // console.log("getNotisByUserid: ", data);
       if (data.results) {
        errorCount= 0
        // dispatch({type: FETCH_ALL_CONTACT});
          if(!isUndefined(data.results.inAktiv)){
            dispatch(userSignOut())
          }
         dispatch({type: ON_GET_NOTIS, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_NOTIS, payload: data.error});
         if (data.status === 401) {
         errorCount++;
         if(errorCount === 2){
          window.location.reload();
          errorCount = 0
        }
        }
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_NOTIS, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
        errorCount++;
        console.log(errorCount)
        //
        if(errorCount === 2){
          window.location.reload();
          errorCount = 0
        }
          //reload and remove token 
        //  dispatch(userSignOut())
       } 
     });
  }
}
//setSeenNotis
export const setSeenNotis = (userid) =>{
  const jwt =  JSON.parse(localStorage.token);
  console.log(userid)
return (dispatch) => {
    dispatch({type: ON_START_GET_NOTIS});
    axios.get('kontos/Notis/SetSeen',
    { params:{userid:userid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("setSeenNotis: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_NOTIS, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_NOTIS, payload: data.error});
       }
    dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_NOTIS, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  } /* */
}

//setToastrThisNotis
export const setToastrThisNotis = (userid,NotisId) =>{
  const jwt =  JSON.parse(localStorage.token);
  console.log(userid)
return (dispatch) => {
    dispatch({type: ON_START_GET_NOTIST});
    axios.get('kontos/Notis/SetToastr',
    { params:{userid:userid,NotisId:NotisId}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("setSeenNotis: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_NOTIST, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_NOTIST, payload: data.error});
       }
       ////dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_NOTIST, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  } /* */
}
//setDismissNotisByUserid
export const setDismissNotisByUserid = (userid) =>{
  const jwt =  JSON.parse(localStorage.token);
  console.log(userid)
return (dispatch) => {
    dispatch({type: ON_START_GET_NOTIS});
    axios.get('kontos/Notis/SetDismiss',
    { params:{userid:userid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("setSeenNotis: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_NOTIS, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_NOTIS, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_NOTIS, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  } /* */
}

export const setDismissThisNotisByUserid = (userid, notis) =>{
  const jwt =  JSON.parse(localStorage.token);
  console.log(userid)
  return (dispatch) => {
      dispatch({type: ON_START_GET_NOTIS});
      axios.put('kontos/Notis/SetDismissThisNotis',
      { body:{userid:userid,notis:notis}, 
      headers: { 'Authorization': `Bearer ${jwt}`} },      
      {headers: { 'Authorization': `Bearer ${jwt}`} }
      ).then(({data}) => {
        console.log("setSeenNotis: ", data);
        if (data.results) {
          // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_GET_NOTIS, payload: data.results});
        } else {
          dispatch({type: ON_ERROR_GET_NOTIS, payload: data.error});
        }
        dispatch(RefreshUserInterface(userid))
      }).catch(function (error) {
        dispatch({type: ON_ERROR_GET_NOTIS, payload: error.message});
            if(!isUndefined(error.response)){
          if (error.response.status === 401) {
            dispatch({type: FETCH_START_SET_UNAUTHE});
          } 
        } 
        if(error.message === "Network Error"){
            //reload and remove token 
            //dispatch(userSignOut())
        } 
      });
    } /* */
  }
 //AddnewObjekt
 export const AddnewObjekt = ( userid, Afid,Objekt, Type) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {

      let returnRes = {}

     dispatch({type: ON_START_NEW_UTOKNING});
     await axios.put('kontos/Utokning/new', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        Objekt:Objekt,
        Type:Type
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("AddnewObjekt: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_NEW_UTOKNING, payload: data.results});
         returnRes = data.results  
       } else {
         dispatch({type: ON_ERROR_NEW_UTOKNING, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_NEW_UTOKNING, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
     return returnRes
   }
 }

 //getCurrentObjektById
 export const getCurrentObjektById = (Afid,ObjektId,userid ) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_GET_UTOKNING});
    axios.get('kontos/Utokning/get',
    { params:{Afid:Afid,ObjektId:ObjektId}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
     // console.log("getNotisByUserid: ", data);
      if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({type: ON_GET_UTOKNING, payload: data.results});
      } else {
        dispatch({type: ON_ERROR_GET_UTOKNING, payload: data.error});
      }
     }).catch(function (error) {
      console.log("getCurrentObjektById error: ", error)
       dispatch({type: ON_ERROR_GET_UTOKNING, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//AddnewFalt
export const AddnewFalt = ( userid, Afid,Falt) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_NEW_FALT});
     axios.put('kontos/Utokning/Falt/new', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        Falt:Falt
      },
           
  },{
    headers: {
      'content-type': 'application/json',
      'Authorization':   `Bearer ${jwt}`
  }  
  }).then(({data}) => {
      console.log("AddnewFalt: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_NEW_FALT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_NEW_FALT, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_NEW_FALT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //SaveThisFalt
export const SaveThisFalt = ( userid, Afid,Falt) =>{
  console.log(Falt)
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_SAVE_FALT});
     axios.put('kontos/Utokning/Falt/save', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        Falt:Falt
      },      
    }, {
      headers: {
        'content-type': 'application/json',
        'Authorization':   `Bearer ${jwt}`
      } 
  }).then(({data}) => {
      console.log("SaveThisFalt: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_SAVE_FALT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_SAVE_FALT, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SAVE_FALT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//DeletFalt
export const DeletFalt = ( Afid,FaltId) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_FALT});
     axios.delete('kontos/Utokning/Falt/delete', {
      method: 'DELETE',
      data: {
        Afid:Afid,
        FaltId:FaltId
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("DeletFalt: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_FALT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DELETE_FALT, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_FALT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }

 
// ON_START_ADD_KALK_TEMP_ROW,
// ON_ADD_KALK_TEMP_ROW,
// ON_ERROR_ADD_KALK_TEMP_ROW,
//AddnewFalt
export const AddnewFaltKalkTemp = ( userid, Afid,Falt) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_ADD_KALK_TEMP_ROW});
     axios.put('kontos/Utokning/FaltK/new', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        Falt:Falt
      },
           
  },{
    headers: {
      'content-type': 'application/json',
      'Authorization':   `Bearer ${jwt}`
  }  
  }).then(({data}) => {
      console.log("AddnewFalt: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_ADD_KALK_TEMP_ROW, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_ADD_KALK_TEMP_ROW, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_ADD_KALK_TEMP_ROW, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 // ON_START_UPDATE_KALK_TEMP_ROW,
 // ON_UPDATE_KALK_TEMP_ROW,
 // ON_ERROR_UPDATE_KALK_TEMP_ROW,
 //SaveThisFalt
export const SaveThisFaltKalkTemp = ( userid, Afid,Falt) =>{
  console.log(Falt)
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_UPDATE_KALK_TEMP_ROW});
     axios.put('kontos/Utokning/FaltK/save', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        Falt:Falt
      },      
    }, {
      headers: {
        'content-type': 'application/json',
        'Authorization':   `Bearer ${jwt}`
      } 
  }).then(({data}) => {
      console.log("SaveThisFalt: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_UPDATE_KALK_TEMP_ROW, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_UPDATE_KALK_TEMP_ROW, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_KALK_TEMP_ROW, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 // ON_START_DELETE_KALK_TEMP_ROW,
 // ON_DELETE_KALK_TEMP_ROW,
 // ON_ERROR_DELETE_KALK_TEMP_ROW,
//DeletFalt
export const DeletFaltKalkTemp = ( Afid,FaltId) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_KALK_TEMP_ROW});
     axios.delete('kontos/Utokning/FaltK/delete', {
      method: 'DELETE',
      data: {
        Afid:Afid,
        FaltId:FaltId
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("DeletFalt: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_KALK_TEMP_ROW, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DELETE_KALK_TEMP_ROW, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_KALK_TEMP_ROW, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }

 export const getFiraFaltRapport = (Name, ObjId, Columns,Haveid, Havesdate, Haveorgnr,HaveAfname, HaveAnsvarigName, Afid, Ansvarig,Utrustning, SheetName) => {
  console.log(ObjId)
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_FETCH_UTOKNING_RAPPORT})
     axios.get('kontos/Utokning/Falt/rapport',  { params:{
      ObjId,
      Columns,
      Haveid,
      Havesdate,
      Haveorgnr,
      HaveAfname,
      HaveAnsvarigName,
      Name,
      Afid,
      Ansvarig,
      Utrustning,
      SheetName
    }, 
     responseType: 'arraybuffer' ,
     headers: { 'Authorization': `Bearer ${jwt}`} } ).then((resp) => {
      // console.log(resp)
      const dirtyFileName = resp.headers['content-disposition'];
      const regex = /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/;
      var  fileName = dirtyFileName.match(regex)[3];
      var blob = new Blob([resp.data], 
       { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
     );
     fileSaver.saveAs(blob, fileName);
     dispatch({type: ON_FETCH_UTOKNING_RAPPORT})
     }).catch(function (error) {
      dispatch({type: ON_ERROR_FETCH_UTOKNING_RAPPORT})
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
 }
 export const getFiraFaltMall = (Afid, Userid, ObjId ) => {
  console.log(ObjId)
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_FETCH_UTOKNING_RAPPORT})
     axios.get('kontos/Utokning/Falt/mall',  { params:{
      Afid, Userid, ObjId
    }, 
     responseType: 'arraybuffer' ,
     headers: { 'Authorization': `Bearer ${jwt}`} } ).then((resp) => {
      // console.log(resp)
      const dirtyFileName = resp.headers['content-disposition'];
      const regex = /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/;
      var  fileName = dirtyFileName.match(regex)[3];
      var blob = new Blob([resp.data], 
       { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
     );
     fileSaver.saveAs(blob, fileName);
     dispatch({type: ON_FETCH_UTOKNING_RAPPORT})
     dispatch(RefreshUserInterface(Userid))
     }).catch(function (error) {
      dispatch({type: ON_ERROR_FETCH_UTOKNING_RAPPORT})
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
 }


export const archiveUtokand = (ObjektId,ObjektNamn, archive, Afid, Userid) => {
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_SAVE_FALT});
    axios.put('kontos/Kund/UTOKNING/archive', {
     method: 'PUT',
     body: {
       id:ObjektId,
       name:ObjektNamn,
       archive,
       Afid
     },
          
 },{
  headers: {
    'content-type': 'application/json',
    'Authorization':   `Bearer ${jwt}`
} 
 }).then(({data}) => {
      console.log("Success: ", data)
      dispatch({type: ON_ARCHIVE_KONTO_OBJECT, payload: data.results});
      // dispatch(getKontonByid(Kontoid, Userid))
    }).catch(function (error) {
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
    });
  }
}
export const changeUtokandName = (ObjektId, name, Afid, Userid, vy,KanKoppla, ObjektType,ProspektKalkyl,Beskrivning) => {
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_SAVE_FALT});
    axios.put('kontos/Kund/UTOKNING/name', {
     method: 'PUT',
     body: {
       id:ObjektId,
       name,
       vy,
       KanKoppla,
       Afid,
       Userid,
       ObjektType,ProspektKalkyl,Beskrivning
     },
          
 }, {
  headers: {
    'content-type': 'application/json',
    'Authorization':   `Bearer ${jwt}`
} 
 }).then(({data}) => {
        console.log("Success: ", data)
        dispatch({type: ON_SAVE_KONTO_OBJECT, payload: data.results});
        // dispatch(getKontonByid(Kontoid, Userid))
    }).catch(function (error) {
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
    });
  }
}
//SaveNewKundUtoknad
export const SaveNewKundUtoknad = (Afid,userid,Orgnr,newObjekt,ObjektId, GetByAfidFlag, Offset, KundnrAf, AvtalId = 0, UpdateAvtalOpt = 0) =>{
  const jwt =  JSON.parse(localStorage.token);
 // console.log(newObjekt)
 // console.log(newObjekt.Bild)
  let NewObjektBild = newObjekt.filter(item =>{ return item.TypeS === "Bild"})
 // console.log(NewObjektBild[0])
  
  let files = isEmpty(NewObjektBild)?[]:NewObjektBild[0].Value
  var fromdata = new FormData();
  fromdata.append("Orgnr",Orgnr)
  fromdata.append("AvtalId",AvtalId)
  fromdata.append("UpdateAvtalOpt",UpdateAvtalOpt)
  fromdata.append("Afid",Afid)
  fromdata.append("userid",userid)
  fromdata.append("ObjektId",ObjektId)
  fromdata.append("newObjekt",JSON.stringify(newObjekt))
  fromdata.append('files[]', files)
/* */ return (dispatch) => {
    dispatch({type: ON_START_KUND_NEW_UTOKNING});
    axios.post('kontos/Kund/UTOKNING/new',
    fromdata,
    {
      body:{
        Orgnr:Orgnr,
        AvtalId:AvtalId,
        Afid:Afid,
        userid:userid,
        ObjektId:ObjektId,
        newObjekt:newObjekt,
        Offset:Offset,
        KundnrAf:KundnrAf,
        UpdateAvtalOpt:UpdateAvtalOpt
       },
      headers: {
        'content-type': 'application/json',
        'Authorization':   `Bearer ${jwt}`
    } 
     }
    )
    .then(({data}) => {
      if (data.results) {
        dispatch({type: ON_KUND_NEW_UTOKNING, payload: data.results});
        if(AvtalId  !== 0) {
          dispatch({type: ON_SET_CURRENT_AVTAL_ANTAL_FRIA, payload: data.results});
          dispatch(getAvtalUpdatedKalkyl(Afid,userid,Orgnr,AvtalId))
        }
        if(!isUndefined(GetByAfidFlag))
          dispatch(getUtokningByAfid(Afid,userid,-1, ObjektId, Offset))
      }
      else{
        dispatch({type: ON_ERROR_KUND_NEW_UTOKNING, payload: data.error});
      }
      // if(!isEmpty(Title)){
      //   dispatch({type: ON_START_MESSAGE_KUND,payload:`Hämtar ${Title}`});
      //   //ON_START_MESSAGE_KUND,ON_MESSAGE_KUND,ON_ERROR_MESSAGE_KUND,
      // }
      // dispatch({type: ON_START_GET_UTOKNING_BY_ORGNR});
      // setTimeout(() => {
      // axios.get('kontos/Kund/UTOKNING/get',
      // { params:{
      //   Orgnr:Orgnr,
      //   AvtalId:AvtalId,
      //   Afid:Afid,
      //   ObjektId:ObjektId,
      //   userid:userid,
      //   KundnrAf:KundnrAf,
      // }, 
      //  headers: { 'Authorization': `Bearer ${jwt}`} }      
      //  ).then(({data}) => {
      //   console.log("getKundAvtalProspekt: ", data);
      //    if (data.results) {
      //     dispatch({type: ON_GET_UTOKNING_BY_ORGNR, payload: data.results});
      //     if(!isUndefined(GetByAfidFlag))
      //       dispatch(getUtokningByAfid(Afid,userid,-1, ObjektId, Offset))
      //    } else {
      //      dispatch({type: ON_ERROR_UTOKNING_BY_ORGNR, payload: data.error});
      //   }
      //  }).catch(function (error) {
      //    dispatch({type: ON_ERROR_UTOKNING_BY_ORGNR, payload: error.message});
      //       if(!isUndefined(error.response)){
      //   if (error.response.status === 401) {
      //     dispatch({type: FETCH_START_SET_UNAUTHE});
      //    } 
      //  } 
      //  if(error.message === "Network Error"){
      //     //reload and remove token 
      //     //dispatch(userSignOut())
      //  } 
      //  });
      // },
      // 5000)
    })
    .catch(function (error) {
      dispatch({type: ON_ERROR_KUND_NEW_UTOKNING, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
    });
  }
  
 }
 
//  ON_START_UPDATE_KUND_UTOKNING_BY_AFID,
//  ON_ERROR_UPDATE_KUND_UTOKNING_BY_AFID,
//  ON_UPDATE_KUND_UTOKNING_BY_AFID,
export const UpdateKundUtokning = (Afid,userid,Orgnr,FaltId,ObjektId,Offset,SearchString = "", sortObj = {}) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_UPDATE_KUND_UTOKNING_BY_AFID});
    axios.put('kontos/Kund/UTOKNING/updateKund',
    {
      body:{
        Orgnr:Orgnr,
        Afid:Afid,
        userid:userid,
        FaltId:FaltId
       },
    },
    {
       headers: {
        'Authorization':   `Bearer ${jwt}`
      }
    }
    )
    .then(({data}) => {
      if (data.results) {
        dispatch({type: ON_UPDATE_KUND_UTOKNING_BY_AFID, payload: data.results});
        if(SearchString === "") dispatch(getUtokningByAfid(Afid,userid,-1, ObjektId, Offset, undefined, 30, undefined, sortObj))
        // Afid,userid,Orgnr,ObjektId, Offset, BufferFlag, Limit, cacheFlag, sortObj = {}
        if(SearchString !== "") dispatch(searchUtokning(Afid, userid, ObjektId, SearchString, 0, sortObj))
      }
      else{
        dispatch({type: ON_ERROR_UPDATE_KUND_UTOKNING_BY_AFID, payload: data.error});
      }
      
    })
    .catch(function (error) {
      dispatch({type: ON_ERROR_UPDATE_KUND_UTOKNING_BY_AFID, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
    });
  }
  
 }
 
//ongetUtokningDescription
export const ongetUtokningDescription = (Afid,userid,Orgnr,ObjectID,AvtalId = 0) => {
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_GET_UTOKNING_DESC_BY_ORGNR});
    axios.get('kontos/Kund/UTOKNING/desc/get',
    { params:{
      Orgnr:Orgnr,
      Afid:Afid,
      ObjectID:ObjectID,
      userid:userid,
      AvtalId:AvtalId
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getKundAvtalProspekt: ", data);
       if (data.results) {
        dispatch({type: ON_GET_UTOKNING_DESC_BY_ORGNR, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_UTOKNING_DESC_BY_ORGNR, payload: data.error});
      }
      dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_UTOKNING_DESC_BY_ORGNR, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}
//onSaveUtokningDescription
export const onSaveUtokningDescription = (Afid,userid,Orgnr,ObjectID,description,AvtalId = 0) => {
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_SAVE_UTOKNING_DESC_BY_ORGNR});
    axios.put('kontos/Kund/UTOKNING/desc/update', {
     method: 'PUT',
     body: {
      Afid:Afid,
      userid:userid,
      Orgnr:Orgnr,
      description:description,
      AvtalId:AvtalId,
      ObjectID:ObjectID
     }}, {
     headers: {
         'content-type': 'application/json',
         'Authorization':   `Bearer ${jwt}`
     }       
 }).then(({data}) => {
     console.log("onSaveUtokningDescription: ", data);
      if (data.results) {
       // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({type: ON_SAVE_UTOKNING_DESC_BY_ORGNR, payload: data.results});
      } else {
        dispatch({type: ON_ERROR_SAVE_UTOKNING_DESC_BY_ORGNR, payload: data.error});
      }
      //dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
      dispatch({type: ON_ERROR_SAVE_UTOKNING_DESC_BY_ORGNR, payload: error.message});
         if(!isUndefined(error.response)){
       if (error.response.status === 401) {
         dispatch({type: FETCH_START_SET_UNAUTHE});
        } 
      } 
      if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      } 
    });
  }
}
//getUtokningByOrgnr
export const getUtokningByOrgnr = (Afid,userid,  Orgnr,ObjektId, KundnrAf, Offset, Search,Title, AvtalId = 0) =>{
  Title = isUndefined(Title)?"":Title
  const jwt =  JSON.parse(localStorage.token);
  console.log("----------")
  console.log(KundnrAf)
  console.log("----------")
   return (dispatch) => {
    dispatch({type: ON_START_GET_UTOKNING_BY_ORGNR});
    if(!isEmpty(Title)){
      dispatch({type: ON_START_MESSAGE_KUND,payload:translate("Action.Client.Extension.fetching",`Hämtar ${Title}`,{item:Title})});
      //ON_START_MESSAGE_KUND,ON_MESSAGE_KUND,ON_ERROR_MESSAGE_KUND,
    }
    axios.get('kontos/Kund/UTOKNING/get',
    { params:{
      Orgnr:Orgnr,
      KundnrAf:KundnrAf,
      Afid:Afid,
      ObjektId:ObjektId,
      userid:userid,
      Offset:Offset,
      Search:Search,
      AvtalId:AvtalId
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getKundAvtalProspekt: ", data);
       if (data.results) {
        dispatch({type: ON_GET_UTOKNING_BY_ORGNR, payload: data.results});
        if(!isEmpty(Title)){
        dispatch({type: ON_MESSAGE_KUND,payload:translate("Action.Client.Extension.fetch",`${Title} hämtats`,{item:Title})});
        }
       } else {
         dispatch({type: ON_ERROR_UTOKNING_BY_ORGNR, payload: data.error});
         dispatch({type: ON_MESSAGE_KUND,payload:translate("Error.Client.Extension.fetch",`Error 2011: Kunde inte hämta ${Title}!`,{item:Title})});
      }
      dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UTOKNING_BY_ORGNR, payload: error.message});
       dispatch({type: ON_ERROR_MESSAGE_KUND,payload:translate("Error.Client.Extension.fetch",`Error 2011: Kunde inte hämta ${Title}!`,{item:Title})});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}
export const getUtokningListByOrgnr = (Afid,userid, Orgnr, AvtalId = 0) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
    dispatch({type: ON_START_GET_UTOKNING_LIST_BY_ORGNR});
    axios.get('kontos/Kund/UTOKNINGLIST/get',
    { params:{
      Orgnr:Orgnr,
      Afid:Afid,
      userid:userid,
      AvtalId:AvtalId
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getUtokningListByOrgnr: ", data);
       if (data.results) {
        dispatch({type: ON_GET_UTOKNING_LIST_BY_ORGNR, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_UTOKNING_LIST_BY_ORGNR, payload: data.error});
      }
      dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UTOKNING_LIST_BY_ORGNR, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}


//Sök Utokning 

export const searchUtokning = (Afid, userid, ObjektId, SearchString, KartaFlag, sortObj = {},AnsvarigFilter=[],FFilter=[]) => {
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
    dispatch({type: ON_START_SEARCH_UTOKNING_BY_AFID});
    axios.get('kontos/Kund/UTOKNING/search',
    { 
      params:{
      Afid,
      ObjektId,
      userid,
      SearchString,
      sortObj,
      AnsvarigFilter,
      FFilter
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("SEARCH UTOKNING: ", data);
       if (data.results) {
        dispatch({type: ON_SEARCH_UTOKNING_BY_AFID, payload: data.results, KartaFlag});
       } else {
         dispatch({type: ON_ERROR_SEARCH_UTOKNING_BY_AFID, payload: data.error});
        }
        dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SEARCH_UTOKNING_BY_AFID, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}

export const getUtokningLogg = (FaltId, Båtid) => {
  const jwt =  JSON.parse(localStorage.token);
  let _Båtid = isUndefined(Båtid) ? 0 : Båtid.Value
   return (dispatch) => {
    dispatch({type: ON_START_GET_UTOKNING_LOGG});
    axios.get('kontos/Kund/UTOKNING/logg',
    { 
      params:{
      FaltId,
      Båtid: _Båtid
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("UTOAKNING LOGG: ", data);
      if(data.results)
        dispatch({type: ON_GET_UTOKNING_LOGG, payload: data.results});
      else  
        dispatch({type: ON_ERROR_GET_UTOKNING_LOGG, payload: data.error})
     }).catch(function (error) {
        dispatch({type: ON_ERROR_GET_UTOKNING_LOGG, payload: error.message})
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}

//getUtokningByAFID
//Hämtar utokning (Orgnr != Orgnr, Afid = Afid)
export const getUtokningByAfid = (Afid,userid,Orgnr,ObjektId, Offset, BufferFlag, Limit, cacheFlag, sortObj = {},filter=[],AnsvarigFilter=[],FFilter=[]) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
    dispatch({type: ON_START_GET_UTOKNING_BY_AFID});
    axios.get('kontos/Kund/UTOKNING/getAfid',
    { params:{
      Orgnr:Orgnr,
      Afid:Afid,
      ObjektId:ObjektId,
      userid:userid,
      Offset,
      Limit,
      sortObj,
      filter,
      AnsvarigFilter,
      FFilter
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
       if(isUndefined(BufferFlag)){
        // console.log("ON_GET_UTOKNING_BY_AFID: ", data);
        if (data.success) {
         dispatch({type: ON_GET_UTOKNING_BY_AFID, payload: data.results});
         if(!isUndefined(cacheFlag)){
          dispatch({type: ON_CACHE_UTOKNING_BY_AFID, payload: {results: data.results, ObjektId}});
         }
        } else {
          dispatch({type: ON_ERROR_UTOKNING_BY_AFID, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
       } else {
        if (data.results) {
          dispatch({type: ON_BUFFER_UTOKNING_BY_AFID, payload: data.results});
          console.log(data.results)
         } else {
           dispatch({type: ON_ERROR_UTOKNING_BY_AFID, payload: data.error});
       }
      }
      //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       console.log(1111)
       dispatch({type: ON_ERROR_UTOKNING_BY_AFID, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}
export const loadCachedUtokning = (ObjectId) => {
  return (dispatch) => {
    dispatch({type: ON_LOAD_CACHE_UTOKNING_BY_AFID, payload: {ObjectId}})
  }
}
export const bufferUtokningByAfid = (Afid,userid,Orgnr,ObjektId, Count) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    dispatch({type: ON_START_BUFFER_UTOKNING_BY_AFID});
    let _buffers = Math.floor(Count / 30)
    for (let index = 0; index < _buffers; index++) {
      // const element = array[index];
      console.log(index)
      await dispatch(getUtokningByAfid(Afid,userid,Orgnr,ObjektId, index, 1))
    }
    
  }
}

//deleteKundUtoknad
export const deleteKundUtoknad = (Afid,userid,Orgnr,dRad, OIdFlag, Offset, Search = "", AvtalId = 0) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_UTOKNING_BY_ORGNR});
     axios.delete('kontos/Kund/UTOKNING/delete', {
      method: 'DELETE',
      data: {
        Orgnr:Orgnr,
        Afid:Afid,
        dRad:dRad,
        userid:userid,
        Search: Search,
        Offset: Offset,
        AvtalId: AvtalId,
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("deleteKundUtoknad: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
        if(!isUndefined(OIdFlag)){
            dispatch((getUtokningByAfid(Afid,userid,-1,OIdFlag, Offset)))
          }
          if(AvtalId  !== 0) dispatch({type: ON_SET_CURRENT_AVTAL_ANTAL_FRIA, payload: data.results});
          dispatch({type: ON_DELETE_UTOKNING_BY_ORGNR, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DELETE_UTOKNING_BY_ORGNR, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_UTOKNING_BY_ORGNR, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 } 

//SaveThisKundUtoknad
export const SaveThisKundUtoknad = (Afid,userid,Orgnr,newObjekt,ObjektId,faltId, GetByAfidFlag, Offset, KundnrAf, Search="", AvtalId = 0, UpdateAvtalOpt = 0, UpdateOfferts=[]) =>{
  const jwt =  JSON.parse(localStorage.token);
  let NewObjektBild = newObjekt.UtokningRows.filter(item =>{ return item.TypeS === "Bild"})
  let files = isUndefined(NewObjektBild[0])?[]:NewObjektBild[0].Value
  var fromdata = new FormData();
  fromdata.append("AvtalId",AvtalId)
  fromdata.append("UpdateAvtalOpt",UpdateAvtalOpt)
  fromdata.append("UpdateOfferts",UpdateOfferts.join(','))
  fromdata.append("Orgnr",Orgnr)
  fromdata.append("Afid",Afid)
  fromdata.append("userid",userid)
  fromdata.append("ObjektId",ObjektId)
  fromdata.append("faltId",faltId)
  fromdata.append("newObjekt",JSON.stringify(newObjekt))
  fromdata.append("Offset",Offset)
  fromdata.append("Search",Search)
  fromdata.append('files[]', files)
  return (dispatch) => {
    dispatch({type: ON_START_KUND_UPDATE_UTOKNING});
    axios.post('kontos/Kund/UTOKNING/update',
    fromdata,
    {
      body:{
        Orgnr:Orgnr,
        Afid:Afid,
        userid:userid,
        ObjektId:ObjektId,
        faltId:faltId,
        newObjekt:newObjekt,
        Offset:Offset,
        Search:Search,
        AvtalId:AvtalId,
        UpdateAvtalOpt:UpdateAvtalOpt,
        UpdateOfferts:UpdateOfferts.join(',')
       },
       headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization':   `Bearer ${jwt}`
      }
    }
    )
    .then(({data}) => {
      //
      if (data.results) {
        dispatch({type: ON_KUND_UPDATE_UTOKNING, payload: data.results});
        if(AvtalId  !== 0) {
          dispatch(getAvtalUpdatedKalkyl(Afid,userid,Orgnr,AvtalId))
        }
        if(!isUndefined(GetByAfidFlag))
          dispatch(getUtokningByAfid(Afid,userid,-1, ObjektId, Offset))
      }
      else{
        dispatch({type: ON_ERROR_KUND_UPDATE_UTOKNING, payload: data.error});
      }
    })
    .catch(function (error) {
      dispatch({type: ON_ERROR_KUND_UPDATE_UTOKNING, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
    });
  }
 }
//AddnewKedjaKlient
export const AddnewKedjaKlient = (Afid,Kedja,userid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_NEW_AFID_KEDJA});
     axios.put('kontos/Kedja/new', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        Kedja:Kedja
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("AddnewKedjaKlient: ", data);
       if (data) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_NEW_AFID_KEDJA, payload: data});
       } else {
         dispatch({type: ON_ERROR_NEW_AFID_KEDJA, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_NEW_AFID_KEDJA, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
export const SetKedjaHasArendeRapport = (Afid,KedjaId,userid, HasArendeRapport= 0) => {
  const jwt =  JSON.parse(localStorage.token);
       return (dispatch) => {
      dispatch({type: ON_START_UPDATE_AFID_KEDJA});
      axios.put('kontos/Kedja/setHasArendeRapport',
    {
    method: 'PUT',
    body:{
			Afid,
			KedjaId,
			HasArendeRapport,
      userid:userid,
    }}, {
     headers: { 'Authorization': `Bearer ${jwt}`}   }
     ).then(({data}) => {
      console.log("Update kedja has arende: ", data.message);
      if (data.success) {
        dispatch({type: ON_UPDATE_AFID_KEDJA, payload: data});
      } else {
        dispatch({type: ON_ERROR_UPDATE_AFID_KEDJA, payload: data.error});
      }
      //dispatch(RefreshUserInterface(userid))
    })
    .catch(function (error) {
      dispatch({type: ON_ERROR_UPDATE_AFID_KEDJA, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
    });
    }
}
//DeleteKedjaKlient
export const DeleteKedjaKlient = (AfObj,Kedja,userid) => {
  const jwt =  JSON.parse(localStorage.token);
       return (dispatch) => {
      dispatch({type: ON_START_DELETE_AFID_KEDJA});
      axios.put('kontos/Kedja/Delete',
    {
    method: 'PUT',
    body:{
      AfObj:AfObj,
      userid:userid,
      Kedja:Kedja,
    }}, {
     headers: { 'Authorization': `Bearer ${jwt}`}   }
     ).then(({data}) => {
      console.log("DeleteKedjaKlient: ", data.message);
      if (data.success) {
        dispatch({type: ON_DELETE_AFID_KEDJA, payload: data});
      } else {
        dispatch({type: ON_ERROR_DELETE_AFID_KEDJA, payload: data.error});
      }
      //dispatch(RefreshUserInterface(userid))
    })
    .catch(function (error) {
      dispatch({type: ON_ERROR_DELETE_AFID_KEDJA, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
    });
    }
}
//setThisserchedKund
export const setThisserchedKund = (Kund) => {
  if(!isEmpty(Kund))
  {
    return (dispatch) => {
    dispatch({type: ON_GET_NEW_KUND_BASIC, payload: {Kund:Kund}});
   }
  }
}
//setKundPage
export const setKundPage = (Page) => {
  return (dispatch) => {
    dispatch({type: ON_GET_KUNDER_PAGE_BASIC, payload: {Page:Page}});
   }
}
//setKundPagerows
export const setKundPagerows = (Page) => {
  return (dispatch) => {
    dispatch({type: ON_GET_KUNDER_PAGE_ROWS_BASIC, payload: {Page:Page}});
   }
}
//setKundSearch
export const setKundSearch = (Search) => {
  return (dispatch) => {
    dispatch({type: ON_GET_KUNDER_SEARCH_BASIC, payload: {KundSearch:Search}});
   }
}
//setKontaktPage
export const setKontaktPage = (Page) => {
  return (dispatch) => {
    dispatch({type: ON_GET_KONTAKT_PAGE_BASIC, payload: {Page:Page}});
   }
}
//setTabIndex
export const setTabIndex = (TabIndex) => {
  return (dispatch) => {
    dispatch({type: ON_GET_KUND_TABINDEX, payload: {TabIndex:TabIndex}});
   }
}
//setSortByObej
export const setSortByObej = (SortObj) => {
  return (dispatch) => {
    dispatch({type: ON_GET_KUND_SORTOBJ, payload: {SortObj:SortObj}});
   }
}
//setFilterOption
export const setFilterOption = (Meta,FilterList) => {
  
  return (dispatch) => {
    console.log(Meta,"ASDddd")
    switch(Meta){
      case "Kunder": dispatch({type:SET_KUNDER_FILTER,payload:FilterList}); break;
      case "Prospekt": dispatch({type:SET_PROSPEKT_FILTER,payload:FilterList});break;
      case "Avtal": dispatch({type:SET_AVTAL_FILTER,payload:FilterList});break;
      case "Event": dispatch({type:SET_EVENT_FILTER,payload:FilterList});break;
      case "Esignering": dispatch({type:SET_ESIGNERING_FILTER,payload:FilterList});break;
      case "Dashboard": dispatch({type:SET_DASHBORD_FILTER,payload:FilterList});break;
      case "DashboardSalj": dispatch({type:SET_DASHBORD_SALJ_FILTER,payload:FilterList});break;
      case "DashboardBokning": dispatch({type:SET_DASHBORD_BOKA_FILTER,payload:FilterList});break;
      case "DashboardDialer": dispatch({type:SET_DASHBORD_DIALER_FILTER,payload:FilterList});break;
      case "DashboardOrder": dispatch({type:SET_DASHBORD_ORDER_FILTER,payload:FilterList});break;
      case "DashboardBarn": dispatch({type:SET_DASHBORD_BARN_FILTER,payload:FilterList});break;
      case "DashboardProspekt": dispatch({type:SET_DASHBORD_PROSPEKT_FILTER,payload:FilterList});break;
      case "DashboardPuls": dispatch({type:SET_DASHBORD_PULS_FILTER,payload:FilterList});break;
      case "DashboardV2": dispatch({type:SET_DASHBORD_FILTER,payload:FilterList});break;
      case "DashboardSaljV2": dispatch({type:SET_DASHBORD_SALJ_FILTER,payload:FilterList});break;
      case "DashboardBokningV2": dispatch({type:SET_DASHBORD_BOKA_FILTER,payload:FilterList});break;
      case "DashboardDialerV2": dispatch({type:SET_DASHBORD_DIALER_FILTER,payload:FilterList});break;
      case "DashboardOrderV2": dispatch({type:SET_DASHBORD_ORDER_FILTER,payload:FilterList});break;
      case "DashboardBarnV2": dispatch({type:SET_DASHBORD_BARN_FILTER,payload:FilterList});break;
      case "DashboardProspektV2": dispatch({type:SET_DASHBORD_PROSPEKT_FILTER,payload:FilterList});break;
      case "DashboardKontor": dispatch({type:SET_DASHBORD_KONTOR_FILTER,payload:FilterList});break;
      case "DashboardAnpassad": dispatch({type:SET_DASHBORD_ANPASSAD_FILTER,payload:FilterList});break;
      case "Order": dispatch({type:SET_ORDER_FILTER,payload:FilterList});break;
      case "Aktiviteter": dispatch({type:SET_AKTIVITETER_FILTER,payload:FilterList});break;
      case "Ärende": dispatch({type:SET_ARENDE_FILTER,payload:FilterList});break;
      case "Offert": dispatch({type:SET_OFFERT_FILTER,payload:FilterList});break;
      case "Projekt": dispatch({type:SET_PROJEKT_FILTER,payload:FilterList});break;
      case "ProjektKort": dispatch({type:SET_PROJEKTKORT_FILTER,payload:FilterList});break;
      case "Artiklar": dispatch({type:SET_ARTIKLAR_FILTER,payload:FilterList});break;
      case "Users": dispatch({type:SET_USERS_FILTER,payload:FilterList});break;
      case "SMSs": dispatch({type:SET_SMSS_FILTER,payload:FilterList});break;
      case "Kampanj": dispatch({type:SET_CAMPAIGN_FILTER,payload:FilterList});break;
    }
  }
}
//onUpdateDialerSetting
export const onUpdateDialerSetting = (  Afid,userid,Meta,Value) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_SAVE_DIALER});
     axios.put('kontos/Dialer/save', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        Meta:Meta,
        Value:Value,
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("onUpdateDialerSetting: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_SAVE_DIALER, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_SAVE_DIALER, payload: data.message});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SAVE_DIALER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//onUpdateUserDialerSetting
export const onUpdateUserDialerSetting = (  Afid,userid,FuncJson) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_SAVE_USER_DIALER});
     axios.put('kontos/Dialer/user/save', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        FuncJson:FuncJson
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("onUpdateUserDialerSetting: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_SAVE_USER_DIALER, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_SAVE_USER_DIALER, payload: data.message});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SAVE_USER_DIALER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//AddToEjSvarList
export const AddToEjSvarList = (  Afid,userid,name) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_DIALER_ADD_EJSVAR});
     axios.put('kontos/Dialer/EjSvar/Add', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        name:name,
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("AddToEjSvarList: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DIALER_ADD_EJSVAR, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DIALER_ADD_EJSVAR, payload: data.message});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DIALER_ADD_EJSVAR, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//AddToNejTackList
export const AddToNejTackList = (  Afid,userid,name) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_DIALER_ADD_NEJTACK});
     axios.put('kontos/Dialer/NejTack/Add', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        name:name,
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("AddToNejTackList: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DIALER_ADD_NEJTACK, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DIALER_ADD_NEJTACK, payload: data.message});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DIALER_ADD_NEJTACK, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }

 //removeThisFromNejtackList
 export const removeThisFromNejtackList = (  Afid,userid,chip) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_DIALER_ADD_NEJTACK});
     axios.put('kontos/Dialer/NejTack/delete', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        chip:chip,
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("removeThisFromNejtackList: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DIALER_DELETE_NEJTACK, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DIALER_ADD_NEJTACK, payload: data.message});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DIALER_ADD_NEJTACK, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //removeThisFromEjSvarList
 export const removeThisFromEjSvarList = (  Afid,userid,chip) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_DIALER_ADD_EJSVAR});
     axios.put('kontos/Dialer/EjSvar/delete', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        chip:chip,
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("removeThisFromEjSvarList: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DIALER_DELETE_EJSVAR, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DIALER_ADD_EJSVAR, payload: data.message});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DIALER_ADD_EJSVAR, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 
 //updateThisDocKund
 export const updateThisDocKund = (Afid,userid,Updatedrad,Orgnr,page,searchWord) =>{
  page = isUndefined(page)?0:page
  searchWord = isUndefined(searchWord)?"":searchWord
  const jwt =  JSON.parse(localStorage.token);
  return async(dispatch) => {
    const ipAdress="0.0.0.0"
    dispatch({type: ON_START_UPDATE_KUND_DOCUMENT});
    axios.put('kontos/Document/update', {
     method: 'PUT',
     body: {
       userid:userid,
       Afid:Afid,
       Updatedrad:Updatedrad,
       Orgnr:Orgnr,
       Page:page,
       searchWord:searchWord,
       ipAdress:ipAdress,
     }}, {
     headers: {
         'content-type': 'application/json',
         'Authorization':   `Bearer ${jwt}`
     }       
 }).then(({data}) => {
     console.log("updateThisDocKund: ", data);
      if (data.results) {
       // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({type: ON_UPDATE_KUND_DOCUMENT, payload: data.results});
      } else {
        dispatch({type: ON_ERROR_UPDATE_KUND_DOCUMENT, payload: data.message});
      }
    }).catch(function (error) {
      dispatch({type: ON_ERROR_UPDATE_KUND_DOCUMENT, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
      if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      } 
    });
  }
 }
 //savethisNewDocument
  export const savethisNewDocument = (Afid,userid,Orgnr,Document, UploadOnedrive = 0) =>{
  const jwt =  JSON.parse(localStorage.token);
  let files = Document.file; 
  var fromdata = new FormData();
  fromdata.append("Orgnr",Orgnr)
  fromdata.append("Afid",Afid)
  fromdata.append("userid",userid)
  fromdata.append("name",Document.name)
  fromdata.append("UploadOnedrive",UploadOnedrive)
  fromdata.append("Type","Dokument")
  files.forEach(file => fromdata.append('files[]', file));
  return (dispatch) => {
    dispatch({type: ON_START_ADD_DOCUMENT});
    axios.post('kontos/Document/new',
    fromdata,
     {
       body:{
        Orgnr:Orgnr,
        Afid:Afid,
        userid:userid,
        UploadOnedrive,
        name:Document.name,
        Type:"Dokument"
       },
       headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization':   `Bearer ${jwt}`
        }
     }
     ).then(({data}) => {
    console.log("savethisNewDocument: ", data);
     if (data.results) {
      // dispatch({type: FETCH_ALL_CONTACT});
       dispatch({type: ON_ADD_DOCUMENT, payload: data.results});
     } else {
       dispatch({type: ON_ERROR_ADD_DOCUMENT, payload: data.error});
     }
     //dispatch(RefreshUserInterface(userid))
   }).catch(function (error) {
     dispatch({type: ON_ERROR_ADD_DOCUMENT, payload: error.message});
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
   });
  } 
 }
 export const SyncThisDocumentOnedrive = (Afid, Userid, Orgnr, Docid, Doctype, type = 0, page, searchWord, Mallmodul) => {
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_SYNC_DOCUMENT_ONEDRIVE});
    axios.post('kontos/Document/syncOnedrive',
     {
        Afid,
        userid:Userid,
				Docid,
				Orgnr,
				Doctype,
				type, 
				page,
				searchWord,
				Mallmodul	
     },
     {  
			headers: {
				'Authorization':   `Bearer ${jwt}`
      }}
     ).then(({data}) => {
     if (data.results) {
      // dispatch({type: FETCH_ALL_CONTACT});
       dispatch({type: ON_SYNC_DOCUMENT_ONEDRIVE, payload: data.results});
     } else {
       dispatch({type: ON_ERROR_SYNC_DOCUMENT_ONEDRIVE, payload: data.error});
     }
     //dispatch(RefreshUserInterface(userid))
   }).catch(function (error) {
     dispatch({type: ON_ERROR_SYNC_DOCUMENT_ONEDRIVE, payload: error.message});
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
   });
  } 
}
 //getAdminStatistik
 export const getAdminStatistik = (userid , BolagData ='') =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_FETCH_ADMIN_STATISTIK});
    axios.get('kontos/statistic/admin',
    { params:{userid:userid,BolagData:BolagData}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getAdminStatistik: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_FETCH_ADMIN_STATISTIK, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_ADMIN_STATISTIK, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
        let errorMessage = translate("Error.Unknown");
        
               if (error.response) {
                 // Server-side error handling
                 switch (error.response.status) {
                   case 400:
                     errorMessage = translate("Error.BadRequest");
                     break;
                   case 401:
                     errorMessage = translate("Error.Unauthorized");
                     dispatch({ type: FETCH_START_SET_UNAUTHE });
                     break;
                   case 404:
                     errorMessage = translate("Error.NotFound")
                     break;
                   case 500:
                     errorMessage = translate("Error.Server")
                     break;
                   default:
                     errorMessage = translate("Error.Generic")
                 }
               } else if (error.message === "Network Error") {
                 errorMessage = translate("Error.Network") ;
               }
                dispatch({type: ON_ERROR_ADMIN_STATISTIK, payload:errorMessage});
              });
  }
}
//getRapport
export const getRapport = (Afid,userid,Filterstate,VisaFilterIExcel,sendTo)=>{
  const jwt =  JSON.parse(localStorage.token);
  VisaFilterIExcel = isUndefined(VisaFilterIExcel)?false:VisaFilterIExcel
  return (dispatch,getState) => {
    const {IpAdress} = getState().auth;
    dispatch({type: ON_START_FETCH_RAPPORT});
    if(isEmpty(sendTo)){
      axios.get('kontos/Rapport',
      { params:{
        Afid:Afid,VisaFilterIExcel,
        userid:userid,
        Filterstate:Filterstate,sendTo,
        IpAdress
      }, 
       responseType: 'arraybuffer' ,
       headers: { 'Authorization': `Bearer ${jwt}`} }      
       ).then((resp) => {
         const dirtyFileName = resp.headers['content-disposition'];
         const regex = /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/;
         var  fileName = dirtyFileName.match(regex)[3];
         var blob = new Blob([resp.data], 
          { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
        );
        dispatch({type: ON_FETCH_RAPPORT, payload: resp});
        fileSaver.saveAs(blob, fileName);
        dispatch(RefreshUserInterface(userid))
       }).catch(function (error) {
         dispatch({type: ON_ERROR_FETCH_RAPPORT, payload: error.message});
         if(!isUndefined(error.response)){
          if (error.response.status === 401) {
            dispatch({type: FETCH_START_SET_UNAUTHE});
           } 
         }
         
         if(error.message === "Network Error"){
            //reload and remove token 
            //dispatch(userSignOut())
         }
       });
    }else{
      axios.get('kontos/Rapport',
    { params:{
      Afid:Afid,VisaFilterIExcel,
      userid:userid,
      Filterstate:Filterstate,sendTo,
      IpAdress
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_FETCH_RAPPORT_MESSAGE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_FETCH_RAPPORT_MESSAGE, payload: data.error});
       }
      dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FETCH_RAPPORT, payload: error.message});
       if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       }
       
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       }
     });
    }    
  }
}
//getMinaKundsOrt
export const getMinaKundsOrt = (Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_FETCH_MINAORT});
    axios.get('kontos/MinaOrt',
    { params:{Afid:Afid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getMinaKundsOrt: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_FETCH_MINAORT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_MINAORT, payload: data.error});
       }
       
     }).catch(function (error) {
       dispatch({type: ON_ERROR_MINAORT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
  }
}

//getMinaKundsTag
export const getMinaKundsTag = (Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_FETCH_MINATAG});
    axios.get('kontos/MinaTag',
    { params:{Afid:Afid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getMinaKundsTag: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_FETCH_MINATAG, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_MINATAG, payload: data.error});
       }
       
     }).catch(function (error) {
       dispatch({type: ON_ERROR_MINATAG, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
  }
}
//deleteDocumentKund
export const deleteDocumentKund = (row,Afid,userid,Orgnr,page,searchWord,type=0,callback) =>{
  const jwt =  JSON.parse(localStorage.token);
  page = isUndefined(page)?0:page
  searchWord = isUndefined(searchWord)?"":searchWord
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_KUND_DOCUMENT});
     axios.delete('kontos/Kund/document/delete', {
      method: 'DELETE',
      data: {
        Orgnr:Orgnr,
        Afid:Afid,
        userid:userid,
        page:page,
        searchWord:searchWord,
        row:row,
        type:type,
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("deleteDocumentKund: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
        if(callback){
          callback()
        }
         dispatch({type: ON_DELETE_KUND_DOCUMENT, payload: data.results});

       } else {
         dispatch({type: ON_ERROR_DELETE_KUND_DOCUMENT, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_KUND_DOCUMENT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//onSetZeroKundSearch
export const onSetZeroKundSearch = () =>{
  return (dispatch) => {
    dispatch({type: ON_SET_KUND_SEARCH});
  }
}
//onSetZeroFortNoxUppgifter
export const onSetZeroFortNoxUppgifter = () =>{
  return (dispatch) => {
    dispatch({type: ON_SET_ZERO_FORTNOX_UPPGIFTER});
  }
}
//getDashboardArr
export const getDashboardArr = (userid, Kontoid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_GET_DASHBORAD_LINK});
    axios.get('kontos/Dashboard/Link',
    { params:{Afid:Kontoid,userid:userid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getDashboardArr: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_FETCH_DASHBORAD_LINK, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DASHBORAD_LINK, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DASHBORAD_LINK, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
  }
}
//GenerateDashBoardLink
export const GenerateDashBoardLink = (Afid,userid,label) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GENERATE_DASHBORAD_LINK});
     axios.put('kontos/Dashboard/Generate', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        label:label,
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("GenerateDashBoardLink: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GENERATE_DASHBORAD_LINK, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GENERATE_DASHBORAD_LINK, payload: data.message});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GENERATE_DASHBORAD_LINK, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //getDashboardObject
export const getDashboardObject = (Token) =>{
  return (dispatch) => {
    dispatch({type: ON_START_GET_DASHBORAD_OBJEKT});
    axios.get('kontos/Dashboard/Objekt',
    { params:{Token:Token} }      
     ).then(({data}) => {
      console.log("getDashboardArr: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_FETCH_DASHBORAD_OBJEKT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DASHBORAD_OBJEKT, payload: data.error});
         dispatch(userSignOut())
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DASHBORAD_OBJEKT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
        dispatch(userSignOut())
     });
  }
}
//AddNewProspektFreeInput
export const AddNewProspektFreeInput = ( userid, Afid,Falt) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_NEW_PROSPEKT_FALT});
     axios.put('kontos/Prospekt/Falt/new', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        Falt:Falt
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("AddNewOrderFreeInput: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_NEW_PROSPEKT_FALT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_PROSPEKT_FALT, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_PROSPEKT_FALT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//updateProspektFreeInput
export const updateProspektFreeInput = ( userid, Afid,rad,newValue,Meta) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_UPDATE_PROSPEKT_FALT});
     axios.put('kontos/Prospekt/Falt/update', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        newValue:newValue,
        Meta:Meta,
        rad:rad
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("updateProspektFreeInput: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_UPDATE_PROSPEKT_FALT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_UPDATE_PROSPEKT_FALT, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_PROSPEKT_FALT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//deleteProspektFreeInput
export const deleteProspektFreeInput = ( Afid,userid,falt) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_PROSPEKT_FALT});
     axios.delete('kontos/Prospekt/Falt/delete', {
      method: 'DELETE',
      data: {
        Afid:Afid,
        falt:falt,
        userid:userid
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("deleteProspektFreeInput: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_PROSPEKT_FALT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DELETE_PROSPEKT_FALT, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_PROSPEKT_FALT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//AddNewOrderFreeInput
export const AddNewOrderFreeInput = ( userid, Afid,Falt) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_NEW_ORDER_FALT});
     axios.put('kontos/Order/Falt/new', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        Falt:Falt
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("AddNewOrderFreeInput: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_NEW_ORDER_FALT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_ORDER_FALT, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_ORDER_FALT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //deleteOrderFreeInput
 export const deleteOrderFreeInput = ( Afid,userid,falt) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_ORDER_FALT});
     axios.delete('kontos/Order/Falt/delete', {
      method: 'DELETE',
      data: {
        Afid:Afid,
        falt:falt,
        userid:userid
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("deleteOrderFreeInput: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_ORDER_FALT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DELETE_ORDER_FALT, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_ORDER_FALT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //updateOrderFreeInput
 export const updateOrderFreeInput = ( userid, Afid,rad,newValue,Meta) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_UPDATE_ORDER_FALT});
     axios.put('kontos/Order/Falt/update', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        newValue:newValue,
        Meta:Meta,
        rad:rad
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("updateOrderFreeInput: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_UPDATE_ORDER_FALT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_UPDATE_ORDER_FALT, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_ORDER_FALT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//getTillGodoByOrgnr
export const getTillGodoByOrgnr = (Orgrn, userid, Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_GET_TILLGODO_KUND});
    axios.get('kontos/Kund/tillGodo',
    { params:{
      Orgrn:Orgrn,
      userid:userid,
      Afid:Afid,
    },headers: { 'Authorization': `Bearer ${jwt}`}}      
     ).then(({data}) => {
      console.log("getDashboardArr: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_FETCH_TILLGODO_KUND, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_TILLGODO_KUND, payload: data.error});
         //dispatch(RefreshUserInterface(userid))
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_TILLGODO_KUND, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
  }
}
//insertthisTillgodo
export const insertthisTillgodoByAf = ( Orgnr, userid, Afid,newValue,newText,Meta) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_INSERT_TILLGODO_KUND});
     axios.put('kontos/Kund/tillGodo/new', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        newValue:newValue,
        newText:newText,
        Meta:Meta,
        Orgnr:Orgnr
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("insertthisTillgodo: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_INSERT_TILLGODO_KUND, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_INSERT_TILLGODO_KUND, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_INSERT_TILLGODO_KUND, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }

  export const AddnewTypeArande = (userid, Afid, newtype, operators) => {
  const jwt = JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({ type: ON_START_NEW_CASE_TYPE });
    axios.put(
      'kontos/Type/Case/new',
      {
        userid: userid,
        Afid: Afid,
        newtype: newtype,
        operators: operators
      },
      {
        headers: {
          'content-type': 'application/json',
          'Authorization': `Bearer ${jwt}`
        }
      }
    ).then(({ data }) => {
      console.log("AddnewTypeArande: ", data);
      if (data.results) {
        dispatch({ type: ON_NEW_CASE_TYPE, payload: data.results });
      } else {
        dispatch({ type: ON_ERROR_NEW_CASE_TYPE, payload: data.error });
      }
    }).catch(function (error) {
      dispatch({ type: ON_ERROR_NEW_CASE_TYPE, payload: error.message });
      if (error.response && error.response.status === 401) {
        dispatch({ type: FETCH_START_SET_UNAUTHE });
      }
    });
  }
}


export const UpdateEditArendeType = (userid, Afid, typeId, newtype, operators) => {
  const jwt = JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({ type: ON_START_NEW_CASE_TYPE });

    axios.put(
      'kontos/Type/Case/update',
      {
        userid: userid,
        Afid: Afid,
        typeId: typeId,
        newtype: newtype,
        operators: operators
      },
      {
        headers: {
          'content-type': 'application/json',
          'Authorization': `Bearer ${jwt}`
        }
      }
    )
    .then(({ data }) => {
      console.log("UpdateArandeType: ", data);
      if (data.results) {
        dispatch({ type: ON_NEW_CASE_TYPE, payload: data.results });
      } else {
        dispatch({ type: ON_ERROR_NEW_CASE_TYPE, payload: data.error });
      }
    })
    .catch((error) => {
      dispatch({ type: ON_ERROR_NEW_CASE_TYPE, payload: error.message });
      if (error.response && error.response.status === 401) {
        dispatch({ type: FETCH_START_SET_UNAUTHE });
      }
    });
  };
};

//getArandeTypeByAfid
export const getArandeTypeByAfid = (Afid, userid) =>{
  return (dispatch) => {
    dispatch({type: ON_START_GET_ARANDETYP_KUND});
    axios.get('kontos/Type/Case',
    { params:{
      userid:userid,
      Afid:Afid,
    }}      
     ).then(({data}) => {
      console.log("getArandeTypeByAfid: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_FETCH_ARANDETYP_KUND, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_ARANDETYP_KUND, payload: data.error});
         dispatch(userSignOut())
       }
       dispatch(RefreshUserInterface(userid))
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_ARANDETYP_KUND, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
  }
}
//AddnewArandeleverantor
export const AddnewArandeleverantor = ( userid, Afid,type) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_NEW_CASE_CATE_TYPE});
     axios.put('kontos/Type/Case/Cate/new', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        newtype:type
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("AddnewArandeleverantor: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_NEW_CASE_CATE_TYPE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_NEW_CASE_CATE_TYPE, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_NEW_CASE_CATE_TYPE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }


//deleteArandeleverantor
export const deleteArandeleverantor = ( userid, Afid,type) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_CASE_CATE_TYPE});
     axios.delete('kontos/Type/Case/Cate/delete', {
      method: 'DELETE',
      data: {
        userid:userid,
        Afid:Afid,
        newtype:type
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("AddnewArandeleverantor: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_CASE_CATE_TYPE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DELETE_CASE_CATE_TYPE, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_CASE_CATE_TYPE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //deleteArandeType
 export const deleteArandeType = ( userid, Afid,type) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_CASE_TYPE});
     axios.delete('kontos/Type/Case/delete', {
      method: 'DELETE',
      data: {
        userid:userid,
        Afid:Afid,
        newtype:type
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("AddnewArandeleverantor: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_CASE_TYPE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DELETE_CASE_TYPE, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_CASE_TYPE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //onSaveNewArandeEmail
export const onSaveNewArandeEmail = ( userid, Afid,newState) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_NEW_ARANDE_EMAIL});
     axios.put('kontos/ArandeEmail/new', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        newState:newState
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("onSaveNewArandeEmail: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_NEW_ARANDE_EMAIL, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_NEW_ARANDE_EMAIL, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_NEW_ARANDE_EMAIL, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //UpdateNotisthisArandeEmail
export const UpdateNotisthisArandeEmail = ( userid, Afid,newState) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_UPDATEN_ARANDE_EMAIL});
     axios.put('kontos/ArandeEmail/updateNotis', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        newState:newState
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("UpdateNotisthisArandeEmail: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_UPDATEN_ARANDE_EMAIL, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_UPDATEN_ARANDE_EMAIL, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UPDATEN_ARANDE_EMAIL, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 
  //deletethisArandeEmail
  export const deletethisArandeEmail = ( userid, Afid,DelState) =>{
    const jwt =  JSON.parse(localStorage.token);
     return (dispatch) => {
       dispatch({type: ON_START_DELETE_ARANDE_EMAIL});
       axios.delete('kontos/ArandeEmail/delete', {
        method: 'DELETE',
        data: {
          userid:userid,
          Afid:Afid,
          DelState:DelState
        },
        headers: {
            'content-type': 'application/json',
            'Authorization':   `Bearer ${jwt}`
        }       
    }).then(({data}) => {
        console.log("deletethisArandeEmail: ", data);
         if (data.results) {
          // dispatch({type: FETCH_ALL_CONTACT});
           dispatch({type: ON_DELETE_ARANDE_EMAIL, payload: data.results});
         } else {
           dispatch({type: ON_ERROR_DELETE_ARANDE_EMAIL, payload: data.error});
         }
         //dispatch(RefreshUserInterface(userid))
       }).catch(function (error) {
         dispatch({type: ON_ERROR_DELETE_ARANDE_EMAIL, payload: error.message});
            if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
         if(error.message === "Network Error"){
            //reload and remove token 
            //dispatch(userSignOut())
         } 
       });
     }
   }
//resetCurrentObjekt
export const resetCurrentObjekt = ()=>{
  return (dispatch) => {    
    dispatch({type: ON_RESET_CURRENT_OBJEKT_FALT});
  }
}
//DeleteAnpassadName
export const DeleteAnpassadName = ( Afid, userid,DelState) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_FETCH_UPDATE_ANPASSAD});
     axios.delete('kontos/Rapport/Anpassad/delete', {
      method: 'DELETE',
      data: {
        userid:userid,
        Afid:Afid,
        DelState:DelState
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("DeleteAnpassadName: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_FETCH_SAVED_ANPASSAD, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DELETE_ARANDE_EMAIL, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FETCH_SAVED_ANPASSAD, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//getSparadAnRapport
export const getSparadAnRapport = (Afid,userid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_FETCH_SAVED_ANPASSAD});
    axios.get('kontos/Rapport/SavedAnpassad',
    { params:{
      userid:userid,
      Afid:Afid,
    },
    headers: { 'Authorization': `Bearer ${jwt}`}
  }      
     ).then(({data}) => {
      console.log("getSparadAnRapport: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_FETCH_SAVED_ANPASSAD, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_FETCH_SAVED_ANPASSAD, payload: data.error});
         dispatch(userSignOut())
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FETCH_SAVED_ANPASSAD, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
  }
}
//updateAnpassadName
export const updateAnpassadName = (Afid,userid,RowId,name)=>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_FETCH_UPDATE_ANPASSAD});
    axios.post('kontos/Rapport/Anpassad/Update', {
      method: 'POST',
      body: {
        userid:userid,
        Afid:Afid,name,RowId
      }
    },{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }   
    })
    .then(({data}) => {  
      console.log("updateAnpassadName: ", data);
    if (data.results) {
     // dispatch({type: FETCH_ALL_CONTACT});
      dispatch({type: ON_FETCH_SAVED_ANPASSAD, payload: data.results});
    } else {
      dispatch({type: ON_ERROR_FETCH_SAVED_ANPASSAD, payload: data.error});
      dispatch(userSignOut())
    }
    dispatch(RefreshUserInterface(userid))
  }).catch(function (error) {
    dispatch({type: ON_ERROR_FETCH_SAVED_ANPASSAD, payload: error.message});
       if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
  });
}
}
////getAnpassadRapport
export const getAnpassadRapport = (Afid,userid,Mstate,saved,Email,name)=>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_FETCH_RAPPORT});
    axios.post('kontos/Rapport/Anpassad', {
      method: 'POST',
      body: {
        userid:userid,
        Afid:Afid,saved,Email,name,
        Mstate:JSON.stringify(Mstate)
      }},{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }   
    })
    .then(({data}) => {
      if (data.results) {
        console.log(data.results)
        dispatch({type: ON_FETCH_RAPPORT});
        axios.get('kontos/Rapport/Anpassad',
        { params:{
          Afid:Afid,
          userid:userid,
          Mstate:data.results  ,
        }, 
         //responseType: 'blob' ,
         headers: { 'Authorization': `Bearer ${jwt}`} }      
         ).then(({data}) => {
          console.log("getKontoUtokning: ", data);
        })
         /*.then((resp) => {
          const dirtyFileName = resp.headers['content-disposition'];
          const regex = /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/;
          var  fileName = dirtyFileName.match(regex)[3];
          var blob = new Blob([resp.data], 
           { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
         );
         dispatch({type: ON_FETCH_RAPPORT, payload: resp});
         fileSaver.saveAs(blob, fileName);
         dispatch(RefreshUserInterface(userid))
         })
         */.catch(function (error) {
           dispatch({type: ON_ERROR_FETCH_RAPPORT, payload: error.message});
              if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
           if(error.message === "Network Error"){
              //reload and remove token 
              //dispatch(userSignOut())
           } 
         });
      }
      else{
        dispatch({type: ON_ERROR_FETCH_RAPPORT, payload: translate("Error.Custom.Report")});
      }
    })
    .catch(function (error) {
      dispatch({type: ON_ERROR_FETCH_RAPPORT, payload: translate("Error.Custom.Report")});
    })
  }
}





export const getAnpassadRapport1 = (Afid,userid,Mstate)=>{
  const jwt =  JSON.parse(localStorage.token);
  
  return (dispatch) => {
    dispatch({type: ON_START_FETCH_RAPPORT});
    axios.get('kontos/Rapport/Anpassad',
    { params:{
      Afid:Afid,
      userid:userid,
      Mstate:Mstate  ,
    }, 
     responseType: 'blob' ,
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then((resp) => {
      const dirtyFileName = resp.headers['content-disposition'];
      const regex = /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/;
      var  fileName = dirtyFileName.match(regex)[3];
      var blob = new Blob([resp.data], 
       { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
     );
     dispatch({type: ON_FETCH_RAPPORT, payload: resp});
     fileSaver.saveAs(blob, fileName);
     dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FETCH_RAPPORT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//getKontoUtokning
export const getKontoUtokning = (Afid,userid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_FETCH_UTOKNING});
    axios.get('kontos/Utokning',
    { params:{
      userid:userid,
      Afid:Afid,
    },
    headers: { 'Authorization': `Bearer ${jwt}`}
  }      
     ).then(({data}) => {
      console.log("getKontoUtokning: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_FETCH_UTOKNING, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_FETCH_UTOKNING, payload: data.error});
         dispatch(userSignOut())
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FETCH_UTOKNING, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
  }
}
export const getKontoUtokningDynamicFields = (Afid,userid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_FETCH_UTOKNING_DYNAMIC_FIELDS});
    axios.get('kontos/Utokning/dynamicFields',
    { params:{
      userid:userid,
      Afid:Afid,
    },
    headers: { 'Authorization': `Bearer ${jwt}`}
  }      
     ).then(({data}) => {
      console.log("getKontoUtokningDynamicFields: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_FETCH_UTOKNING_DYNAMIC_FIELDS, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_FETCH_UTOKNING_DYNAMIC_FIELDS, payload: data.error});
         dispatch(userSignOut())
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FETCH_UTOKNING_DYNAMIC_FIELDS, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
  }
}

export const getKundUtoningListByType = (Afid,userid, Orgnr, Type = 0) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_GET_UTOKNING_KUND_LIST_BY_TYPE});
    axios.get('kontos/Utokning/kund/listByType',
    { params:{
      userid:userid,
      Afid:Afid,
      Orgnr, Type
    },
    headers: { 'Authorization': `Bearer ${jwt}`}
  }      
     ).then(({data}) => {
      console.log("getKontoUtokning: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_UTOKNING_KUND_LIST_BY_TYPE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_UTOKNING_KUND_LIST_BY_TYPE, payload: data.error});
         dispatch(userSignOut())
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_UTOKNING_KUND_LIST_BY_TYPE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
  }
}
//bestallaFortNoxKonto
export const bestallaFortNoxKonto = ( userid, Afid,APIKOD) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_BESTALLA_FORTNOX});
     axios.put('kontos/Fortnox/Bestalla', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        APIKOD:APIKOD
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("bestallaFortNoxKonto: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_BESTALLA_FORTNOX, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_BESTALLA_FORTNOX, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_BESTALLA_FORTNOX, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //getFortnoxAf
export const getFortnoxAf = (Afid,userid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_GET_AF_FORTNOX});
    axios.get('kontos/Fortnox/get',
    { params:{Afid:Afid,userid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getFortnoxAf: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_AF_FORTNOX, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_AF_FORTNOX, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_AF_FORTNOX, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//fetchLastFortnoxupdating
export const fetchLastFortnoxupdating = (userid,Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_GET_AF_LFORTNOX});
    axios.get('kontos/Fortnox/getLastupdate',
    { params:{Afid:Afid,userid:userid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("fetchLastFortnoxupdating: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_AF_LFORTNOX, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_AF_LFORTNOX, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_AF_LFORTNOX, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}

//disconnectNotyfileFortnox
export const disconnectNotyfileFortnox = (userid,Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_GET_AF_DFORTNOX});
    axios.get('kontos/Fortnox/disCon',
    { params:{Afid:Afid,userid:userid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("disconnectNotyfileFortnox: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_AF_DFORTNOX, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_AF_DFORTNOX, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_AF_DFORTNOX, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//SyncaFortnoxKunder
export const SyncaFortnoxKunder = (userid,KundStatus = 2,Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_GET_AF_FORTNOX_KUNDER});
    axios.get('kontos/Fortnox/kunder',
    { params:{Afid:Afid,userid:userid,KundStatus}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("SyncaFortnoxKunder: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_AF_FORTNOX_KUNDER, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_AF_FORTNOX_KUNDER, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_AF_FORTNOX_KUNDER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//SyncaNotyfileFortnoxKunder
export const SyncaNotyfileFortnoxKunder = (userid,Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_GET_AF_FORTNOX_KUNDER});
    axios.get('kontos/Fortnox/Notykunder',
    { params:{Afid:Afid,userid:userid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("SyncaNotyfileFortnoxKunder: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_AF_FORTNOX_KUNDER, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_AF_FORTNOX_KUNDER, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_AF_FORTNOX_KUNDER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//SyncaNotyfileFortnoxArtiklar
export const SyncaNotyfileFortnoxArtiklar = (userid,Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_GET_AF_FORTNOX_ARTIKLAR});
    axios.get('kontos/Fortnox/NotyArtiklar',
    { params:{Afid:Afid,userid:userid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("SyncaNotyfileFortnoxArtiklar: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_AF_FORTNOX_ARTIKLAR, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_AF_FORTNOX_ARTIKLAR, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_AF_FORTNOX_ARTIKLAR, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//createNewKundIFortnox
export const createNewKundIFortnox = ( Orgrn, Afid, userid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_FORTNOX_NEWKUND});
     axios.put('kontos/Fortnox/NewKund', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        Orgrn:Orgrn
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("createNewKundIFortnox: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_FORTNOX_NEWKUND, payload: data.results});
         dispatch(getFortnoxInvoicesByOrgnr(Orgrn,Afid,userid,data.results.KundNummer))
       } else {
         dispatch({type: ON_ERROR_FORTNOX_NEWKUND, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FORTNOX_NEWKUND, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //getKundFortnoxUppgifterFak
 export const getKundFortnoxUppgifterFak = (Afid,userid,KundNummer) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_GET_AF_FORTNOX_KUND});
    axios.get('kontos/Fortnox/Faktura/kund',
    { params:{
      Afid:Afid,
      KundNummer:KundNummer,
      userid:userid
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getKundFortnoxUppgifterFak: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_AF_FORTNOX_KUND, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_AF_FORTNOX_KUND, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
       
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_AF_FORTNOX_KUND, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//getKundFortnoxUppgifter
export const getKundFortnoxUppgifter = (Afid,userid,KundNummer,callBackFunction) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_GET_AF_FORTNOX_KUND});
    axios.get('kontos/Fortnox/kund',
    { params:{
      Afid:Afid,
      KundNummer:KundNummer,
      userid:userid
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getKundFortnoxUppgifter: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_AF_FORTNOX_KUND, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_AF_FORTNOX_KUND, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
       if(!isUndefined(callBackFunction)){callBackFunction()}
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_AF_FORTNOX_KUND, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}

//getFortnoxKundFFbyKundnummer
export const getFortnoxKundFFbyKundnummer = ( Orgrn, Afid, userid,FortnoxKundNR) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_FORTNOX_CONNECT_KUND});
     axios.put('kontos/Fortnox/getKund', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        FortnoxKundNR:FortnoxKundNR,
        Orgrn:Orgrn
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("getFortnoxKundFFbyKundnummer: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_FORTNOX_CONNECT_KUND, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_FORTNOX_CONNECT_KUND, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FORTNOX_CONNECT_KUND, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//updateFortnoxKundFFbyKundnummer
export const updateFortnoxKundFFbyKundnummer = (Orgnr,Afid,userid,FortnoxKundNR,newState) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_FORTNOX_EDITKUND});
     axios.put('kontos/Fortnox/updateKund', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        Orgnr:Orgnr,
        FortnoxKundNR:FortnoxKundNR,
        newState:newState
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("createNewKundIFortnox: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_FORTNOX_EDITKUND, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_FORTNOX_EDITKUND, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FORTNOX_EDITKUND, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//deletThisFortnoxFakturaKund
export const deletThisFortnoxFakturaKund = (Orgnr,Afid,userid,FortnoxKundNR,newState) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_FORTNOX_DELKUND});
     axios.put('kontos/Fortnox/deleteKund', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        Orgnr:Orgnr,
        FortnoxKundNR:FortnoxKundNR,
        newState:newState
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("deletThisFortnoxFakturaKund: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_FORTNOX_DELKUND, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_FORTNOX_DELKUND, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FORTNOX_DELKUND, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 
//updateFortnoxKundFFFbyKundnummer
export const updateFortnoxKundFFFbyKundnummer = (Orgnr,Afid,userid,FortnoxKundNR,newState) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_FORTNOX_EDITKUND});
     axios.put('kontos/Fortnox/updateFakKund', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        Orgnr:Orgnr,
        FortnoxKundNR:FortnoxKundNR,
        newState:newState
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("updateFortnoxKundFFFbyKundnummer: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_FORTNOX_EDITKUND, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_FORTNOX_EDITKUND, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FORTNOX_EDITKUND, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 
//SyncaFortnoxArtiklar
export const SyncaFortnoxArtiklar = (userid,Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_GET_AF_FORTNOX_ARTIKLAR});
    axios.get('kontos/Fortnox/Artiklar',
    { params:{Afid:Afid,userid:userid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("SyncaFortnoxArtiklar: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_AF_FORTNOX_ARTIKLAR, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_AF_FORTNOX_ARTIKLAR, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_AF_FORTNOX_ARTIKLAR, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//SyncaFortnoxOrdrar
export const SyncaFortnoxOrdrar = (userid,Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_GET_AF_FORTNOX_ORDER});
    axios.get('kontos/Fortnox/Order',
    { params:{Afid:Afid,userid:userid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("SyncaFortnoxOrdrar: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_AF_FORTNOX_ORDER, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_AF_FORTNOX_ORDER, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_AF_FORTNOX_ORDER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}

//SyncaFortnoxOffert
export const SyncaFortnoxOffert = (userid,Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_GET_AF_FORTNOX_OFFERT});
    axios.get('kontos/Fortnox/Offerts',
    { params:{Afid:Afid,userid:userid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("SyncaFortnoxOffert: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_AF_FORTNOX_OFFERT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_AF_FORTNOX_OFFERT, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_AF_FORTNOX_OFFERT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
 //updateTheOldOne
 export const updateTheOldOne = (userid,Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_GET_UTOKNING});
    axios.get('kontos/Utokning/updateOld',
    { params:{Afid:Afid,userid:userid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
     // console.log("getNotisByUserid: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_UTOKNING, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_UTOKNING, payload: data.error});
       }
     }).catch(function (error) {
      console.log("getCurrentObjektById1 error: ", error)
       dispatch({type: ON_ERROR_GET_UTOKNING, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//getOfficeUsers
export const getOfficeUsers = (userid,Afid,OfficeId) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_OFFICE_ALL_USERS});
     axios.get('kontos/Office/user/All',
     { params:{Afid:Afid,userid:userid,OfficeId:OfficeId}, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getOfficeUsers: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_OFFICE_ALL_USERS, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_OFFICE_ALL_USERS, payload: data.message});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_OFFICE_ALL_USERS, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //UpdateOfficeUsers
 export const UpdateOfficeUsers = (userid,Afid,OfficeID,Ouserid,Meta,Value) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_OFFICE_UPDATE_USER});
     axios.put('kontos/Office/user/update', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        OfficeID:OfficeID,
        Ouserid:Ouserid,
        Meta:Meta,
        Value:Value
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("UpdateOfficeUsers: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_OFFICE_UPDATE_USER, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_OFFICE_UPDATE_USER, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_OFFICE_UPDATE_USER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //
 export const getOfficeSetting = (Afid,userid,OfficeId) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_OFFICE_GET});
     axios.get('kontos/Office/get',
     { params:{Afid:Afid,userid:userid,OfficeId:OfficeId}, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getOfficeSetting: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_OFFICE_GET, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_OFFICE_GET, payload: data.message});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_OFFICE_GET, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //checkMyBlackList
 export const checkMyBlackList = (Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_BLACK_LIST});
     axios.get('kontos/BlackList',
     { params:{Afid:Afid}, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("checkMyBlackList: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_BLACK_LIST, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_BLACK_LIST, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_BLACK_LIST, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//ON_RESET_FORTNOX_KUND_FAKTUROR
export const resetFortnoxUP = () =>{
  return (dispatch) => {
    dispatch({type: ON_RESET_FORTNOX_KUND_FAKTUROR});
  }
}
 //getFortnoxInvoicesByOrgnr
export const getFortnoxInvoicesByOrgnr = ( Orgnr,Afid,userid,FortnoxKundNR) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_FORTNOX_KUND_FAKTUROR});
     axios.put('kontos/Fortnox/getKundFakturor', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        FortnoxKundNR:FortnoxKundNR,
        Orgnr:Orgnr
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("getFortnoxKundFFbyKundnummer: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_FORTNOX_KUND_FAKTUROR, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_FORTNOX_KUND_FAKTUROR, payload: data.message});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FORTNOX_KUND_FAKTUROR, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 } 
//ConnectFortnoxInvoceWithAvtal
export const ConnectFortnoxInvoceWithAvtal = ( userid,Afid,Orgnr,AvtalID,FornoxId) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_FORTNOX_FAKTUROR_CONNECT});
     axios.put('kontos/Fortnox/Invoce/Connect', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        AvtalID:AvtalID,
        FornoxId:FornoxId,
        Orgnr:Orgnr
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("ConnectFortnoxInvoceWithAvtal: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_FORTNOX_FAKTUROR_CONNECT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_FORTNOX_FAKTUROR_CONNECT, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FORTNOX_FAKTUROR_CONNECT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 } 
//DownloadInvoice
export const DownloadInvoice = (Afid,userid,FornoxId)=>{
  const jwt =  JSON.parse(localStorage.token);
  
  return (dispatch) => {
    dispatch({type: ON_START_FORTNOX_FAKTUROR_DOWNLOAD});
    axios.get('kontos/Fortnox/Invoce/download',
    { params:{
      Afid:Afid,
      userid:userid,
      FornoxId:FornoxId,
    }, 
     responseType: 'arraybuffer' ,
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then((resp) => {
       var  fileName = `Faktura-${FornoxId}.pdf`;
       var blob = new Blob([resp.data], 
        { type: 'application/pdf' }
      );
      console.log(resp)
      console.log(resp.data)
      console.log(blob)
      dispatch({type: ON_FORTNOX_FAKTURO_DOWNLOAD, payload: resp});
      fileSaver.saveAs(blob, fileName);
      ////dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FORTNOX_FAKTUROR_DOWNLOAD, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//CancelInvoice
export const CancelInvoice = ( Afid,userid,FornoxId) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_FORTNOX_FAKTUROR_CANCEL});
     axios.put('kontos/Fortnox/Invoce/Cancel', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        FornoxId:FornoxId,
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("CancelInvoice: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_FORTNOX_FAKTUROR_CANCEL, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_FORTNOX_FAKTUROR_CANCEL, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FORTNOX_FAKTUROR_CANCEL, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 } 
//getInvoice
export const getInvoice = (Afid, userid, FornoxId) => {
  const jwt = JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({ type: ON_START_FORTNOX_FAKTURA_GET });
    axios.get('kontos/Fortnox/Invoce/get',
      {
        params: {
          Afid: Afid,
          userid: userid,
          FornoxId: FornoxId,
        },
        headers: { 'Authorization': `Bearer ${jwt}` }
      }
    ).then(({ data }) => {
      console.log("getInvoice: ", data);
      if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({ type: ON_FORTNOX_FAKTURA_GET, payload: data.results });
      } else {
        dispatch({ type: ON_ERROR_FORTNOX_FAKTURA_GET, payload: data.message });
      }
      dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
      dispatch({ type: ON_ERROR_FORTNOX_FAKTURA_GET, payload: error.message });
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
      if (error.message === "Network Error") {
      }
    });
  }
}
//SendInvoice
export const SendInvoice = (Afid, userid, FornoxId,NewState) => {
  const jwt = JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({ type: ON_START_FORTNOX_FAKTUROR_SEND });
    axios.put('kontos/Fortnox/Invoce/Send', {
      method: 'PUT',
      body: {
        userid: userid,
        Afid: Afid,
        FornoxId: FornoxId,
        NewState: NewState,
      }}, {
      headers: {
        'content-type': 'application/json',
        'Authorization': `Bearer ${jwt}`
      }
    }).then(({ data }) => {
      console.log("SendInvoice: ", data);
      if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({ type: ON_FORTNOX_FAKTUROR_SEND, payload: data.results });
      } else {
        dispatch({ type: ON_ERROR_FORTNOX_FAKTUROR_SEND, payload: data.message });
      }
    }).catch(function (error) {
      dispatch({ type: ON_ERROR_FORTNOX_FAKTUROR_SEND, payload: error.message });
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
      if (error.message === "Network Error") {
        //reload and remove token 
        //dispatch(userSignOut())
      }
    });
  }
}
//onSelectStandardAFid
//,    ,    ,
export const onSelectStandardAFid = (userid,Afid,StandardKal) => {
  const jwt = JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({ type: ON_START_UPDATE_MODULE });
    axios.put('kontos/Kakyl/setStandard', {
      method: 'PUT',
      body: {
        userid: userid,
        Afid: Afid,
        StandardKal: StandardKal,
      },
    },{
      headers: {
        'content-type': 'application/json',
        'Authorization': `Bearer ${jwt}`
      }
    }).then(({ data }) => {
      console.log("onSelectStandardAFid: ", data);
      if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({ type: ON_UPDATE_MODULE, payload: data.results });
      } else {
        dispatch({ type: ON_ERROR_UPDATE_MODULE, payload: data.message });
      }
    }).catch(function (error) {
      dispatch({ type: ON_ERROR_UPDATE_MODULE, payload: error.message });
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
      if (error.message === "Network Error") {
        //reload and remove token 
        //dispatch(userSignOut())
      }
    });
  }
}
export const onSwitchOrderVardeAFid = (userid,Afid,Ordervarde) => {
  const jwt = JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({ type: ON_START_UPDATE_MODULE });
    axios.put('kontos/Kakyl/setOvarde', {
      method: 'PUT',
      body: {
        userid: userid,
        Afid: Afid,
        Ordervarde: Ordervarde,
      },
    },{
      headers: {
        'content-type': 'application/json',
        'Authorization': `Bearer ${jwt}`
      }
    }).then(({ data }) => {
      console.log("onSwitchOrderVardeAFid: ", data);
      if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({ type: ON_UPDATE_MODULE, payload: data.results });
      } else {
        dispatch({ type: ON_ERROR_UPDATE_MODULE, payload: data.message });
      }
    }).catch(function (error) {
      dispatch({ type: ON_ERROR_UPDATE_MODULE, payload: error.message });
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
      if (error.message === "Network Error") {
        //reload and remove token 
        //dispatch(userSignOut())
      }
    });
  }
}
export const onSwitchFriaManaderAFid = (userid,Afid,FriaManader) => {
  const jwt = JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({ type: ON_START_UPDATE_MODULE });
    axios.put('kontos/Kakyl/setFriaManader', {
      method: 'PUT',
      body: {
        userid: userid,
        Afid: Afid,
        FriaManader: FriaManader,
      },
    },{
      headers: {
        'content-type': 'application/json',
        'Authorization': `Bearer ${jwt}`
      }
    }).then(({ data }) => {
      console.log("onSwitchFriaManaderAFid: ", data);
      if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({ type: ON_UPDATE_MODULE, payload: data.results });
      } else {
        dispatch({ type: ON_ERROR_UPDATE_MODULE, payload: data.message });
      }
    }).catch(function (error) {
      dispatch({ type: ON_ERROR_UPDATE_MODULE, payload: error.message });
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
      if (error.message === "Network Error") {
        //reload and remove token 
        //dispatch(userSignOut())
      }
    });
  }
}
export const onSwitchKalkylUtpris = (userid,Afid,Ordervarde) => {
  const jwt = JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({ type: ON_START_UPDATE_MODULE });
    axios.put('kontos/Kakyl/setUtpris', {
      method: 'PUT',
      body: {
        userid: userid,
        Afid: Afid,
        Ordervarde: Ordervarde,
      },
    },{
      headers: {
        'content-type': 'application/json',
        'Authorization': `Bearer ${jwt}`
      }
    }).then(({ data }) => {
      console.log("onSwitchKalkylUtpris: ", data);
      if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({ type: ON_UPDATE_MODULE, payload: data.results });
      } else {
        dispatch({ type: ON_ERROR_UPDATE_MODULE, payload: data.message });
      }
    }).catch(function (error) {
      dispatch({ type: ON_ERROR_UPDATE_MODULE, payload: error.message });
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
      if (error.message === "Network Error") {
        //reload and remove token 
        //dispatch(userSignOut())
      }
    });
  }
}
export const onSwitchKalkylTG = (userid,Afid,Ordervarde) => {
  const jwt = JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({ type: ON_START_UPDATE_MODULE });
    axios.put('kontos/Kakyl/setTG', {
      method: 'PUT',
      body: {
        userid: userid,
        Afid: Afid,
        Ordervarde: Ordervarde,
      },
    },{
      headers: {
        'content-type': 'application/json',
        'Authorization': `Bearer ${jwt}`
      }
    }).then(({ data }) => {
      console.log("onSwitchKalkylTG: ", data);
      if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({ type: ON_UPDATE_MODULE, payload: data.results });
      } else {
        dispatch({ type: ON_ERROR_UPDATE_MODULE, payload: data.message });
      }
    }).catch(function (error) {
      dispatch({ type: ON_ERROR_UPDATE_MODULE, payload: error.message });
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
      if (error.message === "Network Error") {
        //reload and remove token 
        //dispatch(userSignOut())
      }
    });
  }
}
export const onSwitchKalklV2 = (userid,Afid,Ordervarde) => {
  const jwt = JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({ type: ON_START_UPDATE_MODULE });
    axios.put('kontos/Kakyl/setV2', {
      method: 'PUT',
      body: {
        userid: userid,
        Afid: Afid,
        Ordervarde: Ordervarde,
      },
    },{
      headers: {
        'content-type': 'application/json',
        'Authorization': `Bearer ${jwt}`
      }
    }).then(({ data }) => {
      console.log("onSwitchKalklV2: ", data);
      if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({ type: ON_UPDATE_MODULE, payload: data.results });
      } else {
        dispatch({ type: ON_ERROR_UPDATE_MODULE, payload: data.message });
      }
    }).catch(function (error) {
      dispatch({ type: ON_ERROR_UPDATE_MODULE, payload: error.message });
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
      if (error.message === "Network Error") {
        //reload and remove token 
        //dispatch(userSignOut())
      }
    });
  }
}
export const onSwitchFortnoxInvoiceSplit = (userid,Afid,Ordervarde,update = true) => {
  const jwt = JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({ type: ON_START_UPDATE_MODULE });
    axios.put('kontos/Kakyl/setFortnoxInvoiceSplit', {
      method: 'PUT',
      body: {
        userid: userid,
        Afid: Afid,
        Ordervarde: Ordervarde,
      },
    },{
      headers: {
        'content-type': 'application/json',
        'Authorization': `Bearer ${jwt}`
      }
    }).then(({ data }) => {
      console.log("onSwitchKalklV2: ", data);
      if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
        if(update === true){
          dispatch({ type: ON_UPDATE_MODULE, payload: data.results });
        }
        else{
          dispatch({ type: ON_UPDATE_MODULE_DONT_UPDATE, payload: data.results });
        }
        
      } else {
        dispatch({ type: ON_ERROR_UPDATE_MODULE, payload: data.message });
      }
    }).catch(function (error) {
      dispatch({ type: ON_ERROR_UPDATE_MODULE, payload: error.message });
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
      if (error.message === "Network Error") {
        //reload and remove token 
        //dispatch(userSignOut())
      }
    });
  }
}
//onSwitchPrislistaIkalkyl
export const onSwitchPrislistaIkalkyl = (userid,Afid,Ordervarde) => {
  const jwt = JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({ type: ON_START_UPDATE_MODULE });
    axios.put('kontos/Kakyl/setPrislista', {
      method: 'PUT',
      body: {
        userid: userid,
        Afid: Afid,
        Ordervarde: Ordervarde,
      },
    },{
      headers: {
        'content-type': 'application/json',
        'Authorization': `Bearer ${jwt}`
      }
    }).then(({ data }) => {
      console.log("onSwitchPrislistaIkalkyl: ", data);
      if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({ type: ON_UPDATE_MODULE, payload: data.results });
      } else {
        dispatch({ type: ON_ERROR_UPDATE_MODULE, payload: data.message });
      }
    }).catch(function (error) {
      dispatch({ type: ON_ERROR_UPDATE_MODULE, payload: error.message });
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
      if (error.message === "Network Error") {
        //reload and remove token 
        //dispatch(userSignOut())
      }
    });
  }
}
//
export const onSwitchKalkylTidsstyrda = (userid,Afid,Ordervarde) => {
  const jwt = JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({ type: ON_START_UPDATE_MODULE });
    axios.put('kontos/Kakyl/setRTidsstyrda', {
      method: 'PUT',
      body: {
        userid: userid,
        Afid: Afid,
        Ordervarde: Ordervarde,
      },
    },{
      headers: {
        'content-type': 'application/json',
        'Authorization': `Bearer ${jwt}`
      }
    }).then(({ data }) => {
      console.log("onSwitchKalkylTidsstyrda: ", data);
      if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({ type: ON_UPDATE_MODULE, payload: data.results });
      } else {
        dispatch({ type: ON_ERROR_UPDATE_MODULE, payload: data.message });
      }
    }).catch(function (error) {
      dispatch({ type: ON_ERROR_UPDATE_MODULE, payload: error.message });
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
      if (error.message === "Network Error") {
        //reload and remove token 
        //dispatch(userSignOut())
      }
    });
  }
}
//onSelectEnhetAFid
export const onSelectEnhetAFid = (userid,Afid,ValueEnhet,Type) => {
  const jwt = JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({ type: ON_START_UPDATE_MODULE });
    axios.put('kontos/Kakyl/setValueEnhet', {
      method: 'PUT',
      body: {
        userid: userid,
        Afid: Afid,
        ValueEnhet: ValueEnhet,
        Type: Type,
      },
    },{
      headers: {
        'content-type': 'application/json',
        'Authorization': `Bearer ${jwt}`
      }
    }).then(({ data }) => {
      console.log("onSelectEnhetAFid: ", data);
      if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({ type: ON_UPDATE_MODULE, payload: data.results });
      } else {
        dispatch({ type: ON_ERROR_UPDATE_MODULE, payload: data.message });
      }
    }).catch(function (error) {
      dispatch({ type: ON_ERROR_UPDATE_MODULE, payload: error.message });
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
      if (error.message === "Network Error") {
        //reload and remove token 
        //dispatch(userSignOut())
      }
    });
  }
}
//
export const onSelectVINAFid = (userid,Afid,ValueInNotyfile) => {
  const jwt = JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({ type: ON_START_UPDATE_MODULE });
    axios.put('kontos/Kakyl/setValueINoty', {
      method: 'PUT',
      body: {
        userid: userid,
        Afid: Afid,
        ValueInNotyfile: ValueInNotyfile,
      },
    },{
      headers: {
        'content-type': 'application/json',
        'Authorization': `Bearer ${jwt}`
      }
    }).then(({ data }) => {
      console.log("onSelectVINAFid: ", data);
      if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({ type: ON_UPDATE_MODULE, payload: data.results });
      } else {
        dispatch({ type: ON_ERROR_UPDATE_MODULE, payload: data.message });
      }
    }).catch(function (error) {
      dispatch({ type: ON_ERROR_UPDATE_MODULE, payload: error.message });
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
      if (error.message === "Network Error") {
        //reload and remove token 
        //dispatch(userSignOut())
      }
    });
  }
}

export const onSelectCINAFid = (userid,Afid,currency) => {
  const jwt = JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({ type: ON_START_UPDATE_MODULE });
    axios.put('kontos/Kakyl/setCurrency', {
      method: 'PUT',
      body: {
        userid: userid,
        Afid: Afid,
        currency: currency,
      },
     
    }, {
      headers: {
        'content-type': 'application/json',
        'Authorization': `Bearer ${jwt}`
      }
    }).then(({ data }) => {
      console.log("onSelectVINAFid: ", data);
      if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({ type: ON_UPDATE_MODULE, payload: data.results });
      } else {
        dispatch({ type: ON_ERROR_UPDATE_MODULE, payload: data.message });
      }
    }).catch(function (error) {
      dispatch({ type: ON_ERROR_UPDATE_MODULE, payload: error.message });
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
      if (error.message === "Network Error") {
        //reload and remove token 
        //dispatch(userSignOut())
      }
    });
  }
}
export const onSelectLINAFid = (userid,Afid,locales) => {
  const jwt = JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({ type: ON_START_UPDATE_MODULE });
    axios.put('kontos/Kakyl/setLocales', {
      method: 'PUT',
      body: {
        userid: userid,
        Afid: Afid,
        locales: locales,
      },
     
    }, {
      headers: {
        'content-type': 'application/json',
        'Authorization': `Bearer ${jwt}`
      }
    }).then(({ data }) => {
      console.log("onSelectVINAFid: ", data);
      if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({ type: ON_UPDATE_MODULE, payload: data.results });
      } else {
        dispatch({ type: ON_ERROR_UPDATE_MODULE, payload: data.message });
      }
    }).catch(function (error) {
      dispatch({ type: ON_ERROR_UPDATE_MODULE, payload: error.message });
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
      if (error.message === "Network Error") {
        //reload and remove token 
        //dispatch(userSignOut())
      }
    });
  }
}
export const onSwitchKalkylInpris = (userid,Afid,Ordervarde) => {
  const jwt = JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({ type: ON_START_UPDATE_MODULE });
    axios.put('kontos/Kakyl/setInpris', {
      method: 'PUT',
      body: {
        userid: userid,
        Afid: Afid,
        Ordervarde: Ordervarde,
      },
    },{
      headers: {
        'content-type': 'application/json',
        'Authorization': `Bearer ${jwt}`
      }
    }).then(({ data }) => {
      console.log("onSwitchKalkylInpris: ", data);
      if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({ type: ON_UPDATE_MODULE, payload: data.results });
      } else {
        dispatch({ type: ON_ERROR_UPDATE_MODULE, payload: data.message });
      }
    }).catch(function (error) {
      dispatch({ type: ON_ERROR_UPDATE_MODULE, payload: error.message });
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
      if (error.message === "Network Error") {
        //reload and remove token 
        //dispatch(userSignOut())
      }
    });
  }
}
export const onSwitchKalkylDisInpris = (userid,Afid,Ordervarde) => {
  const jwt = JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({ type: ON_START_UPDATE_MODULE });
    axios.put('kontos/Kakyl/setDisInpris', {
      method: 'PUT',
      body: {
        userid: userid,
        Afid: Afid,
        Ordervarde: Ordervarde,
      },
    },{
      headers: {
        'content-type': 'application/json',
        'Authorization': `Bearer ${jwt}`
      }
    }).then(({ data }) => {
      console.log("onSwitchKalkylDisInpris: ", data);
      if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({ type: ON_UPDATE_MODULE, payload: data.results });
      } else {
        dispatch({ type: ON_ERROR_UPDATE_MODULE, payload: data.message });
      }
    }).catch(function (error) {
      dispatch({ type: ON_ERROR_UPDATE_MODULE, payload: error.message });
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
      if (error.message === "Network Error") {
        //reload and remove token 
        //dispatch(userSignOut())
      }
    });
  }
}
export const onSwitchKalkylAutoTB = (userid,Afid,Ordervarde) => {
  const jwt = JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({ type: ON_START_UPDATE_MODULE });
    axios.put('kontos/Kakyl/setAutoTB', {
      method: 'PUT',
      body: {
        userid: userid,
        Afid: Afid,
        Ordervarde: Ordervarde,
      },
    },{
      headers: {
        'content-type': 'application/json',
        'Authorization': `Bearer ${jwt}`
      }
    }).then(({ data }) => {
      console.log("onSwitchKalkylAutoTB: ", data);
      if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({ type: ON_UPDATE_MODULE, payload: data.results });
      } else {
        dispatch({ type: ON_ERROR_UPDATE_MODULE, payload: data.message });
      }
    }).catch(function (error) {
      dispatch({ type: ON_ERROR_UPDATE_MODULE, payload: error.message });
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
      if (error.message === "Network Error") {
        //reload and remove token 
        //dispatch(userSignOut())
      }
    });
  }
}
//EditInvoice
export const EditInvoice = (Afid, userid, FornoxId,NewState) => {
  const jwt = JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({ type: ON_START_FORTNOX_FAKTUROR_EDIT });
    axios.put('kontos/Fortnox/Invoce/Edit', {
      method: 'PUT',
      body: {
        userid: userid,
        Afid: Afid,
        FornoxId: FornoxId,
        NewState: NewState,
      },
    },{
      headers: {
        'content-type': 'application/json',
        'Authorization': `Bearer ${jwt}`
      }
    }).then(({ data }) => {
      console.log("SendInvoice: ", data);
      if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({ type: ON_FORTNOX_FAKTUROR_EDIT, payload: data.results });
      } else {
        dispatch({ type: ON_ERROR_FORTNOX_FAKTUROR_EDIT, payload: data.error });
      }
    }).catch(function (error) {
      dispatch({ type: ON_ERROR_FORTNOX_FAKTUROR_EDIT, payload: error.message });
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
      if (error.message === "Network Error") {
        //reload and remove token 
        //dispatch(userSignOut())
      }
    });
  }
}
//OnCreateNewInvoiceFortnox
export const OnCreateNewInvoiceFortnox = (Afid, userid, NewState,isFrom) => {
  const jwt = JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({ type: ON_START_FORTNOX_FAKTUROR_NEW });
    axios.put('kontos/Fortnox/Invoce/New', {
      method: 'PUT',
      body: {
        userid: userid,
        Afid: Afid,
        NewState: NewState,
        isFrom:isFrom
      },
    },{
      headers: {
        'content-type': 'application/json',
        'Authorization': `Bearer ${jwt}`
      }
    }).then(({ data }) => {
      console.log("OnCreateNewInvoiceFortnox: ", data);
      if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({ type: ON_FORTNOX_FAKTUROR_NEW, payload: data.results });
        console.log(isFrom)
        if(isFrom === "Kund"){
          console.log(NewState)
          let Orgnr = NewState.OrganisationNumber
          let FortnoxKundNR = NewState.CustomerNumber
          dispatch(getFortnoxInvoicesByOrgnr(Orgnr,Afid,userid,FortnoxKundNR))
        }
      } else {
        dispatch({ type: ON_ERROR_FORTNOX_FAKTUROR_NEW, payload: data });
      }
    }).catch(function (error) {
      dispatch({ type: ON_ERROR_FORTNOX_FAKTUROR_NEW, payload: error.message });
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
      if (error.message === "Network Error") {
        //reload and remove token 
        //dispatch(userSignOut())
      }
    });
  }
}
//getKalkylOptions
export const getKalkylOptions = (Afid, userid, Orgnr) => {
  const jwt = JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({ type: ON_START_KUND_KALKYL_OPTIONS});
    axios.get('kontos/Kalkyl/options',
      {
        params: {
          Afid: Afid,
          userid: userid,
          Orgnr: Orgnr,
        },
        headers: { 'Authorization': `Bearer ${jwt}` }
      }
    ).then(({ data }) => {
      console.log("getKalkylOptions: ", data);
      if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({ type: ON_KUND_KALKYL_OPTIONS, payload: data.results });
      } else {
        dispatch({ type: ON_ERROR_KUND_KALKYL_OPTIONS, payload: data.message });
      }
      dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
      dispatch({ type: ON_ERROR_KUND_KALKYL_OPTIONS, payload: error.message });
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
      if (error.message === "Network Error") {
      }
    });
  }
}
//downloadExcelMallKunddata
export const downloadExcelMallKunddata = (Afid,OrderType,OrderTypeId,AvtalId)=>{
  const jwt =  JSON.parse(localStorage.token);
  
  return (dispatch) => {
    dispatch({type: ON_START_FETCH_EXCELMALL});
    axios.get('kontos/Order/Kunddata/downloadmall',
    { params:{
      Afid:Afid,
      OrderTypeId:OrderTypeId,
      OrderType:OrderType,
      AvtalId:AvtalId,
    }, 
     responseType: 'arraybuffer' ,
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then((resp) => {
       const regex = /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/;
       var  fileName = "Kunddatamall.xlsx";
       var blob = new Blob([resp.data], 
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
      );
      dispatch({type: ON_FETCH_EXCELMALL, payload: resp});
      fileSaver.saveAs(blob, fileName);
     }).catch(function (error) {
       dispatch({type: ON_ERROR_EXCELMAL, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}

//downloadExcelAvtalKunddata
export const downloadExcelAvtalKunddata = (Afid,AvtalTyp,AvtalTypID,AvtalId)=>{
  const jwt =  JSON.parse(localStorage.token);
  
  return (dispatch) => {
    dispatch({type: ON_START_FETCH_EXCEL_KUNDDATA_AVTAL});
    axios.get('kontos/Avtal/Kunddata/download',
    { params:{
      Afid:Afid,
      AvtalTyp:AvtalTyp,
      AvtalTypID:AvtalTypID,
      AvtalId:AvtalId,
    }, 
     responseType: 'arraybuffer' ,
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then((resp) => {
       const regex = /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/;
       var  fileName = "Kunddata.xlsx";
       var blob = new Blob([resp.data], 
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
      );
      dispatch({type: ON_FETCH_EXCEL_KUNDDATA_AVTAL, payload: resp});
      fileSaver.saveAs(blob, fileName);
     }).catch(function (error) {
       dispatch({type: ON_ERROR_EXCEL_KUNDDATA_AVTAL, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//downloadExcelMallAvtalKunddata
export const downloadExcelMallAvtalKunddata = (Afid,AvtalTyp,AvtalTypID,AvtalId)=>{
  const jwt =  JSON.parse(localStorage.token);
  
  return (dispatch) => {
    dispatch({type: ON_START_FETCH_EXCELMALL});
    axios.get('kontos/Avtal/Kunddata/downloadmall',
    { params:{
      Afid:Afid,
      AvtalTyp:AvtalTyp,
      AvtalTypID:AvtalTypID,
      AvtalId:AvtalId,
    }, 
     responseType: 'arraybuffer' ,
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then((resp) => {
       const regex = /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/;
       var  fileName = "Kunddatamall.xlsx";
       var blob = new Blob([resp.data], 
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
      );
      dispatch({type: ON_FETCH_EXCELMALL, payload: resp});
      fileSaver.saveAs(blob, fileName);
     }).catch(function (error) {
       dispatch({type: ON_ERROR_EXCELMAL, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//AddToBortFallList
export const AddToBortFallList = (  Afid,userid,name) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_DIALER_ADD_BORTFALL});
     axios.put('kontos/Dialer/BortFall/Add', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        name:name,
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("AddToBortFallList: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DIALER_ADD_BORTFALL, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DIALER_ADD_BORTFALL, payload: data.message});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DIALER_ADD_BORTFALL, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //AddToBlackList
export const AddToBlackList = (  Afid,userid,name) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_DIALER_ADD_BLACKLIST_TAGG});
     axios.put('kontos/Dialer/BlackListT/Add', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        name:name,
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("AddToBlackList: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DIALER_ADD_BLACKLIST_TAGG, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DIALER_ADD_BLACKLIST_TAGG, payload: data.message});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DIALER_ADD_BLACKLIST_TAGG, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 
 //removeThisBortFallList
 export const removeThisBortFallList = (  Afid,userid,chip) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_DIALER_ADD_BORTFALL});
     axios.put('kontos/Dialer/BortFall/delete', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        chip:chip,
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("removeThisBortFallList: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DIALER_DELETE_BORTFALL, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DIALER_ADD_BORTFALL, payload: data.message});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DIALER_ADD_BORTFALL, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //removeThisFromBlackList
 export const removeThisFromBlackList = (  Afid,userid,chip) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_DIALER_ADD_BLACKLIST_TAGG});
     axios.put('kontos/Dialer/BlackListT/delete', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        chip:chip,
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("removeThisFromBlackList: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DIALER_DELETE_BLACKLIST_TAGG, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DIALER_ADD_BLACKLIST_TAGG, payload: data.message});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DIALER_ADD_BLACKLIST_TAGG, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //updateDashboardUserslist
 export const updateDashboardUserslist = (Afid,userid,userObj,Meta,newValue) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_DASHBORD_USERLIST});
     axios.put('kontos/Dashbord/user/update', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        userObj:userObj,
        Meta:Meta,
        newValue:newValue,
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("updateDashboardUserslist: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DASHBORD_USERLIST, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DASHBORD_USERLIST, payload: data.message});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DASHBORD_USERLIST, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //SwitchAvPaDashBoardLoop
export const SwitchAvPaDashBoardLoop = (Afid,userid,label,Value) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GENERATE_DASHBORAD_LINK});
     axios.put('kontos/Dashboard/Switch', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        label:label,
        Value:Value,
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("SwitchAvPaDashBoardLoop: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GENERATE_DASHBORAD_LINK, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GENERATE_DASHBORAD_LINK, payload: data.message});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GENERATE_DASHBORAD_LINK, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //SetsecPaDashBoardLoop
 export const SetsecPaDashBoardLoop = (Afid,userid,label,Value) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GENERATE_DASHBORAD_LINK});
     axios.put('kontos/Dashboard/SetSec', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        label:label,
        Value:Value,
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("SetsecPaDashBoardLoop: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GENERATE_DASHBORAD_LINK, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GENERATE_DASHBORAD_LINK, payload: data.message});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GENERATE_DASHBORAD_LINK, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
  //getDashboardObject
export const getDashboardLoopObject = (Token) =>{
  return (dispatch) => {
    dispatch({type: ON_START_GET_DASHBORAD_LOOP_OBJEKT});
    axios.get('kontos/Dashboard/loop/Objekt',
    { params:{Token:Token} }      
     ).then(({data}) => {
      console.log("getDashboardLoopObject: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_FETCH_DASHBORAD_LOOP_OBJEKT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DASHBORAD_LOOP_OBJEKT, payload: data.error});
         dispatch(userSignOut())
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DASHBORAD_LOOP_OBJEKT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
        dispatch(userSignOut())
     });
  }
}
//fetchLastHogiaSetting
export const fetchLastHogiaSetting = (userid,Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_GET_AF_LHOGIA});
    axios.get('kontos/Hogia/getLastupdate',
    { params:{Afid:Afid,userid:userid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("fetchLastHogiaSetting: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_AF_LHOGIA, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_AF_LHOGIA, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_AF_LHOGIA, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//bestallaHogiaKonto
export const bestallaHogiaKonto = ( userid, Afid,APIKOD) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_BESTALLA_HOGIA});
     axios.put('kontos/Hogia/Bestalla', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        APIKOD:APIKOD
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("bestallaHogiaKonto: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_BESTALLA_HOGIA, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_BESTALLA_HOGIA, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_BESTALLA_HOGIA, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//AddNewHogiaStorId
export const AddNewHogiaStorId = (  Afid,userid,HogiaStoreId) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_AF_LHOGIA});
     axios.put('kontos/Hogia/Store/new', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        HogiaStoreId:HogiaStoreId
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("AddNewHogiaStorId: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_AF_LHOGIA_STORE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_AF_LHOGIA, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_AF_LHOGIA, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//deleteHogiaStorId
export const deleteHogiaStorId = (  Afid,userid,HogiaStoreId) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_AF_LHOGIA});
     axios.put('kontos/Hogia/Store/delete', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        HogiaStoreId:HogiaStoreId
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("deleteHogiaStorId: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_AF_LHOGIA_DELETE_STORE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_AF_LHOGIA, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_AF_LHOGIA, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 export const disconnectWpREST = (userid,Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress=await getClientIp()
    dispatch({type: ON_START_DISCONNECT_WOOCOMMERCE_WP_REST});
    axios.delete('kontos/Woocommerce/WpREST',
    { params:{Afid:Afid,userid:userid,ipAdress}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("disconnectWpREST: ", data);
       if (data.results) {
         dispatch({type: ON_DISCONNECT_WOOCOMMERCE_WP_REST, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DISCONNECT_WOOCOMMERCE_WP_REST, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DISCONNECT_WOOCOMMERCE_WP_REST, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}

export const connectWpREST= ( userid, Afid,APIKOD) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_CONNECT_WOOCOMMERCE_WP_REST});
     axios.post('kontos/Woocommerce/WpREST', {
      method: 'POST',
      body: {
        userid:userid,
        Afid:Afid,
        APIKOD:APIKOD
      }},{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("connectWpREST: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_CONNECT_WOOCOMMERCE_WP_REST, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_CONNECT_WOOCOMMERCE_WP_REST, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_CONNECT_WOOCOMMERCE_WP_REST, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 } 
 export const disconnectBitlogREST = (userid,Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress=await getClientIp()
    dispatch({type: ON_START_DISCONNECT_BITLOG_REST});
    axios.delete('kontos/Woocommerce/BitlogREST',
    { params:{Afid:Afid,userid:userid,ipAdress}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("disconnectBitlogREST: ", data);
       if (data.results) {
         dispatch({type: ON_DISCONNECT_BITLOG_REST, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DISCONNECT_BITLOG_REST, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DISCONNECT_BITLOG_REST, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}

export const connectBitlogREST= ( userid, Afid,APIKOD) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_CONNECT_BITLOG_REST});
     axios.post('kontos/Woocommerce/BitlogREST', {
      method: 'POST',
      body: {
        userid:userid,
        Afid:Afid,
        APIKOD:APIKOD
      }},{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("connectBitlogREST: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_CONNECT_BITLOG_REST, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_CONNECT_BITLOG_REST, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_CONNECT_BITLOG_REST, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }

 export const getBitlogProductBalance = (userid,Afid, Artid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async(dispatch) => {
    return await axios.get('kontos/Woocommerce/BitlogREST/stock',
    { params:{Afid:Afid,Artid,userid:userid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      dispatch(RefreshUserInterface(userid))
      return data.results
     }).catch(function (error) {
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
export const connectWoocommerce = ( userid, Afid,APIKOD) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_CONNECT_WOOCOMMERCE});
     axios.post('kontos/Woocommerce', {
      method: 'POST',
      body: {
        userid:userid,
        Afid:Afid,
        APIKOD:APIKOD
      }},{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("connectWoocommerce: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_CONNECT_WOOCOMMERCE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_CONNECT_WOOCOMMERCE, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_CONNECT_WOOCOMMERCE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 
export const updateWoocommerce = ( userid, Afid, Obj) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_UPDATE_WOOCOMMERCE});
     axios.put('kontos/Woocommerce', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        Obj:Obj
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("updateWoocommerce: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_UPDATE_WOOCOMMERCE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_UPDATE_WOOCOMMERCE, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_WOOCOMMERCE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 export const getWoocommerce = (userid,Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_GET_WOOCOMMERCE});
    axios.get('kontos/Woocommerce',
    { params:{Afid:Afid,userid:userid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getWoocommerce: ", data);
       if (data.results) {
         dispatch({type: ON_GET_WOOCOMMERCE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_WOOCOMMERCE, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_WOOCOMMERCE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//ON_START_GET_WOOCOMMERCE_CUSTOMER, ON_GET_WOOCOMMERCE_CUSTOMER,ON_ERROR_GET_WOOCOMMERCE_CUSTOMER,
 export const getWoocommerceCustomer = (userid,Afid,Orgnr) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_GET_WOOCOMMERCE_CUSTOMER});
    const ipAdress= await getClientIp()
    axios.get('kontos/Woocommerce/customer',
    { params:{Afid:Afid,userid:userid,Orgnr:Orgnr,ipAdress}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getWoocommerceCustomer: ", data);
       if (data.results) {
         dispatch({type: ON_GET_WOOCOMMERCE_CUSTOMER, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_WOOCOMMERCE_CUSTOMER, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_WOOCOMMERCE_CUSTOMER, payload: error});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
 export const disconnectWoocommerce = (userid,Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress=await getClientIp()
    dispatch({type: ON_START_DISCONNECT_WOOCOMMERCE});
    axios.delete('kontos/Woocommerce',
    { params:{Afid:Afid,userid:userid,ipAdress}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("disconnectWoocommerce: ", data);
       if (data.results) {
         dispatch({type: ON_DISCONNECT_WOOCOMMERCE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DISCONNECT_WOOCOMMERCE, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DISCONNECT_WOOCOMMERCE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
export const createWoocommerceCustomer = (userid,Afid,Orgnr) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_CREATE_WOOCOMMERCE_CUSTOMER});
    axios.post('kontos/Woocommerce/customer', {
      method: 'POST',
      body: {
        userid:userid,
        Afid:Afid,
        Orgnr:Orgnr
      }},{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("createWoocommerceCustomer: ", data);
       if (data.results) {
         dispatch({type: ON_CREATE_WOOCOMMERCE_CUSTOMER, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_CREATE_WOOCOMMERCE_CUSTOMER, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_CREATE_WOOCOMMERCE_CUSTOMER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
export const connectWoocommerceCustomer = (userid,Afid,Orgnr,Email) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress= await getClientIp()
    dispatch({type: ON_START_CONNECT_WOOCOMMERCE_CUSTOMER});
    axios.put('kontos/Woocommerce/customer', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        Orgnr:Orgnr,
        Email:Email,
        ipAdress
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("connectWoocommerceCustomer: ", data);
       if (data.results) {
         dispatch({type: ON_CONNECT_WOOCOMMERCE_CUSTOMER, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_CONNECT_WOOCOMMERCE_CUSTOMER, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_CONNECT_WOOCOMMERCE_CUSTOMER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
export const disconnectWoocommerceCustomer = (userid,Afid,Orgnr) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress= await getClientIp()
    dispatch({type: ON_START_DISCONNECT_WOOCOMMERCE_CUSTOMER});
    axios.delete('kontos/Woocommerce/customer', {
      method: 'DELETE',
      params: {
        userid:userid,
        Afid:Afid,
        Orgnr:Orgnr,
        ipAdress
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("disconnectWoocommerceCustomer: ", data);
       if (data.results) {
         dispatch({type: ON_DISCONNECT_WOOCOMMERCE_CUSTOMER, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DISCONNECT_WOOCOMMERCE_CUSTOMER, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DISCONNECT_WOOCOMMERCE_CUSTOMER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
 export const syncWoocommerceKunder = (userid,Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_SYNC_WOOCOMMERCE_CUSTOMERS});
    axios.post('kontos/Woocommerce/sync', {
      method: 'POST',
      body: {
        userid:userid,
        Afid:Afid,
      }},{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("syncWoocommerceKunder: ", data);
       if (data.results) {
         dispatch({type: ON_SYNC_WOOCOMMERCE_CUSTOMERS, payload: data.results});
       } else {
         dispatch({type: ON_SYNC_WOOCOMMERCE_CUSTOMERS, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SYNC_WOOCOMMERCE_CUSTOMERS, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}


export const getWholesaleSuite = (userid,Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_GET_WHOLESALESUTIE_ROLES});
    axios.get('kontos/WholesaleSuit/roles',
    { params:{Afid:Afid,userid:userid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getWholesaleSuite: ", data);
       if (data.success) {
         dispatch({type: ON_GET_WHOLESALESUTIE_ROLES, payload: data});
       } else {
         dispatch({type: ON_ERROR_GET_WHOLESALESUTIE_ROLES, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_WHOLESALESUTIE_ROLES, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
// ON_CONNECT_WHOLESALESUTIE_ROLES_AFID_LIST,
// ON_START_CONNECT_WHOLESALESUTIE_ROLES_AFID_LIST,
// ON_ERROR_CONNECT_WHOLESALESUTIE_ROLES_AFID_LIST,
export const connectWholesaleRoleAfid = (userid,Afid, WholesaleRoleKey, PrislistId) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_CONNECT_WHOLESALESUTIE_ROLES_AFID_LIST});
    axios.post('kontos/WholesaleSuit/roles/connect',
      { body:{Afid:Afid,userid:userid, WholesaleRoleKey, PrislistId}, } ,     
      { headers: { 'Authorization': `Bearer ${jwt}`} }
     ).then(({data}) => {
      console.log("connectWholesaleRoleAfid: ", data);
       if (data.success) {
         dispatch({type: ON_CONNECT_WHOLESALESUTIE_ROLES_AFID_LIST, payload: data});
       } else {
         dispatch({type: ON_ERROR_CONNECT_WHOLESALESUTIE_ROLES_AFID_LIST, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_CONNECT_WHOLESALESUTIE_ROLES_AFID_LIST, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}

// ON_CREATE_WHOLESALESUTIE_ROLES_AFID_LIST,
// ON_START_CREATE_WHOLESALESUTIE_ROLES_AFID_LIST,
// ON_ERROR_CREATE_WHOLESALESUTIE_ROLES_AFID_LIST,
export const createWholesaleRoleAfid = (userid,Afid, PrislistId) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_CREATE_WHOLESALESUTIE_ROLES_AFID_LIST});
    axios.post('kontos/WholesaleSuit/roles/create',
      { body:{Afid:Afid,userid:userid, PrislistId}, } ,     
      { headers: { 'Authorization': `Bearer ${jwt}`} }
     ).then(({data}) => {
      console.log("createWholesaleRoleAfid: ", data);
       if (data.success) {
         dispatch({type: ON_CREATE_WHOLESALESUTIE_ROLES_AFID_LIST, payload: data});
       } else {
         dispatch({type: ON_ERROR_CREATE_WHOLESALESUTIE_ROLES_AFID_LIST, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_CREATE_WHOLESALESUTIE_ROLES_AFID_LIST, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}

// ON_GET_ZENDESK,
// ON_ERROR_GET_ZENDESK,
// ON_START_GET_ZENDESK,
export const connectZendesk = ( userid, Afid,APIDATA) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_CONNECT_ZENDESK});
     axios.post('kontos/Zendesk', {
      method: 'POST',
      body: {
        userid:userid,
        Afid:Afid,
        APIDATA:APIDATA
      }, 
      },{
        'content-type': 'application/json',
        'Authorization':   `Bearer ${jwt}`
      }     ).then(({data}) => {
      console.log("connectZendesk: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_CONNECT_ZENDESK, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_CONNECT_ZENDESK, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_CONNECT_ZENDESK, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 export const disconnectZendesk = (userid,Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress=await getClientIp()
    dispatch({type: ON_START_DISCONNECT_ZENDESK});
    axios.delete('kontos/Zendesk',
    { params:{Afid:Afid,userid:userid,ipAdress}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("disconnectZendesk: ", data);
       if (data.results) {
         dispatch({type: ON_DISCONNECT_ZENDESK, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DISCONNECT_ZENDESK, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DISCONNECT_ZENDESK, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
// ON_GET_ZENDESK,
// ON_ERROR_GET_ZENDESK,
// ON_START_GET_ZENDESK,
export const getZendesk = (userid,Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_GET_ZENDESK});
    axios.get('kontos/Zendesk',
    { params:{Afid:Afid,userid:userid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getZendesk: ", data);
       if (data.results) {
         dispatch({type: ON_GET_ZENDESK, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_ZENDESK, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_ZENDESK, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
 //onFlyttaInAktivUser
 export const onFlyttaInAktivUserd= (userid,Afid,stateObj)=>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    console.log(ipAdress)
    dispatch({type: ON_START_FLYTTA_INAKTIV_USER});
    dispatch({type: ON_START_MESSAGE_KUND,payload:translate("Action.Customer.tranfering.data")});
    axios.put('kontos/users/Flytta', {
     method: 'PUT',
     body: {
       stateObj:stateObj,
       Afid:Afid,
       userid:userid,
       ipAdress: ipAdress,
     }}, {
     headers: {
         'content-type': 'application/json',
         'Authorization':   `Bearer ${jwt}`
     }       
 }).then(({data}) => {
     console.log("onFlyttaInAktivUser: ", data);
      if (data.results) {
       // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({type: ON_FETCH_FLYTTA_INAKTIV_USER, payload: data.results});
        dispatch({type: ON_MESSAGE_KUND,payload:translate("Action.Customer.tranfer.data")});
      } else {
        dispatch({type: ON_ERROR_FLYTTA_INAKTIV_USER, payload: data.error});
        dispatch({type: ON_ERROR_MESSAGE_KUND, payload: translate("Error.Customer.tranfer.data")});
      }
      //dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
      dispatch({type: ON_ERROR_FLYTTA_INAKTIV_USER, payload: error.message});
      dispatch({type: ON_ERROR_MESSAGE_KUND, payload: translate("Error.Customer.tranfer.data")});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
    });
  }
 }
//
export const onKopieraSettingUserd= (userid,Afid,stateObj)=>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    console.log(ipAdress)
    dispatch({type: ON_START_FETCH_KOPIERA_USER});
    dispatch({type: ON_START_MESSAGE_KUND,payload:translate("Action.Customer.Copying.settings")});
    axios.put('kontos/users/copy', {
     method: 'PUT',
     body: {
       stateObj:stateObj,
       Afid:Afid,
       userid:userid,
       ipAdress: ipAdress,
     }}, {
     headers: {
         'content-type': 'application/json',
         'Authorization':   `Bearer ${jwt}`
     }       
 }).then(({data}) => {
     console.log("onKopieraSettingUserd: ", data);
      if (data.results) {
       // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({type: ON_FETCH_KOPIERA_USER, payload: data.results});
        dispatch({type: ON_MESSAGE_KUND,payload:translate("Action.Customer.Copy.settings")});
      } else {
        dispatch({type: ON_ERROR_FLYTTA_INAKTIV_USER, payload: data.error});
        dispatch({type: ON_ERROR_MESSAGE_KUND, payload: translate("Error.Customer.Copy.settings")});
      }
      //dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
      dispatch({type: ON_ERROR_FLYTTA_INAKTIV_USER, payload: error.message});
      dispatch({type: ON_ERROR_MESSAGE_KUND, payload: translate("Error.Customer.Copy.settings")});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
    });
  }
 }
//getKunderDokumentList
export const getKunderDokumentList = (Afid, userid,page,search,filter) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_MINA_DOCUMENT_LIST});
    axios.get('kontos/Dokumets/getAll',
    { params:{Afid:Afid,userid:userid,ipAdress,page,search,filter}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getKunderDokumentList: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_MINA_DOCUMENT_LIST, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_MINA_DOCUMENT_LIST, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_MINA_DOCUMENT_LIST, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//getKundsDokumentList
export const getKundsDokumentList = (Afid, userid,Orgnr,page,search) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_MINA_DOCUMENT_KUND_LIST});
    axios.get('kontos/Dokumets/getClientAll',
    { params:{Afid:Afid,userid:userid,ipAdress,page,search,Orgnr}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getKunderDokumentList: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_MINA_DOCUMENT_KUND_LIST, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_MINA_DOCUMENT_KUND_LIST, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_MINA_DOCUMENT_KUND_LIST, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//SaveNewOrderStatus
export const SaveNewOrderStatus = ( userid, Afid,newStatus) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_NEW_ORDER_STATUS});
     axios.put('kontos/Order/Status/new', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        newStatus:newStatus
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("SaveNewOrderStatus: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_NEW_ORDER_STATUS, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_ORDER_STATUS, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_ORDER_STATUS, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//deleteOrderStatus
export const deleteOrderStatus = ( Afid,userid,delStatus) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_ORDER_STATUS});
     axios.delete('kontos/Order/Status/delete', {
      method: 'DELETE',
      data: {
        Afid:Afid,
        delStatus:delStatus,
        userid:userid
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("deleteOrderStatus: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_ORDER_STATUS, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DELETE_ORDER_STATUS, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_ORDER_STATUS, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //UpdateOrderStatus
 export const UpdateOrderStatus = (Afid,userid,EdStatus) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_UPDATE_ORDER_STATUS});
     axios.put('kontos/Order/Status/update', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        EdStatus:EdStatus
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("UpdateOrderStatus: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_UPDATE_ORDER_STATUS, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_UPDATE_ORDER_STATUS, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_ORDER_STATUS, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 
 //getOrderStatusListbyAfid
export const getOrderStatusListbyAfid = (Afid,isFrom) =>{
 // const jwt =  JSON.parse(localStorage.token);
   const isfrom = isUndefined(isFrom)?0:isFrom
   return async (dispatch) => {
     dispatch({type: ON_START_GET_ORDER_STATUS});
     axios.get('kontos/Order/Status/get',
     { params:{Afid:Afid,isfrom}, 
    //  headers: { 'Authorization': `Bearer ${jwt}`} 
    }      
      ).then(({data}) => {
       console.log("getOrderStatusListbyAfid: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_GET_ORDER_STATUS, payload: data.results});
        } else {
          dispatch({type: ON_ERROR_ORDER_STATUS, payload: data.error});
        }
      }).catch(function (error) {
        dispatch({type: ON_ERROR_ORDER_STATUS, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
        if(error.message === "Network Error"){
           //reload and remove token 
           //dispatch(userSignOut())
        } 
      });
   } /**/
 }
 
 //getOrderUserlistabyAfid
export const getOrderUserlistabyAfid = (Afid,Kontoid,userid) =>{
 // const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_GET_ORDER_USER_HV});
     axios.get('kontos/Order/UserAfid/get',
     { params:{
       Afid:Afid,
       userid:userid,
       Kontoid:Kontoid,
      }, 
    //  headers: { 'Authorization': `Bearer ${jwt}`} 
    }      
      ).then(({data}) => {
       console.log("getOrderStatusListbyAfid: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_GET_ORDER_USER_HV, payload: data.results});
        } else {
          dispatch({type: ON_ERROR_ORDER_USER_HV, payload: data.error});
        }
      }).catch(function (error) {
        dispatch({type: ON_ERROR_ORDER_USER_HV, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
        if(error.message === "Network Error"){
           //reload and remove token 
           //dispatch(userSignOut())
        } 
      });
   } /**/
 }

 //ProjektStatus
export const SaveNewProjectStatus = ( userid, Afid,newStatus) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_NEW_PROJEKT_STATUS});
     axios.put('kontos/Project/Status/new', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        newStatus:newStatus
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("SaveNewProjectStatus: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_NEW_PROJEKT_STATUS, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_PROJEKT_STATUS, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_PROJEKT_STATUS, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//deleteProjectStatus
export const deleteProjectStatus = ( Afid,userid,delStatus) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_PROJEKT_STATUS});
     axios.delete('kontos/Project/Status/delete', {
      method: 'DELETE',
      data: {
        Afid:Afid,
        delStatus:delStatus,
        userid:userid
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("deleteProjectStatus: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_PROJEKT_STATUS, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DELETE_PROJEKT_STATUS, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_PROJEKT_STATUS, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //UpdateProjectStatus
 export const UpdateProjectStatus = (Afid,userid,EdStatus) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_UPDATE_PROJEKT_STATUS});
     axios.put('kontos/Project/Status/update', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        EdStatus:EdStatus
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("UpdateProjectStatus: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_UPDATE_PROJEKT_STATUS, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_UPDATE_PROJEKT_STATUS, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_PROJEKT_STATUS, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }

 
 //getProjectStatusListbyAfid
export const getProjectStatusListbyAfid = (Afid) =>{
 // const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_GET_PROJEKT_STATUS});
     axios.get('kontos/Project/Status/get',
     { params:{Afid:Afid}, 
    //  headers: { 'Authorization': `Bearer ${jwt}`} 
    }      
      ).then(({data}) => {
       console.log("getProjectStatusListbyAfid: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_GET_PROJEKT_STATUS, payload: data.results});
        } else {
          dispatch({type: ON_ERROR_PROJEKT_STATUS, payload: data.error});
        }
      }).catch(function (error) {
        dispatch({type: ON_ERROR_PROJEKT_STATUS, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
        if(error.message === "Network Error"){
           //reload and remove token 
           //dispatch(userSignOut())
        } 
      });
   } /**/
 }
 
 
 //Arende Status
export const SaveNewArendeStatus = ( userid, Afid,newStatus) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_NEW_ARENDE_STATUS});
     axios.put('kontos/Arende/Status/new', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        newStatus:newStatus
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("SaveNewArendeStatus: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_NEW_ARENDE_STATUS, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_ARENDE_STATUS, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_ARENDE_STATUS, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//deleteProjectStatus
export const deleteArendeStatus = ( Afid,userid,delStatus) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_ARENDE_STATUS});
     axios.delete('kontos/Arende/Status/delete', {
      method: 'DELETE',
      data: {
        Afid:Afid,
        delStatus:delStatus,
        userid:userid
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("deleteArendeStatus: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_ARENDE_STATUS, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DELETE_ARENDE_STATUS, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_ARENDE_STATUS, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //UpdateProjectStatus
 export const UpdateArendeStatus = (Afid,userid,EdStatus) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_UPDATE_ARENDE_STATUS});
     axios.put('kontos/Arende/Status/update', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        EdStatus:EdStatus
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("UpdateArendeStatus: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_UPDATE_ARENDE_STATUS, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_UPDATE_ARENDE_STATUS, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_ARENDE_STATUS, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }

 
 //getProjectStatusListbyAfid
export const getArendeStatusListbyAfid = (Afid) =>{
 // const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_GET_ARENDE_STATUS});
     axios.get('kontos/Arende/Status/get',
     { params:{Afid:Afid}, 
    //  headers: { 'Authorization': `Bearer ${jwt}`} 
    }      
      ).then(({data}) => {
       console.log("getArendeStatusListbyAfid: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_GET_ARENDE_STATUS, payload: data.results});
        } else {
          dispatch({type: ON_ERROR_ARENDE_STATUS, payload: data.error});
        }
      }).catch(function (error) {
        dispatch({type: ON_ERROR_ARENDE_STATUS, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
        if(error.message === "Network Error"){
           //reload and remove token 
           //dispatch(userSignOut())
        } 
      });
   } /**/
 }
 
//  ON_START_GET_PROJEKT_FAS_LIST,
//  ON_GET_PROJEKT_FAS_LIST,
//  ON_ERROR_GET_PROJEKT_FAS_LIST,
export const getProjectFasList = (Afid, FasView=0) =>{
 const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_GET_PROJEKT_FAS_LIST});
     axios.get('kontos/Project/Fas/get',
     { params:{Afid:Afid,FasView:FasView}, 
     headers: { 'Authorization': `Bearer ${jwt}`} 
    }      
      ).then(({data}) => {
       console.log("getProjectFasList: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_GET_PROJEKT_FAS_LIST, payload: data.results});
        } else {
          dispatch({type: ON_ERROR_GET_PROJEKT_FAS_LIST, payload: data.error});
        }
      }).catch(function (error) {
        dispatch({type: ON_ERROR_GET_PROJEKT_FAS_LIST, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
        if(error.message === "Network Error"){
           //reload and remove token 
           //dispatch(userSignOut())
        } 
      });
   } /**/
 }

 //Projekt Faser
 export const SaveNewProjectFas = ( userid, Afid,newStatus, FasView=0) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_NEW_PROJEKT_FAS});
     axios.put('kontos/Project/Fas/new', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        newStatus:newStatus,
        FasView:FasView
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("SaveNewProjectFas: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_NEW_PROJEKT_FAS, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_PROJEKT_FAS, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_PROJEKT_FAS, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//deleteProjectFas
export const deleteProjectFas = ( Afid,userid,delStatus, FasView=0) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_PROJEKT_FAS});
     axios.delete('kontos/Project/Fas/delete', {
      method: 'DELETE',
      data: {
        Afid:Afid,
        delStatus:delStatus,
        userid:userid,
        FasView:FasView
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("deleteProjectFas: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_PROJEKT_FAS, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DELETE_PROJEKT_FAS, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_PROJEKT_FAS, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //UpdateProjectFas
 export const UpdateProjectFas = (Afid,userid,Meta,Value,FasId,FasView = 0) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_UPDATE_PROJEKT_FAS});
     axios.put('kontos/Project/Fas/update', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        Meta,Value,FasId,FasView
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("UpdateProjectFas: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_UPDATE_PROJEKT_FAS, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_UPDATE_PROJEKT_FAS, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_PROJEKT_FAS, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 /*
//bestallaHogiaKonto
export const CreateWebshopHogiaKonto = ( userid, Afid,APIKOD) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_BESTALLA_HOGIA});
     axios.put('kontos/Hogia/webshop/create', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        APIKOD:APIKOD
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("CreateWebshopHogiaKonto: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_BESTALLA_HOGIA, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_BESTALLA_HOGIA, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_BESTALLA_HOGIA, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 */
//onSaveThisNewChild
export const onSaveThisNewChild = (Afid,userid,newBarn) =>{
  //console.log(konto)
  const jwt = JSON.parse(localStorage.token);;
  return (dispatch) => {
    dispatch({type: FETCH_START_SAVE_NEW_CHILD});
    axios.put('kontos/Child/new', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        newBarn:newBarn
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }
  }).then(({data}) => {
    console.log("onSaveThisNewChild: ", data);
     if (data.results) {
      // dispatch({type: FETCH_ALL_CONTACT});
       dispatch({type: ON_SAVE_NEW_CHILD, payload: data.results});
     } else {
       dispatch({type: ON_ERROR_SAVE_NEW_CHILD, payload: data.message});
     }
   }).catch(function (error) {
     dispatch({type: ON_ERROR_SAVE_NEW_CHILD, payload: error.message});
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
   });
  }
}
//onChangeBLTypeThisNewChild
export const onChangeBLTypeThisNewChild = (Afid,userid,newBarn) =>{
  //console.log(konto)
  const jwt = JSON.parse(localStorage.token);;
  return (dispatch) => {
    dispatch({type: FETCH_START_SAVE_BLTYPE_CHILD});
    axios.put('kontos/Child/updateBLT', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        newBarn:newBarn
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }
  }).then(({data}) => {
    console.log("onChangeBLTypeThisNewChild: ", data);
     if (data.results) {
      // dispatch({type: FETCH_ALL_CONTACT});
       dispatch({type: ON_SAVE_BLTYPE_CHILD, payload: data.results});
     } else {
       dispatch({type: ON_ERROR_SAVE_BLTYPE_CHILD, payload: data.message});
     }
   }).catch(function (error) {
     dispatch({type: ON_ERROR_SAVE_BLTYPE_CHILD, payload: error.message});
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
   });
  }
}
//onChangeCCTypeThisNewChild
export const onChangeCCTypeThisNewChild = (Afid,userid,newBarn) =>{
  //console.log(konto)
  const jwt = JSON.parse(localStorage.token);;
  return (dispatch) => {
    dispatch({type: FETCH_START_SAVE_BLTYPE_CHILD});
    axios.put('kontos/Child/updateCCT', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        newBarn:newBarn
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }
  }).then(({data}) => {
    console.log("onChangeBLTypeThisNewChild: ", data);
     if (data.results) {
      // dispatch({type: FETCH_ALL_CONTACT});
       dispatch({type: ON_SAVE_CCTYPE_CHILD, payload: data.results});
     } else {
       dispatch({type: ON_ERROR_SAVE_BLTYPE_CHILD, payload: data.message});
     }
   }).catch(function (error) {
     dispatch({type: ON_ERROR_SAVE_BLTYPE_CHILD, payload: error.message});
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
   });
  }
}
//
export const onChangeACTypeThisNewChild = (Afid,userid,newBarn) =>{
  //console.log(konto)
  const jwt = JSON.parse(localStorage.token);;
  return (dispatch) => {
    dispatch({type: FETCH_START_SAVE_BLTYPE_CHILD});
    axios.put('kontos/Child/updateACT', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        newBarn:newBarn
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }
  }).then(({data}) => {
    console.log("onChangeBLTypeThisNewChild: ", data);
     if (data.results) {
      // dispatch({type: FETCH_ALL_CONTACT});
       dispatch({type: ON_SAVE_CCTYPE_CHILD, payload: data.results});
     } else {
       dispatch({type: ON_ERROR_SAVE_BLTYPE_CHILD, payload: data.message});
     }
   }).catch(function (error) {
     dispatch({type: ON_ERROR_SAVE_BLTYPE_CHILD, payload: error.message});
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
   });
  }
}
export const onChangeOFFTypeThisNewChild = (Afid,userid,newBarn) =>{
  //console.log(konto)
  const jwt = JSON.parse(localStorage.token);;
  return (dispatch) => {
    dispatch({type: FETCH_START_SAVE_BLTYPE_CHILD});
    axios.put('kontos/Child/updateOFF', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        newBarn:newBarn
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }
  }).then(({data}) => {
    console.log("onChangeBLTypeThisNewChild: ", data);
     if (data.results) {
      // dispatch({type: FETCH_ALL_CONTACT});
       dispatch({type: ON_SAVE_CCTYPE_CHILD, payload: data.results});
     } else {
       dispatch({type: ON_ERROR_SAVE_BLTYPE_CHILD, payload: data.message});
     }
   }).catch(function (error) {
     dispatch({type: ON_ERROR_SAVE_BLTYPE_CHILD, payload: error.message});
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
   });
  }
}
export const onChangeFNTypeThisNewChild = (Afid,userid,newBarn) =>{
  //console.log(konto)
  const jwt = JSON.parse(localStorage.token);;
  return (dispatch) => {
    dispatch({type: FETCH_START_SAVE_FNTYPE_CHILD});
    axios.put('kontos/Child/updateFN', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        newBarn:newBarn
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }
  }).then(({data}) => {
    console.log("onChangeFNTypeThisNewChild: ", data);
     if (data.results) {
      // dispatch({type: FETCH_ALL_CONTACT});
       dispatch({type: ON_SAVE_FNTYPE_CHILD, payload: data.results});
     } else {
       dispatch({type: ON_ERROR_SAVE_FNTYPE_CHILD, payload: data.message});
     }
   }).catch(function (error) {
     dispatch({type: ON_ERROR_SAVE_FNTYPE_CHILD, payload: error.message});
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
   });
  }
}
export const onChangeCLTypeThisNewChild = (Afid,userid,newBarn) =>{
  //console.log(konto)
  const jwt = JSON.parse(localStorage.token);;
  return (dispatch) => {
    dispatch({type: FETCH_START_SAVE_CLTYPE_CHILD});
    axios.put('kontos/Child/updateCL', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        newBarn:newBarn
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }
  }).then(({data}) => {
    console.log("onChangeCLTypeThisNewChild: ", data);
     if (data.results) {
      // dispatch({type: FETCH_ALL_CONTACT});
       dispatch({type: ON_SAVE_CLTYPE_CHILD, payload: data.results});
     } else {
       dispatch({type: ON_ERROR_SAVE_CLTYPE_CHILD, payload: data.message});
     }
   }).catch(function (error) {
     dispatch({type: ON_ERROR_SAVE_CLTYPE_CHILD, payload: error.message});
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
   });
  }
}
export const onChangeSPTypeThisNewChild = (Afid,userid,newBarn) =>{
  //console.log(konto)
  const jwt = JSON.parse(localStorage.token);;
  return (dispatch) => {
    dispatch({type: FETCH_START_SAVE_CLTYPE_CHILD});
    axios.put('kontos/Child/updateSP', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        newBarn:newBarn
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }
  }).then(({data}) => {
    console.log("onChangeSPTypeThisNewChild: ", data);
     if (data.results) {
      // dispatch({type: FETCH_ALL_CONTACT});
       dispatch({type: ON_SAVE_CLTYPE_CHILD, payload: data.results});
     } else {
       dispatch({type: ON_ERROR_SAVE_CLTYPE_CHILD, payload: data.message});
     }
   }).catch(function (error) {
     dispatch({type: ON_ERROR_SAVE_CLTYPE_CHILD, payload: error.message});
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
   });
  }
}
export const onChangeSATypeThisNewChild = (Afid,userid,newBarn) =>{
  //console.log(konto)
  const jwt = JSON.parse(localStorage.token);;
  return (dispatch) => {
    dispatch({type: FETCH_START_SAVE_CLTYPE_CHILD});
    axios.put('kontos/Child/updateSA', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        newBarn:newBarn
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }
  }).then(({data}) => {
    console.log("onChangeSPTypeThisNewChild: ", data);
     if (data.results) {
      // dispatch({type: FETCH_ALL_CONTACT});
       dispatch({type: ON_SAVE_CLTYPE_CHILD, payload: data.results});
     } else {
       dispatch({type: ON_ERROR_SAVE_CLTYPE_CHILD, payload: data.message});
     }
   }).catch(function (error) {
     dispatch({type: ON_ERROR_SAVE_CLTYPE_CHILD, payload: error.message});
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
   });
  }
}
export const onChangeSPPTypeThisNewChild = (Afid,userid,newBarn) =>{
  //console.log(konto)
  const jwt = JSON.parse(localStorage.token);;
  return (dispatch) => {
    dispatch({type: FETCH_START_SAVE_CLTYPE_CHILD});
    axios.put('kontos/Child/updateSPP', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        newBarn:newBarn
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }
  }).then(({data}) => {
    console.log("onChangeSPTypeThisNewChild: ", data);
     if (data.results) {
      // dispatch({type: FETCH_ALL_CONTACT});
       dispatch({type: ON_SAVE_CLTYPE_CHILD, payload: data.results});
     } else {
       dispatch({type: ON_ERROR_SAVE_CLTYPE_CHILD, payload: data.message});
     }
   }).catch(function (error) {
     dispatch({type: ON_ERROR_SAVE_CLTYPE_CHILD, payload: error.message});
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
   });
  }
}
export const onChangeSOTypeThisNewChild = (Afid,userid,newBarn) =>{
  //console.log(konto)
  const jwt = JSON.parse(localStorage.token);;
  return (dispatch) => {
    dispatch({type: FETCH_START_SAVE_CLTYPE_CHILD});
    axios.put('kontos/Child/updateSO', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        newBarn:newBarn
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }
  }).then(({data}) => {
    console.log("onChangeSPTypeThisNewChild: ", data);
     if (data.results) {
      // dispatch({type: FETCH_ALL_CONTACT});
       dispatch({type: ON_SAVE_CLTYPE_CHILD, payload: data.results});
     } else {
       dispatch({type: ON_ERROR_SAVE_CLTYPE_CHILD, payload: data.message});
     }
   }).catch(function (error) {
     dispatch({type: ON_ERROR_SAVE_CLTYPE_CHILD, payload: error.message});
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
   });
  }
}
export const onChangeCATypeThisNewChild = (Afid,userid,newBarn) =>{
  //console.log(konto)
  const jwt = JSON.parse(localStorage.token);;
  return (dispatch) => {
    dispatch({type: FETCH_START_SAVE_CATYPE_CHILD});
    axios.put('kontos/Child/updateCA', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        newBarn:newBarn
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }
  }).then(({data}) => {
    console.log("onChangeSPTypeThisNewChild: ", data);
     if (data.results) {
      // dispatch({type: FETCH_ALL_CONTACT});
       dispatch({type: ON_SAVE_CATYPE_CHILD, payload: data.results});
     } else {
       dispatch({type: ON_ERROR_SAVE_CATYPE_CHILD, payload: data.message});
     }
   }).catch(function (error) {
     dispatch({type: ON_ERROR_SAVE_CATYPE_CHILD, payload: error.message});
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
   });
  }
}

//onGetMinaChild
export const onGetMinaChild = (Afid) =>{
    const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      dispatch({type: ON_START_GET_CHILD});
      axios.get('kontos/Child/get',
      { params:{Afid:Afid}, 
       headers: { 'Authorization': `Bearer ${jwt}`} 
     }      
       ).then(({data}) => {
        console.log("onGetMinaChild: ", data);
         if (data.results) {
          // dispatch({type: FETCH_ALL_CONTACT});
           dispatch({type: ON_GET_CHILD, payload: data.results});
         } else {
           dispatch({type: ON_ERROR_GET_CHILD, payload: data.error});
         }
       }).catch(function (error) {
         dispatch({type: ON_ERROR_GET_CHILD, payload: error.message});
            if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       });
    } 
  }
//getMyChildKontoNotHPrisList
export const getMyChildKontoNotHPrisList = (Afid,ArtId) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_GET_DONT_HA_PL_CHILD});
    axios.get('kontos/Child/DHaPrisLista/get',
    { params:{Afid:Afid,ArtId}, 
     headers: { 'Authorization': `Bearer ${jwt}`} 
   }      
     ).then(({data}) => {
      console.log("getMyChildKontoNotHPrisList: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_DONT_HA_PL_CHILD, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_DONT_HA_PL_CHILD, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_DONT_HA_PL_CHILD, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
  } 
}

//onDeleteThisNewChild
export const onDeleteThisNewChild = (Afid,userid,newBarn) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_AFID_CHILD});
     axios.delete('kontos/Child/delete', {
      method: 'DELETE',
      data: {
        newBarn:newBarn,
        Afid:Afid,
        userid:userid
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("onDeleteThisNewChild: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_AFID_CHILD, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DELETE_AFID_CHILD, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_AFID_CHILD, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
 }

 
 //getChildKontoSetting
 export const getChildKontoSetting = (Afid,userid,Kontoid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_CHILD_KONTO_GET});
     axios.get('kontos/Childkonto/get',
     { params:{Afid:Afid,userid:userid,Kontoid:Kontoid}, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getChildKontoSetting: ", data);
       if (data.results) {
         dispatch({type: ON_CHILD_KONTO_GET, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_CHILD_KONTO_GET, payload: data.message});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_CHILD_KONTO_GET, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
 }
 //getChildKontoUsers
 export const getChildKontoUsers = (Afid,userid,Kontoid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_CHILD_KONTO_USERS_GET});
     axios.get('kontos/Childkonto/users/get',
     { params:{Afid:Afid,userid:userid,Kontoid:Kontoid}, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getChildKontoUsers: ", data);
       if (data.results) {
         dispatch({type: ON_CHILD_KONTO_USERS_GET, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_CHILD_KONTO_USERS_GET, payload: data.message});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_CHILD_KONTO_USERS_GET, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
 }
 //getAllChildKonto
 export const getAllChildKonto = (Afid,userid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_CHILD_KONTO_KONTOR_GET});
     axios.get('kontos/Childkonto/Offices/All',
     { params:{Afid:Afid,userid:userid}, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getChildKontoSetting: ", data);
       if (data.results) {
         dispatch({type: ON_CHILD_KONTO_KONTOR_GET, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_CHILD_KONTO_KONTOR_GET, payload: data.message});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_CHILD_KONTO_KONTOR_GET, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
 }
//getChildKontoOffices
export const getChildKontoOffices = (Afid,userid,Kontoid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_CHILD_KONTO_OFFICES_GET});
     axios.get('kontos/Childkonto/Offices/get',
     { params:{Afid:Afid,userid:userid,Kontoid:Kontoid}, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getChildKontoOffices: ", data);
       if (data.results) {
         dispatch({type: ON_CHILD_KONTO_OFFICES_GET, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_CHILD_KONTO_OFFICES_GET, payload: data.message});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_CHILD_KONTO_OFFICES_GET, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
 }
//
export const getAllTeams = (Afid,userid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_CHILD_KONTO_TEAM_SGET_ALL});
     axios.get('kontos/Childkonto/Teams/All',
     { params:{Afid:Afid,userid:userid}, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getChildKontoTeams: ", data);
       if (data.results) {
         dispatch({type: ON_CHILD_KONTO_TEAMS_GET_ALL, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_CHILD_KONTO_TEAMS_GET_ALL, payload: data.message});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_CHILD_KONTO_TEAMS_GET_ALL, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
}
//getChildKontoTeams
export const getChildKontoTeams = (Afid,userid,Kontoid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_CHILD_KONTO_TEAMS_GET});
     axios.get('kontos/Childkonto/Teams/get',
     { params:{Afid:Afid,userid:userid,Kontoid:Kontoid}, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getChildKontoTeams: ", data);
       if (data.results) {
         dispatch({type: ON_CHILD_KONTO_TEAMS_GET, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_CHILD_KONTO_TEAMS_GET, payload: data.message});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_CHILD_KONTO_TEAMS_GET, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
 }
//
//  ON_START_CHILD_KONTO_USERS_ALL_GET, ON_CHILD_KONTO_USERS_ALL_GET, ON_ERROR_CHILD_KONTO_ALL_USERS_GET,
 //getAllChildKontoUsers
 export const getAllChildKontoUsers = (Afid,userid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_CHILD_KONTO_USERS_ALL_GET});
     axios.get('kontos/Childkonto/users/getAll',
     { params:{Afid:Afid,userid:userid}, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getAllChildKontoUsers: ", data);
       if (data.results) {
         dispatch({type: ON_CHILD_KONTO_USERS_ALL_GET, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_CHILD_KONTO_ALL_USERS_GET, payload: data.message});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_CHILD_KONTO_ALL_USERS_GET, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
 }
 //getChildKontoTyper
 export const getChildKontoTyper = (Afid,userid,Kontoid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_CHILD_KONTO_AVTALTYPER_GET});
     axios.get('kontos/Childkonto/AvtalType/get',
     { params:{Afid:Afid,userid:userid,Kontoid:Kontoid}, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getChildKontoTyper: ", data);
       if (data.results) {
         dispatch({type: ON_CHILD_KONTO_AVTALTYPER_GET, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_CHILD_KONTO_AVTALTYPER_GET, payload: data.message});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_CHILD_KONTO_AVTALTYPER_GET, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
 }
 //deleteThisHandelseLog
 export const deleteThisHandelseLog = (Afid,userid,timeLine,handelseId,Orgnr) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_HANDELSE_LOGG});
     axios.delete('kontos/Handlelse/Log/delete', {
      method: 'DELETE',
      data: {
        Afid:Afid,
        handelseId:handelseId,
        userid:userid,
        timeLine:timeLine
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("deleteThisHandelseLog: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_HANDELSE_LOGG, payload: data.results});
         dispatch(getKundhandelserByOrgnr(Orgnr,Afid,userid) )
       } else {
         dispatch({type: ON_ERROR_DELETE_HANDELSE_LOGG, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_HANDELSE_LOGG, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 } 
//EditThisHandelseLog
export const EditThisHandelseLog = (Afid,userid,timeLine,handelseId,text,Orgnr,KanTabort) =>{
  //console.log(konto)
  const jwt = JSON.parse(localStorage.token);;
  return (dispatch) => {
    dispatch({type: ON_START_EDIT_HANDELSE_LOGG});
    axios.put('kontos/Handlelse/Log/update', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        timeLine:timeLine,
        handelseId:handelseId,
        text:text,
        KanTabort:KanTabort,
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }
  }).then(({data}) => {
    console.log("EditThisHandelseLog: ", data);
     if (data.results) {
      // dispatch({type: FETCH_ALL_CONTACT});
       dispatch({type: ON_EDIT_HANDELSE_LOGG, payload: data.results});
       dispatch(getKundhandelserByOrgnr(Orgnr,Afid,userid) )
       
     } else {
       dispatch({type: ON_ERROR_START_EDIT_HANDELSE_LOGG, payload: data.message});
     }
   }).catch(function (error) {
     dispatch({type: ON_ERROR_START_EDIT_HANDELSE_LOGG, payload: error.message});
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
   });
  }
}
//UpdateFortnoxSettings
export const UpdateFortnoxSettings = ( userid, Afid,Settings,Meta) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_AF_LFORTNOX});
     axios.put('kontos/Fortnox/settings/Update', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        Meta:Meta,
        Settings:Settings
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("UpdateFortnoxSettings: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_AF_LFORTNOX, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_AF_LFORTNOX, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_AF_LFORTNOX, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //getPrintMallFortnox
  export const getPrintMallFortnox = (Afid,userid) =>{
    const jwt =  JSON.parse(localStorage.token);
     return (dispatch) => {
       dispatch({type: ON_START_FORTNOX_TEMPLATE_GET});
       axios.get('kontos/Fortnox/Template/get',
       { params:{Afid:Afid,userid:userid}, 
        headers: { 'Authorization': `Bearer ${jwt}`} }      
        ).then(({data}) => {
        console.log("getPrintMallFortnox: ", data);
         if (data.results) {
           dispatch({type: ON_FORTNOX_TEMPLATE_GET, payload: data.results});
         } else {
           dispatch({type: ON_ERROR_FORTNOX_TEMPLATE_GET, payload: data.message});
         }
       }).catch(function (error) {
         dispatch({type: ON_ERROR_FORTNOX_TEMPLATE_GET, payload: error.message});
            if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       });
     }
   }
  export const getTermsOfPaymentsFortnox = (Afid,userid) =>{
    const jwt =  JSON.parse(localStorage.token);
     return (dispatch) => {
       dispatch({type: ON_START_FORTNOX_TERMOFPAYMENTS_GET});
       axios.get('kontos/Fortnox/TermsOfPayment/get',
       { params:{Afid:Afid,userid:userid}, 
        headers: { 'Authorization': `Bearer ${jwt}`} }      
        ).then(({data}) => {
        console.log("getPrintMallFortnox: ", data);
         if (data.results) {
           dispatch({type: ON_FORTNOX_TERMOFPAYMENTS_GET, payload: data.results});
         } else {
           dispatch({type: ON_ERROR_FORTNOX_TERMOFPAYMENTS_GET, payload: data.message});
         }
       }).catch(function (error) {
         dispatch({type: ON_ERROR_FORTNOX_TERMOFPAYMENTS_GET, payload: error.message});
            if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       });
     }
   }
   
  export const getFortnoxAttachmentsByAFid = (Afid,userid,filePath) =>{
    const jwt =  JSON.parse(localStorage.token);
     return (dispatch) => {
       dispatch({type: ON_START_FORTNOX_ATTACHMENTS_GET});
       axios.get('kontos/Fortnox/Attachments/get',
       { params:{Afid:Afid,userid:userid,FolderPath:filePath}, 
        headers: { 'Authorization': `Bearer ${jwt}`} }      
        ).then(({data}) => {
        console.log("getPrintMallFortnox: ", data);
         if (data.results) {
           dispatch({type: ON_FORTNOX_ATTACHMENTS_GET, payload: data.results});
         } else {
           dispatch({type: ON_ERROR_FORTNOX_ATTACHMENTS_GET, payload: data.message});
         }
       }).catch(function (error) {
         dispatch({type: ON_ERROR_FORTNOX_ATTACHMENTS_GET, payload: error.message});
            if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       });
     }
   }
   
//checkFortNoxToken
export const checkFortNoxToken = (Afid,userid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_CHECK_FORTNOX});
    axios.put('kontos/Fortnox/check', {
     method: 'PUT',
     body: {
       userid:userid,
       Afid:Afid
     },
    //  headers: {
    //      'content-type': 'application/json',
    //      'Authorization':   `Bearer ${jwt}`
    //  }       
 }, {
  headers: {
    'content-type': 'application/json',
    'Authorization':   `Bearer ${jwt}`
  } 
 }).then(({data}) => {
     console.log("checkFortNoxToken: ", data);
      if (data.results) {
       // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({type: ON_GET_CHECK_FORTNOX, payload: data.results});
      } else {
        dispatch({type: ON_ERROR_GET_CHECK_FORTNOX, payload: data.message});
      }
    }).catch(function (error) {
      dispatch({type: ON_ERROR_GET_CHECK_FORTNOX, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
      if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      } 
    });
  }
}


// //ON_START_ADD_NEW_TAG_EVENT,
// ON_ADD_NEW_TAG_EVENT,
// ON_ERROR_ADD_NEW_TAG_EVENT,
// ON_START_ADD_NEW_TAG, ON_ADD_NEW_TAG, ON_ERROR_ADD_NEW_TAG
export const addNewAccountTag = (Afid, Userid, Keyword, Source, Sourceid, TagType = 0) => {
  const jwt =  JSON.parse(localStorage.token);

  const returnActionTypeBySourceStart = (s) => {
    switch (s) {
      case 1: return '' 
      case 2: return ON_START_ADD_NEW_TAG_EVENT
      case 3: return '' 
      case 4: return '' 
      case 5: return '' 
      case 6: return '' 
      case 7: return '' 
      case 8: return '' 
      case 18: return '' 
      case 9: return '' 
      case 10: return '' 
    }
  }
  const returnActionTypeBySource = (s) => {
    switch (s) {
      case 1: return '' 
      case 2: return ON_ADD_NEW_TAG_EVENT
      case 3: return '' 
      case 4: return '' 
      case 5: return '' 
      case 6: return '' 
      case 7: return '' 
      case 8: return '' 
      case 18: return '' 
      case 9: return '' 
      case 10: return '' 
    }
  }
  const returnActionTypeBySourceErr = (s) => {
    switch (s) {
      case 1: return '' 
      case 2: return ON_ERROR_ADD_NEW_TAG_EVENT
      case 3: return '' 
      case 4: return '' 
      case 5: return '' 
      case 6: return '' 
      case 7: return '' 
      case 8: return '' 
      case 18: return '' 
      case 9: return '' 
      case 10: return '' 
    }
  }

  return (dispatch) => {
    dispatch({type: ON_START_ADD_NEW_TAG})
    if(Source !== 0 || Sourceid !== 0) dispatch({type: returnActionTypeBySourceStart(Source)})
    axios.post('kontos/accountTags', {
      method: 'POST',
      body: {
        Afid, Keyword, Source, Sourceid, Userid, TagType
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
    }).then(({data}) => {
      console.log("accountTags: ", data);
      if (data.results) {
        dispatch({type: ON_ADD_NEW_TAG, payload: data.results})
        if(Source !== 0 || Sourceid !== 0)  dispatch({type: returnActionTypeBySource(Source), payload: data.results.SourceTaggar})
      } else {
        dispatch({type: ON_ERROR_ADD_NEW_TAG})
        if(Source !== 0 || Sourceid !== 0)  dispatch({type: returnActionTypeBySourceErr(Source)})
      }
     }).catch(function (error) {
        dispatch({type: ON_ERROR_ADD_NEW_TAG})
        if(Source !== 0 || Sourceid !== 0)  dispatch({type: returnActionTypeBySourceErr(Source)})
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
export const removeTagFromSource = (Afid, Userid, Keyword, Source, Sourceid) => {
  const jwt =  JSON.parse(localStorage.token);

  const returnActionTypeBySourceStart = (s) => {
    switch (s) {
      case 1: return '' 
      case 2: return ''
      case 3: return '' 
      case 4: return '' 
      case 5: return '' 
      case 6: return '' 
      case 7: return '' 
      case 8: return '' 
      case 18: return '' 
    }
  }
  const returnActionTypeBySource = (s) => {
    switch (s) {
      case 1: return '' 
      case 2: return ''
      case 3: return '' 
      case 4: return '' 
      case 5: return '' 
      case 6: return '' 
      case 7: return '' 
      case 8: return '' 
      case 18: return '' 
    }
  }
  const returnActionTypeBySourceErr = (s) => {
    switch (s) {
      case 1: return '' 
      case 2: return ''
      case 3: return '' 
      case 4: return '' 
      case 5: return '' 
      case 6: return '' 
      case 7: return '' 
      case 8: return '' 
      case 18: return '' 
    }
  }

  return (dispatch) => {
    dispatch({type: ON_START_REMOVE_TAG_FROM_SOURCE})
    axios.delete('kontos/accountTags', {
     method: 'DELETE',
     params: {
      Afid, Userid, Keyword, Source, Sourceid
     },
     headers: {
         'content-type': 'application/json',
         'Authorization':   `Bearer ${jwt}`
     }       
    }).then(({data}) => {
     console.log("removeTagFromSource: ", data);
      if (data.results) {
        dispatch({type: ON_REMOVE_TAG_FROM_SOURCE})
      } else {
        dispatch({type: ON_ERROR_REMOVE_TAG_FROM_SOURCE})
      }
    }).catch(function (error) {
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       dispatch({type: ON_ERROR_REMOVE_TAG_FROM_SOURCE})
      if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      } 
    });
  }
}
export const removeTagFromAccount = (Afid, Userid, Tagid,TagKeyword) => {
  const jwt =  JSON.parse(localStorage.token);

  return (dispatch) => {
    dispatch({type: ON_START_REMOVE_TAG_FROM_ACCOUNT})
    axios.delete('kontos/af/accountTags', {
     method: 'DELETE',
     params: {
      Afid, Userid, Tagid,TagKeyword
     },
     headers: {
         'content-type': 'application/json',
         'Authorization':   `Bearer ${jwt}`
     }       
    }).then(({data}) => {
     console.log("removeTagFromAccount: ", data);
      if (data.results) {
        dispatch({type: ON_REMOVE_TAG_FROM_ACCOUNT, payload: data.results})
      } else {
        dispatch({type: ON_ERROR_REMOVE_TAG_FROM_ACCOUNT})
      }
    }).catch(function (error) {
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       dispatch({type: ON_ERROR_REMOVE_TAG_FROM_ACCOUNT})
      if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      } 
    });
  }
}
export const updateTagFromAccount = (Afid, Userid, Tag) => {
  const jwt =  JSON.parse(localStorage.token);

  return (dispatch) => {
    dispatch({type: ON_START_UPDATE_TAG_FROM_ACCOUNT})
    axios.put('kontos/af/accountTags', {
      method: 'PUT',
      body: {
        Afid, Tag, Userid
      }
    }, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
    }).then(({data}) => {
      console.log("updateTagFromAccount: ", data);
      if (data.results) {
        dispatch({type: ON_UPDATE_TAG_FROM_ACCOUNT, payload: data.results})
      } else {
        dispatch({type: ON_ERROR_UPDATE_TAG_FROM_ACCOUNT})
      }
     }).catch(function (error) {
        dispatch({type: ON_ERROR_UPDATE_TAG_FROM_ACCOUNT})
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//getDefaultTermsofPayment
export const getDefaultTermsofPayment = (Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_FORTNOX_TERMOFPAY_GET});
     axios.get('kontos/Fortnox/termofPay/get',
     { params:{Afid:Afid}, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getPrintMallFortnox: ", data);
       if (data.results) {
         dispatch({type: ON_FORTNOX_TERMOFPAY_GET, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_FORTNOX_TERMOFPAY_GET, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FORTNOX_TERMOFPAY_GET, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
 }
//getHogiaStoreId
export const getHogiaStoreId = (Afid,userid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress=await getClientIp()
    dispatch({type: ON_START_GET_HOGIA_OFFICES});
    axios.get('kontos/Hogia/Office/get',
    { params:{Afid:Afid,userid:userid,ipAdress}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
     console.log("getHogiaStoreId: ", data);
      if (data.results) {
        dispatch({type: ON_GET_HOGIA_OFFICES, payload: data.results});
      } else {
        dispatch({type: ON_ERROR_GET_HOGIA_OFFICES, payload: data.message});
      }
      dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
      dispatch({type: ON_ERROR_GET_HOGIA_OFFICES, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
    });
  }
}
//connectThisCustomerToHogia
export const connectThisCustomerToHogia = (Afid,userid,Orgnr) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress=await getClientIp() 
     dispatch({type: ON_START_EDIT_KUND_INFO});
     axios.put('kontos/Kund/Hogia/connect', {
      method: 'PUT',
      body: {
        Afid:Afid,
        userid:userid,
        Orgnr:Orgnr,
        ipAdress
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("connectThisCustomerToHogia: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_EDIT_KUND_INFO, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_EDIT_KUND_INFO, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_EDIT_KUND_INFO, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//getThisFileUrl
export const getThisFileUrl = (userid,Afid,Url,fileName) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_DOWN_FILE});
    axios.get('kontos/File/Attach/get',
    { params:{
      Afid:Afid,
      userid:userid,
      Url:Url,
      ipAdress
    },
    responseType: 'arraybuffer' , 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then((resp) => {
     var blob = new Blob([resp.data]);
     //console.log(blob)
     fileSaver.saveAs(blob, fileName);
     dispatch({type: ON_GET_DOWN_FILE})
     dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_DOWN_FILE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}  
//getThisFileUrl
export const getThisFileUrl_NO_AUTH = (Afid,userid,Url,fileName) =>{
  // const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_DOWN_FILE});
    axios.get('kontos/File/Attach/get_NO_AUTH',
    { params:{
      Afid:Afid,
      userid:userid,
      Url:Url,
      ipAdress
    },
    responseType: 'arraybuffer' ,  }      
     ).then((resp) => {
     var blob = new Blob([resp.data]);
     //console.log(blob)
     fileSaver.saveAs(blob, fileName);
     dispatch({type: ON_GET_DOWN_FILE})
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_DOWN_FILE, payload: error.message});
          
     }); /**/
  }
}  

//connectToCreditSafe
export const connectToCreditSafe = ( userid, Afid,Username,Password,Block) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_BESTALLA_CREDITSAFE});
     axios.put('kontos/creditSafe/Bestalla', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        Username:Username,
        Block:Block,
        Password:Password
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("connectToCreditSafe: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_BESTALLA_CREDITSAFE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_BESTALLA_CREDITSAFE, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_BESTALLA_CREDITSAFE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//onSparaCreditSafe
export const onSparaCreditSafe = ( userid, Afid,Username,Password,Block) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_BESTALLA_CREDITSAFE});
     axios.put('kontos/creditSafe/save', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        Username:Username,
        Block:Block,
        Password:Password
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("onSparaCreditSafe: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_BESTALLA_CREDITSAFE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_BESTALLA_CREDITSAFE, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_BESTALLA_CREDITSAFE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//getCreditSafe
export const getCreditSafe = (Afid,userid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress=await getClientIp()
    dispatch({type: ON_START_GET_CREDITSAFE});
    axios.get('kontos/creditSafe/get',
    { params:{Afid:Afid,userid:userid,ipAdress}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
     console.log("getCreditSafe: ", data);
      if (data.results) {
        dispatch({type: ON_GET_CREDITSAFE, payload: data.results});
      } else {
        dispatch({type: ON_ERROR_GET_CREDITSAFE, payload: data.message});
      }
      dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
      dispatch({type: ON_ERROR_GET_CREDITSAFE, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
    });
  }
}
//SendCreditSafeReq
export const SendCreditSafeReq = (Afid,userid,Block,Orgnr) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_SEND_CREDITSAFE});
     axios.get('kontos/creditSafe/send', {
      params: {
        userid:userid,
        Afid:Afid,
        Block:Block,
        Orgnr:Orgnr
      },
      responseType: 'arraybuffer' ,
      headers: { 'Authorization': `Bearer ${jwt}`} } )
      .then((resp) => {
        console.log(resp)
        var blob = new Blob([resp.data],
          { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
        );
        fileSaver.saveAs(blob, Orgnr+".xlsx");
       // console.log(resp)
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SEND_CREDITSAFE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//allowThisUserToCreditSafe
export const allowThisUserToCreditSafe = (Afid,userid,AllowedId) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_CREDITSAFE_ALLOW_USER});
     axios.put('kontos/creditSafe/user/Allow', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        AllowedId:AllowedId
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("allowThisUserToCreditSafe: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_CREDITSAFE_ALLOW_USER, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_CREDITSAFE_ALLOW_USER, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_CREDITSAFE_ALLOW_USER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//getAllowedUserList
export const getAllowedUserList = (Afid,userid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress=await getClientIp()
    dispatch({type: ON_START_GET_ALL_CREDITSAFE_ALLOW_USER});
    axios.get('kontos/creditSafe/user/get',
    { params:{Afid:Afid,userid:userid,ipAdress}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
     console.log("getAllowedUserList: ", data);
      if (data.results) {
        dispatch({type: ON_GET_ALL_CREDITSAFE_ALLOW_USER, payload: data.results});
      } else {
        dispatch({type: ON_ERROR_GET_ALL_CREDITSAFE_ALLOW_USER, payload: data.message});
      }
    }).catch(function (error) {
      dispatch({type: ON_ERROR_GET_ALL_CREDITSAFE_ALLOW_USER, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
    });
  }
}
//onInaktiveUserToCreditSafe
export const onInaktiveUserToCreditSafe = (Afid,userid,AllowedId,Aktive) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_CREDITSAFE_AKTIVE_ALLOW_USER});
     axios.put('kontos/creditSafe/user/Aktive', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        AllowedId:AllowedId,
        Aktive:Aktive
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("onInaktiveUserToCreditSafe: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_CREDITSAFE_AKTIVE_ALLOW_USER, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_CREDITSAFE_AKTIVE_ALLOW_USER, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_CREDITSAFE_AKTIVE_ALLOW_USER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //SendCreditSafeReqCredit
 export const SendCreditSafeReqCredit = (Afid,userid,Block,Orgnr,isConfirm) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress=await getClientIp()
    dispatch({type: ON_START_GET_ALL_CREDITSAFE_CREDIT_RES});
    axios.get('kontos/creditSafe/credit/send',
    { params:{Afid:Afid,userid:userid,ipAdress,Block:Block,Orgnr:Orgnr,isConfirm:isConfirm}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
     console.log("getAllowedUserList: ", data);
      if (data.results) {
        dispatch({type: ON_GET_ALL_CREDITSAFE_CREDIT_RES, payload: data.results});
      } else {
        dispatch({type: ON_ERROR_GET_ALL_CREDITSAFE_CREDIT_RES, payload: data.message});
      }
    }).catch(function (error) {
      dispatch({type: ON_ERROR_GET_ALL_CREDITSAFE_CREDIT_RES, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
    });
  }
}
//onGetCreditSafeRapport
//,ResultId
export const onGetCreditSafeRapport = (Afid,userid,Orgnr,Period) =>{

  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_SEND_CREDITSAFE_CR});
     axios.get('kontos/creditSafe/credit/rapport', {
      params: {
        userid:userid,
        Afid:Afid,
        Period:Period,
      //  ResultId:ResultId,
        Orgnr:Orgnr
      },
      responseType: 'arraybuffer' ,
      headers: { 'Authorization': `Bearer ${jwt}`} } )
      .then((resp) => {
        console.log(resp)
        var blob = new Blob([resp.data],
          { type: 'text/html' }
        );
        fileSaver.saveAs(blob, Orgnr+".html");
       // console.log(resp)
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SEND_CREDITSAFE_CR, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//getThisCreditSateOld
export const getThisCreditSateOld = (userid,Afid,Orgnr,raId) =>{

  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_SEND_CREDITSAFE_CR});
     axios.get('kontos/creditSafe/credit/Oldrapport', {
      params: {
        userid:userid,
        Afid:Afid,
        raId:raId,
      //  ResultId:ResultId,
        Orgnr:Orgnr
      },
      responseType: 'arraybuffer' ,
      headers: { 'Authorization': `Bearer ${jwt}`} } )
      .then((resp) => {
        console.log(resp)
        var blob = new Blob([resp.data],
          { type: 'text/html' }
        );
        fileSaver.saveAs(blob, Orgnr+".html");
       // console.log(resp)
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SEND_CREDITSAFE_CR, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }

//resetCreditSafeResult
export const resetCreditSafeResult = () =>{
  return (dispatch) => {
    dispatch({type: ON_RESET_CREDITSAFE});
  }
}
//getLastCreditRequest
export const getLastCreditRequest = (Afid,userid,Orgnr) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_GET_LAST_CREDIT});
    axios.get('kontos/creditSafe/credit/get',
    { params:{Afid:Afid,userid:userid,Orgnr:Orgnr}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
     console.log("getAllowedUserList: ", data);
      if (data.results) {
        dispatch({type: ON_GET_LAST_CREDIT, payload: data.results});
      } else {
        dispatch({type: ON_ERROR_GET_LAST_CREDIT, payload: data.message});
      }
      dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
      dispatch({type: ON_ERROR_GET_LAST_CREDIT, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
    });
  }
 }
//getRapportCreditRequest
export const getRapportCreditRequest = (Afid,userid,Orgnr) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_GET_RPS_CREDIT});
    axios.get('kontos/creditSafe/credit/getRapport',
    { params:{Afid:Afid,userid:userid,Orgnr:Orgnr}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
     console.log("getAllowedUserList: ", data);
      if (data.results) {
        dispatch({type: ON_GET_RPS_CREDIT, payload: data.results});
      } else {
        dispatch({type: ON_ERROR_GET_RPS_CREDIT, payload: data.message});
      }
    }).catch(function (error) {
      dispatch({type: ON_ERROR_GET_RPS_CREDIT, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
    });
  }
 }

export const getOrderAntal = (userid, Afid, orgnr) => {
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_STATISTIC_TOTALORDER});
    axios.get('kontos/Konto/statistic/order/get',
    { params:{
      Afid:Afid,
      userid:userid,
      orgnr: orgnr,
    },
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     )
     .then(({data}) => {
      console.log(data)
      if (data.results) {
       // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({type: GET_STATISTIC_TOTALORDER, payload: data.results});
      } else {
        dispatch({type: ERROR_STATISTIC_TOTALORDER, payload: data.error});
      }
      
    }).catch(function (error) {
      dispatch({type: ERROR_STATISTIC_TOTALORDER, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     if(error.message === "Network Error"){
        //reload and remove token 
        //dispatch(userSignOut())
     } 
    });
  }
}
export const getBokadeMotenAntal = (userid, Afid, orgnr) => {
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_STATISTIC_TOTALMOTEN});
    axios.get('kontos/Konto/statistic/mote/get',
    { params:{
      Afid:Afid,
      userid:userid,
      orgnr: orgnr,
    },
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     )
     .then(({data}) => {
      console.log(data)
      if (data.results) {
       // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({type: GET_STATISTIC_TOTALMOTE, payload: data.results});
      } else {
        dispatch({type: ERROR_STATISTIC_TOTALMOTE, payload: data.error});
      }
    }).catch(function (error) {
      dispatch({type: ERROR_STATISTIC_TOTALMOTE, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     if(error.message === "Network Error"){
        //reload and remove token 
        //dispatch(userSignOut())
     } 
    });
  }
}
export const getAktiviteterAntal = (userid, Afid, orgnr) => {
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_STATISTIC_TOTALAKTIVITETER});
    axios.get('kontos/Konto/statistic/aktiviteter/get',
    { params:{
      Afid:Afid,
      userid:userid,
      orgnr: orgnr,
    },
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     )
     .then(({data}) => {
      console.log(data)
      if (data.results) {
       // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({type: GET_STATISTIC_TOTALAKTIVITETER, payload: data.results});
      } else {
        dispatch({type: ERROR_STATISTIC_TOTALAKTIVITETER, payload: data.error});
      }
    }).catch(function (error) {
      dispatch({type: ERROR_STATISTIC_TOTALAKTIVITETER, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     if(error.message === "Network Error"){
        //reload and remove token 
        //dispatch(userSignOut())
     } 
    });
  }
}
export const getOffertAntal = (userid, Afid, orgnr) => {
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_STATISTIC_TOTALOFFERT});
    axios.get('kontos/Konto/statistic/offert/get',
    { params:{
      Afid:Afid,
      userid:userid,
      orgnr: orgnr,
    },
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     )
     .then(({data}) => {
      console.log(data)
      if (data.results) {
       // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({type: GET_STATISTIC_TOTALOFFERT, payload: data.results});
      } else {
        dispatch({type: ERROR_STATISTIC_TOTALOFFERT, payload: data.error});
      }
    }).catch(function (error) {
      dispatch({type: ERROR_STATISTIC_TOTALOFFERT, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     if(error.message === "Network Error"){
        //reload and remove token 
        //dispatch(userSignOut())
     } 
    });
  }
}
export const getLopandeIntaktTotal = (userid, Afid, orgnr) => {
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_STATISTIC_LOPANDEINTAKT_TOTAL});
    axios.get('kontos/Konto/statistic/lopandeintakt/get',
    { params:{
      Afid:Afid,
      userid:userid,
      orgnr: orgnr,
    },
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     )
     .then(({data}) => {
      console.log(data)
      if (data.results) {
       // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({type: GET_STATISTIC_LOPANDEINTAKT_TOTAL, payload: data.results});
      } else {
        dispatch({type: ERROR_STATISTIC_LOPANDEINTAKT_TOTAL, payload: data.error});
      }
    }).catch(function (error) {
      dispatch({type: ERROR_STATISTIC_LOPANDEINTAKT_TOTAL, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     if(error.message === "Network Error"){
        //reload and remove token 
        //dispatch(userSignOut())
     } 
    });
  }
}
export const getOrderTypTotal = (userid, Afid, orgnr) => {
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_STATISTIC_ORDERTYP_TOTAL});
    axios.get('kontos/Konto/statistic/ordertyp/get',
    { params:{
      Afid:Afid,
      userid:userid,
      orgnr: orgnr,
    },
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     )
     .then(({data}) => {
      console.log(data)
      if (data.results) {
       // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({type: GET_STATISTIC_ORDERTYP_TOTAL, payload: data.results});
      } else {
        dispatch({type: ERROR_STATISTIC_ORDERTYP_TOTAL, payload: data.error});
      }
    }).catch(function (error) {
      dispatch({type: ERROR_STATISTIC_ORDERTYP_TOTAL, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     if(error.message === "Network Error"){
        //reload and remove token 
        //dispatch(userSignOut())
     } 
    });
  }
}
export const getSalesTotal = (userid, Afid, orgnr) => {
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_STATISTIC_SALES_TOTAL});
    axios.get('kontos/Konto/statistic/sales/get',
    { params:{
      Afid:Afid,
      userid:userid,
      orgnr: orgnr,
    },
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     )
     .then(({data}) => {
      console.log(data)
      if (data.results) {
       // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({type: GET_STATISTIC_SALES_TOTAL, payload: data.results});
      } else {
        dispatch({type: ERROR_STATISTIC_SALES_TOTAL, payload: data.error});
      }
    }).catch(function (error) {
      dispatch({type: ERROR_STATISTIC_SALES_TOTAL, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     if(error.message === "Network Error"){
        //reload and remove token 
        //dispatch(userSignOut())
     } 
    });
  }
}
 export const generateRestAPIToken = (Afid, Userid, AUserid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_CREATE_API_TOKEN});
     axios.post('kontos/generateToken', {
      method: 'POST',
      body: {
        Userid:Userid,
        AUserid:AUserid,
        Afid:Afid,
      }},{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("generateRestAPIToken: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_CREATE_API_TOKEN, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_CREATE_API_TOKEN, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_CREATE_API_TOKEN, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 export const revokeRestAPIToken = (Afid, Userid, TokenId) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_REVOKE_API_TOKEN});
     axios.put('kontos/revokeToken', {
      method: 'PUT',
      body: {
        Userid:Userid,
        Afid:Afid,
        TokenId:TokenId
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("revokeRestAPIToken: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_REVOKE_API_TOKEN, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_REVOKE_API_TOKEN, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_REVOKE_API_TOKEN, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 
 export const setAFNotisSeen = (Userid, Afid, NotisId, isDevice = 0) => {
  // const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_SET_AF_NOTIS_SEEN})
    axios.post('kontos/Af/notis',
    { body:{Userid, Afid, NotisId,isDevice}, 
    headers: { 
      // 'Authorization': `Bearer ${jwt}`
    }
   }      
     ).then(({data}) => {
      console.log("setDashboardNotisSeen: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_SET_AF_NOTIS_SEEN, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_SET_AF_NOTIS_SEEN, payload: data.error});
       }
       dispatch(RefreshUserInterface(Userid))
     })
     .catch(function (error) {
       dispatch({type: ON_ERROR_SET_AF_NOTIS_SEEN, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       }
       
     });
  }
}
 export const addAFNotis = (Userid, Afid, Text) => {
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_ADD_AF_NOTIS})
    axios.post('kontos/Af/notis/add',
    { body:{Userid, Afid, Text}, 
  },{
    headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("addAFNotis: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_ADD_AF_NOTIS, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_ADD_AF_NOTIS, payload: data.error});
       }
     })
     .catch(function (error) {
       dispatch({type: ON_ERROR_ADD_AF_NOTIS, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       }
       
     });
  }
}

export const getAFNotis = (Userid, Afid, isDevice = 0, isMessage=0, iskontor = 0) =>{
  //const jwt =  JSON.parse(localStorage.token);
  // const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_AF_NOTIS});
     axios.get('kontos/Af/notis',
     { params:{Userid, Afid, isDevice, isMessage,iskontor}, 
      headers: { 
        // 'Authorization': `Bearer ${jwt}`
      } }      
      ).then(({data}) => {
       console.log("getDashboardNotis: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_GET_AF_NOTIS, payload: data.results});
        } else {
          dispatch({type: ON_ERROR_GET_AF_NOTIS, payload: data.error});
        }
      })
      .catch(function (error) {
        dispatch({type: ON_ERROR_GET_AF_NOTIS, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
        if(error.message === "Request failed with status code 401"){
         // dispatch(userSignOut())  
          }
        if(error.message === "Network Error"){
           //reload and remove token 
           //dispatch(userSignOut())
        }
        
      });
   }
 }
//getAfidWayOfDelivery
export const getAfidWayOfDelivery = (Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_FORTNOX_WAYOFDELIVERY_GET});
     axios.get('kontos/Fortnox/wayOfdelivery/get',
     { params:{Afid:Afid}, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getAfidWayOfDelivery: ", data);
       if (data.results) {
         dispatch({type: ON_FORTNOX_WAYOFDELIVERY_GET, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_FORTNOX_WAYOFDELIVERY_GET, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FORTNOX_WAYOFDELIVERY_GET, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
}
//getAfidPrislistor
export const getAfidPrislistor = (Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_FORTNOX_PRISLISTOR_GET});
     axios.get('kontos/Fortnox/prislistor/get',
     { params:{Afid:Afid}, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getAfidPrislistor: ", data);
       if (data.results) {
         dispatch({type: ON_FORTNOX_PRISLISTOR_GET, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_FORTNOX_PRISLISTOR_GET, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FORTNOX_PRISLISTOR_GET, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
}
export const getAfidtermOfdeliverises = (Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_FORTNOX_TERMSOFDELIVERY_GET});
     axios.get('kontos/Fortnox/termOfdeliverises/get',
     { params:{Afid:Afid}, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getAfidtermOfdeliverises: ", data);
       if (data.results) {
         dispatch({type: ON_FORTNOX_TERMSOFDELIVERY_GET, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_FORTNOX_TERMSOFDELIVERY_GET, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FORTNOX_TERMSOFDELIVERY_GET, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
 }
 //onGetAfidOrderAffarfrom
 export const onGetAfidOrderAffarfrom = (Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_ORDER_AFFAR_FROM_AF});
     axios.get('kontos/Order/Affarf/get',
     { params:{Afid:Afid}, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("onGetAfidOrderAffarfrom: ", data);
       if (data.results) {
         dispatch({type: ON_GET_ORDER_AFFAR_FROM_AF, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_ORDER_AFFAR_FROM_AF, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_ORDER_AFFAR_FROM_AF, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
 }
//onDeleteAfidOrderAffarfrom
export const onDeleteAfidOrderAffarfrom = ( Afid,userid,newStatus,callBackFunc) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_UPDATE_ORDER_AFFAR_FROM_AF});
     axios.delete('kontos/Order/Affarf/delete', {
      method: 'DELETE',
      params: {
        userid:userid,
        Afid:Afid,
        newStatus:newStatus
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("SaveNewEventStatus: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_UPDATE_ORDER_AFFAR_FROM_AF, payload: data.results});
         if(!isUndefined(callBackFunc)){
          callBackFunc()
         }
       } else {
         dispatch({type: ON_ERROR_ORDER_AFFAR_FROM_AF, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_ORDER_AFFAR_FROM_AF, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }

 //onUpdateAfidOrderAffarfrom
 export const onUpdateAfidOrderAffarfrom = ( Afid,userid,newStatus,callBackFunc) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_UPDATE_ORDER_AFFAR_FROM_AF});
     axios.put('kontos/Order/Affarf/update', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        newStatus:newStatus
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("SaveNewEventStatus: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_UPDATE_ORDER_AFFAR_FROM_AF, payload: data.results});
         if(!isUndefined(callBackFunc)){
          callBackFunc()
         }
       } else {
         dispatch({type: ON_ERROR_ORDER_AFFAR_FROM_AF, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_ORDER_AFFAR_FROM_AF, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //onsaveAfidOrderAffarfrom
 export const onsaveAfidOrderAffarfrom = ( Afid,userid,newStatus,callBackFunc) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_NEW_ORDER_AFFAR_FROM_AF});
     axios.put('kontos/Order/Affarf/new', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        newStatus:newStatus
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("SaveNewEventStatus: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_NEW_ORDER_AFFAR_FROM_AF, payload: data.results});
         if(!isUndefined(callBackFunc)){
          callBackFunc()
         }
       } else {
         dispatch({type: ON_ERROR_ORDER_AFFAR_FROM_AF, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_ORDER_AFFAR_FROM_AF, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //getAfidOrderSittings
 export const getAfidOrderSittings = (Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_ORDER_SETTING_AF});
     axios.get('kontos/Order/settings/get',
     { params:{Afid:Afid}, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getAfidOrderSittings: ", data);
       if (data.results) {
         dispatch({type: ON_GET_ORDER_SETTING_AF, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_ORDER_SETTING_AF, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_ORDER_SETTING_AF, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
 }
//updateAfOrderSittings
export const updateAfOrderSittings = (Afid,userid,Meta,Value) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_UPDATE_ORDER_SETTING_AF});
     axios.put('kontos/Order/settings/update', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        Meta:Meta,
        Value:Value
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("updateAfOrderSittings: ", data);
       if (data.results) {
         dispatch({type: ON_UPDATE_ORDER_SETTING_AF, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_UPDATE_ORDER_SETTING_AF, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_ORDER_SETTING_AF, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
 }
 //getFortnoxProjektlist
  export const getFortnoxProjektlist = (Afid,userid) =>{
    const jwt =  JSON.parse(localStorage.token);
     return (dispatch) => {
       dispatch({type: ON_START_FORTNOX_PROJEKT_GET});
       axios.get('kontos/Fortnox/Projekt/get',
       { params:{Afid:Afid,userid:userid}, 
        headers: { 'Authorization': `Bearer ${jwt}`} }      
        ).then(({data}) => {
        console.log("getPrintMallFortnox: ", data);
         if (data.results) {
           dispatch({type: ON_FORTNOX_PROJEKT_GET, payload: data.results});
         } else {
           dispatch({type: ON_ERROR_FORTNOX_PROJEKT_GET, payload: data.message});
         }
         dispatch(RefreshUserInterface(userid))
       }).catch(function (error) {
         dispatch({type: ON_ERROR_FORTNOX_PROJEKT_GET, payload: error.message});
            if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       });
     }
   }
//getKundsKunddata
export const getKundsKunddata = (Afid,userid,Orgnr) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_KUND_KUNDDATA_GET});
     axios.get('kontos/KundData/get',
     { params:{Afid:Afid,userid:userid,Orgnr:Orgnr}, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getKundsKunddata: ", data);
       if (data.results) {
         dispatch({type: ON_KUND_KUNDDATA_GET, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_KUND_KUNDDATA_GET, payload: data.message});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_KUND_KUNDDATA_GET, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
 }

 export const getDistriktByAfid = (Afid,Userid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_DISTRIKT});
     axios.get('kontos/distrikt/get',{ params:{Afid,Userid}, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getDistriktByAfid: ", data);
       if (data.results) {
         dispatch({type: ON_GET_DISTRIKT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_DISTRIKT, payload: data.error});
       }
       dispatch(RefreshUserInterface(Userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_DISTRIKT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
      if(error.message === "Network Error"){
          //reload and remove token 
      } 
     });
   }
 }
 export const getMinaDistriktPostnr = (Afid,Userid,Postnr) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_MINA_DISTRIKT_POSTNR});
     axios.get('kontos/distrikt/getMinaDistriktPostnr',{ params:{Afid,Userid,Postnr}, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getMinaDistriktPostnr: ", data);
       if (data.results) {
         dispatch({type: ON_GET_MINA_DISTRIKT_POSTNR, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_MINA_DISTRIKT_POSTNR, payload: data.error});
       }
       dispatch(RefreshUserInterface(Userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_MINA_DISTRIKT_POSTNR, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
      if(error.message === "Network Error"){
          //reload and remove token 
      } 
     });
   }
 }
 export const getThisDistriktByAfid = (Afid,Userid,DistriktId) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_THIS_DISTRIKT});
     axios.get('kontos/distrikt/getThis',{ params:{Afid,Userid, DistriktId}, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getThisDistriktByAfid: ", data);
       if (data.results) {
         dispatch({type: ON_GET_THIS_DISTRIKT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_THIS_DISTRIKT, payload: data.error});
       }
       dispatch(RefreshUserInterface(Userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_THIS_DISTRIKT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
      if(error.message === "Network Error"){
          //reload and remove token 
      } 
     });
   }
 }

 export const updateThisDisktrikt= ( Afid, Userid, Distrikt, DistriktActions = []) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_UPDATE_DISTRIKT});
     axios.put('kontos/distrikt/update', {
      method: 'PUT',
      body: {
        Afid, Userid, Distrikt, DistriktActions
      }}, {
      headers: {
        'content-type': 'application/json',
        'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("updateThisDisktrikt: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_UPDATE_DISTRIKT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_UPDATE_DISTRIKT, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_DISTRIKT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 export const addNewDistriktByAfid = ( Afid, Userid, NewDistrikt) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_ADD_NEW_DISTRIKT});
     axios.post('kontos/distrikt/add', {
      method: 'POST',
      body: {
        Afid, Userid, NewDistrikt
      },
    },{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("addNewDistriktByAfid: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_ADD_NEW_DISTRIKT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_ADD_NEW_DISTRIKT, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_ADD_NEW_DISTRIKT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }

 export const deleteDistriktByAfid = (Afid,Userid,DistriktId) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_DISTRIKT});
     axios.delete('kontos/distrikt/delete',{ params:{Afid,Userid, DistriktId}, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getDistriktByAfid: ", data);
       if (data.results) {
         dispatch({type: ON_DELETE_DISTRIKT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DELETE_DISTRIKT, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_DISTRIKT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
      if(error.message === "Network Error"){
          //reload and remove token 
      } 
     });
   }
 }
//getNoyfileUsers
export const getNoyfileUsers = () =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_NOTYFILE_USERS});
     axios.get('kontos/Admin/getUser',{ 
      headers: { 'Authorization': `Bearer ${jwt}`
      } }      
     ).then(({data}) => {
      console.log("getNoyfileUsers: ", data);
       if (data.results) {
         dispatch({type: ON_GET_NOTYFILE_USERS, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_NOTYFILE_USERS, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_NOTYFILE_USERS, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
      if(error.message === "Network Error"){
          //reload and remove token 
      } 
     });
   }
 }

  //getAfidLobbySittings
  export const getAfidLobbySittings = (Afid) =>{
    const jwt =  JSON.parse(localStorage.token);
     return (dispatch) => {
       dispatch({type: ON_START_GET_LOBBY_SETTING_AF});
       axios.get('kontos/Lobby/settings/get',
       { params:{Afid:Afid}, 
        headers: { 'Authorization': `Bearer ${jwt}`} }      
        ).then(({data}) => {
        console.log("getAfidLobbySittings: ", data);
         if (data.results) {
           dispatch({type: ON_GET_LOBBY_SETTING_AF, payload: data.results});
         } else {
           dispatch({type: ON_ERROR_GET_LOBBY_SETTING_AF, payload: data.message});
         }
         
       }).catch(function (error) {
         dispatch({type: ON_ERROR_GET_LOBBY_SETTING_AF, payload: error.message});
            if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       });
     }
   }
   //updateAfLobbySittings
export const updateAfLobbySittings = (Afid,userid,Meta,Value) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_UPDATE_LOBBY_SETTING_AF});
     axios.put('kontos/Lobby/settings/update', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        Meta:Meta,
        Value:Value
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("updateAfLobbySittings: ", data);
       if (data.results) {
         dispatch({type: ON_UPDATE_LOBBY_SETTING_AF, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_UPDATE_LOBBY_SETTING_AF, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_LOBBY_SETTING_AF, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
 }
//onSaveNewStandardEsFrIn
export const onSaveNewStandardEsFrIn = (Afid,userid,nFreeInput) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_NEW_ESIGNERING_FREE_SETTING_AF});
     axios.put('kontos/Esignering/settings/Free/new', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        nFreeInput:nFreeInput
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("onSaveNewStandardEsFrIn: ", data);
       if (data.results) {
         dispatch({type: ON_NEW_ESIGNERING_FREE_SETTING_AF, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_NEW_ESIGNERING_FREE_SETTING_AF, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_NEW_ESIGNERING_FREE_SETTING_AF, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
 }
 //onGetAfEsigneringFreeIn
 export const onGetAfEsigneringFreeIn = (Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_ESIGNERING_FREE_SETTING_AF});
     axios.get('kontos/Esignering/settings/Free/get',
     { params:{Afid:Afid}, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("onGetAfEsigneringFreeIn: ", data);
       if (data.results) {
         dispatch({type: ON_GET_ESIGNERING_FREE_SETTING_AF, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_ESIGNERING_FREE_SETTING_AF, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_ESIGNERING_FREE_SETTING_AF, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
 }
//onDeleteThisAfEsigneringFreeIn
export const onDeleteThisAfEsigneringFreeIn = (Afid,userid,FreeInput) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    //,invitationM,
      //invitationM:invitationM,
    dispatch({type: ON_START_DELETE_ESIGNERING_FREE_SETTING_AF});
    axios.delete('kontos/Esignering/settings/Free/delete',
    {
    method: 'DELETE',
    params:{
      Afid:Afid,
      userid:userid,
      FreeInput:FreeInput
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`}   }
     ).then(({data}) => {
      console.log("onDeleteThisAfEsigneringFreeIn: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_ESIGNERING_FREE_SETTING_AF, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DELETE_ESIGNERING_FREE_SETTING_AF, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_ESIGNERING_FREE_SETTING_AF, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){ } 
     });
  }
}
//onUpdateThisAfEsigneringFreeIn
export const onUpdateThisAfEsigneringFreeIn = (Afid,userid,nFreeInput) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_UPDATE_ESIGNERING_FREE_SETTING_AF});
     axios.put('kontos/Esignering/settings/Free/update', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        nFreeInput:nFreeInput
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("onUpdateThisAfEsigneringFreeIn: ", data);
       if (data.results) {
         dispatch({type: ON_UPDATE_ESIGNERING_FREE_SETTING_AF, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_UPDATE_ESIGNERING_FREE_SETTING_AF, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_ESIGNERING_FREE_SETTING_AF, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
 }
 
 //getFordonitescoByOrgnr
 export const getFordonitescoByOrgnr = (Afid,userid,Orgnr) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_ORGNR_FORDON});
     axios.get('kontos/Kund/fordon',
     { params:{
      Afid:Afid,
      userid:userid,
      Orgnr:Orgnr,
      }, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getFordonitescoByOrgnr: ", data);
       if (data.results) {
         dispatch({type: ON_GET_ORGNR_FORDON, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_ORGNR_FORDON, payload: data.message});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_ORGNR_FORDON, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
 }
 //onSaveNewVaxleAccount
 export const onSaveNewVaxleAccount = (userid,fuserid,fAfid,Nuserid,NAfid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_NEW_USER_VAXLE});
     axios.put('kontos/User/Vaxle/new', {
      method: 'PUT',
      body: {
        userid:userid,
        fuserid:fuserid,
        fAfid:fAfid,
        Nuserid:Nuserid,
        NAfid:NAfid,
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("onSaveNewVaxleAccount: ", data);
       if (data.results) {
         dispatch({type: ON_NEW_USER_VAXLE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_NEW_USER_VAXLE, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_NEW_USER_VAXLE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
 }
//getVaxleAcocountsforuser
export const getVaxleAcocountsforuser = (Authuserid,userid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_USER_VAXLE});
     axios.get('kontos/User/Vaxle/get',
     { params:{
      Authuserid:Authuserid,
      userid:userid,
      }, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getVaxleAcocountsforuser: ", data);
       if (data.results) {
         dispatch({type: ON_NEW_USER_VAXLE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_NEW_USER_VAXLE, payload: data.message});
       }
       dispatch(RefreshUserInterface(Authuserid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_NEW_USER_VAXLE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
 }
//getVaxleAcocountsforuser2
export const getVaxleAcocountsforuser2 = (Authuserid,userid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_NEW_USER_VAXLE});
     axios.get('kontos/User/Vaxle/get2',
     { params:{
      Authuserid:Authuserid,
      userid:userid,
      }, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getVaxleAcocountsforuser: ", data);
       if (data.results) {
         dispatch({type: ON_NEW_USER_VAXLE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_NEW_USER_VAXLE, payload: data.message});
       }
       dispatch(RefreshUserInterface(Authuserid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_NEW_USER_VAXLE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
 }
 //ondeleteVaxleAccount
 export const ondeleteVaxleAccount = (userid,Cuserid,RadId) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    //,invitationM,
      //invitationM:invitationM,
    dispatch({type: ON_START_NEW_USER_VAXLE});
    axios.delete('kontos/User/Vaxle/delete',
    {
    method: 'DELETE',
    params:{
      Cuserid:Cuserid,
      userid:userid,
      RadId:RadId
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`}   }
     ).then(({data}) => {
      console.log("onDeleteThisAfEsigneringFreeIn: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_NEW_USER_VAXLE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_NEW_USER_VAXLE, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_NEW_USER_VAXLE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){ } 
     });
  }
}

//addNewAccountListTag
export const addNewAccountListTag = (Afid,Filterstate,Mainuserid,Page,searchWord,Type, Tagg, source, sourceList) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch,getState) => {
     dispatch({type: ON_START_SET_KUNDLIST_TAG});
     const {KundPagerows} = getState().accountsData;
     axios.put('kontos/Kunder/Tags/set', {
      method: 'PUT',
      body: {
        userid:Mainuserid,
        Afid:Afid,
        Tagg:Tagg,
        source:source,
        sourceList:sourceList,
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("addNewAccountListTag: ", data);
       if (data.results) {
         dispatch({type: ON_SET_KUNDLIST_TAG, payload: data.results});
         //getminaKunder
         dispatch(getKunderByUserID(Afid,Filterstate,Mainuserid,Page,searchWord,Type,undefined,KundPagerows,1))
       } else {
         dispatch({type: ON_ERROR_SET_KUNDLIST_TAG, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SET_KUNDLIST_TAG, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
 }
export const addNewAccountListTagKontakter = (Afid,Filterstate,Mainuserid,Page,searchWord,Type, Tagg, source, sourceList, rows) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_SET_KUNDLIST_TAG});
     axios.put('kontos/Kontakter/Tags/set', {
      method: 'PUT',
      body: {
        userid:Mainuserid,
        Afid:Afid,
        Tagg:Tagg,
        source:source,
        sourceList:sourceList,
      },     
  }, {
    headers: {
      'content-type': 'application/json',
      'Authorization':   `Bearer ${jwt}`
  } 
  }).then(({data}) => {
      console.log("addNewAccountListTag: ", data);
       if (data.results) {
         dispatch({type: ON_SET_KUNDLIST_TAG, payload: data.results});
         //getminaKunder
         dispatch(getKontakpersonerByUserID(Afid,Filterstate,Mainuserid,Page,searchWord,Type, rows))
       } else {
         dispatch({type: ON_ERROR_SET_KUNDLIST_TAG, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SET_KUNDLIST_TAG, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
 }
export const removeAccountListTagKontakter = (Afid,Filterstate,Mainuserid,Page,searchWord,Type, Tagg, source, sourceList, rows) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_SET_KUNDLIST_TAG});
     axios.put('kontos/Kontakter/Tags/remove', {
      method: 'PUT',
      body: {
        userid:Mainuserid,
        Afid:Afid,
        Tagg:Tagg,
        source:source,
        sourceList:sourceList,
      },   
  }, {
    headers: {
      'content-type': 'application/json',
      'Authorization':   `Bearer ${jwt}`
  } 
  }).then(({data}) => {
      console.log("removeAccountListTagKontakter: ", data);
       if (data.results) {
         dispatch({type: ON_SET_KUNDLIST_TAG, payload: data.results});
         //getminaKunder
         dispatch(getKontakpersonerByUserID(Afid,Filterstate,Mainuserid,Page,searchWord,Type, rows))
       } else {
         dispatch({type: ON_ERROR_SET_KUNDLIST_TAG, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SET_KUNDLIST_TAG, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
 }
export const firmatecknareListTagKontakter = (Afid,Filterstate,Mainuserid,Page,searchWord,Type, Firmatecknare, source, sourceList, rows) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_SET_KUNDLIST_TAG});
     axios.put('kontos/Kontakter/Firmatecknare', {
      method: 'PUT',
      body: {
        userid:Mainuserid,
        Afid:Afid,
        Firmatecknare:Firmatecknare,
        source:source,
        sourceList:sourceList,
      },
           
  }, {
    headers: {
      'content-type': 'application/json',
      'Authorization':   `Bearer ${jwt}`
  } 
  }).then(({data}) => {
      console.log("firmatecknareListTagKontakter: ", data);
       if (data.results) {
         dispatch({type: ON_SET_KUNDLIST_TAG, payload: data.results});
         //getminaKunder
         dispatch(getKontakpersonerByUserID(Afid,Filterstate,Mainuserid,Page,searchWord,Type, rows))
       } else {
         dispatch({type: ON_ERROR_SET_KUNDLIST_TAG, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SET_KUNDLIST_TAG, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
 }
export const nyhetsbrevListTagKontakter = (Afid,Filterstate,Mainuserid,Page,searchWord,Type, Nyhetsbrev, source, sourceList, rows) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_SET_KUNDLIST_TAG});
     axios.put('kontos/Kontakter/Nyhetsbrev', {
      method: 'PUT',
      body: {
        userid:Mainuserid,
        Afid:Afid,
        Nyhetsbrev:Nyhetsbrev,
        source:source,
        sourceList:sourceList,
      },      
  }, {
    headers: {
      'content-type': 'application/json',
      'Authorization':   `Bearer ${jwt}`
  } 
  }).then(({data}) => {
      console.log("nyhetsbrevListTagKontakter: ", data);
       if (data.results) {
         dispatch({type: ON_SET_KUNDLIST_TAG, payload: data.results});
         //getminaKunder
         dispatch(getKontakpersonerByUserID(Afid,Filterstate,Mainuserid,Page,searchWord,Type, rows))
       } else {
         dispatch({type: ON_ERROR_SET_KUNDLIST_TAG, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SET_KUNDLIST_TAG, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
 }
//addNewAnsvarigForAccountList
export const addNewAnsvarigForAccountList = (Afid,Filterstate,Mainuserid,Page,searchWord,Type, ansvarig, sourceList) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch,getState) => {
    const {KundPagerows} = getState().accountsData;
     dispatch({type: ON_START_SET_KUNDLIST_TAG});
     axios.put('kontos/Kunder/Ansvarig/set', {
      method: 'PUT',
      body: {
        userid:Mainuserid,
        Afid:Afid,
        ansvarig:ansvarig,
        sourceList:sourceList,
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("addNewAnsvarigForAccountList: ", data);
       if (data.results) {
         dispatch({type: ON_SET_KUNDLIST_TAG, payload: data.results});
         //getminaKunder
         dispatch(getKunderByUserID(Afid,Filterstate,Mainuserid,Page,searchWord,Type,undefined,KundPagerows,1))
       } else {
         dispatch({type: ON_ERROR_SET_KUNDLIST_TAG, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SET_KUNDLIST_TAG, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
 }
//addHuvudAnsvarigForAccountList
export const addHuvudAnsvarigForAccountList = (Afid,Filterstate,Mainuserid,Page,searchWord,Type, ansvarig, sourceList) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch,getState) => {
    const {KundPagerows} = getState().accountsData;
     dispatch({type: ON_START_SET_KUNDLIST_TAG});
     axios.put('kontos/Kunder/HAnsvarig/set', {
      method: 'PUT',
      body: {
        userid:Mainuserid,
        Afid:Afid,
        ansvarig:ansvarig,
        sourceList:sourceList,
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("addHuvudAnsvarigForAccountList: ", data);
       if (data.results) {
         dispatch({type: ON_SET_KUNDLIST_TAG, payload: data.results});
         //getminaKunder
         dispatch(getKunderByUserID(Afid,Filterstate,Mainuserid,Page,searchWord,Type,undefined,KundPagerows,1))
       } else {
         dispatch({type: ON_ERROR_SET_KUNDLIST_TAG, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SET_KUNDLIST_TAG, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
 }
 //inktiveraAccountList
 export const inktiveraAccountList = (Afid,Filterstate,Mainuserid,Page,searchWord,Type, sourceList) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch,getState) => {
    const {KundPagerows} = getState().accountsData;
     dispatch({type: ON_START_SET_KUNDLIST_TAG});
     axios.put('kontos/Kunder/inaktivera/set', {
      method: 'PUT',
      body: {
        userid:Mainuserid,
        Afid:Afid,
        sourceList:sourceList,
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("inktiveraAccountList: ", data);
       if (data.results) {
         dispatch({type: ON_SET_KUNDLIST_TAG, payload: data.results});
         //getminaKunder
         dispatch(getKunderByUserID(Afid,Filterstate,Mainuserid,Page,searchWord,Type,undefined,KundPagerows,1))
       } else {
         dispatch({type: ON_ERROR_SET_KUNDLIST_TAG, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SET_KUNDLIST_TAG, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
 }
//getKundsKunddataHeader
export const getKundsKunddataHeader = (Afid,userid,Orgnr) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_KUNDDATA_HEADER});
     axios.get('kontos/KundData/header',
     { params:{
      Afid:Afid,
      userid:userid,
      Orgnr:Orgnr,
      }, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getKundsKunddataHeader: ", data);
       if (data.results) {
         dispatch({type: ON_GET_KUNDDATA_HEADER, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_KUNDDATA_HEADER, payload: data.message});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_KUNDDATA_HEADER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
 }
//getKundsKunddatabyType
/**/
export const getKundsKunddatabyType = (Afid,userid,Orgnr,type) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_KUNDDATA_BYTYPE});
     axios.get('kontos/KundData/Bytype/get',
     { params:{
      Afid:Afid,
      userid:userid,
      type:type,
      Orgnr:Orgnr,
      }, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getKundsKunddatabyType: ", data);
       if (data.results) {
         dispatch({type: ON_GET_KUNDDATA_BYTYPE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_KUNDDATA_BYTYPE, payload: data.message});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_KUNDDATA_BYTYPE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
 }
//getExportKundsKunddatabyType
export const getExportKundsKunddatabyType = (Afid,userid,Orgnr,type)=>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_FETCH_EXCELMALL});
    axios.get('kontos/KundData/download',
    { params:{
      Afid:Afid,
      userid:userid,
      Orgnr:Orgnr,
      type:type,
    }, 
     responseType: 'arraybuffer' ,
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then((resp) => {
       const regex = /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/;
       var  fileName = `Kunddata ${Orgnr}.xlsx`;
       var blob = new Blob([resp.data], 
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
      );
      dispatch({type: ON_FETCH_EXCELMALL, payload: resp});
      fileSaver.saveAs(blob, fileName);
     }).catch(function (error) {
       dispatch({type: ON_ERROR_EXCELMAL, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//onDeletRowALLsKunddatabyType
export const onDeletRowALLsKunddatabyType = (Afid,userid,Orgnr,type,DelRad) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    //,invitationM,
      //invitationM:invitationM,
    dispatch({type: ON_START_DELETE_ROW_ALL_KUNDDATA_BYTYPE});
    axios.delete('kontos/KundData/Bytype/All/delete',
    {
    method: 'DELETE',
    params:{
      Afid:Afid,
      userid:userid,
      Orgnr:Orgnr,
      type:type,
      DelRad:DelRad,
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`}   }
     ).then(({data}) => {
      console.log("onDeletRowALLsKunddatabyType: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_ROW_ALL_KUNDDATA_BYTYPE, payload: data.results,DelRad:DelRad.radId});
       } else {
         dispatch({type: ON_ERROR_DELETE_ROW_KUNDDATA_BYTYPE, payload: data.error});
       }
       //
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_ROW_KUNDDATA_BYTYPE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){ } 
     });
  }
}
//onDeletRowKundsKunddatabyType
export const onDeletRowKundsKunddatabyType = (Afid,userid,Orgnr,type,DelRad) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    //,invitationM,
      //invitationM:invitationM,
    dispatch({type: ON_START_DELETE_ROW_KUNDDATA_BYTYPE});
    axios.delete('kontos/KundData/Bytype/delete',
    {
    method: 'DELETE',
    params:{
      Afid:Afid,
      userid:userid,
      Orgnr:Orgnr,
      type:type,
      DelRad:DelRad,
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`}   }
     ).then(({data}) => {
      console.log("onDeletRowKundsKunddatabyType: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_ROW_KUNDDATA_BYTYPE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DELETE_ROW_KUNDDATA_BYTYPE, payload: data.error});
       }
       //
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_ROW_KUNDDATA_BYTYPE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){ } 
     });
  }
}
//deleteKundsKundDataListByIds
export const deleteKundsKundDataListByIds = (Afid,userid,Orgnr,type,DelRads) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    //,invitationM,
      //invitationM:invitationM,
    dispatch({type: ON_START_DELETE_ROW_KUNDDATA_BYTYPE});
    axios.delete('kontos/KundData/Bytype/list/delete',
    {
    method: 'DELETE',
    params:{
      Afid:Afid,
      userid:userid,
      Orgnr:Orgnr,
      type:type,
      DelRads:DelRads,
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`}   }
     ).then(({data}) => {
      console.log("onDeletRowKundsKunddatabyType: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_ROW_KUNDDATA_BYTYPE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DELETE_ROW_KUNDDATA_BYTYPE, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_ROW_KUNDDATA_BYTYPE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){ } 
     });
  }
}
//deleteAllsKundDataListByIds
export const deleteAllsKundDataListByIds = (Afid,userid,type,DelRads) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    //,invitationM,
      //invitationM:invitationM,
    dispatch({type: ON_START_DELETE_ALL_ROW_KUNDDATA_BYTYPE});
    axios.delete('kontos/KundData/Bytype/All/list/delete',
    {
    method: 'DELETE',
    params:{
      Afid:Afid,
      userid:userid,
      type:type,
      DelRads:DelRads,
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`}   }
     ).then(({data}) => {
      console.log("onDeletRowKundsKunddatabyType: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_ALL_ROW_KUNDDATA_BYTYPE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DELETE_ALL_ROW_KUNDDATA_BYTYPE, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_ALL_ROW_KUNDDATA_BYTYPE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){ } 
     });
  }
}

//onSaveKundsKunddatabyType
export const onSaveKundsKunddatabyType = (Afid,userid,Orgnr,type,saveRads) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_SAVE_ROW_KUNDDATA_BYTYPE});
     axios.put('kontos/KundData/Bytype/list/save', {
      method: 'PUT',
      body: {
        Afid:Afid,
        userid:userid,
        Orgnr:Orgnr,
        type:type,
        saveRads:saveRads,
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("onSaveKundsKunddatabyType: ", data);
       if (data.results) {
         dispatch({type: ON_SAVE_ROW_KUNDDATA_BYTYPE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DELETE_ROW_KUNDDATA_BYTYPE, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_ROW_KUNDDATA_BYTYPE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
 }
export const onSaveAllasKunddatabyType = (Afid,userid,Orgnr,type,saveRads) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_SAVE_ROW_KUNDDATA_BYTYPE});
     axios.put('kontos/KundData/Bytype/All/save', {
      method: 'PUT',
      body: {
        Afid:Afid,
        userid:userid,
        Orgnr:Orgnr,
        type:type,
        saveRads:saveRads,
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("onSaveKundsKunddatabyType: ", data);
       if (data.results) {
         dispatch({type: ON_SAVE_All_ROW_KUNDDATA_BYTYPE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_KUNDDATA_ALL_BYTYPE, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_KUNDDATA_ALL_BYTYPE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
 }
 //onSaveAllasDailerKunddatabyType
 export const onSaveAllasDailerKunddatabyType = (Afid,userid,Orgnr,type,saveRads) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_SAVE_ROW_KUNDDATA_DIALER_BYTYPE});
     axios.put('kontos/KundData/dialer/Bytype/All/save', {
      method: 'PUT',
      body: {
        Afid:Afid,
        userid:userid,
        Orgnr:Orgnr,
        type:type,
        saveRads:saveRads,
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("onSaveKundsKunddatabyType: ", data);
       if (data.results) {
         dispatch({type: ON_SAVE_All_ROW_KUNDDATA_DIALER_BYTYPE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_KUNDDATA_ALL_DIALER_BYTYPE, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_KUNDDATA_ALL_DIALER_BYTYPE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
 }
 //getKunddataHeader
 export const getKunddataHeader = (Afid,userid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_KUNDDATA_ALL_HEADER});
     axios.get('kontos/KundData/All/header',
     { params:{
      Afid:Afid,
      userid:userid,
      }, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getKunddataHeader: ", data);
       if (data.results) {
         dispatch({type: ON_GET_KUNDDATA_ALL_HEADER, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_KUNDDATA_ALL_HEADER, payload: data.message});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_KUNDDATA_ALL_HEADER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
 }
//getKunddataAllByType
export const getKunddataAllByType = (Afid,userid,type) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_KUNDDATA_ALL_BYTYPE});
     axios.get('kontos/KundData/All/Bytype/get',
     { params:{
      Afid:Afid,
      userid:userid,
      type:type,
      }, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getKunddataAllByType: ", data);
       if (data.results) {
         dispatch({type: ON_GET_KUNDDATA_ALL_BYTYPE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_KUNDDATA_ALL_BYTYPE, payload: data.message});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_KUNDDATA_ALL_BYTYPE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
}
//getDialerKunddataAllByType
export const getDialerKunddataAllByType = (Afid,userid,type) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_KUNDDATA_DIALER_ALL_BYTYPE});
     axios.get('kontos/KundData/dialer/All/Bytype/get',
     { params:{
      Afid:Afid,
      userid:userid,
      type:type,
      }, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getKunddataAllByType: ", data);
       if (data.results) {
         dispatch({type: ON_GET_KUNDDATA_DIALER_ALL_BYTYPE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_KUNDDATA_DIALER_ALL_BYTYPE, payload: data.message});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_KUNDDATA_DIALER_ALL_BYTYPE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
}
//createKampanjfromKundData
export const createKampanjfromKundData = (Afid,userid,Ringlista,saveRads,type) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_CREATE_RINGLIST_FROM_KUNDDATA});
     axios.put('kontos/KundData/Kampanj/create', {
      method: 'PUT',
      body: {
        Afid:Afid,
        userid:userid,
        Ringlista:Ringlista,
        saveRads:saveRads,
        type:type,
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("createKampanjfromKundData: ", data);
       if (data.results) {
         dispatch({type: ON_CREATE_RINGLIST_FROM_KUNDDATA, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_CREATE_RINGLIST_FROM_KUNDDATA, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_CREATE_RINGLIST_FROM_KUNDDATA, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
 }
//createKampanjfromKund
export const createKampanjfromKund = (Afid,userid,Ringlista,saveRads) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_CREATE_RINGLIST_FROM_KUNDLIST});
     axios.put('kontos/KundList/Kampanj/create', {
      method: 'PUT',
      body: {
        Afid:Afid,
        userid:userid,
        Ringlista:Ringlista,
        saveRads:saveRads,
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("createKampanjfromKund: ", data);
       if (data.results) {
         dispatch({type: ON_CREATE_RINGLIST_FROM_KUNDLIST, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_CREATE_RINGLIST_FROM_KUNDLIST, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_CREATE_RINGLIST_FROM_KUNDLIST, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
 }
//insertintoKampanjfromKund
export const insertintoKampanjfromKund = (Afid,userid,RinglistId,saveRads) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_CREATE_RINGLIST_FROM_KUNDLIST});
     axios.put('kontos/KundList/Kampanj/add', {
      method: 'PUT',
      body: {
        Afid:Afid,
        userid:userid,
        Ringlista:RinglistId,
        saveRads:saveRads,
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("createKampanjfromKund: ", data);
       if (data.results) {
         dispatch({type: ON_CREATE_RINGLIST_FROM_KUNDLIST, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_CREATE_RINGLIST_FROM_KUNDLIST, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_CREATE_RINGLIST_FROM_KUNDLIST, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
 }
//createKampanjfromAvtalTidList
export const createKampanjfromAvtalTidList = (Afid,userid,Ringlista,saveRads) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_CREATE_RINGLIST_FROM_AVTALSTID});
     axios.put('kontos/Avtalstid/Kampanj/create', {
      method: 'PUT',
      body: {
        Afid:Afid,
        userid:userid,
        Ringlista:Ringlista,
        saveRads:JSON.stringify(saveRads),
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("createKampanjfromKundData: ", data);
       if (data.results) {
         dispatch({type: ON_CREATE_RINGLIST_FROM_AVTALSTID, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_CREATE_RINGLIST_FROM_AVTALSTID, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_CREATE_RINGLIST_FROM_AVTALSTID, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
 }
 //onSaveNewArticleType
 export const onSaveNewArticleType = (Afid,userid,newType) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_SAVE_NEW_TYPE_ARTIKEL});
     axios.put('kontos/articles/freeInputs/newType', {
      method: 'PUT',
      body: {
        Afid:Afid,
        userid:userid,
        newType:newType
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("onSaveNewArticleType: ", data);
       if (data.results) {
         dispatch({type: ON_SAVE_SAVE_NEW_TYPE_ARTIKEL, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_SAVE_NEW_TYPE_ARTIKEL, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SAVE_NEW_TYPE_ARTIKEL, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
 }
//getArticleType
export const getArticleType = (Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_TYPE_ARTIKEL_AFID});
     axios.get('kontos/articles/freeInputs/type/get',
     { params:{
      Afid:Afid
      }, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getArticleType: ", data);
       if (data.results) {
         dispatch({type: ON_GET_TYPE_ARTIKEL_AFID, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_TYPE_ARTIKEL_AFID, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_TYPE_ARTIKEL_AFID, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
}
//onDeleteArticleType
export const onDeleteArticleType = (Afid,userid,DelTyp) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    //,invitationM,
      //invitationM:invitationM,
    dispatch({type: ON_START_SAVE_NEW_TYPE_ARTIKEL});
    axios.delete('kontos/articles/freeInputs/delete',
    {
    method: 'DELETE',
    params:{
      Afid:Afid,
      userid:userid,
      DelTyp:DelTyp,
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`}   }
     ).then(({data}) => {
      console.log("onDeleteArticleType: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_SAVE_NEW_TYPE_ARTIKEL, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_SAVE_NEW_TYPE_ARTIKEL, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SAVE_NEW_TYPE_ARTIKEL, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){ } 
     });
  }
}
//onchangeArticleTypeNameByAfid
export const onchangeArticleTypeNameByAfid = (Afid,userid,Typ,NewName) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_SAVE_NEW_TYPE_ARTIKEL});
     axios.put('kontos/articles/freeInputs/updateType', {
      method: 'PUT',
      body: {
        Afid:Afid,
        userid:userid,
        Typ:Typ,
        NewName:NewName,
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("onchangeArticleTypeNameByAfid: ", data);
       if (data.results) {
         dispatch({type: ON_SAVE_SAVE_NEW_TYPE_ARTIKEL, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_SAVE_NEW_TYPE_ARTIKEL, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SAVE_NEW_TYPE_ARTIKEL, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
 }
//onSaveArticleTypeNewFreeInput
export const onSaveArticleTypeNewFreeInput = (Afid,userid,newFalt) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_SAVE_NEW_TYPE_ARTIKEL_FREEINPUT});
     axios.put('kontos/articles/freeInputs/freeInput/new', {
      method: 'PUT',
      body: {
        Afid:Afid,
        userid:userid,
        newFalt:newFalt,
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("onSaveArticleTypeNewFreeInput: ", data);
       if (data.results) {
         dispatch({type: ON_SAVE_NEW_TYPE_ARTIKEL_FREEINPUT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_SAVE_NEW_TYPE_ARTIKEL_FREEINPUT, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SAVE_NEW_TYPE_ARTIKEL_FREEINPUT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
 }
//getArticleTypeFreeInputs
export const getArticleTypeFreeInputs = (Afid,TypName) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_FREEINPUT_ARTIKEL_AFID});
     axios.get('kontos/articles/freeInputs/freeInput/get',
     { params:{
      Afid:Afid,
      TypName:TypName
      }, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getArticleType: ", data);
       if (data.results) {
         dispatch({type: ON_GET_FREEINPUT_ARTIKEL_AFID, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_FREEINPUT_ARTIKEL_AFID, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FREEINPUT_ARTIKEL_AFID, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
}
export const getArticleTypeFreeInputsList = (Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_FREEINPUT_ARTIKEL_AFID_LIST});
     axios.get('kontos/articles/freeInputs/freeInput/get/list',
     { params:{
      Afid:Afid,
      }, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getArticleType: ", data);
       if (data.results) {
         dispatch({type: ON_GET_FREEINPUT_ARTIKEL_AFID_LIST, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_FREEINPUT_ARTIKEL_AFID_LIST, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FREEINPUT_ARTIKEL_AFID_LIST, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
}
export const getArticleTypeFreeInputsListFilterOptions = (Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_FREEINPUT_ARTIKEL_AFID_LIST_FILTER_OPTIONS});
     axios.get('kontos/articles/freeInputs/freeInput/get/list/filterOptions',
     { params:{
      Afid:Afid,
      }, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getArticleType: ", data);
       if (data.results) {
         dispatch({type: ON_GET_FREEINPUT_ARTIKEL_AFID_LIST_FILTER_OPTIONS, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_FREEINPUT_ARTIKEL_AFID_LIST_FILTER_OPTIONS, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FREEINPUT_ARTIKEL_AFID_LIST_FILTER_OPTIONS, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
}

//onDeleteArticleTypeFreeInput
export const onDeleteArticleTypeFreeInput = (Afid,userid,FreeInput) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    //,invitationM,
      //invitationM:invitationM,
    dispatch({type: ON_START_SAVE_NEW_TYPE_ARTIKEL_FREEINPUT});
    axios.delete('kontos/articles/freeInputs/freeInput/delete',
    {
    method: 'DELETE',
    params:{
      Afid:Afid,
      userid:userid,
      FreeInput:FreeInput,
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`}   }
     ).then(({data}) => {
      console.log("onDeleteArticleType: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_TYPE_ARTIKEL_FREEINPUT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_SAVE_NEW_TYPE_ARTIKEL_FREEINPUT, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SAVE_NEW_TYPE_ARTIKEL_FREEINPUT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){ } 
     });
  }
}
//onUpdateArticleTypeFreeInput
export const onUpdateArticleTypeFreeInput = (Afid,userid,newFalt) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_SAVE_NEW_TYPE_ARTIKEL_FREEINPUT});
     axios.put('kontos/articles/freeInputs/freeInput/Update', {
      method: 'PUT',
      body: {
        Afid:Afid,
        userid:userid,
        newFalt:newFalt,
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("onSaveArticleTypeNewFreeInput: ", data);
       if (data.results) {
         dispatch({type: ON_SAVE_NEW_TYPE_ARTIKEL_FREEINPUT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_SAVE_NEW_TYPE_ARTIKEL_FREEINPUT, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SAVE_NEW_TYPE_ARTIKEL_FREEINPUT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
 }
 export const getArticleTypeFreeInputsAll= (Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_FREEINPUT_ARTIKEL_ALL_AFID});
     axios.get('kontos/articles/freeInputs/freeInput/getAll',
     { params:{
      Afid:Afid
      }, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getArticleType: ", data);
       if (data.results) {
         dispatch({type: ON_GET_FREEINPUT_ARTIKEL_ALL_AFID, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_FREEINPUT_ARTIKEL_AFID, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FREEINPUT_ARTIKEL_AFID, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
}
//onGenerateOrderImportMall
export const onGenerateOrderImportMall = (Afid)=>{
  const jwt =  JSON.parse(localStorage.token);
  
  return (dispatch) => {
    dispatch({type: ON_START_FETCH_ORDER_IMPORT_FILE});
    axios.get('kontos/Import/mall/order',
    { params:{
      Afid:Afid
    }, 
     responseType: 'arraybuffer' ,
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then((resp) => {
       const regex = /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/;
       var  fileName = "OrderMall.xlsx";
       var blob = new Blob([resp.data], 
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
      );
      dispatch({type: ON_FETCH_ORDER_IMPORT_FILE, payload: resp});
      fileSaver.saveAs(blob, fileName);
     }).catch(function (error) {
       dispatch({type: ON_FETCH_ORDER_IMPORT_FILE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//onGenerateArteklImportMall
export const onGenerateArteklImportMall = (Afid)=>{
  const jwt =  JSON.parse(localStorage.token);
  
  return (dispatch) => {
    dispatch({type: ON_START_FETCH_ORDER_IMPORT_FILE});
    axios.get('kontos/Import/mall/Artiklar',
    { params:{
      Afid:Afid
    }, 
     responseType: 'arraybuffer' ,
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then((resp) => {
       const regex = /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/;
       var  fileName = "ArtiklarMall.xlsx";
       var blob = new Blob([resp.data], 
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
      );
      dispatch({type: ON_FETCH_ORDER_IMPORT_FILE, payload: resp});
      fileSaver.saveAs(blob, fileName);
     }).catch(function (error) {
       dispatch({type: ON_FETCH_ORDER_IMPORT_FILE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
export const onGenerateOrderArtikelImportMall = (Afid,ArtikelType)=>{
  const jwt =  JSON.parse(localStorage.token);
  
  return (dispatch) => {
    dispatch({type: ON_START_FETCH_ORDER_IMPORT_FILE});
    axios.get('kontos/Import/mall/orderArtikle',
    { params:{
      Afid:Afid,
      ArtikelType:ArtikelType
    }, 
     responseType: 'arraybuffer' ,
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then((resp) => {
       const regex = /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/;
       var  fileName = "OrderMall.xlsx";
       var blob = new Blob([resp.data], 
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
      );
      dispatch({type: ON_FETCH_ORDER_IMPORT_FILE, payload: resp});
      fileSaver.saveAs(blob, fileName);
     }).catch(function (error) {
       dispatch({type: ON_FETCH_ORDER_IMPORT_FILE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
export const onGenerateArtikelImportMall = (Afid,ArtikelType)=>{
  const jwt =  JSON.parse(localStorage.token);
  
  return (dispatch) => {
    dispatch({type: ON_START_FETCH_ORDER_IMPORT_FILE});
    axios.get('kontos/Import/mall/artikel_typ_import',
    { params:{
      Afid:Afid,
      ArtikelType:ArtikelType
    }, 
     responseType: 'arraybuffer' ,
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then((resp) => {
       const regex = /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/;
       var  fileName = "Artikelmall_import_standard.xlsx";
       if(String(ArtikelType) != '0')  fileName = `Artikelmall_import_${ArtikelType}.xlsx`;
       var blob = new Blob([resp.data], 
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
      );
      dispatch({type: ON_FETCH_ORDER_IMPORT_FILE, payload: resp});
      fileSaver.saveAs(blob, fileName);
     }).catch(function (error) {
       dispatch({type: ON_FETCH_ORDER_IMPORT_FILE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}

//onAddNewPlista
export const onAddNewPlista= (userid,Afid,Prislista,copyFromId) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_SAVE_NEW_PRISLISTA});
     axios.put('kontos/articles/prisLista/new', {
      method: 'PUT',
      body: {
        Afid:Afid,
        userid:userid,
        Prislista:Prislista,
        copyFromId
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("onAddNewPlista: ", data);
       if (data.results) {
         dispatch({type: ON_SAVE_NEW_PRISLISTA, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_SAVE_NEW_PRISLISTA, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SAVE_NEW_PRISLISTA, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
}
//onGetKontoPrislistor
export const onGetKontoPrislistor= (Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_AFID_PRISLISTA});
     axios.get('kontos/articles/prisLista/all',
     { params:{
      Afid:Afid
      }, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getArticleType: ", data);
       if (data.results) {
         dispatch({type: ON_GET_AFID_PRISLISTA, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_AFID_PRISLISTA, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_AFID_PRISLISTA, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
}
//onDeleteKontoPrislist
export const onDeleteKontoPrislist = (Afid,userid,rad) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    //,invitationM,
      //invitationM:invitationM,
    dispatch({type: ON_START_GET_AFID_PRISLISTA});
    axios.delete('kontos/articles/prisLista/delete',
    {
    method: 'DELETE',
    params:{
      Afid:Afid,
      userid:userid,
      rad:rad,
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`}   }
     ).then(({data}) => {
      console.log("onDeleteArticleType: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_DELETE_AFID_PRISLISTA, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_AFID_PRISLISTA, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_AFID_PRISLISTA, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){ } 
     });
  }
}
//onUpdateKontoPrislist
export const onUpdateKontoPrislist = (Afid,userid,item) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_AFID_PRISLISTA});
     axios.put('kontos/articles/prisLista/update', {
      method: 'PUT',
      body: {
        Afid:Afid,
        userid:userid,
        item:item
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("onUpdateKontoPrislist: ", data);
       if (data.results) {
         dispatch({type: ON_UPDATE_AFID_PRISLISTA, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_AFID_PRISLISTA, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_AFID_PRISLISTA, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
 }



//getAfidUserList
export const getAfidUserList= (Afid,AuthUSerid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_AFID_USERLIST});
     axios.get('kontos/users/get/all',
     { params:{
      Afid:Afid
      }, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getArticleType: ", data);
       if (data.results) {
         dispatch({type: ON_GET_AFID_USERLIST, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_AFID_USERLIST, payload: data.message});
       }
       dispatch(RefreshUserInterface(AuthUSerid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_AFID_USERLIST, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
}

// ON_START_FETCH_LYNES_SAMTAL_HISTORY,
// ON_FETCH_LYNES_SAMTAL_HISTORY,
// ON_ERROR_LYNES_SAMTAL_HISTORY,
export const getLynesTeleHistory= (Afid,userid,TeleArrStr) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_FETCH_LYNES_SAMTAL_HISTORY});
     axios.get('kontos/lynes/history',
     { params:{
      Afid:Afid,TeleArrStr:TeleArrStr,userid
      }, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getLynesTeleHistory: ", data);
       if (data.success) {
         dispatch({type: ON_FETCH_LYNES_SAMTAL_HISTORY, payload: data});
       } else {
         dispatch({type: ON_ERROR_LYNES_SAMTAL_HISTORY, payload: data.message});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_LYNES_SAMTAL_HISTORY, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
}

// ON_GET_ONEDRIVE_ROOT,
//     ON_ERROR_GET_ONEDRIVE_ROOT,
//     ON_START_GET_ONEDRIVE_ROOT,


export const getNotyfileRootDrive= (Afid,Userid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_ONEDRIVE_ROOT});
     axios.get('/onedrive/getNotyfileRootDrive',
     { params: {
      Afid,Userid
      },
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getNotyfileRootDrive: ", data);
       if (data.results) {
         dispatch({type: ON_GET_ONEDRIVE_ROOT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_ONEDRIVE_ROOT, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_ONEDRIVE_ROOT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
}

//     ON_ADD_ONEDRIVE_ROOT,
//     ON_ERROR_ADD_ONEDRIVE_ROOT,
//     ON_START_ADD_ONEDRIVE_ROOT,
export const addNotyfileRootDrive= (Afid,Userid,DriveId,ItemId) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_ADD_ONEDRIVE_ROOT});
      axios.post('/onedrive/addNotyfileRootDrive',
        { 
          body:{
          Afid:Afid,Userid:Userid,DriveId:DriveId,ItemId:ItemId
          }, 
        } ,
       {
        headers: { 'Authorization': `Bearer ${jwt}`} 
       }     
      ).then(({data}) => {
      console.log("addNotyfileRootDrive: ", data);
       if (data.results) {
         dispatch({type: ON_ADD_ONEDRIVE_ROOT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_ADD_ONEDRIVE_ROOT, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_ADD_ONEDRIVE_ROOT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
}
export const removeNotyfileRootDrive= (Afid,Userid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_ADD_ONEDRIVE_ROOT});
     axios.delete('/onedrive/addNotyfileRootDrive',
     { params:{
      Afid:Afid,Userid:Userid
      }, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("removeNotyfileRootDrive: ", data);
       if (data.results) {
         dispatch({type: ON_ADD_ONEDRIVE_ROOT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_ADD_ONEDRIVE_ROOT, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_ADD_ONEDRIVE_ROOT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
}


//     ON_GET_MY_DRIVES,
//     ON_ERROR_GET_MY_DRIVES,
//     ON_START_GET_MY_DRIVES,


export const getAllDrivesList= (Afid,Userid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_MY_DRIVES});
     axios.get('/onedrive/getAllDrivesList',
     { params:{
      Afid,Userid
      }, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getAllDrivesList: ", data);
       if (data.results) {
         dispatch({type: ON_GET_MY_DRIVES, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_MY_DRIVES, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_MY_DRIVES, payload: error.error});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
}
export const openOneDriveFolderBySource= (Afid,Userid,Source,SourceId,Orgnr) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     axios.get('/onedrive/open',
     { params:{
      Afid,Userid,Source,SourceId,Orgnr
      }, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("openOneDriveFolderBySource: ", data);
       if (data.results) {
        window.open(data.results.folder.webUrl + '?action=openwith&app=explorer');
        // const { spawn } = require('child_process');

        // const child = spawn('cmd.exe', ['/c', 'echo %OneDriveConsumer%']);

        // child.stdout.on('data', (data) => {
        //   const output = data.toString().trim();
        //   if (output !== '') {
        //     const oneDrivePath = output.replace(/\\+/g, '/');
        //     console.log('OneDrive folder path:', oneDrivePath);
        //   } else {
        //     console.log('OneDrive folder not found.');
        //   }
        // });

        // child.stderr.on('data', (data) => {
        //   console.error(`child process error: ${data}`);
        // });

        // child.on('close', (code) => {
        //   console.log(`child process exited with code ${code}`);
        // });
       } 
     }).catch(function (error) {
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
}

//onCloseKontoToaster
export const onCloseKontoToaster = () => {
  return (dispatch) => {
    dispatch({type:ON_CLOSE_KONTO_TOASTR});
  }
}
//onCloseKundToaster
export const onCloseKundToaster = () => {
  return (dispatch) => {
    dispatch({type:ON_CLOSE_KUND_TOASTR});
  }
}
//onCloseRapportToaster
export const onCloseRapportToaster = () => {
  return (dispatch) => {
    dispatch({type:ON_CLOSE_RAPPORT_TOASTR});
  }
}
//savePageAnv
export const savePageAnv = (page) => {
  return (dispatch) => {
    dispatch({type:ON_SAVE_PAGE_ANV,payload:{page}});
  }
}
//getKundMessage
export const getKundMessage= (userid,Afid,Orgnr) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_KUND_MESSAGE});
     axios.get('kontos/message',
     { params:{
      Afid:Afid,
      userid:userid,
      Orgnr:Orgnr,
      }, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getArticleType: ", data);
       if (data.results) {
         dispatch({type: ON_GET_KUND_MESSAGE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_KUND_MESSAGE, payload: data.message});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_KUND_MESSAGE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
}
//onGetKontoAvtalsAvslutning
export const onGetKontoAvtalsAvslutning= (Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_AVTALS_AVSLUTNING});
     axios.get('kontos/Avtals/Avslutning',
     { params:{
      Afid:Afid
      }, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getArticleType: ", data);
       if (data.results) {
         dispatch({type: ON_GET_AVTALS_AVSLUTNING, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_AVTALS_AVSLUTNING, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_AVTALS_AVSLUTNING, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
}
//onAddNewAvtalsAvslutning
export const onAddNewAvtalsAvslutning= (userid,Afid,Label) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_SAVE_NEW_AVTAL_AVSLUTNING});
     axios.put('kontos/Avtals/Avslutning/new', {
      method: 'PUT',
      body: {
        Afid:Afid,
        userid:userid,
        Label:Label
      },
         
  }, {
    headers: {
      'content-type': 'application/json',
      'Authorization':   `Bearer ${jwt}`
  }   
  }).then(({data}) => {
      console.log("onAddNewAvtalsAvslutning: ", data);
       if (data.results) {
         dispatch({type: ON_SAVE_NEW_AVTAL_AVSLUTNING, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_SAVE_NEW_AVTAL_AVSLUTNING, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SAVE_NEW_AVTAL_AVSLUTNING, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
}

//onDeleteKontoAvtalAvslutning
export const onDeleteKontoAvtalAvslutning = (userid,Afid,rad) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    //,invitationM,
      //invitationM:invitationM,
    dispatch({type: ON_START_DELETE_AVTAL_AVSLUTNING});
    axios.delete('kontos/Avtals/Avslutning/delete',
    {
    method: 'DELETE',
    params:{
      Afid:Afid,
      userid:userid,
      rad:rad,
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`}   }
     ).then(({data}) => {
      console.log("onDeleteKontoAvtalAvslutning: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_DELETE_AVTAL_AVSLUTNING, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DELETE_AVTAL_AVSLUTNING, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_AVTAL_AVSLUTNING, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){ } 
     });
  }
}
//getExportKunddatabyType
export const getExportKunddatabyType = (Afid,userid,type,KeyWord,chips,SendTo)=>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_FETCH_EXCELMALL});
    axios.get('kontos/KundData/All/download',
    { params:{
      Afid:Afid,
      userid:userid,
      KeyWord:KeyWord,
      chips:chips,
      type:type,
      SendTo:SendTo,
    }, 
     responseType: 'arraybuffer' ,
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then((resp) => {
       const regex = /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/;
       var  fileName = `Kunddata.xlsx`;
       var blob = new Blob([resp.data], 
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
      );
      dispatch({type: ON_FETCH_EXCELMALL, payload: resp});
      fileSaver.saveAs(blob, fileName);
     }).catch(function (error) {
       dispatch({type: ON_ERROR_EXCELMAL, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//getExportDailerKunddatabyType
export const getExportDailerKunddatabyType = (Afid,userid,type,KeyWord,chips,SendTo)=>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_FETCH_EXCELMALL});
    axios.get('kontos/KundData/dialer/All/download',
    { params:{
      Afid:Afid,
      userid:userid,
      KeyWord:KeyWord,
      chips:chips,
      type:type,
      SendTo:SendTo,
    }, 
     responseType: 'arraybuffer' ,
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then((resp) => {
       const regex = /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/;
       var  fileName = `KunddataDialer.xlsx`;
       var blob = new Blob([resp.data], 
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
      );
      dispatch({type: ON_FETCH_EXCELMALL, payload: resp});
      fileSaver.saveAs(blob, fileName);
     }).catch(function (error) {
       dispatch({type: ON_ERROR_EXCELMAL, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//getAvtalFortnoxSettingsByAfid
export const getAvtalFortnoxSettingsByAfid= (Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_AVTALS_FORTNOX_SETTINGS});
     axios.get('kontos/Avtals/Fortnox/settings',
     { params:{
      Afid:Afid
      }, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getArticleType: ", data);
       if (data.results) {
         dispatch({type: ON_GET_AVTALS_FORTNOX_SETTINGSG, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_AVTALS_FORTNOX_SETTINGS, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_AVTALS_FORTNOX_SETTINGS, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
}
//onUpdateAvtalFortnoxSettingsByAfid
export const onUpdateAvtalFortnoxSettingsByAfid= (Afid,userid,Meta,Value) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_UPDATE_AVTALS_FORTNOX_SETTING});
     axios.put('kontos/Avtals/Fortnox/settings', {
      method: 'PUT',
      body: {
        Afid:Afid,
        userid:userid,
        Meta:Meta,
        Value:Value,
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("onAddNewAvtalsAvslutning: ", data);
       if (data.results) {
         dispatch({type: ON_UPDATE_AVTALS_FORTNOX_SETTING, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_UPDATE_AVTALS_FORTNOX_SETTING, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_AVTALS_FORTNOX_SETTING, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
}
 //getAfidEventSittings
 export const getAfidEventSittings = (Afid) =>{
   return (dispatch) => {
     dispatch({type: ON_START_GET_EVENT_SETTING_AF});
     axios.get('kontos/Event/settings/get',
     { params:{Afid:Afid} }      
      ).then(({data}) => {
      console.log("getAfidEventSittings: ", data);
       if (data.results) {
         dispatch({type: ON_GET_EVENT_SETTING_AF, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_EVENT_SETTING_AF, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_EVENT_SETTING_AF, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
 }
 //updateAfEventSittings
 export const updateAfEventSittings = (Afid,userid,Meta,Value) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_UPDATE_EVENT_SETTING_AF});
     axios.put('kontos/Event/settings/update', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        Meta:Meta,
        Value:Value
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("updateAfEventSittings: ", data);
       if (data.results) {
         dispatch({type: ON_UPDATE_EVENT_SETTING_AF, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_UPDATE_EVENT_SETTING_AF, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_EVENT_SETTING_AF, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
 }
//getAktivitetTypes
export const getAktivitetTypes = (Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_AKTIVITETE_TYPE});
     axios.get('kontos/Aktivitet/type/get',
     { params:{Afid:Afid}, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getAktivitetTypes: ", data);
       if (data.results) {
         dispatch({type: ON_GET_AKTIVITETE_TYPE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_AKTIVITETE_TYPE, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_AKTIVITETE_TYPE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
 }
 
//SaveNewAktiviteteType
export const SaveNewAktivitetetype = ( userid, Afid,newStatus) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_NEW_AKTIVITETE_TYPE});
     axios.put('kontos/Aktivitet/type/new', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        newStatus:newStatus
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("SaveNewEventStatus: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_NEW_AKTIVITETE_TYPE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_AKTIVITETE_TYPE, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_AKTIVITETE_TYPE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//onDeleteAktivitetType
export const onDeleteAktivitetType = ( Afid,userid,delItem) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_AKTIVITETE_TYPE});
     axios.delete('kontos/Aktivitet/type/delete', {
      method: 'DELETE',
      data: {
        Afid:Afid,
        delItem:delItem,
        userid:userid
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("onDeleteAktivitetType: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_AKTIVITETE_TYPE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DELETE_AKTIVITETE_TYPE, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_AKTIVITETE_TYPE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//onUpdateAktivitetType
export const onUpdateAktivitetType = (Afid,userid,EdItem) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_UPDATE_AKTIVITETE_TYPE});
     axios.put('kontos/Aktivitet/type/update', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        EdItem:EdItem
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("UpdateEventStatus: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_UPDATE_AKTIVITETE_TYPE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_UPDATE_AKTIVITETE_TYPE, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_AKTIVITETE_TYPE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //SaveNewOrderStatus
export const SaveNewEventStatus = ( userid, Afid,newStatus) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_NEW_EVENT_STATUS});
     axios.put('kontos/Event/Status/new', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        newStatus:newStatus
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("SaveNewEventStatus: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_NEW_EVENT_STATUS, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_EVENT_STATUS, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_EVENT_STATUS, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
  //getEventStatusListbyAfid
export const getEventStatusListbyAfid = (Afid) =>{
  // const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      dispatch({type: ON_START_GET_EVENT_STATUS});
      axios.get('kontos/Event/Status/get',
      { params:{Afid:Afid}, 
     //  headers: { 'Authorization': `Bearer ${jwt}`} 
     }      
       ).then(({data}) => {
        console.log("getEventStatusListbyAfid: ", data);
         if (data.results) {
          // dispatch({type: FETCH_ALL_CONTACT});
           dispatch({type: ON_GET_EVENT_STATUS, payload: data.results});
         } else {
           dispatch({type: ON_ERROR_EVENT_STATUS, payload: data.error});
         }
       }).catch(function (error) {
         dispatch({type: ON_ERROR_EVENT_STATUS, payload: error.message});
            if(!isUndefined(error.response)){
         if (error.response.status === 401) {
           dispatch({type: FETCH_START_SET_UNAUTHE});
          } 
        } 
         if(error.message === "Network Error"){
            //reload and remove token 
            //dispatch(userSignOut())
         } 
       });
    } /**/
  }
  //deleteEventStatus
export const deleteEventStatus = ( Afid,userid,delStatus) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_EVENT_STATUS});
     axios.delete('kontos/Event/Status/delete', {
      method: 'DELETE',
      data: {
        Afid:Afid,
        delStatus:delStatus,
        userid:userid
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("deleteEventStatus: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_EVENT_STATUS, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DELETE_EVENT_STATUS, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_EVENT_STATUS, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //UpdateEventStatus
 export const UpdateEventStatus = (Afid,userid,EdStatus) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_UPDATE_EVENT_STATUS});
     axios.put('kontos/Event/Status/update', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        EdStatus:EdStatus
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("UpdateEventStatus: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_UPDATE_EVENT_STATUS, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_UPDATE_EVENT_STATUS, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_EVENT_STATUS, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //getAfidFormula
 export const getAfidFormula = (Afid) =>{
   const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      dispatch({type: ON_START_GET_AVTALFORMULA});
      axios.get('kontos/Af/Formula',
      { params:{Afid:Afid}, 
       headers: { 'Authorization': `Bearer ${jwt}`} 
     }      
       ).then(({data}) => {
        console.log("getAfidFormula: ", data);
         if (data.results) {
          // dispatch({type: FETCH_ALL_CONTACT});
           dispatch({type: ON_GET_AVTALFORMULA, payload: data.results});
         } else {
           dispatch({type: ON_ERROR_AVTALFORMULA, payload: data.error});
         }
       }).catch(function (error) {
         dispatch({type: ON_ERROR_AVTALFORMULA, payload: error.message});
            if(!isUndefined(error.response)){
         if (error.response.status === 401) {
           dispatch({type: FETCH_START_SET_UNAUTHE});
          } 
        } 
         if(error.message === "Network Error"){
            //reload and remove token 
            //dispatch(userSignOut())
         } 
       });
    } /**/
  }
//onSaveNewFormula
export const onSaveNewFormula = (Afid,TextArr) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_UPDATE_AVTALFORMULA});
     axios.put('kontos/Af/Formula/update', {
      method: 'PUT',
      body: {
        TextArr:TextArr,
        Afid:Afid
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("UpdateEventStatus: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_UPDATE_AVTALFORMULA, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_UPDATE_AVTALFORMULA, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_AVTALFORMULA, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
 }
 export const getAFBudgetWorkDays = (userid,Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
   const ipAdress ='0.0.0.0'
  //  dispatch({type: FETCH_START});
    axios.get('kontos/BudgetWorkDays', { params:{userid:userid,Afid:Afid,ipAdress}, 
    headers: { 'Authorization': `Bearer ${jwt}`} }
    ).then(({data}) => {
      console.log("getUserBudget: ", data);
      if (data.success) {
        dispatch({type: GET_AF_BUDGET_WORK_DAYS, payload: data.results[0]});
      } else {
        // dispatch({type: FETCH_ERROR, payload: data.error});
      }
    }).catch(function (error) {
      // dispatch({type: FETCH_ERROR, payload: error.message});
         if(!isUndefined(error.response)){
      if (error.response.status === 401) {
        dispatch({type: FETCH_START_SET_UNAUTHE});
       } 
     } 
     if(error.message === "Network Error"){
        //reload and remove token 
        dispatch(userSignOut())
     } 
    }); 
  }
}
//update user Budget 
export const updateAFBudgetWorkDays = (userid,Afid,CBudget,UpdateUsers=0) => {
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress ='0.0.0.0'
    // dispatch({type: FETCH_START});
    axios.put('kontos/BudgetWorkDays', 
      {
        body: {
          userid: userid,
          Afid: Afid,
          CBudget:CBudget,ipAdress,UpdateUsers
        }
    },{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }}).then(({data}) => {
      console.log("getUserBudget: ", data.message);
      if (data.success) {
        // dispatch({type: FETCH_SUCCESS});
        dispatch({type: GET_AF_BUDGET_WORK_DAYS, payload: data.Budget});
      } else {
        // dispatch({type: FETCH_ERROR, payload: data.error});
      }
    }).catch(function (error) {
      // dispatch({type: FETCH_ERROR, payload: error.message});
         if(!isUndefined(error.response)){
      if (error.response.status === 401) {
        dispatch({type: FETCH_START_SET_UNAUTHE});
       } 
     } 
     if(error.message === "Network Error"){
        //reload and remove token 
        dispatch(userSignOut())
     } 
    });
  }
};
//checkFortNoxKundName
export const checkFortNoxKundName = (Afid,userid,Kundname) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_CHECK_FORTNOX_KUNDNAME});
    axios.put('kontos/Fortnox/check/KundName', {
     method: 'PUT',
     body: {
       userid:userid,
       Afid:Afid,
       Kundname
     }      
 }, {
  headers: {
    'content-type': 'application/json',
    'Authorization':   `Bearer ${jwt}`
  } 
 }).then(({data}) => {
     console.log("checkFortNoxKundName: ", data);
      if (data.results) {
       // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({type: ON_GET_CHECK_FORTNOX_KUNDNAME, payload: data.results});
      } else {
        dispatch({type: ON_ERROR_GET_CHECK_FORTNOX_KUNDNAME, payload: data.message});
      }
    }).catch(function (error) {
      dispatch({type: ON_ERROR_GET_CHECK_FORTNOX_KUNDNAME, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
      if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      } 
    });
  }
}
//checkFortNoxKundName1
export const checkFortNoxKundName1 = (Afid,userid,Kundname) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_CHECK_FORTNOX_KUNDNAME1});
    axios.put('kontos/Fortnox/check/KundName', {
     method: 'PUT',
     body: {
       userid:userid,
       Afid:Afid,
       Kundname
     }      
 }, {
  headers: {
    'content-type': 'application/json',
    'Authorization':   `Bearer ${jwt}`
  } 
 }).then(({data}) => {
     console.log("checkFortNoxKundName: ", data);
      if (data.results) {
       // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({type: ON_GET_CHECK_FORTNOX_KUNDNAME1, payload: data.results});
      } else {
        dispatch({type: ON_ERROR_GET_CHECK_FORTNOX_KUNDNAME1, payload: data.message});
      }
    }).catch(function (error) {
      dispatch({type: ON_ERROR_GET_CHECK_FORTNOX_KUNDNAME1, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
      if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      } 
    });
  }
}
//onAddNewTypAvAffar
export const onAddNewTypAvAffar= (Afid,userid,Name) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_SAVE_NEW_TYP_AV_AFFAR});
     axios.put('kontos/Avtals/typAvAffar', {
      method: 'PUT',
      body: {
        Afid:Afid,
        userid:userid,
        Name:Name
      }
    }, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("onAddNewPlista: ", data);
       if (data.results) {
         dispatch({type: ON_SAVE_NEW_TYP_AV_AFFAR, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_SAVE_NEW_TYP_AV_AFFAR, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SAVE_NEW_TYP_AV_AFFAR, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
}
//getTypAvAffar
export const getTypAvAffar = (Afid) =>{
  // const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      dispatch({type: ON_START_GET_TYP_AV_AFFAR});
      axios.get('kontos/Avtals/typAvAffar',
      { params:{Afid:Afid}, 
     //  headers: { 'Authorization': `Bearer ${jwt}`} 
     }      
       ).then(({data}) => {
        console.log("getTypAvAffar: ", data);
         if (data.results) {
          // dispatch({type: FETCH_ALL_CONTACT});
           dispatch({type: ON_GET_TYP_AV_AFFAR, payload: data.results});
         } else {
           dispatch({type: ON_ERROR_GET_TYP_AV_AFFAR, payload: data.error});
         }
       }).catch(function (error) {
         dispatch({type: ON_ERROR_GET_TYP_AV_AFFAR, payload: error.message});
            if(!isUndefined(error.response)){
         if (error.response.status === 401) {
           dispatch({type: FETCH_START_SET_UNAUTHE});
          } 
        } 
         if(error.message === "Network Error"){
            //reload and remove token 
            //dispatch(userSignOut())
         } 
       });
    } /**/
  }
  //onDeleteTypAvAffar
  export const onDeleteTypAvAffar = ( Afid,userid,delStatus) =>{
    const jwt =  JSON.parse(localStorage.token);
     return (dispatch) => {
       dispatch({type: ON_START_DELETE_TYP_AV_AFFAR});
       axios.delete('kontos/Avtals/typAvAffar', {
        method: 'DELETE',
        data: {
          Afid:Afid,
          delStatus:delStatus,
          userid:userid
        },
        headers: {
            'content-type': 'application/json',
            'Authorization':   `Bearer ${jwt}`
        }       
    }).then(({data}) => {
        console.log("onDeleteTypAvAffar: ", data);
         if (data.results) {
          // dispatch({type: FETCH_ALL_CONTACT});
           dispatch({type: ON_DELETE_TYP_AV_AFFAR, payload: data.results});
         } else {
           dispatch({type: ON_ERROR_DELETE_TYP_AV_AFFAR, payload: data.error});
         }
       }).catch(function (error) {
         dispatch({type: ON_ERROR_DELETE_TYP_AV_AFFAR, payload: error.message});
            if(!isUndefined(error.response)){
          if (error.response.status === 401) {
            dispatch({type: FETCH_START_SET_UNAUTHE});
           } 
         } 
         if(error.message === "Network Error"){
            //reload and remove token 
            //dispatch(userSignOut())
         } 
       });
     }
   }
   
//getFakturaIntervallbyAfid
export const getFakturaIntervallbyAfid = (Afid) =>{
  // const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      dispatch({type: ON_START_GET_FAKTURA_INTERVALL_AFID});
      axios.get('kontos/FakturaIntervall',
      { params:{Afid:Afid}, 
     //  headers: { 'Authorization': `Bearer ${jwt}`} 
     }      
       ).then(({data}) => {
        console.log("getTypAvAffar: ", data);
         if (data.results) {
          // dispatch({type: FETCH_ALL_CONTACT});
           dispatch({type: ON_GET_FAKTURA_INTERVALL_AFID, payload: data.results});
         } else {
           dispatch({type: ON_ERROR_GET_FAKTURA_INTERVALL_AFID, payload: data.error});
         }
       }).catch(function (error) {
         dispatch({type: ON_ERROR_GET_FAKTURA_INTERVALL_AFID, payload: error.message});
            if(!isUndefined(error.response)){
         if (error.response.status === 401) {
           dispatch({type: FETCH_START_SET_UNAUTHE});
          } 
        } 
         if(error.message === "Network Error"){
            //reload and remove token 
            //dispatch(userSignOut())
         } 
       });
    } /**/
  }
export const hasNoGoogleAds = ()=>{
  return async (dispatch) => {
    dispatch({type: ON_START_GET_ADS});
  }
}  
//onGetgooglAds
export const onGetgooglAds = (Afid,Orgnr,KundName="") =>{
   const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      dispatch({type: ON_START_GET_ADS});
      axios.get('kontos/Kund/Ads',
      { params:{Orgnr:Orgnr,Afid:Afid,KundName:KundName}, 
       headers: { 'Authorization': `Bearer ${jwt}`} 
     }      
       ).then(({data}) => {
        console.log("getTypAvAffar: ", data);
         if (data.results) {
          // dispatch({type: FETCH_ALL_CONTACT});
           dispatch({type: ON_GET_ADS, payload: data.results});
         } else {
           dispatch({type: ON_ERROR_GET_ADS, payload: data.error});
         }
       }).catch(function (error) {
         dispatch({type: ON_ERROR_GET_ADS, payload: error.message});
            if(!isUndefined(error.response)){
         if (error.response.status === 401) {
           dispatch({type: FETCH_START_SET_UNAUTHE});
          } 
        } 
         if(error.message === "Network Error"){
            //reload and remove token 
            //dispatch(userSignOut())
         } 
       });
  } /**/
}

export const onGetFaceBookAds = (Afid,Orgnr,KundName="") =>{
   const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      dispatch({type: ON_START_GET_FBADS});
      axios.get('kontos/Kund/FBAds',
      { params:{Orgnr:Orgnr,Afid:Afid,KundName:KundName}, 
       headers: { 'Authorization': `Bearer ${jwt}`} 
     }      
       ).then(({data}) => {
        console.log("getTypAvAffar: ", data);
         if (data.results) {
          // dispatch({type: FETCH_ALL_CONTACT});
           dispatch({type: ON_GET_FBADS, payload: data.results});
         } else {
           dispatch({type: ON_ERROR_GET_FBADS, payload: data.error});
         }
       }).catch(function (error) {
         dispatch({type: ON_ERROR_GET_FBADS, payload: error.message});
            if(!isUndefined(error.response)){
         if (error.response.status === 401) {
           dispatch({type: FETCH_START_SET_UNAUTHE});
          } 
        } 
         if(error.message === "Network Error"){
            //reload and remove token 
            //dispatch(userSignOut())
         } 
       });
  }
}
function getMimeTypeFromBlob(fileExtension) {
  // Define a map of common file extensions to MIME types
  const mimeTypes = {
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    gif: 'image/gif',
    pdf: 'application/pdf',
    // Add more mappings as needed
  };
  console.log(fileExtension)
  // Look up the MIME type based on the file extension
  const mimeType = mimeTypes[fileExtension.toLowerCase()] || 'application/octet-stream'; // Default to binary data

  return mimeType;
}
export const getThisFileUrlWithoutSave = (Afid,userid,Url,fileName) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_DOWN_FILE_NO_SAVE});
    axios.get('kontos/File/Attach/get',
    { params:{
      Afid:Afid,
      userid:userid,
      Url:Url,
      ipAdress
    },
    responseType: 'arraybuffer' , 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then((resp) => {
      let result = {}
      if(Url.slice((Url.lastIndexOf(".") - 1 >>> 0) + 2).toUpperCase() === 'PDF'){
        var blob = new Blob([resp.data], {type: 'application/pdf'});
        result = {
         fileBlod:blob,
         Url:Url,
         fileName:fileName
       }
      }else{
        const mimeType = getMimeTypeFromBlob(Url.slice((Url.lastIndexOf(".") - 1 >>> 0) + 2));
        var blob = new Blob([resp.data], {type: mimeType});
        result = {
         fileBlod:blob,
         Url:Url,
         fileName:fileName
       }
      }
     
     //console.log(blob)
     //fileSaver.saveAs(blob, fileName);
     dispatch({type: ON_GET_DOWN_FILE_NO_SAVE,payload: result})
     
     //window.open('/app/file', '_blank')

     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_DOWN_FILE_NO_SAVE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}  

export const onAktiveThisTypeAvAffar= (Afid,userid,state) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_AKTIVE_TYP_AV_AFFAR});
     axios.put('kontos/Avtals/typAvAffar/active', {
      method: 'PUT',
      body: {
        Afid:Afid,
        userid:userid,
        state:state
      }
    }, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("onAddNewPlista: ", data);
       if (data.results) {
         dispatch({type: ON_AKTIVE_TYP_AV_AFFAR, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_AKTIVE_TYP_AV_AFFAR, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_AKTIVE_TYP_AV_AFFAR, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
}
export const onInAktiveThisTypeAvAffar= (Afid,userid,state) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_AKTIVE_TYP_AV_AFFAR});
     axios.put('kontos/Avtals/typAvAffar/Inactive', {
      method: 'PUT',
      body: {
        Afid:Afid,
        userid:userid,
        state:state
      }}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("onAddNewPlista: ", data);
       if (data.results) {
         dispatch({type: ON_AKTIVE_TYP_AV_AFFAR, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_AKTIVE_TYP_AV_AFFAR, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_AKTIVE_TYP_AV_AFFAR, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
}
//onGetKundDataValitive
export const onGetKundDataValitive = (Orgnr) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_GET_VALITIVE});
     dispatch({type: ON_START_GET_ADS});
     axios.get('kontos/Kund/Valitive/get',
     { params:{Orgnr:Orgnr}, 
      headers: { 'Authorization': `Bearer ${jwt}`} 
    }      
      ).then(({data}) => {
       console.log("onGetKundDataValitive: ", data);
        if (data) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_GET_VALITIVE, payload: data});
        } else {
          dispatch({type: ON_ERROR_GET_VALITIVE, payload: data.error});
        }
      }).catch(function (error) {
        dispatch({type: ON_ERROR_GET_VALITIVE, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
        if(error.message === "Network Error"){
        } 
      });
 } /**/
}
export const onGetKundDataIper = (OwnerID,callBackFunc) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     axios.get('kontos/Kund/iper/get',
     { params:{OwnerID:OwnerID}, 
      headers: { 'Authorization': `Bearer ${jwt}`} 
    }      
      ).then(({data}) => {
       console.log("onGetKundDataValitive: ", data);
        if (data) {
          callBackFunc(data.results)
         // dispatch({type: FETCH_ALL_CONTACT});
        } else {
          console.log(data.error)
        }
      }).catch(function (error) {
        console.log(error.message)
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
        if(error.message === "Network Error"){
        } 
      });
 } /**/
}
//getAvtalUpdatedKalkyl
export const getAvtalUpdatedKalkyl = (Afid,userid,Orgnr,avtalId) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_GET_UPDATED_AVTAL_KALKYL});
     axios.get('kontos/Avtal/kalkyl/get',
     { params:{
      Orgnr:Orgnr,
      Afid:Afid,
      userid:userid,
      avtalId:avtalId,
    }, 
      headers: { 'Authorization': `Bearer ${jwt}`} 
    }      
      ).then(({data}) => {
       console.log("onGetKundDataValitive: ", data);
        if (data) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_GET_UPDATED_AVTAL_KALKYL, payload: data});
        } else {
          dispatch({type: ON_ERROR_GET_UPDATED_AVTAL_KALKYL, payload: data.error});
        }
      }).catch(function (error) {
        dispatch({type: ON_ERROR_GET_UPDATED_AVTAL_KALKYL, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
        if(error.message === "Network Error"){
        } 
      });
 } /**/
}
//getMinaImporteradRinglistor
export const getMinaImporteradRinglistor = (Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_GET_IMPORTERAD_RINGLISTOR});
     axios.get('kontos/ringlistor/getImported',
     { params:{Afid:Afid}, 
      headers: { 'Authorization': `Bearer ${jwt}`} 
    }      
      ).then(({data}) => {
       console.log("getTypAvAffar: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_GET_IMPORTERAD_RINGLISTOR, payload: data.results});
        } else {
          dispatch({type: ON_ERROR_GET_IMPORTERAD_RINGLISTOR, payload: data.error});
        }
      }).catch(function (error) {
        dispatch({type: ON_ERROR_GET_IMPORTERAD_RINGLISTOR, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
        if(error.message === "Network Error"){
           //reload and remove token 
           //dispatch(userSignOut())
        } 
      });
 }
}
//getArticleType
export const getArendeCategori = (Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_CATE_ARENDE_AFID});
     axios.get('kontos/arende/freeInputs/type/get',
     { params:{
      Afid:Afid
      }, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getArticleType: ", data);
       if (data.results) {
         dispatch({type: ON_GE_CATE_ARENDE_AFID, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_CATE_ARENDE_AFID, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_CATE_ARENDE_AFID, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
}
//onSaveNewArendeCate
export const onSaveNewArendeCate = (Afid,userid,newTypeObj) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_SAVE_NEW_CATE_ARENDE});
     axios.put('kontos/arende/freeInputs/newType', {
      method: 'PUT',
      body: {
        Afid:Afid,
        userid:userid,
        newTypeObj:newTypeObj
      },
			}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
			}).then(({data}) => {
      console.log("onSaveNewArticleType: ", data);
       if (data.results) {
         dispatch({type: ON_SAVE_SAVE_NEW_CATE_ARENDE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_SAVE_NEW_CATE_ARENDE, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SAVE_NEW_CATE_ARENDE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
 }
 //onchangeArendeCatNameByAfid
 export const onchangeArendeCatNameByAfid = (Afid,userid,Typ,NewName) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_SAVE_NEW_CATE_ARENDE});
     axios.put('kontos/arende/freeInputs/updateType', {
      method: 'PUT',
      body: {
        Afid:Afid,
        userid:userid,
        Typ:Typ,
        NewName:NewName,
      }
    }, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("onchangeArendeCatNameByAfid: ", data);
       if (data.results) {
         dispatch({type: ON_SAVE_SAVE_NEW_CATE_ARENDE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_SAVE_NEW_CATE_ARENDE, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SAVE_NEW_CATE_ARENDE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
 }
 //onDeleteArendeCatName
 export const onDeleteArendeCatName = (Afid,userid,DelTyp) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    //,invitationM,
      //invitationM:invitationM,
    dispatch({type: ON_START_SAVE_NEW_CATE_ARENDE});
    axios.delete('kontos/arende/freeInputs/delete',
    {
    method: 'DELETE',
    params:{
      Afid:Afid,
      userid:userid,
      DelTyp:DelTyp,
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`}   }
     ).then(({data}) => {
      console.log("onDeleteArendeCatName: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_SAVE_NEW_CATE_ARENDE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_SAVE_NEW_CATE_ARENDE, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SAVE_NEW_CATE_ARENDE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){ } 
     });
  }
}
//getArendeCateFreeInputs
export const getArendeCateFreeInputs = (Afid,TypName) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_FREEINPUT_ARENDE_AFID});
     axios.get('kontos/arende/freeInputs/freeInput/get',
     { params:{
      Afid:Afid,
      TypName:TypName
      }, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getArendeCateFreeInputs: ", data);
       if (data.results) {
         dispatch({type: ON_GET_FREEINPUT_ARENDE_AFID, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_FREEINPUT_ARENDE_AFID, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FREEINPUT_ARENDE_AFID, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
}
//onSaveArendeCateNewFreeInput
export const onSaveArendeCateNewFreeInput = (Afid,userid,newFalt) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_SAVE_NEW_ARENDE_CATE_FREEINPUT});
     axios.put('kontos/arende/freeInputs/freeInput/new', {
      method: 'PUT',
      body: {
        Afid:Afid,
        userid:userid,
        newFalt:newFalt,
      },
			}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
			}).then(({data}) => {
      console.log("onSaveArendeCateNewFreeInput: ", data);
       if (data.results) {
         dispatch({type: ON_SAVE_NEW_NEW_ARENDE_CATE_FREEINPUT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_SAVE_NEW_ARENDE_CATE_FREEINPUT, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SAVE_NEW_ARENDE_CATE_FREEINPUT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
 }
 //onUpdateArendeCateFreeInput
 export const onUpdateArendeCateFreeInput = (Afid,userid,newFalt) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_SAVE_NEW_ARENDE_CATE_FREEINPUT});
     axios.put('kontos/arende/freeInputs/freeInput/Update', {
      method: 'PUT',
      body: {
        Afid:Afid,
        userid:userid,
        newFalt:newFalt,
      },
			},{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
			}).then(({data}) => {
      console.log("onUpdateArendeCateFreeInput: ", data);
       if (data.results) {
         dispatch({type: ON_SAVE_NEW_NEW_ARENDE_CATE_FREEINPUT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_SAVE_NEW_ARENDE_CATE_FREEINPUT, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SAVE_NEW_ARENDE_CATE_FREEINPUT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
 }
//ondeleteArendeCateFreeInput
export const ondeleteArendeCateFreeInput = (Afid,userid,FreeInput) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    //,invitationM,
      //invitationM:invitationM,
    dispatch({type: ON_START_SAVE_NEW_ARENDE_CATE_FREEINPUT});
    axios.delete('kontos/arende/freeInputs/freeInput/delete',
    {
    method: 'DELETE',
    params:{
      Afid:Afid,
      userid:userid,
      FreeInput:FreeInput,
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`}   }
     ).then(({data}) => {
      console.log("onDeleteArticleType: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_ARENDE_CATE_FREEINPUT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_SAVE_NEW_ARENDE_CATE_FREEINPUT, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SAVE_NEW_ARENDE_CATE_FREEINPUT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){ } 
     });
  }
}
//getKontoArendeFriaFalt
export const getKontoArendeFriaFalt = (Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_FI_AFID_ARENDE});
     axios.get('kontos/arende/freeInputs/All/get',
     { params:{
      Afid:Afid
      }, 
      headers: { 'Authorization': `Bearer ${jwt}`} }      
      ).then(({data}) => {
      console.log("getArticleType: ", data);
       if (data.results) {
         dispatch({type: ON_GET_FI_AFID_ARENDE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_FI_AFID_ARENDE, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FI_AFID_ARENDE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
}
//onSaveNewTeam
export const onSaveNewTeam = (Team,userid,Afid) => {
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: FETCH_START});
    const formData = new FormData()

    formData.append('Team', JSON.stringify(Team))
    formData.append('userid', userid)
    formData.append('Afid', Afid)
    formData.append('files[]', Team.file)


    axios.put('kontos/Team/new', 
    formData,
    {
      method: 'PUT',
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      },
      body: {
        Team: JSON.stringify(Team),
        userid:userid,
        Afid:Afid
      }
    }
  )
  .then(({data}) => {
    console.log("data:", data);
    dispatch({type: ON_SAVE_NEW_TEAM, payload: data});
    //dispatch(RefreshUserInterface(userid))
  }).catch(function (error) {
    dispatch({type: FETCH_ACCOUNT_ERROR, payload: error.message});
       if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
  });
  }
}
//onDeleteTeam
export const onDeleteTeam = (Team,userid,Afid) => {
  console.log("asd",Team)
  const jwt =  JSON.parse(localStorage.token);
       return (dispatch) => {
      dispatch({type: FETCH_START});
      axios.delete('kontos/Team/delete', {
        method: 'DELETE',
        data: {
          body:JSON.stringify(Team),
          userid:userid,
          Afid:Afid
        },
        headers: {
            'content-type': 'application/json',
            'Authorization':   `Bearer ${jwt}`
        }       
    }).then(({data}) => {
      console.log("onDeleteTeam: ", data.message);
      if (data.success) {
        console.log(data);
        dispatch({type: FETCH_SUCCESS});
        dispatch({type: ON_DELETE_TEAM, payload: data});
        //dispatch(RefreshUserInterface(userid))
      } else {
        dispatch({type: FETCH_ACCOUNT_ERROR, payload: data.error});
      }
    })
    .catch(function (error) {
      dispatch({type: FETCH_ACCOUNT_ERROR, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
    });
    }
}
//onEditTeam
export const onEditTeam = (Team,userid,Afid) => {
  const jwt =  JSON.parse(localStorage.token);
       return (dispatch) => {
      dispatch({type: FETCH_START});

      const formData = new FormData()
  
      formData.append('Team', JSON.stringify(Team))
      formData.append('userid', userid)
      formData.append('Afid', Afid)
      formData.append('files[]', Team.file)

      axios.put('kontos/Team/edit', 
        formData,
        {
          method: 'PUT',
          body: {
            body:JSON.stringify(Team),
            userid:userid,
            Afid:Afid
          },
          headers: {
              'content-type': 'application/json',
              'Authorization':   `Bearer ${jwt}`
          }     
        }
    ).then(({data}) => {
      console.log("onEditTeam: ", data.message);
      if (data.success) {
        console.log(data);
        dispatch({type: FETCH_SUCCESS});
        dispatch({type: ON_EDIT_TEAM, payload: data});
        //dispatch(RefreshUserInterface(userid))
      } else {
        dispatch({type: FETCH_ACCOUNT_ERROR, payload: data.error});
      }
    })
    .catch(function (error) {
      dispatch({type: FETCH_ACCOUNT_ERROR, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
    });
    }
}

export const AddnewProjectFasView= ( userid, Afid,FasView) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_NEW_PROJEKT_FAS_VIEW});
     axios.put('kontos/ProjectFasView/new', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        FasView:FasView
      },
           
  },{
    headers: {
      'content-type': 'application/json',
      'Authorization':   `Bearer ${jwt}`
  }  
  }).then(({data}) => {
      console.log("AddnewProjectFasView: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_NEW_PROJEKT_FAS_VIEW, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_NEW_PROJEKT_FAS_VIEW, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_NEW_PROJEKT_FAS_VIEW, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }


export const deletProjectFasView = ( userid, Afid,deletedtype) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_PROJEKT_FAS_VIEW});
     axios.delete('kontos/ProjectFasView/delete', {
      method: 'DELETE',
      data: {
        userid:userid,
        Afid:Afid,
        deletedtype:deletedtype
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("deletProjectFasView: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_PROJEKT_FAS_VIEW, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DELETE_PROJEKT_FAS_VIEW, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_PROJEKT_FAS_VIEW, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
  export const UpdateProjectFasView = ( userid, Afid,FasView) =>{
    const jwt =  JSON.parse(localStorage.token);
     return (dispatch) => {
       dispatch({type: ON_START_UPDATE_PROJEKT_FAS_VIEW});
       axios.put('kontos/ProjectFasView/update', {
        method: 'PUT',
        body: {
          userid:userid,
          Afid:Afid,
          FasView:FasView
        },
             
    },{
      headers: {
        'content-type': 'application/json',
        'Authorization':   `Bearer ${jwt}`
    } 
    }).then(({data}) => {
        console.log("UpdateProjectFasView: ", data);
         if (data.results) {
           dispatch({type: ON_UPDATE_PROJEKT_FAS_VIEW, payload: data.results});
         } else {
           dispatch({type: ON_ERROR_UPDATE_PROJEKT_FAS_VIEW, payload: data.error});
         }
         //dispatch(RefreshUserInterface(userid))
       }).catch(function (error) {
         dispatch({type: ON_ERROR_UPDATE_PROJEKT_FAS_VIEW, payload: error.message});
            if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
       });
     }
   }



   export const getWoocommerceWebhooks = (Afid) =>{
    const jwt =  JSON.parse(localStorage.token);
      return async (dispatch) => {
        dispatch({type: ON_START_GET_WOOCOMMERCE_WEBHOOK});
        axios.get('kontos/Woocommerce/webhook',
        { params:{Afid:Afid}, 
        headers: { 'Authorization': `Bearer ${jwt}`} 
       }      
         ).then(({data}) => {
          console.log("getWoocommerceWebhooks: ", data);
           if (data.results) {
            // dispatch({type: FETCH_ALL_CONTACT});
             dispatch({type: ON_GET_WOOCOMMERCE_WEBHOOK, payload: data.results});
           } else {
             dispatch({type: ON_ERROR_GET_WOOCOMMERCE_WEBHOOK, payload: data.error});
           }
         }).catch(function (error) {
           dispatch({type: ON_ERROR_GET_WOOCOMMERCE_WEBHOOK, payload: error.message});
              if(!isUndefined(error.response)){
           if (error.response.status === 401) {
             dispatch({type: FETCH_START_SET_UNAUTHE});
            } 
          } 
           if(error.message === "Network Error"){
              //reload and remove token 
              //dispatch(userSignOut())
           } 
         });
      } /**/
    }
    
   export const getValidRestApiToken = (Afid, userid) =>{
    const jwt =  JSON.parse(localStorage.token);
      return async (dispatch) => {
        dispatch({type: ON_START_FETCH_VALID_REST_API_TOKEN});
        axios.get('kontos/RestApi/validToken',
        { params:{Afid:Afid, userid}, 
        headers: { 'Authorization': `Bearer ${jwt}`} 
       }      
         ).then(({data}) => {
          console.log("getValidRestApiToken: ", data);
           if (data.results) {
            // dispatch({type: FETCH_ALL_CONTACT});
             dispatch({type: ON_FETCH_VALID_REST_API_TOKEN, payload: data.results});
           } else {
             dispatch({type: ON_ERROR_FETCH_VALID_REST_API_TOKEN, payload: data.error});
           }
         }).catch(function (error) {
           dispatch({type: ON_ERROR_FETCH_VALID_REST_API_TOKEN, payload: error.message});
              if(!isUndefined(error.response)){
           if (error.response.status === 401) {
             dispatch({type: FETCH_START_SET_UNAUTHE});
            } 
          } 
           if(error.message === "Network Error"){
              //reload and remove token 
              //dispatch(userSignOut())
           } 
         });
      } /**/
    }
    
   export const fetchWpWebhook = (Userid, Afid, topic) =>{
    const jwt =  JSON.parse(localStorage.token);
      return async (dispatch) => {
        dispatch({type: ON_START_FETCH_WP_WOOCOMMERCE_WEBHOOK});
        axios.get('kontos/wp/webhook/fetch',
        { params:{Userid, Afid, topic}, 
        headers: { 'Authorization': `Bearer ${jwt}`} 
       }      
         ).then(({data}) => {
          console.log("fetchWpWebhook: ", data);
           if (data.results) {
            // dispatch({type: FETCH_ALL_CONTACT});
             dispatch({type: ON_FETCH_WP_WOOCOMMERCE_WEBHOOK, payload: data.results});
           } else {
             dispatch({type: ON_ERROR_FETCH_WP_WOOCOMMERCE_WEBHOOK, payload: data.error});
           }
         }).catch(function (error) {
           dispatch({type: ON_ERROR_FETCH_WP_WOOCOMMERCE_WEBHOOK, payload: error.message});
              if(!isUndefined(error.response)){
           if (error.response.status === 401) {
             dispatch({type: FETCH_START_SET_UNAUTHE});
            } 
          } 
           if(error.message === "Network Error"){
              //reload and remove token 
              //dispatch(userSignOut())
           } 
         });
      } /**/
    }

    export const addWoocommerceWebhooks = (Afid, name, type) =>{
      const jwt =  JSON.parse(localStorage.token);
       return (dispatch) => {
         dispatch({type: ON_START_ADD_WOOCOMMERCE_WEBHOOK});
         axios.post('kontos/Woocommerce/webhook', {
          body: {
            Afid, name, type
          },
               
      },{
        headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      } 
      }).then(({data}) => {
          console.log("addWoocommerceWebhooks: ", data);
           if (data.results) {
             dispatch({type: ON_ADD_WOOCOMMERCE_WEBHOOK, payload: data.results});
           } else {
             dispatch({type: ON_ERROR_ADD_WOOCOMMERCE_WEBHOOK, payload: data.error});
           }
           //dispatch(RefreshUserInterface(userid))
         }).catch(function (error) {
           dispatch({type: ON_ERROR_ADD_WOOCOMMERCE_WEBHOOK, payload: error.message});
              if(!isUndefined(error.response)){
          if (error.response.status === 401) {
            dispatch({type: FETCH_START_SET_UNAUTHE});
           } 
         } 
         if(error.message === "Network Error"){
            //reload and remove token 
            //dispatch(userSignOut())
         } 
         });
       }
     }
     export const deleteWoocommerceWebhook = (Afid, webhookid) =>{
      const jwt =  JSON.parse(localStorage.token);
        return async (dispatch) => {
          dispatch({type: ON_START_DELETE_WOOCOMMERCE_WEBHOOK});
          axios.delete('kontos/Woocommerce/webhook',
          { params:{Afid, webhookid}, 
          headers: { 'Authorization': `Bearer ${jwt}`} 
         }      
           ).then(({data}) => {
            console.log("getWoocommerceWebhooks: ", data);
             if (data.results) {
              // dispatch({type: FETCH_ALL_CONTACT});
               dispatch({type: ON_DELETE_WOOCOMMERCE_WEBHOOK, payload: data.results});
             } else {
               dispatch({type: ON_ERROR_DELETE_WOOCOMMERCE_WEBHOOK, payload: data.error});
             }
           }).catch(function (error) {
             dispatch({type: ON_ERROR_DELETE_WOOCOMMERCE_WEBHOOK, payload: error.message});
                if(!isUndefined(error.response)){
             if (error.response.status === 401) {
               dispatch({type: FETCH_START_SET_UNAUTHE});
              } 
            } 
             if(error.message === "Network Error"){
                //reload and remove token 
                //dispatch(userSignOut())
             } 
           });
        } /**/
      }
export const onGetUsingStorage = (Afid)=>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_GET_KONTO_STORAGE});
    axios.get('kontos/Storage/get',
    { params:{Afid:Afid}, 
    headers: { 'Authorization': `Bearer ${jwt}`} 
   }      
     ).then(({data}) => {
      console.log("onGetUsingStorage: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_KONTO_STORAGE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_KONTO_STORAGE, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_KONTO_STORAGE, payload: error.message});
          if(!isUndefined(error.response)){
       if (error.response.status === 401) {
         dispatch({type: FETCH_START_SET_UNAUTHE});
        } 
      } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  } /**/
}


export const addSendgridAuthDomain = (Afid, Domain) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_ADD_AUTH_MAIL_DOMAIN});
     axios.post('kontos/SendGridAuth/add', {
      body: {
        Afid, Domain
      },
           
  },{
    headers: {
      'content-type': 'application/json',
      'Authorization':   `Bearer ${jwt}`
  } 
  }).then(({data}) => {
      console.log("addSendgridAuthDomain: ", data);
       if (data.results) {
         dispatch({type: ON_ADD_AUTH_MAIL_DOMAIN, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_ADD_AUTH_MAIL_DOMAIN, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_ADD_AUTH_MAIL_DOMAIN, payload: error.message});
          if(!isUndefined(error.response)){
      if (error.response.status === 401) {
        dispatch({type: FETCH_START_SET_UNAUTHE});
       } 
     } 
     if(error.message === "Network Error"){
        //reload and remove token 
        //dispatch(userSignOut())
     } 
     });
   }
 }
 
//  ON_VALIDATE_AUTH_MAIL_DOMAIN,
//  ON_ERROR_VALIDATE_AUTH_MAIL_DOMAIN,
//  ON_START_VALIDATE_AUTH_MAIL_DOMAIN,
export const validateSendgridAuthDomain = (Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_VALIDATE_AUTH_MAIL_DOMAIN});
     axios.post('kontos/SendGridAuth/validate', {
      body: {
        Afid
      },
           
  },{
    headers: {
      'content-type': 'application/json',
      'Authorization':   `Bearer ${jwt}`
  } 
  }).then(({data}) => {
      console.log("addSendgridAuthDomain: ", data);
       if (data.results) {
         dispatch({type: ON_VALIDATE_AUTH_MAIL_DOMAIN, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_VALIDATE_AUTH_MAIL_DOMAIN, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_VALIDATE_AUTH_MAIL_DOMAIN, payload: error.message});
          if(!isUndefined(error.response)){
      if (error.response.status === 401) {
        dispatch({type: FETCH_START_SET_UNAUTHE});
       } 
     } 
     if(error.message === "Network Error"){
        //reload and remove token 
        //dispatch(userSignOut())
     } 
     });
   }
 }
 export const removeSendgridAuthDomain = (Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      dispatch({type: ON_START_REMOVE_AUTH_MAIL_DOMAIN});
      axios.delete('kontos/SendGridAuth/remove',
      { params:{Afid}, 
      headers: { 'Authorization': `Bearer ${jwt}`} 
     }      
       ).then(({data}) => {
        console.log("removeSendgridAuthDomain: ", data);
         if (data.results) {
          // dispatch({type: FETCH_ALL_CONTACT});
           dispatch({type: ON_REMOVE_AUTH_MAIL_DOMAIN, payload: data.results});
         } else {
           dispatch({type: ON_ERROR_REMOVE_AUTH_MAIL_DOMAIN, payload: data.error});
         }
       }).catch(function (error) {
         dispatch({type: ON_ERROR_REMOVE_AUTH_MAIL_DOMAIN, payload: error.message});
            if(!isUndefined(error.response)){
         if (error.response.status === 401) {
           dispatch({type: FETCH_START_SET_UNAUTHE});
          } 
        } 
         if(error.message === "Network Error"){
            //reload and remove token 
            //dispatch(userSignOut())
         } 
       });
    } /**/
  }
export const onGetSendgridAuthData = (Afid)=>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_GET_AUTH_MAIL_DOMAIN});
    axios.get('kontos/SendGridAuth/get',
    { params:{Afid:Afid}, 
    headers: { 'Authorization': `Bearer ${jwt}`} 
   }      
     ).then(({data}) => {
      console.log("onGetSendgridAuthData: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_AUTH_MAIL_DOMAIN, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_AUTH_MAIL_DOMAIN, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_AUTH_MAIL_DOMAIN, payload: error.message});
       if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
        if(error.message === "Network Error"){
           //reload and remove token 
           //dispatch(userSignOut())
        } 
      });
   } /**/
 }
//getSamplesImport
export const getSamplesImport = (Afid,userid,Filterstate)=>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_GET_IMPORT_SAMPLE});
    axios.get('kontos/v/import/sample/get',
    { params:{
      Afid:Afid,
      userid:userid,
      Filterstate:Filterstate,
    }, 
    headers: { 'Authorization': `Bearer ${jwt}`} 
   }      
     ).then(({data}) => {
      console.log("onGetUsingStorage: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_IMPORT_SAMPLE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_IMPORT_SAMPLE, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_IMPORT_SAMPLE, payload: error.message});

          if(!isUndefined(error.response)){
       if (error.response.status === 401) {
         dispatch({type: FETCH_START_SET_UNAUTHE});
        } 
      } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  } /**/
}
//


//

//getUnderkontoKunderAfid
export const getUnderkontoKunderAfid = (Afid,userid)=>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_GET_UNDERKONTO_KUNDER});
    axios.get('kontos/Underkonto/Kunder',
    { params:{
      Afid:Afid,
      userid:userid
    }, 
    headers: { 'Authorization': `Bearer ${jwt}`} 
   }      
     ).then(({data}) => {
      console.log("getUnderkontoKunderAfid: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_UNDERKONTO_KUNDER, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_UNDERKONTO_KUNDER, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_UNDERKONTO_KUNDER, payload: error.message});

          if(!isUndefined(error.response)){
       if (error.response.status === 401) {
         dispatch({type: FETCH_START_SET_UNAUTHE});
        } 
      } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  } /**/
}
//setToZeroImportSample
export const setToZeroImportSample = ()=>{
  return async (dispatch) => {
    dispatch({type: ON_START_GET_IMPORT_SAMPLE});
  } /**/
}
//getRapport
export const onGetRapportV2J = (Afid,userid,Name,sendTo,beskrivning,FilterChips)=>{
  const jwt =  JSON.parse(localStorage.token);
  let VisaFilterIExcel = false
  
  return (dispatch,getState) => {
    const {IpAdress} = getState().auth;
    dispatch({type: ON_START_FETCH_RAPPORTV2});
    dispatch(getLoggRepportV2(userid,Afid))
    if(isEmpty(sendTo)){
      axios.get('kontos/RapportV2',
      { params:{
        Afid:Afid,
        userid:userid,
        Name:Name,
        beskrivning:beskrivning,
        FilterChips:JSON.stringify(FilterChips),sendTo,
        IpAdress
      }, 
       responseType: 'arraybuffer' ,
       headers: { 'Authorization': `Bearer ${jwt}`} }      
       ).then((resp) => {
         const dirtyFileName = resp.headers['content-disposition'];
         const regex = /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/;
         var  fileName = dirtyFileName.match(regex)[3];
         var blob = new Blob([resp.data], 
          { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
        );
        dispatch({type: ON_FETCH_RAPPORTV2, payload: resp});
        fileSaver.saveAs(blob, fileName);
        dispatch(getLoggRepportV2(userid,Afid))

        dispatch(RefreshUserInterface(userid))
       }).catch(function (error) {
         dispatch({type: ON_ERROR_FETCH_RAPPORTV2, payload: error.message});
         dispatch(getLoggRepportV2(userid,Afid))

         if(!isUndefined(error.response)){
          if (error.response.status === 401) {
            dispatch({type: FETCH_START_SET_UNAUTHE});
           } 
         }
         
         if(error.message === "Network Error"){
            //reload and remove token 
            //dispatch(userSignOut())
         }
       });
    }else{
      axios.get('kontos/RapportV2',
    { params:{
      Afid:Afid,
      userid:userid,
      Name:Name,
      beskrivning:beskrivning,
      FilterChips:JSON.stringify(FilterChips),sendTo,
      IpAdress
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_FETCH_RAPPORTV2, payload: data.results});
       } else {
         dispatch({type: ON_FETCH_RAPPORTV2, payload: data.error});
       }
       dispatch(getLoggRepportV2(userid,Afid))
      dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FETCH_RAPPORTV2, payload: error.message});
       dispatch(getLoggRepportV2(userid,Afid))
       if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       }
       
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       }
     });
    }    
  }
}
//onGetAndSaveRapportV2J
export const onGetAndSaveRapportV2J = (Afid,userid,Name,sendTo,beskrivning,FilterChips,id,callbackFunc)=>{
  const jwt =  JSON.parse(localStorage.token);
  let VisaFilterIExcel = false
  return (dispatch,getState) => {
    const {IpAdress} = getState().auth;
    dispatch({type: ON_START_FETCH_RAPPORTV2});
    dispatch(getLoggRepportV2(userid,Afid))
    if(isEmpty(sendTo)){
      axios.get('kontos/RapportV2/Save',
      { params:{
        Afid:Afid,
        userid:userid,
        Name:Name,
        id:isUndefined(id)?0:id,
        beskrivning:beskrivning,
        FilterChips:JSON.stringify(FilterChips),sendTo,
        IpAdress
      }, 
       responseType: 'arraybuffer' ,
       headers: { 'Authorization': `Bearer ${jwt}`} }      
       ).then((resp) => {
         const dirtyFileName = resp.headers['content-disposition'];
         const regex = /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/;
         var  fileName = dirtyFileName.match(regex)[3];
         var blob = new Blob([resp.data], 
          { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
        );
        dispatch({type: ON_FETCH_RAPPORTV2, payload: resp});
        dispatch(getSparadRepportV2(userid,Afid))
        dispatch(getLoggRepportV2(userid,Afid))
        //dispatch(getSparadRepportV2(userid,Afid))
        fileSaver.saveAs(blob, fileName);
        dispatch(RefreshUserInterface(userid))
       }).catch(function (error) {
         dispatch({type: ON_ERROR_FETCH_RAPPORTV2, payload: error.message});
         dispatch(getLoggRepportV2(userid,Afid))
         if(!isUndefined(error.response)){
          if (error.response.status === 401) {
            dispatch({type: FETCH_START_SET_UNAUTHE});
           } 
         }
         
         if(error.message === "Network Error"){
            //reload and remove token 
            //dispatch(userSignOut())
         }
       });
    }else{
      axios.get('kontos/RapportV2/Save',
    { params:{
      Afid:Afid,
      userid:userid,
      Name:Name,
      beskrivning:beskrivning,
      id:isUndefined(id)?0:id,
      FilterChips:JSON.stringify(FilterChips),sendTo,
      IpAdress
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_FETCH_RAPPORTV2, payload: data.results});
       } else {
         dispatch({type: ON_FETCH_RAPPORTV2, payload: data.error});
       }
      dispatch(RefreshUserInterface(userid))
      dispatch(getSparadRepportV2(userid,Afid))
      dispatch(getLoggRepportV2(userid,Afid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FETCH_RAPPORTV2, payload: error.message});
       dispatch(getLoggRepportV2(userid,Afid))
       if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       }
       
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       }
     });
    }    
  }
}
//onSetToNullImportSamplesMessage
export const onSetToNullImportSamplesMessage = ()=>{
  return async (dispatch) => {
    dispatch({type: ON_SET_TO_NULL_IMPORTSAMPLE});
  }
}
//getSparadRepportV2
export const getSparadRepportV2 = (userid,Afid)=>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_GET_SPARAD_RAPPORTV2});
    axios.get('kontos/RapportV2/get',
    { params:{
      Afid:Afid,
      userid:userid
    }, 
    headers: { 'Authorization': `Bearer ${jwt}`} 
   }      
     ).then(({data}) => {
      console.log("getSparadRepportV2: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_SPARAD_RAPPORTV2, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_SPARAD_RAPPORTV2, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_SPARAD_RAPPORTV2, payload: error.message});

          if(!isUndefined(error.response)){
       if (error.response.status === 401) {
         dispatch({type: FETCH_START_SET_UNAUTHE});
        } 
      } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  } /**/
}
//getLoggRepportV2
export const getLoggRepportV2 = (userid,Afid)=>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_GET_LOGG_RAPPORTV2});
    axios.get('kontos/RapportV2/getLogg',
    { params:{
      Afid:Afid,
      userid:userid
    }, 
    headers: { 'Authorization': `Bearer ${jwt}`} 
   }      
     ).then(({data}) => {
      console.log("getLoggRepportV2: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_LOGG_RAPPORTV2, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_LOGG_RAPPORTV2, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_LOGG_RAPPORTV2, payload: error.message});

          if(!isUndefined(error.response)){
       if (error.response.status === 401) {
         dispatch({type: FETCH_START_SET_UNAUTHE});
        } 
      } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  } /**/
}
//onSearchKommentar
export const onSearchKommentar = (userid,Afid,searchWord,date)=>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_SEARCH_KOMMENTAR});
    axios.get('kontos/search/comment',
    { params:{
      Afid:Afid,
      userid:userid,
      searchWord:searchWord,
      date:date,
    }, 
    headers: { 'Authorization': `Bearer ${jwt}`} 
   }      
     ).then(({data}) => {
      console.log("getLoggRepportV2: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_SEARCH_KOMMENTAR, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_SEARCH_KOMMENTAR, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SEARCH_KOMMENTAR, payload: error.message});

          if(!isUndefined(error.response)){
       if (error.response.status === 401) {
         dispatch({type: FETCH_START_SET_UNAUTHE});
        } 
      } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  } /**/
}
//onsetNullSearchKommentar
export const onsetNullSearchKommentar = ()=>{
  return async (dispatch) => {
    dispatch({type: ON_START_SEARCH_KOMMENTAR});
  }
}
//onDeleteThiRapportV2
export const onDeleteThiRapportV2 = (Afid,userid,item) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch,getState) => {
    const {IpAdress} = getState().auth;
     dispatch({type: ON_START_DELETE_AFID_RAPPORTV2});
     axios.delete('kontos/RapportV2/delete',
     { params:{
      item:item,
      Afid:Afid,
      userid:userid,
      IpAdress
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`} 
    }).then(({data}) => {
      console.log("onDeleteThiRapportV2: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_AFID_RAPPORTV2, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DELETE_AFID_RAPPORTV2, payload: data.error});
       }
       dispatch(getSparadRepportV2(userid,Afid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_AFID_RAPPORTV2, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
 }
 //onEditThiRapportV2
 export const onEditThiRapportV2 = ( Afid,userid, item) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch,getState) => {
    const {IpAdress} = getState().auth;
     dispatch({type: ON_START_UPDATE_RAPPORTV2});
     axios.put('kontos/RapportV2/update', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        item:item,
        IpAdress
      },
           
  },{
    headers: {
      'content-type': 'application/json',
      'Authorization':   `Bearer ${jwt}`
  } 
  }).then(({data}) => {
      console.log("UpdateProjectFasView: ", data);
       if (data.results) {
         dispatch({type: ON_UPDATE_RAPPORTV2, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_UPDATE_RAPPORTV2, payload: data.error});
       }
       dispatch(getSparadRepportV2(userid,Afid))
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_RAPPORTV2, payload: error.message});
          if(!isUndefined(error.response)){
      if (error.response.status === 401) {
        dispatch({type: FETCH_START_SET_UNAUTHE});
       } 
     } 
     if(error.message === "Network Error"){
        //reload and remove token 
        //dispatch(userSignOut())
     } 
     });
   }
 }
 export const onsetThisReportAsFav = ( Afid,userid, item) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch,getState) => {
    const {IpAdress} = getState().auth;
     dispatch({type: ON_START_UPDATE_RAPPORTV2});
     axios.put('kontos/RapportV2/Fav', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        item:item
      },
           
  },{
    headers: {
      'content-type': 'application/json',
      'Authorization':   `Bearer ${jwt}`
  } 
  }).then(({data}) => {
      console.log("UpdateProjectFasView: ", data);
       if (data.results) {
         dispatch({type: ON_UPDATE_RAPPORTV2, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_UPDATE_RAPPORTV2, payload: data.error});
       }
       dispatch(getSparadRepportV2(userid,Afid))
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_RAPPORTV2, payload: error.message});
          if(!isUndefined(error.response)){
      if (error.response.status === 401) {
        dispatch({type: FETCH_START_SET_UNAUTHE});
       } 
     } 
     if(error.message === "Network Error"){
        //reload and remove token 
        //dispatch(userSignOut())
     } 
     });
   }
 }
//checkKundNr
export const checkKundNr = (Afid,KundNr)=>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_CHECH_KUNDNR});
    axios.get('kontos/kund/check',
    { params:{
      Afid:Afid,
      KundNr:KundNr
    }, 
    headers: { 'Authorization': `Bearer ${jwt}`} 
   }      
     ).then(({data}) => {
      console.log("checkKundNr: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_CHECH_KUNDNR, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_CHECH_KUNDNR, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_CHECH_KUNDNR, payload: error.message});

          if(!isUndefined(error.response)){
       if (error.response.status === 401) {
         dispatch({type: FETCH_START_SET_UNAUTHE});
        } 
      } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  } /**/
}
//onGetWhoLikes
export const onGetWhoLikes = (Afid,postId)=>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_FLODE_LIKES});
    axios.get('kontos/flode/check',
    { params:{
      Afid:Afid,
      postId:postId
    }, 
    headers: { 'Authorization': `Bearer ${jwt}`} 
   }      
     ).then(({data}) => {
      console.log("checkKundNr: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_FLODE_LIKES, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_FLODE_LIKES, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FLODE_LIKES, payload: error.message});

          if(!isUndefined(error.response)){
       if (error.response.status === 401) {
         dispatch({type: FETCH_START_SET_UNAUTHE});
        } 
      } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  } /**/
}
export const onCloseWhoLikes = ()=>{
  return async (dispatch) => {
    dispatch({type: ON_START_FLODE_LIKES});
  }
}
//getAfidOrgnrTree
export const getAfidOrgnrTree = (Afid,userid,Orgnr)=>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_ORGNR_FAMILY_TREE});
    axios.get('kontos/Kund/family/tree',
    { params:{
      Afid:Afid,
      userid:userid,
      Orgnr:Orgnr
    }, 
    headers: { 'Authorization': `Bearer ${jwt}`} 
   }      
     ).then(({data}) => {
       if (data.results) {
         dispatch({type: ON_ORGNR_FAMILY_TREE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR__ORGNR_FAMILY_TREE, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR__ORGNR_FAMILY_TREE, payload: error.message});
       if(!isUndefined(error.response)){
       if (error.response.status === 401) {
         dispatch({type: FETCH_START_SET_UNAUTHE});
        } 
      } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  } /**/
}
//onSaveNewCNodeAfid
export const onSaveNewCNodeAfid = ( Afid,userid,PNode,CNode,callBackFunction) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
     dispatch({type: ON_START_ADD_ORGNR_FAMILY_TREE});
     axios.put('kontos/Kund/family/tree/add', {
      method: 'PUT',
      body: {
        Afid:Afid,
        userid:userid,
        PNode:PNode,
        CNode:CNode        
      },
           
  },{
    headers: {
      'content-type': 'application/json',
      'Authorization':   `Bearer ${jwt}`
  } 
  }).then(({data}) => {
      console.log("onSaveNewCNodeAfid: ", data);
       if (data.results) {
         dispatch({type: ON_ADD_ORGNR_FAMILY_TREE, payload: data.results});
         callBackFunction()
       } else {
         dispatch({type: ON_ERROR_ADD_ORGNR_FAMILY_TREE, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_ADD_ORGNR_FAMILY_TREE, payload: error.message});
          if(!isUndefined(error.response)){
      if (error.response.status === 401) {
        dispatch({type: FETCH_START_SET_UNAUTHE});
       } 
     } 
     if(error.message === "Network Error"){
        //reload and remove token 
        //dispatch(userSignOut())
     } 
     });
   }
 }
 //onRemovethisNodeAfid
 export const onRemovethisNodeAfid = (Afid,userid,Orgnr,RNode,callBackFunction) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
     dispatch({type: ON_START_DELETE_ORGNR_FAMILY_TREE});
     axios.delete('kontos/Kund/family/tree/delete',
     { params:{
      Afid:Afid,
      userid:userid,
      RNode:RNode,
      Orgnr:Orgnr,
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`} 
    }).then(({data}) => {
      console.log("onDeleteThiRapportV2: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_ORGNR_FAMILY_TREE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR__ORGNR_FAMILY_TREE, payload: data.error});
       }
       callBackFunction()
     }).catch(function (error) {
       dispatch({type: ON_ERROR__ORGNR_FAMILY_TREE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
 }
//onGetArtikelTbAvdrag
export const onGetArtikelTbAvdrag = (userid,Afid,arikelID)=>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_GET_ARTIKEL_TBAVDRAG});
    axios.get('kontos/artikel/tbavdrag',
    { params:{
      Afid:Afid,
      userid:userid,
      arikelID:arikelID
    }, 
    headers: { 'Authorization': `Bearer ${jwt}`} 
   }      
     ).then(({data}) => {
       if (data.results) {
         dispatch({type: ON_GET_ARTIKEL_TBAVDRAG, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_ARTIKEL_TBAVDRAG, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_ARTIKEL_TBAVDRAG, payload: error.message});
       if(!isUndefined(error.response)){
       if (error.response.status === 401) {
         dispatch({type: FETCH_START_SET_UNAUTHE});
        } 
      } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  } /**/
}
//onAddNewTBavdragArtikel
export const onAddNewTBavdragArtikel = ( Afid,userid,ArtId,stateObj) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
     dispatch({type: ON_START_ADD_ARTIKEL_TBAVDRAG});
     axios.put('kontos/artikel/tbavdrag/add', {
      method: 'PUT',
      body: {
        Afid:Afid,
        userid:userid,
        ArtId:ArtId,
        stateObj:stateObj        
      },           
  },{
    headers: {
      'content-type': 'application/json',
      'Authorization':   `Bearer ${jwt}`
  } 
  }).then(({data}) => {
      console.log("onSaveNewCNodeAfid: ", data);
       if (data.results) {
         dispatch({type: ON_ADD_ARTIKEL_TBAVDRAG, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_ADD_ARTIKEL_TBAVDRAG, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_ADD_ARTIKEL_TBAVDRAG, payload: error.message});
          if(!isUndefined(error.response)){
      if (error.response.status === 401) {
        dispatch({type: FETCH_START_SET_UNAUTHE});
       } 
     } 
     if(error.message === "Network Error"){
        //reload and remove token 
        //dispatch(userSignOut())
     } 
     });
   }
 }
//onUpdateArtikelTBAvdrag
export const onUpdateArtikelTBAvdrag = (userid,Afid ,ArtId,row,Meta,Value) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
     dispatch({type: ON_START_ADD_ARTIKEL_TBAVDRAG});
     axios.put('kontos/artikel/tbavdrag/update', {
      method: 'PUT',
      body: {
        Afid:Afid,
        userid:userid,
        ArtId:ArtId,
        row:row,
        Meta:Meta,
        Value:Value,
      },           
  },{
    headers: {
      'content-type': 'application/json',
      'Authorization':   `Bearer ${jwt}`
  } 
  }).then(({data}) => {
      console.log("onSaveNewCNodeAfid: ", data);
       if (data.results) {
         dispatch({type: ON_ADD_ARTIKEL_TBAVDRAG, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_ADD_ARTIKEL_TBAVDRAG, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_ADD_ARTIKEL_TBAVDRAG, payload: error.message});
          if(!isUndefined(error.response)){
      if (error.response.status === 401) {
        dispatch({type: FETCH_START_SET_UNAUTHE});
       } 
     } 
     if(error.message === "Network Error"){
        //reload and remove token 
        //dispatch(userSignOut())
     } 
     });
   }
 }
//onDeleteArtikelTBAvdrag
export const onDeleteArtikelTBAvdrag = (userid,Afid ,ArtId,row) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
     dispatch({type: ON_START_ADD_ARTIKEL_TBAVDRAG});
     axios.delete('kontos/artikel/tbavdrag/delete',
     { params:{
      Afid:Afid,
      userid:userid,
      row:row,
      ArtId:ArtId,
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`} 
    }).then(({data}) => {
      console.log("onDeleteArtikelTBAvdrag: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_ADD_ARTIKEL_TBAVDRAG, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_ADD_ARTIKEL_TBAVDRAG, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_ADD_ARTIKEL_TBAVDRAG, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
 }
//getKontakterByOrgnr
export const getKontakterByOrgnr = (userid,Afid,Orgnr)=>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_GET_KUND_KONTAKTER});
    axios.get('kontos/Kund/Kontakter',
    { params:{
      Afid:Afid,
      userid:userid,
      Orgnr:Orgnr
    }, 
    headers: { 'Authorization': `Bearer ${jwt}`} 
   }      
     ).then(({data}) => {
       if (data.results) {
         dispatch({type: ON_GET_KUND_KONTAKTER, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_KUND_KONTAKTER, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_KUND_KONTAKTER, payload: error.message});
       if(!isUndefined(error.response)){
       if (error.response.status === 401) {
         dispatch({type: FETCH_START_SET_UNAUTHE});
        } 
      } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  } /**/
}
//ongetTagsList
export const ongetTagsList = (Afid)=>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_GET_KONTO_TAGS});
    axios.get('kontos/Kund/tag/get',
    { params:{
      Afid:Afid
    }, 
    headers: { 'Authorization': `Bearer ${jwt}`} 
   }      
     ).then(({data}) => {
       if (data.results) {
         dispatch({type: ON_GET_KONTO_TAGS, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_KONTO_TAGS, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_KONTO_TAGS, payload: error.message});
       if(!isUndefined(error.response)){
       if (error.response.status === 401) {
         dispatch({type: FETCH_START_SET_UNAUTHE});
        } 
      } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  } /**/
}
 export const getPyramid = (userid,Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_GET_PYRAMID});
    axios.get('kontos/Pyramid',
    { params:{Afid:Afid,userid:userid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getPyramid: ", data);
       if (data.results) {
         dispatch({type: ON_GET_PYRAMID, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_PYRAMID, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_PYRAMID, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}

export const connectPyramid = ( userid, Afid,APIKOD) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_CONNECT_PYRAMID});
     axios.post('kontos/Pyramid', {
      method: 'POST',
      body: {
        userid:userid,
        Afid:Afid,
        APIKOD:APIKOD
      },
    },{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("connectPyramid: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_CONNECT_PYRAMID, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_CONNECT_PYRAMID, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_CONNECT_PYRAMID, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
export const updatePyramid = ( userid, Afid, Obj) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_UPDATE_PYRAMID});
     axios.put('kontos/Pyramid', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        Obj:Obj
      }
    },
    {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("updatePyramid: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_UPDATE_PYRAMID, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_UPDATE_PYRAMID, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_PYRAMID, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 export const disconnectPyramid = (userid,Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress=await getClientIp()
    dispatch({type: ON_START_DISCONNECT_PYRAMID});
    axios.delete('kontos/disconnectPyramid',
    { params:{Afid:Afid,userid:userid,ipAdress}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("disconnectPyramid: ", data);
       if (data.results) {
         dispatch({type: ON_DISCONNECT_PYRAMID, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DISCONNECT_PYRAMID, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DISCONNECT_PYRAMID, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
 export const getPyramidCustomer = (userid,Afid,Orgnr) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_GET_PYRAMID_CUSTOMER});
    const ipAdress= await getClientIp()
    axios.get('kontos/Pyramid/customer',
    { params:{Afid:Afid,userid:userid,Orgnr:Orgnr,ipAdress}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getPyramidCustomer: ", data);
       if (data.results) {
         dispatch({type: ON_GET_PYRAMID_CUSTOMER, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_PYRAMID_CUSTOMER, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_PYRAMID_CUSTOMER, payload: error});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
export const createPyramidCustomer = (userid,Afid,Orgnr) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_CREATE_PYRAMID_CUSTOMER});
    axios.post('kontos/Pyramid/customer', {
      method: 'POST',
      body: {
        userid:userid,
        Afid:Afid,
        Orgnr:Orgnr
      },
    },{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("createPyramidCustomer: ", data);
       if (data.results) {
         dispatch({type: ON_CREATE_PYRAMID_CUSTOMER, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_CREATE_PYRAMID_CUSTOMER, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_CREATE_PYRAMID_CUSTOMER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
export const connectPyramidCustomer = (userid,Afid,Orgnr,PyramidID) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress= await getClientIp()
    dispatch({type: ON_START_CONNECT_PYRAMID_CUSTOMER});
    axios.put('kontos/Pyramid/customer', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        Orgnr:Orgnr,
        PyramidID:PyramidID,
        ipAdress
      }
    },
    {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("connectPyramidCustomer: ", data);
       if (data.results) {
         dispatch({type: ON_CONNECT_PYRAMID_CUSTOMER, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_CONNECT_PYRAMID_CUSTOMER, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_CONNECT_PYRAMID_CUSTOMER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
export const disconnectPyramidCustomer = (userid,Afid,Orgnr) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress= await getClientIp()
    dispatch({type: ON_START_DISCONNECT_PYRAMID_CUSTOMER});
    axios.delete('kontos/Pyramid/customer', {
      method: 'DELETE',
      params: {
        userid:userid,
        Afid:Afid,
        Orgnr:Orgnr,
        ipAdress
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("disconnectPyramidCustomer: ", data);
       if (data.results) {
         dispatch({type: ON_DISCONNECT_PYRAMID_CUSTOMER, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DISCONNECT_PYRAMID_CUSTOMER, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DISCONNECT_PYRAMID_CUSTOMER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
 export const getPyramidContact = (userid,Afid,KontaktId) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_GET_PYRAMID_CONTACT});
    const ipAdress= await getClientIp()
    axios.get('kontos/Pyramid/contact',
    { params:{Afid:Afid,userid:userid,KontaktId,ipAdress}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getPyramidContact: ", data);
       if (data.results) {
         dispatch({type: ON_GET_PYRAMID_CONTACT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_PYRAMID_CONTACT, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_PYRAMID_CONTACT, payload: error});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
export const createPyramidContact = (userid,Afid,KontaktId) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_CREATE_PYRAMID_CONTACT});
    axios.post('kontos/Pyramid/contact', {
      method: 'POST',
      body: {
        userid:userid,
        Afid:Afid,
        KontaktId
      },
    },{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("createPyramidContact: ", data);
       if (data.results) {
         dispatch({type: ON_CREATE_PYRAMID_CONTACT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_CREATE_PYRAMID_CONTACT, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_CREATE_PYRAMID_CONTACT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
export const connectPyramidContact = (userid,Afid,KontaktId,PyramidID) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress= await getClientIp()
    dispatch({type: ON_START_CONNECT_PYRAMID_CONTACT});
    axios.put('kontos/Pyramid/contact', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        KontaktId,
        PyramidID:PyramidID,
        ipAdress
      }
    },
    {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("connectPyramidContact: ", data);
       if (data.results) {
         dispatch({type: ON_CONNECT_PYRAMID_CONTACT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_CONNECT_PYRAMID_CONTACT, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_CONNECT_PYRAMID_CONTACT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
export const disconnectPyramidContact = (userid,Afid,KontaktId) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress= await getClientIp()
    dispatch({type: ON_START_DISCONNECT_PYRAMID_CONTACT});
    axios.delete('kontos/Pyramid/contact', {
      method: 'DELETE',
      params: {
        userid:userid,
        Afid:Afid,
        KontaktId,
        ipAdress
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("disconnectPyramidContact: ", data);
       if (data.results) {
         dispatch({type: ON_DISCONNECT_PYRAMID_CONTACT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DISCONNECT_PYRAMID_CONTACT, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DISCONNECT_PYRAMID_CONTACT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//onGetDashBoardValueOf
export const onGetDashBoardValueOf = (Afid,userid) =>{
  return async (dispatch) => {
    dispatch({type: ON_START_GET_DASHBOARD_VALUEOF});
    axios.get('kontos/dashboard/valueOf',
    { params:{Afid:Afid,userid:userid}}      
     ).then(({data}) => {
      console.log("getPyramidContact: ", data);
       if (data.results) {
         dispatch({type: ON_GET_DASHBOARD_VALUEOF, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_DASHBOARD_VALUEOF, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_DASHBOARD_VALUEOF, payload: error});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//onUpdateDashBoardValueOf
export const onUpdateDashBoardValueOf = (Afid,userid,ValueOf) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_UPDATE_DASHBOARD_VALUEOF});
    axios.put('kontos/dashboard/valueOf/update', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        ValueOf
      }
    },
    {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("connectPyramidContact: ", data);
       if (data.results) {
         dispatch({type: ON_UPDATE_DASHBOARD_VALUEOF, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_UPDATE_DASHBOARD_VALUEOF, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_DASHBOARD_VALUEOF, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//onGetAfSMSsettings
export const onGetAfSMSsettings = (Afid,userid) =>{
  return async (dispatch) => {
    dispatch({type: ON_START_GET_SMS_SETTINGS});
    axios.get('kontos/SMS/settings',
    { params:{Afid:Afid,userid:userid}}      
     ).then(({data}) => {
      console.log("onGetAfSMSsettings: ", data);
       if (data.results) {
         dispatch({type: ON_GET_SMS_SETTINGS, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_SMS_SETTINGS, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_SMS_SETTINGS, payload: error});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//onUpdateAfSmsSettings
export const onUpdateAfSmsSettings = (Afid,userid,Meta,value) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_UPDATE_SMS_SETTINGS});
    axios.put('kontos/SMS/settings/update', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        Meta:Meta,
        value:value,
      }
    },
    {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("onUpdateAfSmsSettings: ", data);
       if (data.results) {
         dispatch({type: ON_UPDATE_SMS_SETTINGS, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_UPDATE_SMS_SETTINGS, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_SMS_SETTINGS, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//onCheckThisOrgnrInDatabase
export const onCheckThisOrgnrInDatabase = (Afid,CuOrgnr,Orgnr,CallBackFunc) =>{
  return async (dispatch) => {
    axios.get('kontos/Orgnr/Check',
    { params:{
      Afid:Afid,
      CuOrgnr:CuOrgnr,
      Orgnr:Orgnr
    }}      
     ).then(({data}) => {
      console.log("onCheckThisOrgnrInDatabase: ", data);
       if (data.results) {
        CallBackFunc(data.results)
       } else {
        CallBackFunc([])
       }
     }).catch(function (error) {
      console.log(error)
      CallBackFunc([])
     })
   
  }
}
//onGetFortnoxEmployees
export const onGetFortnoxEmployees = (CallBackFunc) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    axios.get('kontos/Fortnox/Employee',{
      headers: {
        'content-type': 'application/json',
        'Authorization':   `Bearer ${jwt}`
      }     
    }
     ).then(({data}) => {
      console.log("onCheckThisOrgnrInDatabase: ", data);
       if (data.results) {
        CallBackFunc(data.results.Employee)
       } else {
        CallBackFunc([])
       }
     }).catch(function (error) {
      console.log(error)
      CallBackFunc([])
     })
   
  }
}
//getSveaCreditCheck
export const getSveaCreditCheck = (Afid,userid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress=await getClientIp()
    dispatch({type: ON_START_GET_SVEACREDIT});
    axios.get('kontos/SveaCredit/get',
    { params:{Afid:Afid,userid:userid,ipAdress}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
     console.log("getSveaCreditCheck: ", data);
      if (data.results) {
        dispatch({type: ON_GET_SVEACREDIT, payload: data.results});
      } else {
        dispatch({type: ON_ERROR_GET_SVEACREDIT, payload: data.message});
      }
      dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
      dispatch({type: ON_ERROR_GET_SVEACREDIT, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
    });
  }
}
//connectToSveaCreditSafe
export const connectToSveaCreditSafe = ( userid, Afid,Username,Password,clientNumber) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_BESTALLA_SVEACREDIT});
     axios.put('kontos/SveaCredit/Bestalla', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        Username:Username,
        clientNumber:clientNumber,
        Password:Password
      }
    },
    {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("connectToCreditSafe: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_BESTALLA_SVEACREDIT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_BESTALLA_SVEACREDIT, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_BESTALLA_SVEACREDIT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //onSparaSveaCreditSafe
 export const onSparaSveaCreditSafe = ( userid, Afid,Username,Password,clientNumber) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_BESTALLA_SVEACREDIT});
     axios.put('kontos/SveaCredit/save', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        Username:Username,
        clientNumber:clientNumber,
        Password:Password
      }
    },
    {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("onSparaSveaCreditSafe: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_BESTALLA_SVEACREDIT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_BESTALLA_SVEACREDIT, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_BESTALLA_SVEACREDIT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //getSVeaAllowedUserList
 export const getSVeaAllowedUserList = (Afid,userid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress=await getClientIp()
    dispatch({type: ON_START_GET_ALL_SVEACREDIT_ALLOW_USER});
    axios.get('kontos/SveaCredit/user/get',
    { params:{Afid:Afid,userid:userid,ipAdress}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
     console.log("getSVeaAllowedUserList: ", data);
      if (data.results) {
        dispatch({type: ON_GET_ALL_SVEACREDIT_ALLOW_USER, payload: data.results});
      } else {
        dispatch({type: ON_ERROR_GET_ALL_SVEACREDIT_ALLOW_USER, payload: data.message});
      }
    }).catch(function (error) {
      dispatch({type: ON_ERROR_GET_ALL_SVEACREDIT_ALLOW_USER, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
    });
  }
}
//onInaktiveUserToSVeaCredit
export const onInaktiveUserToSVeaCredit = (Afid,userid,AllowedId,Aktive) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_SVEACREDIT_AKTIVE_ALLOW_USER});
     axios.put('kontos/SveaCredit/user/Aktive', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        AllowedId:AllowedId,
        Aktive:Aktive
      }
    },
    {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("onInaktiveUserToSVeaCredit: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_SVEACREDIT_AKTIVE_ALLOW_USER, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_SVEACREDIT_AKTIVE_ALLOW_USER, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SVEACREDIT_AKTIVE_ALLOW_USER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //allowThisUserToSveaCredit
 export const allowThisUserToSveaCredit = (Afid,userid,AllowedId) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_SVEACREDIT_ALLOW_USER});
     axios.put('kontos/SveaCredit/user/Allow', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        AllowedId:AllowedId
      }
    },
    {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("allowThisUserToSveaCredit: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_SVEACREDIT_ALLOW_USER, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_SVEACREDIT_ALLOW_USER, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SVEACREDIT_ALLOW_USER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //getLastSveaCreditRequest
 export const getLastSveaCreditRequest = (Afid,userid,Orgnr) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_GET_LAST_SVEACREDIT});
    axios.get('kontos/SveaCredit/credit/get',
    { params:{Afid:Afid,userid:userid,Orgnr:Orgnr}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
     console.log("getLastSveaCreditRequest: ", data);
      if (data.results) {
        dispatch({type: ON_GET_LAST_SVEACREDIT, payload: data.results});
      } else {
        dispatch({type: ON_ERROR_GET_LAST_SVEACREDIT, payload: data.message});
      }
      dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
      dispatch({type: ON_ERROR_GET_LAST_SVEACREDIT, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
    });
  }
 }
 //SendSveaCreditSafeReq
 export const SendSveaCreditSafeReq = (Afid,userid,Orgnr) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_SEND_SVEACREDIT});
     axios.get('kontos/SveaCredit/send', {
      params: {
        userid:userid,
        Afid:Afid,
        Orgnr:Orgnr
      },
      headers: { 'Authorization': `Bearer ${jwt}`} } )
      .then(({data}) => {
        console.log("SendSveaCreditSafeReq: ", data);
         if (data.results) {
           dispatch({type: ON_SEND_SVEACREDIT, payload: data.results});
           dispatch(getLastSveaCreditRequest(Afid,userid,Orgnr))
         } else {
           dispatch({type: ON_ERROR_SEND_SVEACREDIT, payload: data.message});
         }
         dispatch(RefreshUserInterface(userid))
       })
     .catch(function (error) {
       dispatch({type: ON_ERROR_SEND_SVEACREDIT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //getAfidKundCounty
 export const getAfidKundCounty = (Afid,callBackFunction) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    axios.get('kontos/Country/kund',
    { params:{
      Afid:Afid
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getAfidKundCounty: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
        if(!isUndefined(callBackFunction)){callBackFunction(data.results)}
       } 
       
     })
  }
}
//getAfDialerHidden
export const getAfDialerHidden = (Afid,callBackFunction) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    axios.get('kontos/dialer/hs',
    { params:{
      Afid:Afid
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getAfidKundCounty: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
        if(!isUndefined(callBackFunction)){callBackFunction(data.results)}
       } 
       
     })
  }
}
//onAddHiddenStatus
export const onAddHiddenStatus = (Afid,status,callBackfunc) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     axios.put('kontos/dialer/hs/add', {
      method: 'PUT',
      body: {
        Afid:Afid,
        status:status
      }
    },
    {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("allowThisUserToSveaCredit: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
        if(!isUndefined(callBackfunc)){callBackfunc(data.results)}
       }
     })
   }
 }
//onDeleteHiddenStatus
export const onDeleteHiddenStatus = (Afid,Item,callBackfunc) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     axios.delete('kontos/dialer/hs/delete', {
      method: 'DELETE',
      data: {
        Afid:Afid,
        Item:JSON.stringify(Item)
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("allowThisUserToSveaCredit: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
        if(!isUndefined(callBackfunc)){callBackfunc(data.results)}
       }
     })
   }
 }
//getFortnoxSetting
export const getFortnoxSetting = (Afid,callBackFunction) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    axios.get('kontos/fortnox/sync/settings',
    { params:{
      Afid:Afid
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getAfidKundCounty: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
        if(!isUndefined(callBackFunction)){callBackFunction(data.results)}
       } 
       
     })
  }
}
//getFortnoxLog
export const getFortnoxLog = (Afid,Page,callBackFunction) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    axios.get('kontos/fortnox/log',
    { params:{
      Afid:Afid,
      Page:Page,
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getAfidKundCounty: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
        if(!isUndefined(callBackFunction)){callBackFunction(data.results)}
       } 
       
     })
  }
}
//updateFortnoxsyncSettings
export const updateFortnoxsyncSettings = (Afid,Meta,Value,callBackfunc) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
      dispatch({type: ON_START_MESSAGE_KUND,payload:translate("Action.Fortnox.Sync.Saving")});
     axios.put('kontos/fortnox/sync/settings', {
      method: 'PUT',
      body: {
        Afid:Afid,
        Meta:Meta,
        Value:Value
      }
    },
    {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("allowThisUserToSveaCredit: ", data);
       if (data.results) {
        dispatch({type: ON_MESSAGE_KUND,payload:translate("Action.Fortnox.Sync.Save")});
        // dispatch({type: FETCH_ALL_CONTACT});
        if(!isUndefined(callBackfunc)){callBackfunc()}
       }else{
        dispatch({type: ON_ERROR_MESSAGE_KUND,payload:translate("Error.Fortnox.Sync.Save")});
       }
     })
   }
 }
